/*! jQuery v2.1.4 | (c) 2005, 2015 jQuery Foundation, Inc. | jquery.org/license */
!function(a, b) {
    "object" == typeof module && "object" == typeof module.exports ? module.exports = a.document ? b(a, !0) : function(a) {
        if (!a.document)
            throw new Error("jQuery requires a window with a document");
        return b(a)
    }
    : b(a)
}("undefined" != typeof window ? window : this, function(a, b) {
    var c = []
      , d = c.slice
      , e = c.concat
      , f = c.push
      , g = c.indexOf
      , h = {}
      , i = h.toString
      , j = h.hasOwnProperty
      , k = {}
      , l = a.document
      , m = "2.1.4"
      , n = function(a, b) {
        return new n.fn.init(a,b)
    }
      , o = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g
      , p = /^-ms-/
      , q = /-([\da-z])/gi
      , r = function(a, b) {
        return b.toUpperCase()
    };
    n.fn = n.prototype = {
        jquery: m,
        constructor: n,
        selector: "",
        length: 0,
        toArray: function() {
            return d.call(this)
        },
        get: function(a) {
            return null != a ? 0 > a ? this[a + this.length] : this[a] : d.call(this)
        },
        pushStack: function(a) {
            var b = n.merge(this.constructor(), a);
            return b.prevObject = this,
            b.context = this.context,
            b
        },
        each: function(a, b) {
            return n.each(this, a, b)
        },
        map: function(a) {
            return this.pushStack(n.map(this, function(b, c) {
                return a.call(b, c, b)
            }))
        },
        slice: function() {
            return this.pushStack(d.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        eq: function(a) {
            var b = this.length
              , c = +a + (0 > a ? b : 0);
            return this.pushStack(c >= 0 && b > c ? [this[c]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor(null)
        },
        push: f,
        sort: c.sort,
        splice: c.splice
    },
    n.extend = n.fn.extend = function() {
        var a, b, c, d, e, f, g = arguments[0] || {}, h = 1, i = arguments.length, j = !1;
        for ("boolean" == typeof g && (j = g,
        g = arguments[h] || {},
        h++),
        "object" == typeof g || n.isFunction(g) || (g = {}),
        h === i && (g = this,
        h--); i > h; h++)
            if (null != (a = arguments[h]))
                for (b in a)
                    c = g[b],
                    d = a[b],
                    g !== d && (j && d && (n.isPlainObject(d) || (e = n.isArray(d))) ? (e ? (e = !1,
                    f = c && n.isArray(c) ? c : []) : f = c && n.isPlainObject(c) ? c : {},
                    g[b] = n.extend(j, f, d)) : void 0 !== d && (g[b] = d));
        return g
    }
    ,
    n.extend({
        expando: "jQuery" + (m + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(a) {
            throw new Error(a)
        },
        noop: function() {},
        isFunction: function(a) {
            return "function" === n.type(a)
        },
        isArray: Array.isArray,
        isWindow: function(a) {
            return null != a && a === a.window
        },
        isNumeric: function(a) {
            return !n.isArray(a) && a - parseFloat(a) + 1 >= 0
        },
        isPlainObject: function(a) {
            return "object" !== n.type(a) || a.nodeType || n.isWindow(a) ? !1 : a.constructor && !j.call(a.constructor.prototype, "isPrototypeOf") ? !1 : !0
        },
        isEmptyObject: function(a) {
            var b;
            for (b in a)
                return !1;
            return !0
        },
        type: function(a) {
            return null == a ? a + "" : "object" == typeof a || "function" == typeof a ? h[i.call(a)] || "object" : typeof a
        },
        globalEval: function(a) {
            var b, c = eval;
            a = n.trim(a),
            a && (1 === a.indexOf("use strict") ? (b = l.createElement("script"),
            b.text = a,
            l.head.appendChild(b).parentNode.removeChild(b)) : c(a))
        },
        camelCase: function(a) {
            return a.replace(p, "ms-").replace(q, r)
        },
        nodeName: function(a, b) {
            return a.nodeName && a.nodeName.toLowerCase() === b.toLowerCase()
        },
        each: function(a, b, c) {
            var d, e = 0, f = a.length, g = s(a);
            if (c) {
                if (g) {
                    for (; f > e; e++)
                        if (d = b.apply(a[e], c),
                        d === !1)
                            break
                } else
                    for (e in a)
                        if (d = b.apply(a[e], c),
                        d === !1)
                            break
            } else if (g) {
                for (; f > e; e++)
                    if (d = b.call(a[e], e, a[e]),
                    d === !1)
                        break
            } else
                for (e in a)
                    if (d = b.call(a[e], e, a[e]),
                    d === !1)
                        break;
            return a
        },
        trim: function(a) {
            return null == a ? "" : (a + "").replace(o, "")
        },
        makeArray: function(a, b) {
            var c = b || [];
            return null != a && (s(Object(a)) ? n.merge(c, "string" == typeof a ? [a] : a) : f.call(c, a)),
            c
        },
        inArray: function(a, b, c) {
            return null == b ? -1 : g.call(b, a, c)
        },
        merge: function(a, b) {
            for (var c = +b.length, d = 0, e = a.length; c > d; d++)
                a[e++] = b[d];
            return a.length = e,
            a
        },
        grep: function(a, b, c) {
            for (var d, e = [], f = 0, g = a.length, h = !c; g > f; f++)
                d = !b(a[f], f),
                d !== h && e.push(a[f]);
            return e
        },
        map: function(a, b, c) {
            var d, f = 0, g = a.length, h = s(a), i = [];
            if (h)
                for (; g > f; f++)
                    d = b(a[f], f, c),
                    null != d && i.push(d);
            else
                for (f in a)
                    d = b(a[f], f, c),
                    null != d && i.push(d);
            return e.apply([], i)
        },
        guid: 1,
        proxy: function(a, b) {
            var c, e, f;
            return "string" == typeof b && (c = a[b],
            b = a,
            a = c),
            n.isFunction(a) ? (e = d.call(arguments, 2),
            f = function() {
                return a.apply(b || this, e.concat(d.call(arguments)))
            }
            ,
            f.guid = a.guid = a.guid || n.guid++,
            f) : void 0
        },
        now: Date.now,
        support: k
    }),
    n.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(a, b) {
        h["[object " + b + "]"] = b.toLowerCase()
    });
    function s(a) {
        var b = "length"in a && a.length
          , c = n.type(a);
        return "function" === c || n.isWindow(a) ? !1 : 1 === a.nodeType && b ? !0 : "array" === c || 0 === b || "number" == typeof b && b > 0 && b - 1 in a
    }
    var t = function(a) {
        var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u = "sizzle" + 1 * new Date, v = a.document, w = 0, x = 0, y = ha(), z = ha(), A = ha(), B = function(a, b) {
            return a === b && (l = !0),
            0
        }, C = 1 << 31, D = {}.hasOwnProperty, E = [], F = E.pop, G = E.push, H = E.push, I = E.slice, J = function(a, b) {
            for (var c = 0, d = a.length; d > c; c++)
                if (a[c] === b)
                    return c;
            return -1
        }, K = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", L = "[\\x20\\t\\r\\n\\f]", M = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+", N = M.replace("w", "w#"), O = "\\[" + L + "*(" + M + ")(?:" + L + "*([*^$|!~]?=)" + L + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + N + "))|)" + L + "*\\]", P = ":(" + M + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + O + ")*)|.*)\\)|)", Q = new RegExp(L + "+","g"), R = new RegExp("^" + L + "+|((?:^|[^\\\\])(?:\\\\.)*)" + L + "+$","g"), S = new RegExp("^" + L + "*," + L + "*"), T = new RegExp("^" + L + "*([>+~]|" + L + ")" + L + "*"), U = new RegExp("=" + L + "*([^\\]'\"]*?)" + L + "*\\]","g"), V = new RegExp(P), W = new RegExp("^" + N + "$"), X = {
            ID: new RegExp("^#(" + M + ")"),
            CLASS: new RegExp("^\\.(" + M + ")"),
            TAG: new RegExp("^(" + M.replace("w", "w*") + ")"),
            ATTR: new RegExp("^" + O),
            PSEUDO: new RegExp("^" + P),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + L + "*(even|odd|(([+-]|)(\\d*)n|)" + L + "*(?:([+-]|)" + L + "*(\\d+)|))" + L + "*\\)|)","i"),
            bool: new RegExp("^(?:" + K + ")$","i"),
            needsContext: new RegExp("^" + L + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + L + "*((?:-\\d)?\\d*)" + L + "*\\)|)(?=[^-]|$)","i")
        }, Y = /^(?:input|select|textarea|button)$/i, Z = /^h\d$/i, $ = /^[^{]+\{\s*\[native \w/, _ = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, aa = /[+~]/, ba = /'|\\/g, ca = new RegExp("\\\\([\\da-f]{1,6}" + L + "?|(" + L + ")|.)","ig"), da = function(a, b, c) {
            var d = "0x" + b - 65536;
            return d !== d || c ? b : 0 > d ? String.fromCharCode(d + 65536) : String.fromCharCode(d >> 10 | 55296, 1023 & d | 56320)
        }, ea = function() {
            m()
        };
        try {
            H.apply(E = I.call(v.childNodes), v.childNodes),
            E[v.childNodes.length].nodeType
        } catch (fa) {
            H = {
                apply: E.length ? function(a, b) {
                    G.apply(a, I.call(b))
                }
                : function(a, b) {
                    var c = a.length
                      , d = 0;
                    while (a[c++] = b[d++])
                        ;
                    a.length = c - 1
                }
            }
        }
        function ga(a, b, d, e) {
            var f, h, j, k, l, o, r, s, w, x;
            if ((b ? b.ownerDocument || b : v) !== n && m(b),
            b = b || n,
            d = d || [],
            k = b.nodeType,
            "string" != typeof a || !a || 1 !== k && 9 !== k && 11 !== k)
                return d;
            if (!e && p) {
                if (11 !== k && (f = _.exec(a)))
                    if (j = f[1]) {
                        if (9 === k) {
                            if (h = b.getElementById(j),
                            !h || !h.parentNode)
                                return d;
                            if (h.id === j)
                                return d.push(h),
                                d
                        } else if (b.ownerDocument && (h = b.ownerDocument.getElementById(j)) && t(b, h) && h.id === j)
                            return d.push(h),
                            d
                    } else {
                        if (f[2])
                            return H.apply(d, b.getElementsByTagName(a)),
                            d;
                        if ((j = f[3]) && c.getElementsByClassName)
                            return H.apply(d, b.getElementsByClassName(j)),
                            d
                    }
                if (c.qsa && (!q || !q.test(a))) {
                    if (s = r = u,
                    w = b,
                    x = 1 !== k && a,
                    1 === k && "object" !== b.nodeName.toLowerCase()) {
                        o = g(a),
                        (r = b.getAttribute("id")) ? s = r.replace(ba, "\\$&") : b.setAttribute("id", s),
                        s = "[id='" + s + "'] ",
                        l = o.length;
                        while (l--)
                            o[l] = s + ra(o[l]);
                        w = aa.test(a) && pa(b.parentNode) || b,
                        x = o.join(",")
                    }
                    if (x)
                        try {
                            return H.apply(d, w.querySelectorAll(x)),
                            d
                        } catch (y) {} finally {
                            r || b.removeAttribute("id")
                        }
                }
            }
            return i(a.replace(R, "$1"), b, d, e)
        }
        function ha() {
            var a = [];
            function b(c, e) {
                return a.push(c + " ") > d.cacheLength && delete b[a.shift()],
                b[c + " "] = e
            }
            return b
        }
        function ia(a) {
            return a[u] = !0,
            a
        }
        function ja(a) {
            var b = n.createElement("div");
            try {
                return !!a(b)
            } catch (c) {
                return !1
            } finally {
                b.parentNode && b.parentNode.removeChild(b),
                b = null
            }
        }
        function ka(a, b) {
            var c = a.split("|")
              , e = a.length;
            while (e--)
                d.attrHandle[c[e]] = b
        }
        function la(a, b) {
            var c = b && a
              , d = c && 1 === a.nodeType && 1 === b.nodeType && (~b.sourceIndex || C) - (~a.sourceIndex || C);
            if (d)
                return d;
            if (c)
                while (c = c.nextSibling)
                    if (c === b)
                        return -1;
            return a ? 1 : -1
        }
        function ma(a) {
            return function(b) {
                var c = b.nodeName.toLowerCase();
                return "input" === c && b.type === a
            }
        }
        function na(a) {
            return function(b) {
                var c = b.nodeName.toLowerCase();
                return ("input" === c || "button" === c) && b.type === a
            }
        }
        function oa(a) {
            return ia(function(b) {
                return b = +b,
                ia(function(c, d) {
                    var e, f = a([], c.length, b), g = f.length;
                    while (g--)
                        c[e = f[g]] && (c[e] = !(d[e] = c[e]))
                })
            })
        }
        function pa(a) {
            return a && "undefined" != typeof a.getElementsByTagName && a
        }
        c = ga.support = {},
        f = ga.isXML = function(a) {
            var b = a && (a.ownerDocument || a).documentElement;
            return b ? "HTML" !== b.nodeName : !1
        }
        ,
        m = ga.setDocument = function(a) {
            var b, e, g = a ? a.ownerDocument || a : v;
            return g !== n && 9 === g.nodeType && g.documentElement ? (n = g,
            o = g.documentElement,
            e = g.defaultView,
            e && e !== e.top && (e.addEventListener ? e.addEventListener("unload", ea, !1) : e.attachEvent && e.attachEvent("onunload", ea)),
            p = !f(g),
            c.attributes = ja(function(a) {
                return a.className = "i",
                !a.getAttribute("className")
            }),
            c.getElementsByTagName = ja(function(a) {
                return a.appendChild(g.createComment("")),
                !a.getElementsByTagName("*").length
            }),
            c.getElementsByClassName = $.test(g.getElementsByClassName),
            c.getById = ja(function(a) {
                return o.appendChild(a).id = u,
                !g.getElementsByName || !g.getElementsByName(u).length
            }),
            c.getById ? (d.find.ID = function(a, b) {
                if ("undefined" != typeof b.getElementById && p) {
                    var c = b.getElementById(a);
                    return c && c.parentNode ? [c] : []
                }
            }
            ,
            d.filter.ID = function(a) {
                var b = a.replace(ca, da);
                return function(a) {
                    return a.getAttribute("id") === b
                }
            }
            ) : (delete d.find.ID,
            d.filter.ID = function(a) {
                var b = a.replace(ca, da);
                return function(a) {
                    var c = "undefined" != typeof a.getAttributeNode && a.getAttributeNode("id");
                    return c && c.value === b
                }
            }
            ),
            d.find.TAG = c.getElementsByTagName ? function(a, b) {
                return "undefined" != typeof b.getElementsByTagName ? b.getElementsByTagName(a) : c.qsa ? b.querySelectorAll(a) : void 0
            }
            : function(a, b) {
                var c, d = [], e = 0, f = b.getElementsByTagName(a);
                if ("*" === a) {
                    while (c = f[e++])
                        1 === c.nodeType && d.push(c);
                    return d
                }
                return f
            }
            ,
            d.find.CLASS = c.getElementsByClassName && function(a, b) {
                return p ? b.getElementsByClassName(a) : void 0
            }
            ,
            r = [],
            q = [],
            (c.qsa = $.test(g.querySelectorAll)) && (ja(function(a) {
                o.appendChild(a).innerHTML = "<a id='" + u + "'></a><select id='" + u + "-\f]' msallowcapture=''><option selected=''></option></select>",
                a.querySelectorAll("[msallowcapture^='']").length && q.push("[*^$]=" + L + "*(?:''|\"\")"),
                a.querySelectorAll("[selected]").length || q.push("\\[" + L + "*(?:value|" + K + ")"),
                a.querySelectorAll("[id~=" + u + "-]").length || q.push("~="),
                a.querySelectorAll(":checked").length || q.push(":checked"),
                a.querySelectorAll("a#" + u + "+*").length || q.push(".#.+[+~]")
            }),
            ja(function(a) {
                var b = g.createElement("input");
                b.setAttribute("type", "hidden"),
                a.appendChild(b).setAttribute("name", "D"),
                a.querySelectorAll("[name=d]").length && q.push("name" + L + "*[*^$|!~]?="),
                a.querySelectorAll(":enabled").length || q.push(":enabled", ":disabled"),
                a.querySelectorAll("*,:x"),
                q.push(",.*:")
            })),
            (c.matchesSelector = $.test(s = o.matches || o.webkitMatchesSelector || o.mozMatchesSelector || o.oMatchesSelector || o.msMatchesSelector)) && ja(function(a) {
                c.disconnectedMatch = s.call(a, "div"),
                s.call(a, "[s!='']:x"),
                r.push("!=", P)
            }),
            q = q.length && new RegExp(q.join("|")),
            r = r.length && new RegExp(r.join("|")),
            b = $.test(o.compareDocumentPosition),
            t = b || $.test(o.contains) ? function(a, b) {
                var c = 9 === a.nodeType ? a.documentElement : a
                  , d = b && b.parentNode;
                return a === d || !(!d || 1 !== d.nodeType || !(c.contains ? c.contains(d) : a.compareDocumentPosition && 16 & a.compareDocumentPosition(d)))
            }
            : function(a, b) {
                if (b)
                    while (b = b.parentNode)
                        if (b === a)
                            return !0;
                return !1
            }
            ,
            B = b ? function(a, b) {
                if (a === b)
                    return l = !0,
                    0;
                var d = !a.compareDocumentPosition - !b.compareDocumentPosition;
                return d ? d : (d = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : 1,
                1 & d || !c.sortDetached && b.compareDocumentPosition(a) === d ? a === g || a.ownerDocument === v && t(v, a) ? -1 : b === g || b.ownerDocument === v && t(v, b) ? 1 : k ? J(k, a) - J(k, b) : 0 : 4 & d ? -1 : 1)
            }
            : function(a, b) {
                if (a === b)
                    return l = !0,
                    0;
                var c, d = 0, e = a.parentNode, f = b.parentNode, h = [a], i = [b];
                if (!e || !f)
                    return a === g ? -1 : b === g ? 1 : e ? -1 : f ? 1 : k ? J(k, a) - J(k, b) : 0;
                if (e === f)
                    return la(a, b);
                c = a;
                while (c = c.parentNode)
                    h.unshift(c);
                c = b;
                while (c = c.parentNode)
                    i.unshift(c);
                while (h[d] === i[d])
                    d++;
                return d ? la(h[d], i[d]) : h[d] === v ? -1 : i[d] === v ? 1 : 0
            }
            ,
            g) : n
        }
        ,
        ga.matches = function(a, b) {
            return ga(a, null, null, b)
        }
        ,
        ga.matchesSelector = function(a, b) {
            if ((a.ownerDocument || a) !== n && m(a),
            b = b.replace(U, "='$1']"),
            !(!c.matchesSelector || !p || r && r.test(b) || q && q.test(b)))
                try {
                    var d = s.call(a, b);
                    if (d || c.disconnectedMatch || a.document && 11 !== a.document.nodeType)
                        return d
                } catch (e) {}
            return ga(b, n, null, [a]).length > 0
        }
        ,
        ga.contains = function(a, b) {
            return (a.ownerDocument || a) !== n && m(a),
            t(a, b)
        }
        ,
        ga.attr = function(a, b) {
            (a.ownerDocument || a) !== n && m(a);
            var e = d.attrHandle[b.toLowerCase()]
              , f = e && D.call(d.attrHandle, b.toLowerCase()) ? e(a, b, !p) : void 0;
            return void 0 !== f ? f : c.attributes || !p ? a.getAttribute(b) : (f = a.getAttributeNode(b)) && f.specified ? f.value : null
        }
        ,
        ga.error = function(a) {
            throw new Error("Syntax error, unrecognized expression: " + a)
        }
        ,
        ga.uniqueSort = function(a) {
            var b, d = [], e = 0, f = 0;
            if (l = !c.detectDuplicates,
            k = !c.sortStable && a.slice(0),
            a.sort(B),
            l) {
                while (b = a[f++])
                    b === a[f] && (e = d.push(f));
                while (e--)
                    a.splice(d[e], 1)
            }
            return k = null,
            a
        }
        ,
        e = ga.getText = function(a) {
            var b, c = "", d = 0, f = a.nodeType;
            if (f) {
                if (1 === f || 9 === f || 11 === f) {
                    if ("string" == typeof a.textContent)
                        return a.textContent;
                    for (a = a.firstChild; a; a = a.nextSibling)
                        c += e(a)
                } else if (3 === f || 4 === f)
                    return a.nodeValue
            } else
                while (b = a[d++])
                    c += e(b);
            return c
        }
        ,
        d = ga.selectors = {
            cacheLength: 50,
            createPseudo: ia,
            match: X,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: !0
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: !0
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(a) {
                    return a[1] = a[1].replace(ca, da),
                    a[3] = (a[3] || a[4] || a[5] || "").replace(ca, da),
                    "~=" === a[2] && (a[3] = " " + a[3] + " "),
                    a.slice(0, 4)
                },
                CHILD: function(a) {
                    return a[1] = a[1].toLowerCase(),
                    "nth" === a[1].slice(0, 3) ? (a[3] || ga.error(a[0]),
                    a[4] = +(a[4] ? a[5] + (a[6] || 1) : 2 * ("even" === a[3] || "odd" === a[3])),
                    a[5] = +(a[7] + a[8] || "odd" === a[3])) : a[3] && ga.error(a[0]),
                    a
                },
                PSEUDO: function(a) {
                    var b, c = !a[6] && a[2];
                    return X.CHILD.test(a[0]) ? null : (a[3] ? a[2] = a[4] || a[5] || "" : c && V.test(c) && (b = g(c, !0)) && (b = c.indexOf(")", c.length - b) - c.length) && (a[0] = a[0].slice(0, b),
                    a[2] = c.slice(0, b)),
                    a.slice(0, 3))
                }
            },
            filter: {
                TAG: function(a) {
                    var b = a.replace(ca, da).toLowerCase();
                    return "*" === a ? function() {
                        return !0
                    }
                    : function(a) {
                        return a.nodeName && a.nodeName.toLowerCase() === b
                    }
                },
                CLASS: function(a) {
                    var b = y[a + " "];
                    return b || (b = new RegExp("(^|" + L + ")" + a + "(" + L + "|$)")) && y(a, function(a) {
                        return b.test("string" == typeof a.className && a.className || "undefined" != typeof a.getAttribute && a.getAttribute("class") || "")
                    })
                },
                ATTR: function(a, b, c) {
                    return function(d) {
                        var e = ga.attr(d, a);
                        return null == e ? "!=" === b : b ? (e += "",
                        "=" === b ? e === c : "!=" === b ? e !== c : "^=" === b ? c && 0 === e.indexOf(c) : "*=" === b ? c && e.indexOf(c) > -1 : "$=" === b ? c && e.slice(-c.length) === c : "~=" === b ? (" " + e.replace(Q, " ") + " ").indexOf(c) > -1 : "|=" === b ? e === c || e.slice(0, c.length + 1) === c + "-" : !1) : !0
                    }
                },
                CHILD: function(a, b, c, d, e) {
                    var f = "nth" !== a.slice(0, 3)
                      , g = "last" !== a.slice(-4)
                      , h = "of-type" === b;
                    return 1 === d && 0 === e ? function(a) {
                        return !!a.parentNode
                    }
                    : function(b, c, i) {
                        var j, k, l, m, n, o, p = f !== g ? "nextSibling" : "previousSibling", q = b.parentNode, r = h && b.nodeName.toLowerCase(), s = !i && !h;
                        if (q) {
                            if (f) {
                                while (p) {
                                    l = b;
                                    while (l = l[p])
                                        if (h ? l.nodeName.toLowerCase() === r : 1 === l.nodeType)
                                            return !1;
                                    o = p = "only" === a && !o && "nextSibling"
                                }
                                return !0
                            }
                            if (o = [g ? q.firstChild : q.lastChild],
                            g && s) {
                                k = q[u] || (q[u] = {}),
                                j = k[a] || [],
                                n = j[0] === w && j[1],
                                m = j[0] === w && j[2],
                                l = n && q.childNodes[n];
                                while (l = ++n && l && l[p] || (m = n = 0) || o.pop())
                                    if (1 === l.nodeType && ++m && l === b) {
                                        k[a] = [w, n, m];
                                        break
                                    }
                            } else if (s && (j = (b[u] || (b[u] = {}))[a]) && j[0] === w)
                                m = j[1];
                            else
                                while (l = ++n && l && l[p] || (m = n = 0) || o.pop())
                                    if ((h ? l.nodeName.toLowerCase() === r : 1 === l.nodeType) && ++m && (s && ((l[u] || (l[u] = {}))[a] = [w, m]),
                                    l === b))
                                        break;
                            return m -= e,
                            m === d || m % d === 0 && m / d >= 0
                        }
                    }
                },
                PSEUDO: function(a, b) {
                    var c, e = d.pseudos[a] || d.setFilters[a.toLowerCase()] || ga.error("unsupported pseudo: " + a);
                    return e[u] ? e(b) : e.length > 1 ? (c = [a, a, "", b],
                    d.setFilters.hasOwnProperty(a.toLowerCase()) ? ia(function(a, c) {
                        var d, f = e(a, b), g = f.length;
                        while (g--)
                            d = J(a, f[g]),
                            a[d] = !(c[d] = f[g])
                    }) : function(a) {
                        return e(a, 0, c)
                    }
                    ) : e
                }
            },
            pseudos: {
                not: ia(function(a) {
                    var b = []
                      , c = []
                      , d = h(a.replace(R, "$1"));
                    return d[u] ? ia(function(a, b, c, e) {
                        var f, g = d(a, null, e, []), h = a.length;
                        while (h--)
                            (f = g[h]) && (a[h] = !(b[h] = f))
                    }) : function(a, e, f) {
                        return b[0] = a,
                        d(b, null, f, c),
                        b[0] = null,
                        !c.pop()
                    }
                }),
                has: ia(function(a) {
                    return function(b) {
                        return ga(a, b).length > 0
                    }
                }),
                contains: ia(function(a) {
                    return a = a.replace(ca, da),
                    function(b) {
                        return (b.textContent || b.innerText || e(b)).indexOf(a) > -1
                    }
                }),
                lang: ia(function(a) {
                    return W.test(a || "") || ga.error("unsupported lang: " + a),
                    a = a.replace(ca, da).toLowerCase(),
                    function(b) {
                        var c;
                        do
                            if (c = p ? b.lang : b.getAttribute("xml:lang") || b.getAttribute("lang"))
                                return c = c.toLowerCase(),
                                c === a || 0 === c.indexOf(a + "-");
                        while ((b = b.parentNode) && 1 === b.nodeType);
                        return !1
                    }
                }),
                target: function(b) {
                    var c = a.location && a.location.hash;
                    return c && c.slice(1) === b.id
                },
                root: function(a) {
                    return a === o
                },
                focus: function(a) {
                    return a === n.activeElement && (!n.hasFocus || n.hasFocus()) && !!(a.type || a.href || ~a.tabIndex)
                },
                enabled: function(a) {
                    return a.disabled === !1
                },
                disabled: function(a) {
                    return a.disabled === !0
                },
                checked: function(a) {
                    var b = a.nodeName.toLowerCase();
                    return "input" === b && !!a.checked || "option" === b && !!a.selected
                },
                selected: function(a) {
                    return a.parentNode && a.parentNode.selectedIndex,
                    a.selected === !0
                },
                empty: function(a) {
                    for (a = a.firstChild; a; a = a.nextSibling)
                        if (a.nodeType < 6)
                            return !1;
                    return !0
                },
                parent: function(a) {
                    return !d.pseudos.empty(a)
                },
                header: function(a) {
                    return Z.test(a.nodeName)
                },
                input: function(a) {
                    return Y.test(a.nodeName)
                },
                button: function(a) {
                    var b = a.nodeName.toLowerCase();
                    return "input" === b && "button" === a.type || "button" === b
                },
                text: function(a) {
                    var b;
                    return "input" === a.nodeName.toLowerCase() && "text" === a.type && (null == (b = a.getAttribute("type")) || "text" === b.toLowerCase())
                },
                first: oa(function() {
                    return [0]
                }),
                last: oa(function(a, b) {
                    return [b - 1]
                }),
                eq: oa(function(a, b, c) {
                    return [0 > c ? c + b : c]
                }),
                even: oa(function(a, b) {
                    for (var c = 0; b > c; c += 2)
                        a.push(c);
                    return a
                }),
                odd: oa(function(a, b) {
                    for (var c = 1; b > c; c += 2)
                        a.push(c);
                    return a
                }),
                lt: oa(function(a, b, c) {
                    for (var d = 0 > c ? c + b : c; --d >= 0; )
                        a.push(d);
                    return a
                }),
                gt: oa(function(a, b, c) {
                    for (var d = 0 > c ? c + b : c; ++d < b; )
                        a.push(d);
                    return a
                })
            }
        },
        d.pseudos.nth = d.pseudos.eq;
        for (b in {
            radio: !0,
            checkbox: !0,
            file: !0,
            password: !0,
            image: !0
        })
            d.pseudos[b] = ma(b);
        for (b in {
            submit: !0,
            reset: !0
        })
            d.pseudos[b] = na(b);
        function qa() {}
        qa.prototype = d.filters = d.pseudos,
        d.setFilters = new qa,
        g = ga.tokenize = function(a, b) {
            var c, e, f, g, h, i, j, k = z[a + " "];
            if (k)
                return b ? 0 : k.slice(0);
            h = a,
            i = [],
            j = d.preFilter;
            while (h) {
                (!c || (e = S.exec(h))) && (e && (h = h.slice(e[0].length) || h),
                i.push(f = [])),
                c = !1,
                (e = T.exec(h)) && (c = e.shift(),
                f.push({
                    value: c,
                    type: e[0].replace(R, " ")
                }),
                h = h.slice(c.length));
                for (g in d.filter)
                    !(e = X[g].exec(h)) || j[g] && !(e = j[g](e)) || (c = e.shift(),
                    f.push({
                        value: c,
                        type: g,
                        matches: e
                    }),
                    h = h.slice(c.length));
                if (!c)
                    break
            }
            return b ? h.length : h ? ga.error(a) : z(a, i).slice(0)
        }
        ;
        function ra(a) {
            for (var b = 0, c = a.length, d = ""; c > b; b++)
                d += a[b].value;
            return d
        }
        function sa(a, b, c) {
            var d = b.dir
              , e = c && "parentNode" === d
              , f = x++;
            return b.first ? function(b, c, f) {
                while (b = b[d])
                    if (1 === b.nodeType || e)
                        return a(b, c, f)
            }
            : function(b, c, g) {
                var h, i, j = [w, f];
                if (g) {
                    while (b = b[d])
                        if ((1 === b.nodeType || e) && a(b, c, g))
                            return !0
                } else
                    while (b = b[d])
                        if (1 === b.nodeType || e) {
                            if (i = b[u] || (b[u] = {}),
                            (h = i[d]) && h[0] === w && h[1] === f)
                                return j[2] = h[2];
                            if (i[d] = j,
                            j[2] = a(b, c, g))
                                return !0
                        }
            }
        }
        function ta(a) {
            return a.length > 1 ? function(b, c, d) {
                var e = a.length;
                while (e--)
                    if (!a[e](b, c, d))
                        return !1;
                return !0
            }
            : a[0]
        }
        function ua(a, b, c) {
            for (var d = 0, e = b.length; e > d; d++)
                ga(a, b[d], c);
            return c
        }
        function va(a, b, c, d, e) {
            for (var f, g = [], h = 0, i = a.length, j = null != b; i > h; h++)
                (f = a[h]) && (!c || c(f, d, e)) && (g.push(f),
                j && b.push(h));
            return g
        }
        function wa(a, b, c, d, e, f) {
            return d && !d[u] && (d = wa(d)),
            e && !e[u] && (e = wa(e, f)),
            ia(function(f, g, h, i) {
                var j, k, l, m = [], n = [], o = g.length, p = f || ua(b || "*", h.nodeType ? [h] : h, []), q = !a || !f && b ? p : va(p, m, a, h, i), r = c ? e || (f ? a : o || d) ? [] : g : q;
                if (c && c(q, r, h, i),
                d) {
                    j = va(r, n),
                    d(j, [], h, i),
                    k = j.length;
                    while (k--)
                        (l = j[k]) && (r[n[k]] = !(q[n[k]] = l))
                }
                if (f) {
                    if (e || a) {
                        if (e) {
                            j = [],
                            k = r.length;
                            while (k--)
                                (l = r[k]) && j.push(q[k] = l);
                            e(null, r = [], j, i)
                        }
                        k = r.length;
                        while (k--)
                            (l = r[k]) && (j = e ? J(f, l) : m[k]) > -1 && (f[j] = !(g[j] = l))
                    }
                } else
                    r = va(r === g ? r.splice(o, r.length) : r),
                    e ? e(null, g, r, i) : H.apply(g, r)
            })
        }
        function xa(a) {
            for (var b, c, e, f = a.length, g = d.relative[a[0].type], h = g || d.relative[" "], i = g ? 1 : 0, k = sa(function(a) {
                return a === b
            }, h, !0), l = sa(function(a) {
                return J(b, a) > -1
            }, h, !0), m = [function(a, c, d) {
                var e = !g && (d || c !== j) || ((b = c).nodeType ? k(a, c, d) : l(a, c, d));
                return b = null,
                e
            }
            ]; f > i; i++)
                if (c = d.relative[a[i].type])
                    m = [sa(ta(m), c)];
                else {
                    if (c = d.filter[a[i].type].apply(null, a[i].matches),
                    c[u]) {
                        for (e = ++i; f > e; e++)
                            if (d.relative[a[e].type])
                                break;
                        return wa(i > 1 && ta(m), i > 1 && ra(a.slice(0, i - 1).concat({
                            value: " " === a[i - 2].type ? "*" : ""
                        })).replace(R, "$1"), c, e > i && xa(a.slice(i, e)), f > e && xa(a = a.slice(e)), f > e && ra(a))
                    }
                    m.push(c)
                }
            return ta(m)
        }
        function ya(a, b) {
            var c = b.length > 0
              , e = a.length > 0
              , f = function(f, g, h, i, k) {
                var l, m, o, p = 0, q = "0", r = f && [], s = [], t = j, u = f || e && d.find.TAG("*", k), v = w += null == t ? 1 : Math.random() || .1, x = u.length;
                for (k && (j = g !== n && g); q !== x && null != (l = u[q]); q++) {
                    if (e && l) {
                        m = 0;
                        while (o = a[m++])
                            if (o(l, g, h)) {
                                i.push(l);
                                break
                            }
                        k && (w = v)
                    }
                    c && ((l = !o && l) && p--,
                    f && r.push(l))
                }
                if (p += q,
                c && q !== p) {
                    m = 0;
                    while (o = b[m++])
                        o(r, s, g, h);
                    if (f) {
                        if (p > 0)
                            while (q--)
                                r[q] || s[q] || (s[q] = F.call(i));
                        s = va(s)
                    }
                    H.apply(i, s),
                    k && !f && s.length > 0 && p + b.length > 1 && ga.uniqueSort(i)
                }
                return k && (w = v,
                j = t),
                r
            };
            return c ? ia(f) : f
        }
        return h = ga.compile = function(a, b) {
            var c, d = [], e = [], f = A[a + " "];
            if (!f) {
                b || (b = g(a)),
                c = b.length;
                while (c--)
                    f = xa(b[c]),
                    f[u] ? d.push(f) : e.push(f);
                f = A(a, ya(e, d)),
                f.selector = a
            }
            return f
        }
        ,
        i = ga.select = function(a, b, e, f) {
            var i, j, k, l, m, n = "function" == typeof a && a, o = !f && g(a = n.selector || a);
            if (e = e || [],
            1 === o.length) {
                if (j = o[0] = o[0].slice(0),
                j.length > 2 && "ID" === (k = j[0]).type && c.getById && 9 === b.nodeType && p && d.relative[j[1].type]) {
                    if (b = (d.find.ID(k.matches[0].replace(ca, da), b) || [])[0],
                    !b)
                        return e;
                    n && (b = b.parentNode),
                    a = a.slice(j.shift().value.length)
                }
                i = X.needsContext.test(a) ? 0 : j.length;
                while (i--) {
                    if (k = j[i],
                    d.relative[l = k.type])
                        break;
                    if ((m = d.find[l]) && (f = m(k.matches[0].replace(ca, da), aa.test(j[0].type) && pa(b.parentNode) || b))) {
                        if (j.splice(i, 1),
                        a = f.length && ra(j),
                        !a)
                            return H.apply(e, f),
                            e;
                        break
                    }
                }
            }
            return (n || h(a, o))(f, b, !p, e, aa.test(a) && pa(b.parentNode) || b),
            e
        }
        ,
        c.sortStable = u.split("").sort(B).join("") === u,
        c.detectDuplicates = !!l,
        m(),
        c.sortDetached = ja(function(a) {
            return 1 & a.compareDocumentPosition(n.createElement("div"))
        }),
        ja(function(a) {
            return a.innerHTML = "<a href='#'></a>",
            "#" === a.firstChild.getAttribute("href")
        }) || ka("type|href|height|width", function(a, b, c) {
            return c ? void 0 : a.getAttribute(b, "type" === b.toLowerCase() ? 1 : 2)
        }),
        c.attributes && ja(function(a) {
            return a.innerHTML = "<input/>",
            a.firstChild.setAttribute("value", ""),
            "" === a.firstChild.getAttribute("value")
        }) || ka("value", function(a, b, c) {
            return c || "input" !== a.nodeName.toLowerCase() ? void 0 : a.defaultValue
        }),
        ja(function(a) {
            return null == a.getAttribute("disabled")
        }) || ka(K, function(a, b, c) {
            var d;
            return c ? void 0 : a[b] === !0 ? b.toLowerCase() : (d = a.getAttributeNode(b)) && d.specified ? d.value : null
        }),
        ga
    }(a);
    n.find = t,
    n.expr = t.selectors,
    n.expr[":"] = n.expr.pseudos,
    n.unique = t.uniqueSort,
    n.text = t.getText,
    n.isXMLDoc = t.isXML,
    n.contains = t.contains;
    var u = n.expr.match.needsContext
      , v = /^<(\w+)\s*\/?>(?:<\/\1>|)$/
      , w = /^.[^:#\[\.,]*$/;
    function x(a, b, c) {
        if (n.isFunction(b))
            return n.grep(a, function(a, d) {
                return !!b.call(a, d, a) !== c
            });
        if (b.nodeType)
            return n.grep(a, function(a) {
                return a === b !== c
            });
        if ("string" == typeof b) {
            if (w.test(b))
                return n.filter(b, a, c);
            b = n.filter(b, a)
        }
        return n.grep(a, function(a) {
            return g.call(b, a) >= 0 !== c
        })
    }
    n.filter = function(a, b, c) {
        var d = b[0];
        return c && (a = ":not(" + a + ")"),
        1 === b.length && 1 === d.nodeType ? n.find.matchesSelector(d, a) ? [d] : [] : n.find.matches(a, n.grep(b, function(a) {
            return 1 === a.nodeType
        }))
    }
    ,
    n.fn.extend({
        find: function(a) {
            var b, c = this.length, d = [], e = this;
            if ("string" != typeof a)
                return this.pushStack(n(a).filter(function() {
                    for (b = 0; c > b; b++)
                        if (n.contains(e[b], this))
                            return !0
                }));
            for (b = 0; c > b; b++)
                n.find(a, e[b], d);
            return d = this.pushStack(c > 1 ? n.unique(d) : d),
            d.selector = this.selector ? this.selector + " " + a : a,
            d
        },
        filter: function(a) {
            return this.pushStack(x(this, a || [], !1))
        },
        not: function(a) {
            return this.pushStack(x(this, a || [], !0))
        },
        is: function(a) {
            return !!x(this, "string" == typeof a && u.test(a) ? n(a) : a || [], !1).length
        }
    });
    var y, z = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/, A = n.fn.init = function(a, b) {
        var c, d;
        if (!a)
            return this;
        if ("string" == typeof a) {
            if (c = "<" === a[0] && ">" === a[a.length - 1] && a.length >= 3 ? [null, a, null] : z.exec(a),
            !c || !c[1] && b)
                return !b || b.jquery ? (b || y).find(a) : this.constructor(b).find(a);
            if (c[1]) {
                if (b = b instanceof n ? b[0] : b,
                n.merge(this, n.parseHTML(c[1], b && b.nodeType ? b.ownerDocument || b : l, !0)),
                v.test(c[1]) && n.isPlainObject(b))
                    for (c in b)
                        n.isFunction(this[c]) ? this[c](b[c]) : this.attr(c, b[c]);
                return this
            }
            return d = l.getElementById(c[2]),
            d && d.parentNode && (this.length = 1,
            this[0] = d),
            this.context = l,
            this.selector = a,
            this
        }
        return a.nodeType ? (this.context = this[0] = a,
        this.length = 1,
        this) : n.isFunction(a) ? "undefined" != typeof y.ready ? y.ready(a) : a(n) : (void 0 !== a.selector && (this.selector = a.selector,
        this.context = a.context),
        n.makeArray(a, this))
    }
    ;
    A.prototype = n.fn,
    y = n(l);
    var B = /^(?:parents|prev(?:Until|All))/
      , C = {
        children: !0,
        contents: !0,
        next: !0,
        prev: !0
    };
    n.extend({
        dir: function(a, b, c) {
            var d = []
              , e = void 0 !== c;
            while ((a = a[b]) && 9 !== a.nodeType)
                if (1 === a.nodeType) {
                    if (e && n(a).is(c))
                        break;
                    d.push(a)
                }
            return d
        },
        sibling: function(a, b) {
            for (var c = []; a; a = a.nextSibling)
                1 === a.nodeType && a !== b && c.push(a);
            return c
        }
    }),
    n.fn.extend({
        has: function(a) {
            var b = n(a, this)
              , c = b.length;
            return this.filter(function() {
                for (var a = 0; c > a; a++)
                    if (n.contains(this, b[a]))
                        return !0
            })
        },
        closest: function(a, b) {
            for (var c, d = 0, e = this.length, f = [], g = u.test(a) || "string" != typeof a ? n(a, b || this.context) : 0; e > d; d++)
                for (c = this[d]; c && c !== b; c = c.parentNode)
                    if (c.nodeType < 11 && (g ? g.index(c) > -1 : 1 === c.nodeType && n.find.matchesSelector(c, a))) {
                        f.push(c);
                        break
                    }
            return this.pushStack(f.length > 1 ? n.unique(f) : f)
        },
        index: function(a) {
            return a ? "string" == typeof a ? g.call(n(a), this[0]) : g.call(this, a.jquery ? a[0] : a) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(a, b) {
            return this.pushStack(n.unique(n.merge(this.get(), n(a, b))))
        },
        addBack: function(a) {
            return this.add(null == a ? this.prevObject : this.prevObject.filter(a))
        }
    });
    function D(a, b) {
        while ((a = a[b]) && 1 !== a.nodeType)
            ;
        return a
    }
    n.each({
        parent: function(a) {
            var b = a.parentNode;
            return b && 11 !== b.nodeType ? b : null
        },
        parents: function(a) {
            return n.dir(a, "parentNode")
        },
        parentsUntil: function(a, b, c) {
            return n.dir(a, "parentNode", c)
        },
        next: function(a) {
            return D(a, "nextSibling")
        },
        prev: function(a) {
            return D(a, "previousSibling")
        },
        nextAll: function(a) {
            return n.dir(a, "nextSibling")
        },
        prevAll: function(a) {
            return n.dir(a, "previousSibling")
        },
        nextUntil: function(a, b, c) {
            return n.dir(a, "nextSibling", c)
        },
        prevUntil: function(a, b, c) {
            return n.dir(a, "previousSibling", c)
        },
        siblings: function(a) {
            return n.sibling((a.parentNode || {}).firstChild, a)
        },
        children: function(a) {
            return n.sibling(a.firstChild)
        },
        contents: function(a) {
            return a.contentDocument || n.merge([], a.childNodes)
        }
    }, function(a, b) {
        n.fn[a] = function(c, d) {
            var e = n.map(this, b, c);
            return "Until" !== a.slice(-5) && (d = c),
            d && "string" == typeof d && (e = n.filter(d, e)),
            this.length > 1 && (C[a] || n.unique(e),
            B.test(a) && e.reverse()),
            this.pushStack(e)
        }
    });
    var E = /\S+/g
      , F = {};
    function G(a) {
        var b = F[a] = {};
        return n.each(a.match(E) || [], function(a, c) {
            b[c] = !0
        }),
        b
    }
    n.Callbacks = function(a) {
        a = "string" == typeof a ? F[a] || G(a) : n.extend({}, a);
        var b, c, d, e, f, g, h = [], i = !a.once && [], j = function(l) {
            for (b = a.memory && l,
            c = !0,
            g = e || 0,
            e = 0,
            f = h.length,
            d = !0; h && f > g; g++)
                if (h[g].apply(l[0], l[1]) === !1 && a.stopOnFalse) {
                    b = !1;
                    break
                }
            d = !1,
            h && (i ? i.length && j(i.shift()) : b ? h = [] : k.disable())
        }, k = {
            add: function() {
                if (h) {
                    var c = h.length;
                    !function g(b) {
                        n.each(b, function(b, c) {
                            var d = n.type(c);
                            "function" === d ? a.unique && k.has(c) || h.push(c) : c && c.length && "string" !== d && g(c)
                        })
                    }(arguments),
                    d ? f = h.length : b && (e = c,
                    j(b))
                }
                return this
            },
            remove: function() {
                return h && n.each(arguments, function(a, b) {
                    var c;
                    while ((c = n.inArray(b, h, c)) > -1)
                        h.splice(c, 1),
                        d && (f >= c && f--,
                        g >= c && g--)
                }),
                this
            },
            has: function(a) {
                return a ? n.inArray(a, h) > -1 : !(!h || !h.length)
            },
            empty: function() {
                return h = [],
                f = 0,
                this
            },
            disable: function() {
                return h = i = b = void 0,
                this
            },
            disabled: function() {
                return !h
            },
            lock: function() {
                return i = void 0,
                b || k.disable(),
                this
            },
            locked: function() {
                return !i
            },
            fireWith: function(a, b) {
                return !h || c && !i || (b = b || [],
                b = [a, b.slice ? b.slice() : b],
                d ? i.push(b) : j(b)),
                this
            },
            fire: function() {
                return k.fireWith(this, arguments),
                this
            },
            fired: function() {
                return !!c
            }
        };
        return k
    }
    ,
    n.extend({
        Deferred: function(a) {
            var b = [["resolve", "done", n.Callbacks("once memory"), "resolved"], ["reject", "fail", n.Callbacks("once memory"), "rejected"], ["notify", "progress", n.Callbacks("memory")]]
              , c = "pending"
              , d = {
                state: function() {
                    return c
                },
                always: function() {
                    return e.done(arguments).fail(arguments),
                    this
                },
                then: function() {
                    var a = arguments;
                    return n.Deferred(function(c) {
                        n.each(b, function(b, f) {
                            var g = n.isFunction(a[b]) && a[b];
                            e[f[1]](function() {
                                var a = g && g.apply(this, arguments);
                                a && n.isFunction(a.promise) ? a.promise().done(c.resolve).fail(c.reject).progress(c.notify) : c[f[0] + "With"](this === d ? c.promise() : this, g ? [a] : arguments)
                            })
                        }),
                        a = null
                    }).promise()
                },
                promise: function(a) {
                    return null != a ? n.extend(a, d) : d
                }
            }
              , e = {};
            return d.pipe = d.then,
            n.each(b, function(a, f) {
                var g = f[2]
                  , h = f[3];
                d[f[1]] = g.add,
                h && g.add(function() {
                    c = h
                }, b[1 ^ a][2].disable, b[2][2].lock),
                e[f[0]] = function() {
                    return e[f[0] + "With"](this === e ? d : this, arguments),
                    this
                }
                ,
                e[f[0] + "With"] = g.fireWith
            }),
            d.promise(e),
            a && a.call(e, e),
            e
        },
        when: function(a) {
            var b = 0, c = d.call(arguments), e = c.length, f = 1 !== e || a && n.isFunction(a.promise) ? e : 0, g = 1 === f ? a : n.Deferred(), h = function(a, b, c) {
                return function(e) {
                    b[a] = this,
                    c[a] = arguments.length > 1 ? d.call(arguments) : e,
                    c === i ? g.notifyWith(b, c) : --f || g.resolveWith(b, c)
                }
            }, i, j, k;
            if (e > 1)
                for (i = new Array(e),
                j = new Array(e),
                k = new Array(e); e > b; b++)
                    c[b] && n.isFunction(c[b].promise) ? c[b].promise().done(h(b, k, c)).fail(g.reject).progress(h(b, j, i)) : --f;
            return f || g.resolveWith(k, c),
            g.promise()
        }
    });
    var H;
    n.fn.ready = function(a) {
        return n.ready.promise().done(a),
        this
    }
    ,
    n.extend({
        isReady: !1,
        readyWait: 1,
        holdReady: function(a) {
            a ? n.readyWait++ : n.ready(!0)
        },
        ready: function(a) {
            (a === !0 ? --n.readyWait : n.isReady) || (n.isReady = !0,
            a !== !0 && --n.readyWait > 0 || (H.resolveWith(l, [n]),
            n.fn.triggerHandler && (n(l).triggerHandler("ready"),
            n(l).off("ready"))))
        }
    });
    function I() {
        l.removeEventListener("DOMContentLoaded", I, !1),
        a.removeEventListener("load", I, !1),
        n.ready()
    }
    n.ready.promise = function(b) {
        return H || (H = n.Deferred(),
        "complete" === l.readyState ? setTimeout(n.ready) : (l.addEventListener("DOMContentLoaded", I, !1),
        a.addEventListener("load", I, !1))),
        H.promise(b)
    }
    ,
    n.ready.promise();
    var J = n.access = function(a, b, c, d, e, f, g) {
        var h = 0
          , i = a.length
          , j = null == c;
        if ("object" === n.type(c)) {
            e = !0;
            for (h in c)
                n.access(a, b, h, c[h], !0, f, g)
        } else if (void 0 !== d && (e = !0,
        n.isFunction(d) || (g = !0),
        j && (g ? (b.call(a, d),
        b = null) : (j = b,
        b = function(a, b, c) {
            return j.call(n(a), c)
        }
        )),
        b))
            for (; i > h; h++)
                b(a[h], c, g ? d : d.call(a[h], h, b(a[h], c)));
        return e ? a : j ? b.call(a) : i ? b(a[0], c) : f
    }
    ;
    n.acceptData = function(a) {
        return 1 === a.nodeType || 9 === a.nodeType || !+a.nodeType
    }
    ;
    function K() {
        Object.defineProperty(this.cache = {}, 0, {
            get: function() {
                return {}
            }
        }),
        this.expando = n.expando + K.uid++
    }
    K.uid = 1,
    K.accepts = n.acceptData,
    K.prototype = {
        key: function(a) {
            if (!K.accepts(a))
                return 0;
            var b = {}
              , c = a[this.expando];
            if (!c) {
                c = K.uid++;
                try {
                    b[this.expando] = {
                        value: c
                    },
                    Object.defineProperties(a, b)
                } catch (d) {
                    b[this.expando] = c,
                    n.extend(a, b)
                }
            }
            return this.cache[c] || (this.cache[c] = {}),
            c
        },
        set: function(a, b, c) {
            var d, e = this.key(a), f = this.cache[e];
            if ("string" == typeof b)
                f[b] = c;
            else if (n.isEmptyObject(f))
                n.extend(this.cache[e], b);
            else
                for (d in b)
                    f[d] = b[d];
            return f
        },
        get: function(a, b) {
            var c = this.cache[this.key(a)];
            return void 0 === b ? c : c[b]
        },
        access: function(a, b, c) {
            var d;
            return void 0 === b || b && "string" == typeof b && void 0 === c ? (d = this.get(a, b),
            void 0 !== d ? d : this.get(a, n.camelCase(b))) : (this.set(a, b, c),
            void 0 !== c ? c : b)
        },
        remove: function(a, b) {
            var c, d, e, f = this.key(a), g = this.cache[f];
            if (void 0 === b)
                this.cache[f] = {};
            else {
                n.isArray(b) ? d = b.concat(b.map(n.camelCase)) : (e = n.camelCase(b),
                b in g ? d = [b, e] : (d = e,
                d = d in g ? [d] : d.match(E) || [])),
                c = d.length;
                while (c--)
                    delete g[d[c]]
            }
        },
        hasData: function(a) {
            return !n.isEmptyObject(this.cache[a[this.expando]] || {})
        },
        discard: function(a) {
            a[this.expando] && delete this.cache[a[this.expando]]
        }
    };
    var L = new K
      , M = new K
      , N = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/
      , O = /([A-Z])/g;
    function P(a, b, c) {
        var d;
        if (void 0 === c && 1 === a.nodeType)
            if (d = "data-" + b.replace(O, "-$1").toLowerCase(),
            c = a.getAttribute(d),
            "string" == typeof c) {
                try {
                    c = "true" === c ? !0 : "false" === c ? !1 : "null" === c ? null : +c + "" === c ? +c : N.test(c) ? n.parseJSON(c) : c
                } catch (e) {}
                M.set(a, b, c)
            } else
                c = void 0;
        return c
    }
    n.extend({
        hasData: function(a) {
            return M.hasData(a) || L.hasData(a)
        },
        data: function(a, b, c) {
            return M.access(a, b, c)
        },
        removeData: function(a, b) {
            M.remove(a, b)
        },
        _data: function(a, b, c) {
            return L.access(a, b, c)
        },
        _removeData: function(a, b) {
            L.remove(a, b)
        }
    }),
    n.fn.extend({
        data: function(a, b) {
            var c, d, e, f = this[0], g = f && f.attributes;
            if (void 0 === a) {
                if (this.length && (e = M.get(f),
                1 === f.nodeType && !L.get(f, "hasDataAttrs"))) {
                    c = g.length;
                    while (c--)
                        g[c] && (d = g[c].name,
                        0 === d.indexOf("data-") && (d = n.camelCase(d.slice(5)),
                        P(f, d, e[d])));
                    L.set(f, "hasDataAttrs", !0)
                }
                return e
            }
            return "object" == typeof a ? this.each(function() {
                M.set(this, a)
            }) : J(this, function(b) {
                var c, d = n.camelCase(a);
                if (f && void 0 === b) {
                    if (c = M.get(f, a),
                    void 0 !== c)
                        return c;
                    if (c = M.get(f, d),
                    void 0 !== c)
                        return c;
                    if (c = P(f, d, void 0),
                    void 0 !== c)
                        return c
                } else
                    this.each(function() {
                        var c = M.get(this, d);
                        M.set(this, d, b),
                        -1 !== a.indexOf("-") && void 0 !== c && M.set(this, a, b)
                    })
            }, null, b, arguments.length > 1, null, !0)
        },
        removeData: function(a) {
            return this.each(function() {
                M.remove(this, a)
            })
        }
    }),
    n.extend({
        queue: function(a, b, c) {
            var d;
            return a ? (b = (b || "fx") + "queue",
            d = L.get(a, b),
            c && (!d || n.isArray(c) ? d = L.access(a, b, n.makeArray(c)) : d.push(c)),
            d || []) : void 0
        },
        dequeue: function(a, b) {
            b = b || "fx";
            var c = n.queue(a, b)
              , d = c.length
              , e = c.shift()
              , f = n._queueHooks(a, b)
              , g = function() {
                n.dequeue(a, b)
            };
            "inprogress" === e && (e = c.shift(),
            d--),
            e && ("fx" === b && c.unshift("inprogress"),
            delete f.stop,
            e.call(a, g, f)),
            !d && f && f.empty.fire()
        },
        _queueHooks: function(a, b) {
            var c = b + "queueHooks";
            return L.get(a, c) || L.access(a, c, {
                empty: n.Callbacks("once memory").add(function() {
                    L.remove(a, [b + "queue", c])
                })
            })
        }
    }),
    n.fn.extend({
        queue: function(a, b) {
            var c = 2;
            return "string" != typeof a && (b = a,
            a = "fx",
            c--),
            arguments.length < c ? n.queue(this[0], a) : void 0 === b ? this : this.each(function() {
                var c = n.queue(this, a, b);
                n._queueHooks(this, a),
                "fx" === a && "inprogress" !== c[0] && n.dequeue(this, a)
            })
        },
        dequeue: function(a) {
            return this.each(function() {
                n.dequeue(this, a)
            })
        },
        clearQueue: function(a) {
            return this.queue(a || "fx", [])
        },
        promise: function(a, b) {
            var c, d = 1, e = n.Deferred(), f = this, g = this.length, h = function() {
                --d || e.resolveWith(f, [f])
            };
            "string" != typeof a && (b = a,
            a = void 0),
            a = a || "fx";
            while (g--)
                c = L.get(f[g], a + "queueHooks"),
                c && c.empty && (d++,
                c.empty.add(h));
            return h(),
            e.promise(b)
        }
    });
    var Q = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source
      , R = ["Top", "Right", "Bottom", "Left"]
      , S = function(a, b) {
        return a = b || a,
        "none" === n.css(a, "display") || !n.contains(a.ownerDocument, a)
    }
      , T = /^(?:checkbox|radio)$/i;
    !function() {
        var a = l.createDocumentFragment()
          , b = a.appendChild(l.createElement("div"))
          , c = l.createElement("input");
        c.setAttribute("type", "radio"),
        c.setAttribute("checked", "checked"),
        c.setAttribute("name", "t"),
        b.appendChild(c),
        k.checkClone = b.cloneNode(!0).cloneNode(!0).lastChild.checked,
        b.innerHTML = "<textarea>x</textarea>",
        k.noCloneChecked = !!b.cloneNode(!0).lastChild.defaultValue
    }();
    var U = "undefined";
    k.focusinBubbles = "onfocusin"in a;
    var V = /^key/
      , W = /^(?:mouse|pointer|contextmenu)|click/
      , X = /^(?:focusinfocus|focusoutblur)$/
      , Y = /^([^.]*)(?:\.(.+)|)$/;
    function Z() {
        return !0
    }
    function $() {
        return !1
    }
    function _() {
        try {
            return l.activeElement
        } catch (a) {}
    }
    n.event = {
        global: {},
        add: function(a, b, c, d, e) {
            var f, g, h, i, j, k, l, m, o, p, q, r = L.get(a);
            if (r) {
                c.handler && (f = c,
                c = f.handler,
                e = f.selector),
                c.guid || (c.guid = n.guid++),
                (i = r.events) || (i = r.events = {}),
                (g = r.handle) || (g = r.handle = function(b) {
                    return typeof n !== U && n.event.triggered !== b.type ? n.event.dispatch.apply(a, arguments) : void 0
                }
                ),
                b = (b || "").match(E) || [""],
                j = b.length;
                while (j--)
                    h = Y.exec(b[j]) || [],
                    o = q = h[1],
                    p = (h[2] || "").split(".").sort(),
                    o && (l = n.event.special[o] || {},
                    o = (e ? l.delegateType : l.bindType) || o,
                    l = n.event.special[o] || {},
                    k = n.extend({
                        type: o,
                        origType: q,
                        data: d,
                        handler: c,
                        guid: c.guid,
                        selector: e,
                        needsContext: e && n.expr.match.needsContext.test(e),
                        namespace: p.join(".")
                    }, f),
                    (m = i[o]) || (m = i[o] = [],
                    m.delegateCount = 0,
                    l.setup && l.setup.call(a, d, p, g) !== !1 || a.addEventListener && a.addEventListener(o, g, !1)),
                    l.add && (l.add.call(a, k),
                    k.handler.guid || (k.handler.guid = c.guid)),
                    e ? m.splice(m.delegateCount++, 0, k) : m.push(k),
                    n.event.global[o] = !0)
            }
        },
        remove: function(a, b, c, d, e) {
            var f, g, h, i, j, k, l, m, o, p, q, r = L.hasData(a) && L.get(a);
            if (r && (i = r.events)) {
                b = (b || "").match(E) || [""],
                j = b.length;
                while (j--)
                    if (h = Y.exec(b[j]) || [],
                    o = q = h[1],
                    p = (h[2] || "").split(".").sort(),
                    o) {
                        l = n.event.special[o] || {},
                        o = (d ? l.delegateType : l.bindType) || o,
                        m = i[o] || [],
                        h = h[2] && new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                        g = f = m.length;
                        while (f--)
                            k = m[f],
                            !e && q !== k.origType || c && c.guid !== k.guid || h && !h.test(k.namespace) || d && d !== k.selector && ("**" !== d || !k.selector) || (m.splice(f, 1),
                            k.selector && m.delegateCount--,
                            l.remove && l.remove.call(a, k));
                        g && !m.length && (l.teardown && l.teardown.call(a, p, r.handle) !== !1 || n.removeEvent(a, o, r.handle),
                        delete i[o])
                    } else
                        for (o in i)
                            n.event.remove(a, o + b[j], c, d, !0);
                n.isEmptyObject(i) && (delete r.handle,
                L.remove(a, "events"))
            }
        },
        trigger: function(b, c, d, e) {
            var f, g, h, i, k, m, o, p = [d || l], q = j.call(b, "type") ? b.type : b, r = j.call(b, "namespace") ? b.namespace.split(".") : [];
            if (g = h = d = d || l,
            3 !== d.nodeType && 8 !== d.nodeType && !X.test(q + n.event.triggered) && (q.indexOf(".") >= 0 && (r = q.split("."),
            q = r.shift(),
            r.sort()),
            k = q.indexOf(":") < 0 && "on" + q,
            b = b[n.expando] ? b : new n.Event(q,"object" == typeof b && b),
            b.isTrigger = e ? 2 : 3,
            b.namespace = r.join("."),
            b.namespace_re = b.namespace ? new RegExp("(^|\\.)" + r.join("\\.(?:.*\\.|)") + "(\\.|$)") : null,
            b.result = void 0,
            b.target || (b.target = d),
            c = null == c ? [b] : n.makeArray(c, [b]),
            o = n.event.special[q] || {},
            e || !o.trigger || o.trigger.apply(d, c) !== !1)) {
                if (!e && !o.noBubble && !n.isWindow(d)) {
                    for (i = o.delegateType || q,
                    X.test(i + q) || (g = g.parentNode); g; g = g.parentNode)
                        p.push(g),
                        h = g;
                    h === (d.ownerDocument || l) && p.push(h.defaultView || h.parentWindow || a)
                }
                f = 0;
                while ((g = p[f++]) && !b.isPropagationStopped())
                    b.type = f > 1 ? i : o.bindType || q,
                    m = (L.get(g, "events") || {})[b.type] && L.get(g, "handle"),
                    m && m.apply(g, c),
                    m = k && g[k],
                    m && m.apply && n.acceptData(g) && (b.result = m.apply(g, c),
                    b.result === !1 && b.preventDefault());
                return b.type = q,
                e || b.isDefaultPrevented() || o._default && o._default.apply(p.pop(), c) !== !1 || !n.acceptData(d) || k && n.isFunction(d[q]) && !n.isWindow(d) && (h = d[k],
                h && (d[k] = null),
                n.event.triggered = q,
                d[q](),
                n.event.triggered = void 0,
                h && (d[k] = h)),
                b.result
            }
        },
        dispatch: function(a) {
            a = n.event.fix(a);
            var b, c, e, f, g, h = [], i = d.call(arguments), j = (L.get(this, "events") || {})[a.type] || [], k = n.event.special[a.type] || {};
            if (i[0] = a,
            a.delegateTarget = this,
            !k.preDispatch || k.preDispatch.call(this, a) !== !1) {
                h = n.event.handlers.call(this, a, j),
                b = 0;
                while ((f = h[b++]) && !a.isPropagationStopped()) {
                    a.currentTarget = f.elem,
                    c = 0;
                    while ((g = f.handlers[c++]) && !a.isImmediatePropagationStopped())
                        (!a.namespace_re || a.namespace_re.test(g.namespace)) && (a.handleObj = g,
                        a.data = g.data,
                        e = ((n.event.special[g.origType] || {}).handle || g.handler).apply(f.elem, i),
                        void 0 !== e && (a.result = e) === !1 && (a.preventDefault(),
                        a.stopPropagation()))
                }
                return k.postDispatch && k.postDispatch.call(this, a),
                a.result
            }
        },
        handlers: function(a, b) {
            var c, d, e, f, g = [], h = b.delegateCount, i = a.target;
            if (h && i.nodeType && (!a.button || "click" !== a.type))
                for (; i !== this; i = i.parentNode || this)
                    if (i.disabled !== !0 || "click" !== a.type) {
                        for (d = [],
                        c = 0; h > c; c++)
                            f = b[c],
                            e = f.selector + " ",
                            void 0 === d[e] && (d[e] = f.needsContext ? n(e, this).index(i) >= 0 : n.find(e, this, null, [i]).length),
                            d[e] && d.push(f);
                        d.length && g.push({
                            elem: i,
                            handlers: d
                        })
                    }
            return h < b.length && g.push({
                elem: this,
                handlers: b.slice(h)
            }),
            g
        },
        props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
        fixHooks: {},
        keyHooks: {
            props: "char charCode key keyCode".split(" "),
            filter: function(a, b) {
                return null == a.which && (a.which = null != b.charCode ? b.charCode : b.keyCode),
                a
            }
        },
        mouseHooks: {
            props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
            filter: function(a, b) {
                var c, d, e, f = b.button;
                return null == a.pageX && null != b.clientX && (c = a.target.ownerDocument || l,
                d = c.documentElement,
                e = c.body,
                a.pageX = b.clientX + (d && d.scrollLeft || e && e.scrollLeft || 0) - (d && d.clientLeft || e && e.clientLeft || 0),
                a.pageY = b.clientY + (d && d.scrollTop || e && e.scrollTop || 0) - (d && d.clientTop || e && e.clientTop || 0)),
                a.which || void 0 === f || (a.which = 1 & f ? 1 : 2 & f ? 3 : 4 & f ? 2 : 0),
                a
            }
        },
        fix: function(a) {
            if (a[n.expando])
                return a;
            var b, c, d, e = a.type, f = a, g = this.fixHooks[e];
            g || (this.fixHooks[e] = g = W.test(e) ? this.mouseHooks : V.test(e) ? this.keyHooks : {}),
            d = g.props ? this.props.concat(g.props) : this.props,
            a = new n.Event(f),
            b = d.length;
            while (b--)
                c = d[b],
                a[c] = f[c];
            return a.target || (a.target = l),
            3 === a.target.nodeType && (a.target = a.target.parentNode),
            g.filter ? g.filter(a, f) : a
        },
        special: {
            load: {
                noBubble: !0
            },
            focus: {
                trigger: function() {
                    return this !== _() && this.focus ? (this.focus(),
                    !1) : void 0
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function() {
                    return this === _() && this.blur ? (this.blur(),
                    !1) : void 0
                },
                delegateType: "focusout"
            },
            click: {
                trigger: function() {
                    return "checkbox" === this.type && this.click && n.nodeName(this, "input") ? (this.click(),
                    !1) : void 0
                },
                _default: function(a) {
                    return n.nodeName(a.target, "a")
                }
            },
            beforeunload: {
                postDispatch: function(a) {
                    void 0 !== a.result && a.originalEvent && (a.originalEvent.returnValue = a.result)
                }
            }
        },
        simulate: function(a, b, c, d) {
            var e = n.extend(new n.Event, c, {
                type: a,
                isSimulated: !0,
                originalEvent: {}
            });
            d ? n.event.trigger(e, null, b) : n.event.dispatch.call(b, e),
            e.isDefaultPrevented() && c.preventDefault()
        }
    },
    n.removeEvent = function(a, b, c) {
        a.removeEventListener && a.removeEventListener(b, c, !1)
    }
    ,
    n.Event = function(a, b) {
        return this instanceof n.Event ? (a && a.type ? (this.originalEvent = a,
        this.type = a.type,
        this.isDefaultPrevented = a.defaultPrevented || void 0 === a.defaultPrevented && a.returnValue === !1 ? Z : $) : this.type = a,
        b && n.extend(this, b),
        this.timeStamp = a && a.timeStamp || n.now(),
        void (this[n.expando] = !0)) : new n.Event(a,b)
    }
    ,
    n.Event.prototype = {
        isDefaultPrevented: $,
        isPropagationStopped: $,
        isImmediatePropagationStopped: $,
        preventDefault: function() {
            var a = this.originalEvent;
            this.isDefaultPrevented = Z,
            a && a.preventDefault && a.preventDefault()
        },
        stopPropagation: function() {
            var a = this.originalEvent;
            this.isPropagationStopped = Z,
            a && a.stopPropagation && a.stopPropagation()
        },
        stopImmediatePropagation: function() {
            var a = this.originalEvent;
            this.isImmediatePropagationStopped = Z,
            a && a.stopImmediatePropagation && a.stopImmediatePropagation(),
            this.stopPropagation()
        }
    },
    n.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(a, b) {
        n.event.special[a] = {
            delegateType: b,
            bindType: b,
            handle: function(a) {
                var c, d = this, e = a.relatedTarget, f = a.handleObj;
                return (!e || e !== d && !n.contains(d, e)) && (a.type = f.origType,
                c = f.handler.apply(this, arguments),
                a.type = b),
                c
            }
        }
    }),
    k.focusinBubbles || n.each({
        focus: "focusin",
        blur: "focusout"
    }, function(a, b) {
        var c = function(a) {
            n.event.simulate(b, a.target, n.event.fix(a), !0)
        };
        n.event.special[b] = {
            setup: function() {
                var d = this.ownerDocument || this
                  , e = L.access(d, b);
                e || d.addEventListener(a, c, !0),
                L.access(d, b, (e || 0) + 1)
            },
            teardown: function() {
                var d = this.ownerDocument || this
                  , e = L.access(d, b) - 1;
                e ? L.access(d, b, e) : (d.removeEventListener(a, c, !0),
                L.remove(d, b))
            }
        }
    }),
    n.fn.extend({
        on: function(a, b, c, d, e) {
            var f, g;
            if ("object" == typeof a) {
                "string" != typeof b && (c = c || b,
                b = void 0);
                for (g in a)
                    this.on(g, b, c, a[g], e);
                return this
            }
            if (null == c && null == d ? (d = b,
            c = b = void 0) : null == d && ("string" == typeof b ? (d = c,
            c = void 0) : (d = c,
            c = b,
            b = void 0)),
            d === !1)
                d = $;
            else if (!d)
                return this;
            return 1 === e && (f = d,
            d = function(a) {
                return n().off(a),
                f.apply(this, arguments)
            }
            ,
            d.guid = f.guid || (f.guid = n.guid++)),
            this.each(function() {
                n.event.add(this, a, d, c, b)
            })
        },
        one: function(a, b, c, d) {
            return this.on(a, b, c, d, 1)
        },
        off: function(a, b, c) {
            var d, e;
            if (a && a.preventDefault && a.handleObj)
                return d = a.handleObj,
                n(a.delegateTarget).off(d.namespace ? d.origType + "." + d.namespace : d.origType, d.selector, d.handler),
                this;
            if ("object" == typeof a) {
                for (e in a)
                    this.off(e, b, a[e]);
                return this
            }
            return (b === !1 || "function" == typeof b) && (c = b,
            b = void 0),
            c === !1 && (c = $),
            this.each(function() {
                n.event.remove(this, a, c, b)
            })
        },
        trigger: function(a, b) {
            return this.each(function() {
                n.event.trigger(a, b, this)
            })
        },
        triggerHandler: function(a, b) {
            var c = this[0];
            return c ? n.event.trigger(a, b, c, !0) : void 0
        }
    });
    var aa = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi
      , ba = /<([\w:]+)/
      , ca = /<|&#?\w+;/
      , da = /<(?:script|style|link)/i
      , ea = /checked\s*(?:[^=]|=\s*.checked.)/i
      , fa = /^$|\/(?:java|ecma)script/i
      , ga = /^true\/(.*)/
      , ha = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g
      , ia = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
    };
    ia.optgroup = ia.option,
    ia.tbody = ia.tfoot = ia.colgroup = ia.caption = ia.thead,
    ia.th = ia.td;
    function ja(a, b) {
        return n.nodeName(a, "table") && n.nodeName(11 !== b.nodeType ? b : b.firstChild, "tr") ? a.getElementsByTagName("tbody")[0] || a.appendChild(a.ownerDocument.createElement("tbody")) : a
    }
    function ka(a) {
        return a.type = (null !== a.getAttribute("type")) + "/" + a.type,
        a
    }
    function la(a) {
        var b = ga.exec(a.type);
        return b ? a.type = b[1] : a.removeAttribute("type"),
        a
    }
    function ma(a, b) {
        for (var c = 0, d = a.length; d > c; c++)
            L.set(a[c], "globalEval", !b || L.get(b[c], "globalEval"))
    }
    function na(a, b) {
        var c, d, e, f, g, h, i, j;
        if (1 === b.nodeType) {
            if (L.hasData(a) && (f = L.access(a),
            g = L.set(b, f),
            j = f.events)) {
                delete g.handle,
                g.events = {};
                for (e in j)
                    for (c = 0,
                    d = j[e].length; d > c; c++)
                        n.event.add(b, e, j[e][c])
            }
            M.hasData(a) && (h = M.access(a),
            i = n.extend({}, h),
            M.set(b, i))
        }
    }
    function oa(a, b) {
        var c = a.getElementsByTagName ? a.getElementsByTagName(b || "*") : a.querySelectorAll ? a.querySelectorAll(b || "*") : [];
        return void 0 === b || b && n.nodeName(a, b) ? n.merge([a], c) : c
    }
    function pa(a, b) {
        var c = b.nodeName.toLowerCase();
        "input" === c && T.test(a.type) ? b.checked = a.checked : ("input" === c || "textarea" === c) && (b.defaultValue = a.defaultValue)
    }
    n.extend({
        clone: function(a, b, c) {
            var d, e, f, g, h = a.cloneNode(!0), i = n.contains(a.ownerDocument, a);
            if (!(k.noCloneChecked || 1 !== a.nodeType && 11 !== a.nodeType || n.isXMLDoc(a)))
                for (g = oa(h),
                f = oa(a),
                d = 0,
                e = f.length; e > d; d++)
                    pa(f[d], g[d]);
            if (b)
                if (c)
                    for (f = f || oa(a),
                    g = g || oa(h),
                    d = 0,
                    e = f.length; e > d; d++)
                        na(f[d], g[d]);
                else
                    na(a, h);
            return g = oa(h, "script"),
            g.length > 0 && ma(g, !i && oa(a, "script")),
            h
        },
        buildFragment: function(a, b, c, d) {
            for (var e, f, g, h, i, j, k = b.createDocumentFragment(), l = [], m = 0, o = a.length; o > m; m++)
                if (e = a[m],
                e || 0 === e)
                    if ("object" === n.type(e))
                        n.merge(l, e.nodeType ? [e] : e);
                    else if (ca.test(e)) {
                        f = f || k.appendChild(b.createElement("div")),
                        g = (ba.exec(e) || ["", ""])[1].toLowerCase(),
                        h = ia[g] || ia._default,
                        f.innerHTML = h[1] + e.replace(aa, "<$1></$2>") + h[2],
                        j = h[0];
                        while (j--)
                            f = f.lastChild;
                        n.merge(l, f.childNodes),
                        f = k.firstChild,
                        f.textContent = ""
                    } else
                        l.push(b.createTextNode(e));
            k.textContent = "",
            m = 0;
            while (e = l[m++])
                if ((!d || -1 === n.inArray(e, d)) && (i = n.contains(e.ownerDocument, e),
                f = oa(k.appendChild(e), "script"),
                i && ma(f),
                c)) {
                    j = 0;
                    while (e = f[j++])
                        fa.test(e.type || "") && c.push(e)
                }
            return k
        },
        cleanData: function(a) {
            for (var b, c, d, e, f = n.event.special, g = 0; void 0 !== (c = a[g]); g++) {
                if (n.acceptData(c) && (e = c[L.expando],
                e && (b = L.cache[e]))) {
                    if (b.events)
                        for (d in b.events)
                            f[d] ? n.event.remove(c, d) : n.removeEvent(c, d, b.handle);
                    L.cache[e] && delete L.cache[e]
                }
                delete M.cache[c[M.expando]]
            }
        }
    }),
    n.fn.extend({
        text: function(a) {
            return J(this, function(a) {
                return void 0 === a ? n.text(this) : this.empty().each(function() {
                    (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) && (this.textContent = a)
                })
            }, null, a, arguments.length)
        },
        append: function() {
            return this.domManip(arguments, function(a) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var b = ja(this, a);
                    b.appendChild(a)
                }
            })
        },
        prepend: function() {
            return this.domManip(arguments, function(a) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var b = ja(this, a);
                    b.insertBefore(a, b.firstChild)
                }
            })
        },
        before: function() {
            return this.domManip(arguments, function(a) {
                this.parentNode && this.parentNode.insertBefore(a, this)
            })
        },
        after: function() {
            return this.domManip(arguments, function(a) {
                this.parentNode && this.parentNode.insertBefore(a, this.nextSibling)
            })
        },
        remove: function(a, b) {
            for (var c, d = a ? n.filter(a, this) : this, e = 0; null != (c = d[e]); e++)
                b || 1 !== c.nodeType || n.cleanData(oa(c)),
                c.parentNode && (b && n.contains(c.ownerDocument, c) && ma(oa(c, "script")),
                c.parentNode.removeChild(c));
            return this
        },
        empty: function() {
            for (var a, b = 0; null != (a = this[b]); b++)
                1 === a.nodeType && (n.cleanData(oa(a, !1)),
                a.textContent = "");
            return this
        },
        clone: function(a, b) {
            return a = null == a ? !1 : a,
            b = null == b ? a : b,
            this.map(function() {
                return n.clone(this, a, b)
            })
        },
        html: function(a) {
            return J(this, function(a) {
                var b = this[0] || {}
                  , c = 0
                  , d = this.length;
                if (void 0 === a && 1 === b.nodeType)
                    return b.innerHTML;
                if ("string" == typeof a && !da.test(a) && !ia[(ba.exec(a) || ["", ""])[1].toLowerCase()]) {
                    a = a.replace(aa, "<$1></$2>");
                    try {
                        for (; d > c; c++)
                            b = this[c] || {},
                            1 === b.nodeType && (n.cleanData(oa(b, !1)),
                            b.innerHTML = a);
                        b = 0
                    } catch (e) {}
                }
                b && this.empty().append(a)
            }, null, a, arguments.length)
        },
        replaceWith: function() {
            var a = arguments[0];
            return this.domManip(arguments, function(b) {
                a = this.parentNode,
                n.cleanData(oa(this)),
                a && a.replaceChild(b, this)
            }),
            a && (a.length || a.nodeType) ? this : this.remove()
        },
        detach: function(a) {
            return this.remove(a, !0)
        },
        domManip: function(a, b) {
            a = e.apply([], a);
            var c, d, f, g, h, i, j = 0, l = this.length, m = this, o = l - 1, p = a[0], q = n.isFunction(p);
            if (q || l > 1 && "string" == typeof p && !k.checkClone && ea.test(p))
                return this.each(function(c) {
                    var d = m.eq(c);
                    q && (a[0] = p.call(this, c, d.html())),
                    d.domManip(a, b)
                });
            if (l && (c = n.buildFragment(a, this[0].ownerDocument, !1, this),
            d = c.firstChild,
            1 === c.childNodes.length && (c = d),
            d)) {
                for (f = n.map(oa(c, "script"), ka),
                g = f.length; l > j; j++)
                    h = c,
                    j !== o && (h = n.clone(h, !0, !0),
                    g && n.merge(f, oa(h, "script"))),
                    b.call(this[j], h, j);
                if (g)
                    for (i = f[f.length - 1].ownerDocument,
                    n.map(f, la),
                    j = 0; g > j; j++)
                        h = f[j],
                        fa.test(h.type || "") && !L.access(h, "globalEval") && n.contains(i, h) && (h.src ? n._evalUrl && n._evalUrl(h.src) : n.globalEval(h.textContent.replace(ha, "")))
            }
            return this
        }
    }),
    n.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(a, b) {
        n.fn[a] = function(a) {
            for (var c, d = [], e = n(a), g = e.length - 1, h = 0; g >= h; h++)
                c = h === g ? this : this.clone(!0),
                n(e[h])[b](c),
                f.apply(d, c.get());
            return this.pushStack(d)
        }
    });
    var qa, ra = {};
    function sa(b, c) {
        var d, e = n(c.createElement(b)).appendTo(c.body), f = a.getDefaultComputedStyle && (d = a.getDefaultComputedStyle(e[0])) ? d.display : n.css(e[0], "display");
        return e.detach(),
        f
    }
    function ta(a) {
        var b = l
          , c = ra[a];
        return c || (c = sa(a, b),
        "none" !== c && c || (qa = (qa || n("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement),
        b = qa[0].contentDocument,
        b.write(),
        b.close(),
        c = sa(a, b),
        qa.detach()),
        ra[a] = c),
        c
    }
    var ua = /^margin/
      , va = new RegExp("^(" + Q + ")(?!px)[a-z%]+$","i")
      , wa = function(b) {
        return b.ownerDocument.defaultView.opener ? b.ownerDocument.defaultView.getComputedStyle(b, null) : a.getComputedStyle(b, null)
    };
    function xa(a, b, c) {
        var d, e, f, g, h = a.style;
        return c = c || wa(a),
        c && (g = c.getPropertyValue(b) || c[b]),
        c && ("" !== g || n.contains(a.ownerDocument, a) || (g = n.style(a, b)),
        va.test(g) && ua.test(b) && (d = h.width,
        e = h.minWidth,
        f = h.maxWidth,
        h.minWidth = h.maxWidth = h.width = g,
        g = c.width,
        h.width = d,
        h.minWidth = e,
        h.maxWidth = f)),
        void 0 !== g ? g + "" : g
    }
    function ya(a, b) {
        return {
            get: function() {
                return a() ? void delete this.get : (this.get = b).apply(this, arguments)
            }
        }
    }
    !function() {
        var b, c, d = l.documentElement, e = l.createElement("div"), f = l.createElement("div");
        if (f.style) {
            f.style.backgroundClip = "content-box",
            f.cloneNode(!0).style.backgroundClip = "",
            k.clearCloneStyle = "content-box" === f.style.backgroundClip,
            e.style.cssText = "border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;position:absolute",
            e.appendChild(f);
            function g() {
                f.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute",
                f.innerHTML = "",
                d.appendChild(e);
                var g = a.getComputedStyle(f, null);
                b = "1%" !== g.top,
                c = "4px" === g.width,
                d.removeChild(e)
            }
            a.getComputedStyle && n.extend(k, {
                pixelPosition: function() {
                    return g(),
                    b
                },
                boxSizingReliable: function() {
                    return null == c && g(),
                    c
                },
                reliableMarginRight: function() {
                    var b, c = f.appendChild(l.createElement("div"));
                    return c.style.cssText = f.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0",
                    c.style.marginRight = c.style.width = "0",
                    f.style.width = "1px",
                    d.appendChild(e),
                    b = !parseFloat(a.getComputedStyle(c, null).marginRight),
                    d.removeChild(e),
                    f.removeChild(c),
                    b
                }
            })
        }
    }(),
    n.swap = function(a, b, c, d) {
        var e, f, g = {};
        for (f in b)
            g[f] = a.style[f],
            a.style[f] = b[f];
        e = c.apply(a, d || []);
        for (f in b)
            a.style[f] = g[f];
        return e
    }
    ;
    var za = /^(none|table(?!-c[ea]).+)/
      , Aa = new RegExp("^(" + Q + ")(.*)$","i")
      , Ba = new RegExp("^([+-])=(" + Q + ")","i")
      , Ca = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }
      , Da = {
        letterSpacing: "0",
        fontWeight: "400"
    }
      , Ea = ["Webkit", "O", "Moz", "ms"];
    function Fa(a, b) {
        if (b in a)
            return b;
        var c = b[0].toUpperCase() + b.slice(1)
          , d = b
          , e = Ea.length;
        while (e--)
            if (b = Ea[e] + c,
            b in a)
                return b;
        return d
    }
    function Ga(a, b, c) {
        var d = Aa.exec(b);
        return d ? Math.max(0, d[1] - (c || 0)) + (d[2] || "px") : b
    }
    function Ha(a, b, c, d, e) {
        for (var f = c === (d ? "border" : "content") ? 4 : "width" === b ? 1 : 0, g = 0; 4 > f; f += 2)
            "margin" === c && (g += n.css(a, c + R[f], !0, e)),
            d ? ("content" === c && (g -= n.css(a, "padding" + R[f], !0, e)),
            "margin" !== c && (g -= n.css(a, "border" + R[f] + "Width", !0, e))) : (g += n.css(a, "padding" + R[f], !0, e),
            "padding" !== c && (g += n.css(a, "border" + R[f] + "Width", !0, e)));
        return g
    }
    function Ia(a, b, c) {
        var d = !0
          , e = "width" === b ? a.offsetWidth : a.offsetHeight
          , f = wa(a)
          , g = "border-box" === n.css(a, "boxSizing", !1, f);
        if (0 >= e || null == e) {
            if (e = xa(a, b, f),
            (0 > e || null == e) && (e = a.style[b]),
            va.test(e))
                return e;
            d = g && (k.boxSizingReliable() || e === a.style[b]),
            e = parseFloat(e) || 0
        }
        return e + Ha(a, b, c || (g ? "border" : "content"), d, f) + "px"
    }
    function Ja(a, b) {
        for (var c, d, e, f = [], g = 0, h = a.length; h > g; g++)
            d = a[g],
            d.style && (f[g] = L.get(d, "olddisplay"),
            c = d.style.display,
            b ? (f[g] || "none" !== c || (d.style.display = ""),
            "" === d.style.display && S(d) && (f[g] = L.access(d, "olddisplay", ta(d.nodeName)))) : (e = S(d),
            "none" === c && e || L.set(d, "olddisplay", e ? c : n.css(d, "display"))));
        for (g = 0; h > g; g++)
            d = a[g],
            d.style && (b && "none" !== d.style.display && "" !== d.style.display || (d.style.display = b ? f[g] || "" : "none"));
        return a
    }
    n.extend({
        cssHooks: {
            opacity: {
                get: function(a, b) {
                    if (b) {
                        var c = xa(a, "opacity");
                        return "" === c ? "1" : c
                    }
                }
            }
        },
        cssNumber: {
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {
            "float": "cssFloat"
        },
        style: function(a, b, c, d) {
            if (a && 3 !== a.nodeType && 8 !== a.nodeType && a.style) {
                var e, f, g, h = n.camelCase(b), i = a.style;
                return b = n.cssProps[h] || (n.cssProps[h] = Fa(i, h)),
                g = n.cssHooks[b] || n.cssHooks[h],
                void 0 === c ? g && "get"in g && void 0 !== (e = g.get(a, !1, d)) ? e : i[b] : (f = typeof c,
                "string" === f && (e = Ba.exec(c)) && (c = (e[1] + 1) * e[2] + parseFloat(n.css(a, b)),
                f = "number"),
                null != c && c === c && ("number" !== f || n.cssNumber[h] || (c += "px"),
                k.clearCloneStyle || "" !== c || 0 !== b.indexOf("background") || (i[b] = "inherit"),
                g && "set"in g && void 0 === (c = g.set(a, c, d)) || (i[b] = c)),
                void 0)
            }
        },
        css: function(a, b, c, d) {
            var e, f, g, h = n.camelCase(b);
            return b = n.cssProps[h] || (n.cssProps[h] = Fa(a.style, h)),
            g = n.cssHooks[b] || n.cssHooks[h],
            g && "get"in g && (e = g.get(a, !0, c)),
            void 0 === e && (e = xa(a, b, d)),
            "normal" === e && b in Da && (e = Da[b]),
            "" === c || c ? (f = parseFloat(e),
            c === !0 || n.isNumeric(f) ? f || 0 : e) : e
        }
    }),
    n.each(["height", "width"], function(a, b) {
        n.cssHooks[b] = {
            get: function(a, c, d) {
                return c ? za.test(n.css(a, "display")) && 0 === a.offsetWidth ? n.swap(a, Ca, function() {
                    return Ia(a, b, d)
                }) : Ia(a, b, d) : void 0
            },
            set: function(a, c, d) {
                var e = d && wa(a);
                return Ga(a, c, d ? Ha(a, b, d, "border-box" === n.css(a, "boxSizing", !1, e), e) : 0)
            }
        }
    }),
    n.cssHooks.marginRight = ya(k.reliableMarginRight, function(a, b) {
        return b ? n.swap(a, {
            display: "inline-block"
        }, xa, [a, "marginRight"]) : void 0
    }),
    n.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(a, b) {
        n.cssHooks[a + b] = {
            expand: function(c) {
                for (var d = 0, e = {}, f = "string" == typeof c ? c.split(" ") : [c]; 4 > d; d++)
                    e[a + R[d] + b] = f[d] || f[d - 2] || f[0];
                return e
            }
        },
        ua.test(a) || (n.cssHooks[a + b].set = Ga)
    }),
    n.fn.extend({
        css: function(a, b) {
            return J(this, function(a, b, c) {
                var d, e, f = {}, g = 0;
                if (n.isArray(b)) {
                    for (d = wa(a),
                    e = b.length; e > g; g++)
                        f[b[g]] = n.css(a, b[g], !1, d);
                    return f
                }
                return void 0 !== c ? n.style(a, b, c) : n.css(a, b)
            }, a, b, arguments.length > 1)
        },
        show: function() {
            return Ja(this, !0)
        },
        hide: function() {
            return Ja(this)
        },
        toggle: function(a) {
            return "boolean" == typeof a ? a ? this.show() : this.hide() : this.each(function() {
                S(this) ? n(this).show() : n(this).hide()
            })
        }
    });
    function Ka(a, b, c, d, e) {
        return new Ka.prototype.init(a,b,c,d,e)
    }
    n.Tween = Ka,
    Ka.prototype = {
        constructor: Ka,
        init: function(a, b, c, d, e, f) {
            this.elem = a,
            this.prop = c,
            this.easing = e || "swing",
            this.options = b,
            this.start = this.now = this.cur(),
            this.end = d,
            this.unit = f || (n.cssNumber[c] ? "" : "px")
        },
        cur: function() {
            var a = Ka.propHooks[this.prop];
            return a && a.get ? a.get(this) : Ka.propHooks._default.get(this)
        },
        run: function(a) {
            var b, c = Ka.propHooks[this.prop];
            return this.options.duration ? this.pos = b = n.easing[this.easing](a, this.options.duration * a, 0, 1, this.options.duration) : this.pos = b = a,
            this.now = (this.end - this.start) * b + this.start,
            this.options.step && this.options.step.call(this.elem, this.now, this),
            c && c.set ? c.set(this) : Ka.propHooks._default.set(this),
            this
        }
    },
    Ka.prototype.init.prototype = Ka.prototype,
    Ka.propHooks = {
        _default: {
            get: function(a) {
                var b;
                return null == a.elem[a.prop] || a.elem.style && null != a.elem.style[a.prop] ? (b = n.css(a.elem, a.prop, ""),
                b && "auto" !== b ? b : 0) : a.elem[a.prop]
            },
            set: function(a) {
                n.fx.step[a.prop] ? n.fx.step[a.prop](a) : a.elem.style && (null != a.elem.style[n.cssProps[a.prop]] || n.cssHooks[a.prop]) ? n.style(a.elem, a.prop, a.now + a.unit) : a.elem[a.prop] = a.now
            }
        }
    },
    Ka.propHooks.scrollTop = Ka.propHooks.scrollLeft = {
        set: function(a) {
            a.elem.nodeType && a.elem.parentNode && (a.elem[a.prop] = a.now)
        }
    },
    n.easing = {
        linear: function(a) {
            return a
        },
        swing: function(a) {
            return .5 - Math.cos(a * Math.PI) / 2
        }
    },
    n.fx = Ka.prototype.init,
    n.fx.step = {};
    var La, Ma, Na = /^(?:toggle|show|hide)$/, Oa = new RegExp("^(?:([+-])=|)(" + Q + ")([a-z%]*)$","i"), Pa = /queueHooks$/, Qa = [Va], Ra = {
        "*": [function(a, b) {
            var c = this.createTween(a, b)
              , d = c.cur()
              , e = Oa.exec(b)
              , f = e && e[3] || (n.cssNumber[a] ? "" : "px")
              , g = (n.cssNumber[a] || "px" !== f && +d) && Oa.exec(n.css(c.elem, a))
              , h = 1
              , i = 20;
            if (g && g[3] !== f) {
                f = f || g[3],
                e = e || [],
                g = +d || 1;
                do
                    h = h || ".5",
                    g /= h,
                    n.style(c.elem, a, g + f);
                while (h !== (h = c.cur() / d) && 1 !== h && --i)
            }
            return e && (g = c.start = +g || +d || 0,
            c.unit = f,
            c.end = e[1] ? g + (e[1] + 1) * e[2] : +e[2]),
            c
        }
        ]
    };
    function Sa() {
        return setTimeout(function() {
            La = void 0
        }),
        La = n.now()
    }
    function Ta(a, b) {
        var c, d = 0, e = {
            height: a
        };
        for (b = b ? 1 : 0; 4 > d; d += 2 - b)
            c = R[d],
            e["margin" + c] = e["padding" + c] = a;
        return b && (e.opacity = e.width = a),
        e
    }
    function Ua(a, b, c) {
        for (var d, e = (Ra[b] || []).concat(Ra["*"]), f = 0, g = e.length; g > f; f++)
            if (d = e[f].call(c, b, a))
                return d
    }
    function Va(a, b, c) {
        var d, e, f, g, h, i, j, k, l = this, m = {}, o = a.style, p = a.nodeType && S(a), q = L.get(a, "fxshow");
        c.queue || (h = n._queueHooks(a, "fx"),
        null == h.unqueued && (h.unqueued = 0,
        i = h.empty.fire,
        h.empty.fire = function() {
            h.unqueued || i()
        }
        ),
        h.unqueued++,
        l.always(function() {
            l.always(function() {
                h.unqueued--,
                n.queue(a, "fx").length || h.empty.fire()
            })
        })),
        1 === a.nodeType && ("height"in b || "width"in b) && (c.overflow = [o.overflow, o.overflowX, o.overflowY],
        j = n.css(a, "display"),
        k = "none" === j ? L.get(a, "olddisplay") || ta(a.nodeName) : j,
        "inline" === k && "none" === n.css(a, "float") && (o.display = "inline-block")),
        c.overflow && (o.overflow = "hidden",
        l.always(function() {
            o.overflow = c.overflow[0],
            o.overflowX = c.overflow[1],
            o.overflowY = c.overflow[2]
        }));
        for (d in b)
            if (e = b[d],
            Na.exec(e)) {
                if (delete b[d],
                f = f || "toggle" === e,
                e === (p ? "hide" : "show")) {
                    if ("show" !== e || !q || void 0 === q[d])
                        continue;
                    p = !0
                }
                m[d] = q && q[d] || n.style(a, d)
            } else
                j = void 0;
        if (n.isEmptyObject(m))
            "inline" === ("none" === j ? ta(a.nodeName) : j) && (o.display = j);
        else {
            q ? "hidden"in q && (p = q.hidden) : q = L.access(a, "fxshow", {}),
            f && (q.hidden = !p),
            p ? n(a).show() : l.done(function() {
                n(a).hide()
            }),
            l.done(function() {
                var b;
                L.remove(a, "fxshow");
                for (b in m)
                    n.style(a, b, m[b])
            });
            for (d in m)
                g = Ua(p ? q[d] : 0, d, l),
                d in q || (q[d] = g.start,
                p && (g.end = g.start,
                g.start = "width" === d || "height" === d ? 1 : 0))
        }
    }
    function Wa(a, b) {
        var c, d, e, f, g;
        for (c in a)
            if (d = n.camelCase(c),
            e = b[d],
            f = a[c],
            n.isArray(f) && (e = f[1],
            f = a[c] = f[0]),
            c !== d && (a[d] = f,
            delete a[c]),
            g = n.cssHooks[d],
            g && "expand"in g) {
                f = g.expand(f),
                delete a[d];
                for (c in f)
                    c in a || (a[c] = f[c],
                    b[c] = e)
            } else
                b[d] = e
    }
    function Xa(a, b, c) {
        var d, e, f = 0, g = Qa.length, h = n.Deferred().always(function() {
            delete i.elem
        }), i = function() {
            if (e)
                return !1;
            for (var b = La || Sa(), c = Math.max(0, j.startTime + j.duration - b), d = c / j.duration || 0, f = 1 - d, g = 0, i = j.tweens.length; i > g; g++)
                j.tweens[g].run(f);
            return h.notifyWith(a, [j, f, c]),
            1 > f && i ? c : (h.resolveWith(a, [j]),
            !1)
        }, j = h.promise({
            elem: a,
            props: n.extend({}, b),
            opts: n.extend(!0, {
                specialEasing: {}
            }, c),
            originalProperties: b,
            originalOptions: c,
            startTime: La || Sa(),
            duration: c.duration,
            tweens: [],
            createTween: function(b, c) {
                var d = n.Tween(a, j.opts, b, c, j.opts.specialEasing[b] || j.opts.easing);
                return j.tweens.push(d),
                d
            },
            stop: function(b) {
                var c = 0
                  , d = b ? j.tweens.length : 0;
                if (e)
                    return this;
                for (e = !0; d > c; c++)
                    j.tweens[c].run(1);
                return b ? h.resolveWith(a, [j, b]) : h.rejectWith(a, [j, b]),
                this
            }
        }), k = j.props;
        for (Wa(k, j.opts.specialEasing); g > f; f++)
            if (d = Qa[f].call(j, a, k, j.opts))
                return d;
        return n.map(k, Ua, j),
        n.isFunction(j.opts.start) && j.opts.start.call(a, j),
        n.fx.timer(n.extend(i, {
            elem: a,
            anim: j,
            queue: j.opts.queue
        })),
        j.progress(j.opts.progress).done(j.opts.done, j.opts.complete).fail(j.opts.fail).always(j.opts.always)
    }
    n.Animation = n.extend(Xa, {
        tweener: function(a, b) {
            n.isFunction(a) ? (b = a,
            a = ["*"]) : a = a.split(" ");
            for (var c, d = 0, e = a.length; e > d; d++)
                c = a[d],
                Ra[c] = Ra[c] || [],
                Ra[c].unshift(b)
        },
        prefilter: function(a, b) {
            b ? Qa.unshift(a) : Qa.push(a)
        }
    }),
    n.speed = function(a, b, c) {
        var d = a && "object" == typeof a ? n.extend({}, a) : {
            complete: c || !c && b || n.isFunction(a) && a,
            duration: a,
            easing: c && b || b && !n.isFunction(b) && b
        };
        return d.duration = n.fx.off ? 0 : "number" == typeof d.duration ? d.duration : d.duration in n.fx.speeds ? n.fx.speeds[d.duration] : n.fx.speeds._default,
        (null == d.queue || d.queue === !0) && (d.queue = "fx"),
        d.old = d.complete,
        d.complete = function() {
            n.isFunction(d.old) && d.old.call(this),
            d.queue && n.dequeue(this, d.queue)
        }
        ,
        d
    }
    ,
    n.fn.extend({
        fadeTo: function(a, b, c, d) {
            return this.filter(S).css("opacity", 0).show().end().animate({
                opacity: b
            }, a, c, d)
        },
        animate: function(a, b, c, d) {
            var e = n.isEmptyObject(a)
              , f = n.speed(b, c, d)
              , g = function() {
                var b = Xa(this, n.extend({}, a), f);
                (e || L.get(this, "finish")) && b.stop(!0)
            };
            return g.finish = g,
            e || f.queue === !1 ? this.each(g) : this.queue(f.queue, g)
        },
        stop: function(a, b, c) {
            var d = function(a) {
                var b = a.stop;
                delete a.stop,
                b(c)
            };
            return "string" != typeof a && (c = b,
            b = a,
            a = void 0),
            b && a !== !1 && this.queue(a || "fx", []),
            this.each(function() {
                var b = !0
                  , e = null != a && a + "queueHooks"
                  , f = n.timers
                  , g = L.get(this);
                if (e)
                    g[e] && g[e].stop && d(g[e]);
                else
                    for (e in g)
                        g[e] && g[e].stop && Pa.test(e) && d(g[e]);
                for (e = f.length; e--; )
                    f[e].elem !== this || null != a && f[e].queue !== a || (f[e].anim.stop(c),
                    b = !1,
                    f.splice(e, 1));
                (b || !c) && n.dequeue(this, a)
            })
        },
        finish: function(a) {
            return a !== !1 && (a = a || "fx"),
            this.each(function() {
                var b, c = L.get(this), d = c[a + "queue"], e = c[a + "queueHooks"], f = n.timers, g = d ? d.length : 0;
                for (c.finish = !0,
                n.queue(this, a, []),
                e && e.stop && e.stop.call(this, !0),
                b = f.length; b--; )
                    f[b].elem === this && f[b].queue === a && (f[b].anim.stop(!0),
                    f.splice(b, 1));
                for (b = 0; g > b; b++)
                    d[b] && d[b].finish && d[b].finish.call(this);
                delete c.finish
            })
        }
    }),
    n.each(["toggle", "show", "hide"], function(a, b) {
        var c = n.fn[b];
        n.fn[b] = function(a, d, e) {
            return null == a || "boolean" == typeof a ? c.apply(this, arguments) : this.animate(Ta(b, !0), a, d, e)
        }
    }),
    n.each({
        slideDown: Ta("show"),
        slideUp: Ta("hide"),
        slideToggle: Ta("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(a, b) {
        n.fn[a] = function(a, c, d) {
            return this.animate(b, a, c, d)
        }
    }),
    n.timers = [],
    n.fx.tick = function() {
        var a, b = 0, c = n.timers;
        for (La = n.now(); b < c.length; b++)
            a = c[b],
            a() || c[b] !== a || c.splice(b--, 1);
        c.length || n.fx.stop(),
        La = void 0
    }
    ,
    n.fx.timer = function(a) {
        n.timers.push(a),
        a() ? n.fx.start() : n.timers.pop()
    }
    ,
    n.fx.interval = 13,
    n.fx.start = function() {
        Ma || (Ma = setInterval(n.fx.tick, n.fx.interval))
    }
    ,
    n.fx.stop = function() {
        clearInterval(Ma),
        Ma = null
    }
    ,
    n.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    },
    n.fn.delay = function(a, b) {
        return a = n.fx ? n.fx.speeds[a] || a : a,
        b = b || "fx",
        this.queue(b, function(b, c) {
            var d = setTimeout(b, a);
            c.stop = function() {
                clearTimeout(d)
            }
        })
    }
    ,
    function() {
        var a = l.createElement("input")
          , b = l.createElement("select")
          , c = b.appendChild(l.createElement("option"));
        a.type = "checkbox",
        k.checkOn = "" !== a.value,
        k.optSelected = c.selected,
        b.disabled = !0,
        k.optDisabled = !c.disabled,
        a = l.createElement("input"),
        a.value = "t",
        a.type = "radio",
        k.radioValue = "t" === a.value
    }();
    var Ya, Za, $a = n.expr.attrHandle;
    n.fn.extend({
        attr: function(a, b) {
            return J(this, n.attr, a, b, arguments.length > 1)
        },
        removeAttr: function(a) {
            return this.each(function() {
                n.removeAttr(this, a)
            })
        }
    }),
    n.extend({
        attr: function(a, b, c) {
            var d, e, f = a.nodeType;
            if (a && 3 !== f && 8 !== f && 2 !== f)
                return typeof a.getAttribute === U ? n.prop(a, b, c) : (1 === f && n.isXMLDoc(a) || (b = b.toLowerCase(),
                d = n.attrHooks[b] || (n.expr.match.bool.test(b) ? Za : Ya)),
                void 0 === c ? d && "get"in d && null !== (e = d.get(a, b)) ? e : (e = n.find.attr(a, b),
                null == e ? void 0 : e) : null !== c ? d && "set"in d && void 0 !== (e = d.set(a, c, b)) ? e : (a.setAttribute(b, c + ""),
                c) : void n.removeAttr(a, b))
        },
        removeAttr: function(a, b) {
            var c, d, e = 0, f = b && b.match(E);
            if (f && 1 === a.nodeType)
                while (c = f[e++])
                    d = n.propFix[c] || c,
                    n.expr.match.bool.test(c) && (a[d] = !1),
                    a.removeAttribute(c)
        },
        attrHooks: {
            type: {
                set: function(a, b) {
                    if (!k.radioValue && "radio" === b && n.nodeName(a, "input")) {
                        var c = a.value;
                        return a.setAttribute("type", b),
                        c && (a.value = c),
                        b
                    }
                }
            }
        }
    }),
    Za = {
        set: function(a, b, c) {
            return b === !1 ? n.removeAttr(a, c) : a.setAttribute(c, c),
            c
        }
    },
    n.each(n.expr.match.bool.source.match(/\w+/g), function(a, b) {
        var c = $a[b] || n.find.attr;
        $a[b] = function(a, b, d) {
            var e, f;
            return d || (f = $a[b],
            $a[b] = e,
            e = null != c(a, b, d) ? b.toLowerCase() : null,
            $a[b] = f),
            e
        }
    });
    var _a = /^(?:input|select|textarea|button)$/i;
    n.fn.extend({
        prop: function(a, b) {
            return J(this, n.prop, a, b, arguments.length > 1)
        },
        removeProp: function(a) {
            return this.each(function() {
                delete this[n.propFix[a] || a]
            })
        }
    }),
    n.extend({
        propFix: {
            "for": "htmlFor",
            "class": "className"
        },
        prop: function(a, b, c) {
            var d, e, f, g = a.nodeType;
            if (a && 3 !== g && 8 !== g && 2 !== g)
                return f = 1 !== g || !n.isXMLDoc(a),
                f && (b = n.propFix[b] || b,
                e = n.propHooks[b]),
                void 0 !== c ? e && "set"in e && void 0 !== (d = e.set(a, c, b)) ? d : a[b] = c : e && "get"in e && null !== (d = e.get(a, b)) ? d : a[b]
        },
        propHooks: {
            tabIndex: {
                get: function(a) {
                    return a.hasAttribute("tabindex") || _a.test(a.nodeName) || a.href ? a.tabIndex : -1
                }
            }
        }
    }),
    k.optSelected || (n.propHooks.selected = {
        get: function(a) {
            var b = a.parentNode;
            return b && b.parentNode && b.parentNode.selectedIndex,
            null
        }
    }),
    n.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        n.propFix[this.toLowerCase()] = this
    });
    var ab = /[\t\r\n\f]/g;
    n.fn.extend({
        addClass: function(a) {
            var b, c, d, e, f, g, h = "string" == typeof a && a, i = 0, j = this.length;
            if (n.isFunction(a))
                return this.each(function(b) {
                    n(this).addClass(a.call(this, b, this.className))
                });
            if (h)
                for (b = (a || "").match(E) || []; j > i; i++)
                    if (c = this[i],
                    d = 1 === c.nodeType && (c.className ? (" " + c.className + " ").replace(ab, " ") : " ")) {
                        f = 0;
                        while (e = b[f++])
                            d.indexOf(" " + e + " ") < 0 && (d += e + " ");
                        g = n.trim(d),
                        c.className !== g && (c.className = g)
                    }
            return this
        },
        removeClass: function(a) {
            var b, c, d, e, f, g, h = 0 === arguments.length || "string" == typeof a && a, i = 0, j = this.length;
            if (n.isFunction(a))
                return this.each(function(b) {
                    n(this).removeClass(a.call(this, b, this.className))
                });
            if (h)
                for (b = (a || "").match(E) || []; j > i; i++)
                    if (c = this[i],
                    d = 1 === c.nodeType && (c.className ? (" " + c.className + " ").replace(ab, " ") : "")) {
                        f = 0;
                        while (e = b[f++])
                            while (d.indexOf(" " + e + " ") >= 0)
                                d = d.replace(" " + e + " ", " ");
                        g = a ? n.trim(d) : "",
                        c.className !== g && (c.className = g)
                    }
            return this
        },
        toggleClass: function(a, b) {
            var c = typeof a;
            return "boolean" == typeof b && "string" === c ? b ? this.addClass(a) : this.removeClass(a) : this.each(n.isFunction(a) ? function(c) {
                n(this).toggleClass(a.call(this, c, this.className, b), b)
            }
            : function() {
                if ("string" === c) {
                    var b, d = 0, e = n(this), f = a.match(E) || [];
                    while (b = f[d++])
                        e.hasClass(b) ? e.removeClass(b) : e.addClass(b)
                } else
                    (c === U || "boolean" === c) && (this.className && L.set(this, "__className__", this.className),
                    this.className = this.className || a === !1 ? "" : L.get(this, "__className__") || "")
            }
            )
        },
        hasClass: function(a) {
            for (var b = " " + a + " ", c = 0, d = this.length; d > c; c++)
                if (1 === this[c].nodeType && (" " + this[c].className + " ").replace(ab, " ").indexOf(b) >= 0)
                    return !0;
            return !1
        }
    });
    var bb = /\r/g;
    n.fn.extend({
        val: function(a) {
            var b, c, d, e = this[0];
            {
                if (arguments.length)
                    return d = n.isFunction(a),
                    this.each(function(c) {
                        var e;
                        1 === this.nodeType && (e = d ? a.call(this, c, n(this).val()) : a,
                        null == e ? e = "" : "number" == typeof e ? e += "" : n.isArray(e) && (e = n.map(e, function(a) {
                            return null == a ? "" : a + ""
                        })),
                        b = n.valHooks[this.type] || n.valHooks[this.nodeName.toLowerCase()],
                        b && "set"in b && void 0 !== b.set(this, e, "value") || (this.value = e))
                    });
                if (e)
                    return b = n.valHooks[e.type] || n.valHooks[e.nodeName.toLowerCase()],
                    b && "get"in b && void 0 !== (c = b.get(e, "value")) ? c : (c = e.value,
                    "string" == typeof c ? c.replace(bb, "") : null == c ? "" : c)
            }
        }
    }),
    n.extend({
        valHooks: {
            option: {
                get: function(a) {
                    var b = n.find.attr(a, "value");
                    return null != b ? b : n.trim(n.text(a))
                }
            },
            select: {
                get: function(a) {
                    for (var b, c, d = a.options, e = a.selectedIndex, f = "select-one" === a.type || 0 > e, g = f ? null : [], h = f ? e + 1 : d.length, i = 0 > e ? h : f ? e : 0; h > i; i++)
                        if (c = d[i],
                        !(!c.selected && i !== e || (k.optDisabled ? c.disabled : null !== c.getAttribute("disabled")) || c.parentNode.disabled && n.nodeName(c.parentNode, "optgroup"))) {
                            if (b = n(c).val(),
                            f)
                                return b;
                            g.push(b)
                        }
                    return g
                },
                set: function(a, b) {
                    var c, d, e = a.options, f = n.makeArray(b), g = e.length;
                    while (g--)
                        d = e[g],
                        (d.selected = n.inArray(d.value, f) >= 0) && (c = !0);
                    return c || (a.selectedIndex = -1),
                    f
                }
            }
        }
    }),
    n.each(["radio", "checkbox"], function() {
        n.valHooks[this] = {
            set: function(a, b) {
                return n.isArray(b) ? a.checked = n.inArray(n(a).val(), b) >= 0 : void 0
            }
        },
        k.checkOn || (n.valHooks[this].get = function(a) {
            return null === a.getAttribute("value") ? "on" : a.value
        }
        )
    }),
    n.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function(a, b) {
        n.fn[b] = function(a, c) {
            return arguments.length > 0 ? this.on(b, null, a, c) : this.trigger(b)
        }
    }),
    n.fn.extend({
        hover: function(a, b) {
            return this.mouseenter(a).mouseleave(b || a)
        },
        bind: function(a, b, c) {
            return this.on(a, null, b, c)
        },
        unbind: function(a, b) {
            return this.off(a, null, b)
        },
        delegate: function(a, b, c, d) {
            return this.on(b, a, c, d)
        },
        undelegate: function(a, b, c) {
            return 1 === arguments.length ? this.off(a, "**") : this.off(b, a || "**", c)
        }
    });
    var cb = n.now()
      , db = /\?/;
    n.parseJSON = function(a) {
        return JSON.parse(a + "")
    }
    ,
    n.parseXML = function(a) {
        var b, c;
        if (!a || "string" != typeof a)
            return null;
        try {
            c = new DOMParser,
            b = c.parseFromString(a, "text/xml")
        } catch (d) {
            b = void 0
        }
        return (!b || b.getElementsByTagName("parsererror").length) && n.error("Invalid XML: " + a),
        b
    }
    ;
    var eb = /#.*$/
      , fb = /([?&])_=[^&]*/
      , gb = /^(.*?):[ \t]*([^\r\n]*)$/gm
      , hb = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/
      , ib = /^(?:GET|HEAD)$/
      , jb = /^\/\//
      , kb = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/
      , lb = {}
      , mb = {}
      , nb = "*/".concat("*")
      , ob = a.location.href
      , pb = kb.exec(ob.toLowerCase()) || [];
    function qb(a) {
        return function(b, c) {
            "string" != typeof b && (c = b,
            b = "*");
            var d, e = 0, f = b.toLowerCase().match(E) || [];
            if (n.isFunction(c))
                while (d = f[e++])
                    "+" === d[0] ? (d = d.slice(1) || "*",
                    (a[d] = a[d] || []).unshift(c)) : (a[d] = a[d] || []).push(c)
        }
    }
    function rb(a, b, c, d) {
        var e = {}
          , f = a === mb;
        function g(h) {
            var i;
            return e[h] = !0,
            n.each(a[h] || [], function(a, h) {
                var j = h(b, c, d);
                return "string" != typeof j || f || e[j] ? f ? !(i = j) : void 0 : (b.dataTypes.unshift(j),
                g(j),
                !1)
            }),
            i
        }
        return g(b.dataTypes[0]) || !e["*"] && g("*")
    }
    function sb(a, b) {
        var c, d, e = n.ajaxSettings.flatOptions || {};
        for (c in b)
            void 0 !== b[c] && ((e[c] ? a : d || (d = {}))[c] = b[c]);
        return d && n.extend(!0, a, d),
        a
    }
    function tb(a, b, c) {
        var d, e, f, g, h = a.contents, i = a.dataTypes;
        while ("*" === i[0])
            i.shift(),
            void 0 === d && (d = a.mimeType || b.getResponseHeader("Content-Type"));
        if (d)
            for (e in h)
                if (h[e] && h[e].test(d)) {
                    i.unshift(e);
                    break
                }
        if (i[0]in c)
            f = i[0];
        else {
            for (e in c) {
                if (!i[0] || a.converters[e + " " + i[0]]) {
                    f = e;
                    break
                }
                g || (g = e)
            }
            f = f || g
        }
        return f ? (f !== i[0] && i.unshift(f),
        c[f]) : void 0
    }
    function ub(a, b, c, d) {
        var e, f, g, h, i, j = {}, k = a.dataTypes.slice();
        if (k[1])
            for (g in a.converters)
                j[g.toLowerCase()] = a.converters[g];
        f = k.shift();
        while (f)
            if (a.responseFields[f] && (c[a.responseFields[f]] = b),
            !i && d && a.dataFilter && (b = a.dataFilter(b, a.dataType)),
            i = f,
            f = k.shift())
                if ("*" === f)
                    f = i;
                else if ("*" !== i && i !== f) {
                    if (g = j[i + " " + f] || j["* " + f],
                    !g)
                        for (e in j)
                            if (h = e.split(" "),
                            h[1] === f && (g = j[i + " " + h[0]] || j["* " + h[0]])) {
                                g === !0 ? g = j[e] : j[e] !== !0 && (f = h[0],
                                k.unshift(h[1]));
                                break
                            }
                    if (g !== !0)
                        if (g && a["throws"])
                            b = g(b);
                        else
                            try {
                                b = g(b)
                            } catch (l) {
                                return {
                                    state: "parsererror",
                                    error: g ? l : "No conversion from " + i + " to " + f
                                }
                            }
                }
        return {
            state: "success",
            data: b
        }
    }
    n.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: ob,
            type: "GET",
            isLocal: hb.test(pb[1]),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": nb,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /xml/,
                html: /html/,
                json: /json/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": n.parseJSON,
                "text xml": n.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(a, b) {
            return b ? sb(sb(a, n.ajaxSettings), b) : sb(n.ajaxSettings, a)
        },
        ajaxPrefilter: qb(lb),
        ajaxTransport: qb(mb),
        ajax: function(a, b) {
            "object" == typeof a && (b = a,
            a = void 0),
            b = b || {};
            var c, d, e, f, g, h, i, j, k = n.ajaxSetup({}, b), l = k.context || k, m = k.context && (l.nodeType || l.jquery) ? n(l) : n.event, o = n.Deferred(), p = n.Callbacks("once memory"), q = k.statusCode || {}, r = {}, s = {}, t = 0, u = "canceled", v = {
                readyState: 0,
                getResponseHeader: function(a) {
                    var b;
                    if (2 === t) {
                        if (!f) {
                            f = {};
                            while (b = gb.exec(e))
                                f[b[1].toLowerCase()] = b[2]
                        }
                        b = f[a.toLowerCase()]
                    }
                    return null == b ? null : b
                },
                getAllResponseHeaders: function() {
                    return 2 === t ? e : null
                },
                setRequestHeader: function(a, b) {
                    var c = a.toLowerCase();
                    return t || (a = s[c] = s[c] || a,
                    r[a] = b),
                    this
                },
                overrideMimeType: function(a) {
                    return t || (k.mimeType = a),
                    this
                },
                statusCode: function(a) {
                    var b;
                    if (a)
                        if (2 > t)
                            for (b in a)
                                q[b] = [q[b], a[b]];
                        else
                            v.always(a[v.status]);
                    return this
                },
                abort: function(a) {
                    var b = a || u;
                    return c && c.abort(b),
                    x(0, b),
                    this
                }
            };
            if (o.promise(v).complete = p.add,
            v.success = v.done,
            v.error = v.fail,
            k.url = ((a || k.url || ob) + "").replace(eb, "").replace(jb, pb[1] + "//"),
            k.type = b.method || b.type || k.method || k.type,
            k.dataTypes = n.trim(k.dataType || "*").toLowerCase().match(E) || [""],
            null == k.crossDomain && (h = kb.exec(k.url.toLowerCase()),
            k.crossDomain = !(!h || h[1] === pb[1] && h[2] === pb[2] && (h[3] || ("http:" === h[1] ? "80" : "443")) === (pb[3] || ("http:" === pb[1] ? "80" : "443")))),
            k.data && k.processData && "string" != typeof k.data && (k.data = n.param(k.data, k.traditional)),
            rb(lb, k, b, v),
            2 === t)
                return v;
            i = n.event && k.global,
            i && 0 === n.active++ && n.event.trigger("ajaxStart"),
            k.type = k.type.toUpperCase(),
            k.hasContent = !ib.test(k.type),
            d = k.url,
            k.hasContent || (k.data && (d = k.url += (db.test(d) ? "&" : "?") + k.data,
            delete k.data),
            k.cache === !1 && (k.url = fb.test(d) ? d.replace(fb, "$1_=" + cb++) : d + (db.test(d) ? "&" : "?") + "_=" + cb++)),
            k.ifModified && (n.lastModified[d] && v.setRequestHeader("If-Modified-Since", n.lastModified[d]),
            n.etag[d] && v.setRequestHeader("If-None-Match", n.etag[d])),
            (k.data && k.hasContent && k.contentType !== !1 || b.contentType) && v.setRequestHeader("Content-Type", k.contentType),
            v.setRequestHeader("Accept", k.dataTypes[0] && k.accepts[k.dataTypes[0]] ? k.accepts[k.dataTypes[0]] + ("*" !== k.dataTypes[0] ? ", " + nb + "; q=0.01" : "") : k.accepts["*"]);
            for (j in k.headers)
                v.setRequestHeader(j, k.headers[j]);
            if (k.beforeSend && (k.beforeSend.call(l, v, k) === !1 || 2 === t))
                return v.abort();
            u = "abort";
            for (j in {
                success: 1,
                error: 1,
                complete: 1
            })
                v[j](k[j]);
            if (c = rb(mb, k, b, v)) {
                v.readyState = 1,
                i && m.trigger("ajaxSend", [v, k]),
                k.async && k.timeout > 0 && (g = setTimeout(function() {
                    v.abort("timeout")
                }, k.timeout));
                try {
                    t = 1,
                    c.send(r, x)
                } catch (w) {
                    if (!(2 > t))
                        throw w;
                    x(-1, w)
                }
            } else
                x(-1, "No Transport");
            function x(a, b, f, h) {
                var j, r, s, u, w, x = b;
                2 !== t && (t = 2,
                g && clearTimeout(g),
                c = void 0,
                e = h || "",
                v.readyState = a > 0 ? 4 : 0,
                j = a >= 200 && 300 > a || 304 === a,
                f && (u = tb(k, v, f)),
                u = ub(k, u, v, j),
                j ? (k.ifModified && (w = v.getResponseHeader("Last-Modified"),
                w && (n.lastModified[d] = w),
                w = v.getResponseHeader("etag"),
                w && (n.etag[d] = w)),
                204 === a || "HEAD" === k.type ? x = "nocontent" : 304 === a ? x = "notmodified" : (x = u.state,
                r = u.data,
                s = u.error,
                j = !s)) : (s = x,
                (a || !x) && (x = "error",
                0 > a && (a = 0))),
                v.status = a,
                v.statusText = (b || x) + "",
                j ? o.resolveWith(l, [r, x, v]) : o.rejectWith(l, [v, x, s]),
                v.statusCode(q),
                q = void 0,
                i && m.trigger(j ? "ajaxSuccess" : "ajaxError", [v, k, j ? r : s]),
                p.fireWith(l, [v, x]),
                i && (m.trigger("ajaxComplete", [v, k]),
                --n.active || n.event.trigger("ajaxStop")))
            }
            return v
        },
        getJSON: function(a, b, c) {
            return n.get(a, b, c, "json")
        },
        getScript: function(a, b) {
            return n.get(a, void 0, b, "script")
        }
    }),
    n.each(["get", "post"], function(a, b) {
        n[b] = function(a, c, d, e) {
            return n.isFunction(c) && (e = e || d,
            d = c,
            c = void 0),
            n.ajax({
                url: a,
                type: b,
                dataType: e,
                data: c,
                success: d
            })
        }
    }),
    n._evalUrl = function(a) {
        return n.ajax({
            url: a,
            type: "GET",
            dataType: "script",
            async: !1,
            global: !1,
            "throws": !0
        })
    }
    ,
    n.fn.extend({
        wrapAll: function(a) {
            var b;
            return n.isFunction(a) ? this.each(function(b) {
                n(this).wrapAll(a.call(this, b))
            }) : (this[0] && (b = n(a, this[0].ownerDocument).eq(0).clone(!0),
            this[0].parentNode && b.insertBefore(this[0]),
            b.map(function() {
                var a = this;
                while (a.firstElementChild)
                    a = a.firstElementChild;
                return a
            }).append(this)),
            this)
        },
        wrapInner: function(a) {
            return this.each(n.isFunction(a) ? function(b) {
                n(this).wrapInner(a.call(this, b))
            }
            : function() {
                var b = n(this)
                  , c = b.contents();
                c.length ? c.wrapAll(a) : b.append(a)
            }
            )
        },
        wrap: function(a) {
            var b = n.isFunction(a);
            return this.each(function(c) {
                n(this).wrapAll(b ? a.call(this, c) : a)
            })
        },
        unwrap: function() {
            return this.parent().each(function() {
                n.nodeName(this, "body") || n(this).replaceWith(this.childNodes)
            }).end()
        }
    }),
    n.expr.filters.hidden = function(a) {
        return a.offsetWidth <= 0 && a.offsetHeight <= 0
    }
    ,
    n.expr.filters.visible = function(a) {
        return !n.expr.filters.hidden(a)
    }
    ;
    var vb = /%20/g
      , wb = /\[\]$/
      , xb = /\r?\n/g
      , yb = /^(?:submit|button|image|reset|file)$/i
      , zb = /^(?:input|select|textarea|keygen)/i;
    function Ab(a, b, c, d) {
        var e;
        if (n.isArray(b))
            n.each(b, function(b, e) {
                c || wb.test(a) ? d(a, e) : Ab(a + "[" + ("object" == typeof e ? b : "") + "]", e, c, d)
            });
        else if (c || "object" !== n.type(b))
            d(a, b);
        else
            for (e in b)
                Ab(a + "[" + e + "]", b[e], c, d)
    }
    n.param = function(a, b) {
        var c, d = [], e = function(a, b) {
            b = n.isFunction(b) ? b() : null == b ? "" : b,
            d[d.length] = encodeURIComponent(a) + "=" + encodeURIComponent(b)
        };
        if (void 0 === b && (b = n.ajaxSettings && n.ajaxSettings.traditional),
        n.isArray(a) || a.jquery && !n.isPlainObject(a))
            n.each(a, function() {
                e(this.name, this.value)
            });
        else
            for (c in a)
                Ab(c, a[c], b, e);
        return d.join("&").replace(vb, "+")
    }
    ,
    n.fn.extend({
        serialize: function() {
            return n.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var a = n.prop(this, "elements");
                return a ? n.makeArray(a) : this
            }).filter(function() {
                var a = this.type;
                return this.name && !n(this).is(":disabled") && zb.test(this.nodeName) && !yb.test(a) && (this.checked || !T.test(a))
            }).map(function(a, b) {
                var c = n(this).val();
                return null == c ? null : n.isArray(c) ? n.map(c, function(a) {
                    return {
                        name: b.name,
                        value: a.replace(xb, "\r\n")
                    }
                }) : {
                    name: b.name,
                    value: c.replace(xb, "\r\n")
                }
            }).get()
        }
    }),
    n.ajaxSettings.xhr = function() {
        try {
            return new XMLHttpRequest
        } catch (a) {}
    }
    ;
    var Bb = 0
      , Cb = {}
      , Db = {
        0: 200,
        1223: 204
    }
      , Eb = n.ajaxSettings.xhr();
    a.attachEvent && a.attachEvent("onunload", function() {
        for (var a in Cb)
            Cb[a]()
    }),
    k.cors = !!Eb && "withCredentials"in Eb,
    k.ajax = Eb = !!Eb,
    n.ajaxTransport(function(a) {
        var b;
        return k.cors || Eb && !a.crossDomain ? {
            send: function(c, d) {
                var e, f = a.xhr(), g = ++Bb;
                if (f.open(a.type, a.url, a.async, a.username, a.password),
                a.xhrFields)
                    for (e in a.xhrFields)
                        f[e] = a.xhrFields[e];
                a.mimeType && f.overrideMimeType && f.overrideMimeType(a.mimeType),
                a.crossDomain || c["X-Requested-With"] || (c["X-Requested-With"] = "XMLHttpRequest");
                for (e in c)
                    f.setRequestHeader(e, c[e]);
                b = function(a) {
                    return function() {
                        b && (delete Cb[g],
                        b = f.onload = f.onerror = null,
                        "abort" === a ? f.abort() : "error" === a ? d(f.status, f.statusText) : d(Db[f.status] || f.status, f.statusText, "string" == typeof f.responseText ? {
                            text: f.responseText
                        } : void 0, f.getAllResponseHeaders()))
                    }
                }
                ,
                f.onload = b(),
                f.onerror = b("error"),
                b = Cb[g] = b("abort");
                try {
                    f.send(a.hasContent && a.data || null)
                } catch (h) {
                    if (b)
                        throw h
                }
            },
            abort: function() {
                b && b()
            }
        } : void 0
    }),
    n.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /(?:java|ecma)script/
        },
        converters: {
            "text script": function(a) {
                return n.globalEval(a),
                a
            }
        }
    }),
    n.ajaxPrefilter("script", function(a) {
        void 0 === a.cache && (a.cache = !1),
        a.crossDomain && (a.type = "GET")
    }),
    n.ajaxTransport("script", function(a) {
        if (a.crossDomain) {
            var b, c;
            return {
                send: function(d, e) {
                    b = n("<script>").prop({
                        async: !0,
                        charset: a.scriptCharset,
                        src: a.url
                    }).on("load error", c = function(a) {
                        b.remove(),
                        c = null,
                        a && e("error" === a.type ? 404 : 200, a.type)
                    }
                    ),
                    l.head.appendChild(b[0])
                },
                abort: function() {
                    c && c()
                }
            }
        }
    });
    var Fb = []
      , Gb = /(=)\?(?=&|$)|\?\?/;
    n.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var a = Fb.pop() || n.expando + "_" + cb++;
            return this[a] = !0,
            a
        }
    }),
    n.ajaxPrefilter("json jsonp", function(b, c, d) {
        var e, f, g, h = b.jsonp !== !1 && (Gb.test(b.url) ? "url" : "string" == typeof b.data && !(b.contentType || "").indexOf("application/x-www-form-urlencoded") && Gb.test(b.data) && "data");
        return h || "jsonp" === b.dataTypes[0] ? (e = b.jsonpCallback = n.isFunction(b.jsonpCallback) ? b.jsonpCallback() : b.jsonpCallback,
        h ? b[h] = b[h].replace(Gb, "$1" + e) : b.jsonp !== !1 && (b.url += (db.test(b.url) ? "&" : "?") + b.jsonp + "=" + e),
        b.converters["script json"] = function() {
            return g || n.error(e + " was not called"),
            g[0]
        }
        ,
        b.dataTypes[0] = "json",
        f = a[e],
        a[e] = function() {
            g = arguments
        }
        ,
        d.always(function() {
            a[e] = f,
            b[e] && (b.jsonpCallback = c.jsonpCallback,
            Fb.push(e)),
            g && n.isFunction(f) && f(g[0]),
            g = f = void 0
        }),
        "script") : void 0
    }),
    n.parseHTML = function(a, b, c) {
        if (!a || "string" != typeof a)
            return null;
        "boolean" == typeof b && (c = b,
        b = !1),
        b = b || l;
        var d = v.exec(a)
          , e = !c && [];
        return d ? [b.createElement(d[1])] : (d = n.buildFragment([a], b, e),
        e && e.length && n(e).remove(),
        n.merge([], d.childNodes))
    }
    ;
    var Hb = n.fn.load;
    n.fn.load = function(a, b, c) {
        if ("string" != typeof a && Hb)
            return Hb.apply(this, arguments);
        var d, e, f, g = this, h = a.indexOf(" ");
        return h >= 0 && (d = n.trim(a.slice(h)),
        a = a.slice(0, h)),
        n.isFunction(b) ? (c = b,
        b = void 0) : b && "object" == typeof b && (e = "POST"),
        g.length > 0 && n.ajax({
            url: a,
            type: e,
            dataType: "html",
            data: b
        }).done(function(a) {
            f = arguments,
            g.html(d ? n("<div>").append(n.parseHTML(a)).find(d) : a)
        }).complete(c && function(a, b) {
            g.each(c, f || [a.responseText, b, a])
        }
        ),
        this
    }
    ,
    n.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(a, b) {
        n.fn[b] = function(a) {
            return this.on(b, a)
        }
    }),
    n.expr.filters.animated = function(a) {
        return n.grep(n.timers, function(b) {
            return a === b.elem
        }).length
    }
    ;
    var Ib = a.document.documentElement;
    function Jb(a) {
        return n.isWindow(a) ? a : 9 === a.nodeType && a.defaultView
    }
    n.offset = {
        setOffset: function(a, b, c) {
            var d, e, f, g, h, i, j, k = n.css(a, "position"), l = n(a), m = {};
            "static" === k && (a.style.position = "relative"),
            h = l.offset(),
            f = n.css(a, "top"),
            i = n.css(a, "left"),
            j = ("absolute" === k || "fixed" === k) && (f + i).indexOf("auto") > -1,
            j ? (d = l.position(),
            g = d.top,
            e = d.left) : (g = parseFloat(f) || 0,
            e = parseFloat(i) || 0),
            n.isFunction(b) && (b = b.call(a, c, h)),
            null != b.top && (m.top = b.top - h.top + g),
            null != b.left && (m.left = b.left - h.left + e),
            "using"in b ? b.using.call(a, m) : l.css(m)
        }
    },
    n.fn.extend({
        offset: function(a) {
            if (arguments.length)
                return void 0 === a ? this : this.each(function(b) {
                    n.offset.setOffset(this, a, b)
                });
            var b, c, d = this[0], e = {
                top: 0,
                left: 0
            }, f = d && d.ownerDocument;
            if (f)
                return b = f.documentElement,
                n.contains(b, d) ? (typeof d.getBoundingClientRect !== U && (e = d.getBoundingClientRect()),
                c = Jb(f),
                {
                    top: e.top + c.pageYOffset - b.clientTop,
                    left: e.left + c.pageXOffset - b.clientLeft
                }) : e
        },
        position: function() {
            if (this[0]) {
                var a, b, c = this[0], d = {
                    top: 0,
                    left: 0
                };
                return "fixed" === n.css(c, "position") ? b = c.getBoundingClientRect() : (a = this.offsetParent(),
                b = this.offset(),
                n.nodeName(a[0], "html") || (d = a.offset()),
                d.top += n.css(a[0], "borderTopWidth", !0),
                d.left += n.css(a[0], "borderLeftWidth", !0)),
                {
                    top: b.top - d.top - n.css(c, "marginTop", !0),
                    left: b.left - d.left - n.css(c, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                var a = this.offsetParent || Ib;
                while (a && !n.nodeName(a, "html") && "static" === n.css(a, "position"))
                    a = a.offsetParent;
                return a || Ib
            })
        }
    }),
    n.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(b, c) {
        var d = "pageYOffset" === c;
        n.fn[b] = function(e) {
            return J(this, function(b, e, f) {
                var g = Jb(b);
                return void 0 === f ? g ? g[c] : b[e] : void (g ? g.scrollTo(d ? a.pageXOffset : f, d ? f : a.pageYOffset) : b[e] = f)
            }, b, e, arguments.length, null)
        }
    }),
    n.each(["top", "left"], function(a, b) {
        n.cssHooks[b] = ya(k.pixelPosition, function(a, c) {
            return c ? (c = xa(a, b),
            va.test(c) ? n(a).position()[b] + "px" : c) : void 0
        })
    }),
    n.each({
        Height: "height",
        Width: "width"
    }, function(a, b) {
        n.each({
            padding: "inner" + a,
            content: b,
            "": "outer" + a
        }, function(c, d) {
            n.fn[d] = function(d, e) {
                var f = arguments.length && (c || "boolean" != typeof d)
                  , g = c || (d === !0 || e === !0 ? "margin" : "border");
                return J(this, function(b, c, d) {
                    var e;
                    return n.isWindow(b) ? b.document.documentElement["client" + a] : 9 === b.nodeType ? (e = b.documentElement,
                    Math.max(b.body["scroll" + a], e["scroll" + a], b.body["offset" + a], e["offset" + a], e["client" + a])) : void 0 === d ? n.css(b, c, g) : n.style(b, c, d, g)
                }, b, f ? d : void 0, f, null)
            }
        })
    }),
    n.fn.size = function() {
        return this.length
    }
    ,
    n.fn.andSelf = n.fn.addBack,
    "function" == typeof define && define.amd && define("jquery", [], function() {
        return n
    });
    var Kb = a.jQuery
      , Lb = a.$;
    return n.noConflict = function(b) {
        return a.$ === n && (a.$ = Lb),
        b && a.jQuery === n && (a.jQuery = Kb),
        n
    }
    ,
    typeof b === U && (a.jQuery = a.$ = n),
    n
});

(function(b, c) {
    var $ = b.jQuery || b.Cowboy || (b.Cowboy = {}), a;
    $.throttle = a = function(e, f, j, i) {
        var h, d = 0;
        if (typeof f !== "boolean") {
            i = j;
            j = f;
            f = c
        }
        function g() {
            var o = this
              , m = +new Date() - d
              , n = arguments;
            function l() {
                d = +new Date();
                j.apply(o, n)
            }
            function k() {
                h = c
            }
            if (i && !h) {
                l()
            }
            h && clearTimeout(h);
            if (i === c && m > e) {
                l()
            } else {
                if (f !== true) {
                    h = setTimeout(i ? k : l, i === c ? e - m : e)
                }
            }
        }
        if ($.guid) {
            g.guid = j.guid = j.guid || $.guid++
        }
        return g
    }
    ;
    $.debounce = function(d, e, f) {
        return f === c ? a(d, e, false) : a(d, f, e !== false)
    }
}
)(this);

/*! GreenSock VERSION: 1.18.2 */
var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function() {
    "use strict";
    _gsScope._gsDefine("TweenMax", ["core.Animation", "core.SimpleTimeline", "TweenLite"], function(a, b, c) {
        var d = function(a) {
            var b, c = [], d = a.length;
            for (b = 0; b !== d; c.push(a[b++]))
                ;
            return c
        }
          , e = function(a, b, c) {
            var d, e, f = a.cycle;
            for (d in f)
                e = f[d],
                a[d] = "function" == typeof e ? e.call(b[c], c) : e[c % e.length];
            delete a.cycle
        }
          , f = function(a, b, d) {
            c.call(this, a, b, d),
            this._cycle = 0,
            this._yoyo = this.vars.yoyo === !0,
            this._repeat = this.vars.repeat || 0,
            this._repeatDelay = this.vars.repeatDelay || 0,
            this._dirty = !0,
            this.render = f.prototype.render
        }
          , g = 1e-10
          , h = c._internals
          , i = h.isSelector
          , j = h.isArray
          , k = f.prototype = c.to({}, .1, {})
          , l = [];
        f.version = "1.18.2",
        k.constructor = f,
        k.kill()._gc = !1,
        f.killTweensOf = f.killDelayedCallsTo = c.killTweensOf,
        f.getTweensOf = c.getTweensOf,
        f.lagSmoothing = c.lagSmoothing,
        f.ticker = c.ticker,
        f.render = c.render,
        k.invalidate = function() {
            return this._yoyo = this.vars.yoyo === !0,
            this._repeat = this.vars.repeat || 0,
            this._repeatDelay = this.vars.repeatDelay || 0,
            this._uncache(!0),
            c.prototype.invalidate.call(this)
        }
        ,
        k.updateTo = function(a, b) {
            var d, e = this.ratio, f = this.vars.immediateRender || a.immediateRender;
            b && this._startTime < this._timeline._time && (this._startTime = this._timeline._time,
            this._uncache(!1),
            this._gc ? this._enabled(!0, !1) : this._timeline.insert(this, this._startTime - this._delay));
            for (d in a)
                this.vars[d] = a[d];
            if (this._initted || f)
                if (b)
                    this._initted = !1,
                    f && this.render(0, !0, !0);
                else if (this._gc && this._enabled(!0, !1),
                this._notifyPluginsOfEnabled && this._firstPT && c._onPluginEvent("_onDisable", this),
                this._time / this._duration > .998) {
                    var g = this._totalTime;
                    this.render(0, !0, !1),
                    this._initted = !1,
                    this.render(g, !0, !1)
                } else if (this._initted = !1,
                this._init(),
                this._time > 0 || f)
                    for (var h, i = 1 / (1 - e), j = this._firstPT; j; )
                        h = j.s + j.c,
                        j.c *= i,
                        j.s = h - j.c,
                        j = j._next;
            return this
        }
        ,
        k.render = function(a, b, c) {
            this._initted || 0 === this._duration && this.vars.repeat && this.invalidate();
            var d, e, f, i, j, k, l, m, n = this._dirty ? this.totalDuration() : this._totalDuration, o = this._time, p = this._totalTime, q = this._cycle, r = this._duration, s = this._rawPrevTime;
            if (a >= n - 1e-7 ? (this._totalTime = n,
            this._cycle = this._repeat,
            this._yoyo && 0 !== (1 & this._cycle) ? (this._time = 0,
            this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0) : (this._time = r,
            this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1),
            this._reversed || (d = !0,
            e = "onComplete",
            c = c || this._timeline.autoRemoveChildren),
            0 === r && (this._initted || !this.vars.lazy || c) && (this._startTime === this._timeline._duration && (a = 0),
            (0 > s || 0 >= a && a >= -1e-7 || s === g && "isPause" !== this.data) && s !== a && (c = !0,
            s > g && (e = "onReverseComplete")),
            this._rawPrevTime = m = !b || a || s === a ? a : g)) : 1e-7 > a ? (this._totalTime = this._time = this._cycle = 0,
            this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0,
            (0 !== p || 0 === r && s > 0) && (e = "onReverseComplete",
            d = this._reversed),
            0 > a && (this._active = !1,
            0 === r && (this._initted || !this.vars.lazy || c) && (s >= 0 && (c = !0),
            this._rawPrevTime = m = !b || a || s === a ? a : g)),
            this._initted || (c = !0)) : (this._totalTime = this._time = a,
            0 !== this._repeat && (i = r + this._repeatDelay,
            this._cycle = this._totalTime / i >> 0,
            0 !== this._cycle && this._cycle === this._totalTime / i && this._cycle--,
            this._time = this._totalTime - this._cycle * i,
            this._yoyo && 0 !== (1 & this._cycle) && (this._time = r - this._time),
            this._time > r ? this._time = r : this._time < 0 && (this._time = 0)),
            this._easeType ? (j = this._time / r,
            k = this._easeType,
            l = this._easePower,
            (1 === k || 3 === k && j >= .5) && (j = 1 - j),
            3 === k && (j *= 2),
            1 === l ? j *= j : 2 === l ? j *= j * j : 3 === l ? j *= j * j * j : 4 === l && (j *= j * j * j * j),
            1 === k ? this.ratio = 1 - j : 2 === k ? this.ratio = j : this._time / r < .5 ? this.ratio = j / 2 : this.ratio = 1 - j / 2) : this.ratio = this._ease.getRatio(this._time / r)),
            o === this._time && !c && q === this._cycle)
                return void (p !== this._totalTime && this._onUpdate && (b || this._callback("onUpdate")));
            if (!this._initted) {
                if (this._init(),
                !this._initted || this._gc)
                    return;
                if (!c && this._firstPT && (this.vars.lazy !== !1 && this._duration || this.vars.lazy && !this._duration))
                    return this._time = o,
                    this._totalTime = p,
                    this._rawPrevTime = s,
                    this._cycle = q,
                    h.lazyTweens.push(this),
                    void (this._lazy = [a, b]);
                this._time && !d ? this.ratio = this._ease.getRatio(this._time / r) : d && this._ease._calcEnd && (this.ratio = this._ease.getRatio(0 === this._time ? 0 : 1))
            }
            for (this._lazy !== !1 && (this._lazy = !1),
            this._active || !this._paused && this._time !== o && a >= 0 && (this._active = !0),
            0 === p && (2 === this._initted && a > 0 && this._init(),
            this._startAt && (a >= 0 ? this._startAt.render(a, b, c) : e || (e = "_dummyGS")),
            this.vars.onStart && (0 !== this._totalTime || 0 === r) && (b || this._callback("onStart"))),
            f = this._firstPT; f; )
                f.f ? f.t[f.p](f.c * this.ratio + f.s) : f.t[f.p] = f.c * this.ratio + f.s,
                f = f._next;
            this._onUpdate && (0 > a && this._startAt && this._startTime && this._startAt.render(a, b, c),
            b || (this._totalTime !== p || d) && this._callback("onUpdate")),
            this._cycle !== q && (b || this._gc || this.vars.onRepeat && this._callback("onRepeat")),
            e && (!this._gc || c) && (0 > a && this._startAt && !this._onUpdate && this._startTime && this._startAt.render(a, b, c),
            d && (this._timeline.autoRemoveChildren && this._enabled(!1, !1),
            this._active = !1),
            !b && this.vars[e] && this._callback(e),
            0 === r && this._rawPrevTime === g && m !== g && (this._rawPrevTime = 0))
        }
        ,
        f.to = function(a, b, c) {
            return new f(a,b,c)
        }
        ,
        f.from = function(a, b, c) {
            return c.runBackwards = !0,
            c.immediateRender = 0 != c.immediateRender,
            new f(a,b,c)
        }
        ,
        f.fromTo = function(a, b, c, d) {
            return d.startAt = c,
            d.immediateRender = 0 != d.immediateRender && 0 != c.immediateRender,
            new f(a,b,d)
        }
        ,
        f.staggerTo = f.allTo = function(a, b, g, h, k, m, n) {
            h = h || 0;
            var o, p, q, r, s = 0, t = [], u = function() {
                g.onComplete && g.onComplete.apply(g.onCompleteScope || this, arguments),
                k.apply(n || g.callbackScope || this, m || l)
            }, v = g.cycle, w = g.startAt && g.startAt.cycle;
            for (j(a) || ("string" == typeof a && (a = c.selector(a) || a),
            i(a) && (a = d(a))),
            a = a || [],
            0 > h && (a = d(a),
            a.reverse(),
            h *= -1),
            o = a.length - 1,
            q = 0; o >= q; q++) {
                p = {};
                for (r in g)
                    p[r] = g[r];
                if (v && e(p, a, q),
                w) {
                    w = p.startAt = {};
                    for (r in g.startAt)
                        w[r] = g.startAt[r];
                    e(p.startAt, a, q)
                }
                p.delay = s + (p.delay || 0),
                q === o && k && (p.onComplete = u),
                t[q] = new f(a[q],b,p),
                s += h
            }
            return t
        }
        ,
        f.staggerFrom = f.allFrom = function(a, b, c, d, e, g, h) {
            return c.runBackwards = !0,
            c.immediateRender = 0 != c.immediateRender,
            f.staggerTo(a, b, c, d, e, g, h)
        }
        ,
        f.staggerFromTo = f.allFromTo = function(a, b, c, d, e, g, h, i) {
            return d.startAt = c,
            d.immediateRender = 0 != d.immediateRender && 0 != c.immediateRender,
            f.staggerTo(a, b, d, e, g, h, i)
        }
        ,
        f.delayedCall = function(a, b, c, d, e) {
            return new f(b,0,{
                delay: a,
                onComplete: b,
                onCompleteParams: c,
                callbackScope: d,
                onReverseComplete: b,
                onReverseCompleteParams: c,
                immediateRender: !1,
                useFrames: e,
                overwrite: 0
            })
        }
        ,
        f.set = function(a, b) {
            return new f(a,0,b)
        }
        ,
        f.isTweening = function(a) {
            return c.getTweensOf(a, !0).length > 0
        }
        ;
        var m = function(a, b) {
            for (var d = [], e = 0, f = a._first; f; )
                f instanceof c ? d[e++] = f : (b && (d[e++] = f),
                d = d.concat(m(f, b)),
                e = d.length),
                f = f._next;
            return d
        }
          , n = f.getAllTweens = function(b) {
            return m(a._rootTimeline, b).concat(m(a._rootFramesTimeline, b))
        }
        ;
        f.killAll = function(a, c, d, e) {
            null == c && (c = !0),
            null == d && (d = !0);
            var f, g, h, i = n(0 != e), j = i.length, k = c && d && e;
            for (h = 0; j > h; h++)
                g = i[h],
                (k || g instanceof b || (f = g.target === g.vars.onComplete) && d || c && !f) && (a ? g.totalTime(g._reversed ? 0 : g.totalDuration()) : g._enabled(!1, !1))
        }
        ,
        f.killChildTweensOf = function(a, b) {
            if (null != a) {
                var e, g, k, l, m, n = h.tweenLookup;
                if ("string" == typeof a && (a = c.selector(a) || a),
                i(a) && (a = d(a)),
                j(a))
                    for (l = a.length; --l > -1; )
                        f.killChildTweensOf(a[l], b);
                else {
                    e = [];
                    for (k in n)
                        for (g = n[k].target.parentNode; g; )
                            g === a && (e = e.concat(n[k].tweens)),
                            g = g.parentNode;
                    for (m = e.length,
                    l = 0; m > l; l++)
                        b && e[l].totalTime(e[l].totalDuration()),
                        e[l]._enabled(!1, !1)
                }
            }
        }
        ;
        var o = function(a, c, d, e) {
            c = c !== !1,
            d = d !== !1,
            e = e !== !1;
            for (var f, g, h = n(e), i = c && d && e, j = h.length; --j > -1; )
                g = h[j],
                (i || g instanceof b || (f = g.target === g.vars.onComplete) && d || c && !f) && g.paused(a)
        };
        return f.pauseAll = function(a, b, c) {
            o(!0, a, b, c)
        }
        ,
        f.resumeAll = function(a, b, c) {
            o(!1, a, b, c)
        }
        ,
        f.globalTimeScale = function(b) {
            var d = a._rootTimeline
              , e = c.ticker.time;
            return arguments.length ? (b = b || g,
            d._startTime = e - (e - d._startTime) * d._timeScale / b,
            d = a._rootFramesTimeline,
            e = c.ticker.frame,
            d._startTime = e - (e - d._startTime) * d._timeScale / b,
            d._timeScale = a._rootTimeline._timeScale = b,
            b) : d._timeScale
        }
        ,
        k.progress = function(a) {
            return arguments.length ? this.totalTime(this.duration() * (this._yoyo && 0 !== (1 & this._cycle) ? 1 - a : a) + this._cycle * (this._duration + this._repeatDelay), !1) : this._time / this.duration()
        }
        ,
        k.totalProgress = function(a) {
            return arguments.length ? this.totalTime(this.totalDuration() * a, !1) : this._totalTime / this.totalDuration()
        }
        ,
        k.time = function(a, b) {
            return arguments.length ? (this._dirty && this.totalDuration(),
            a > this._duration && (a = this._duration),
            this._yoyo && 0 !== (1 & this._cycle) ? a = this._duration - a + this._cycle * (this._duration + this._repeatDelay) : 0 !== this._repeat && (a += this._cycle * (this._duration + this._repeatDelay)),
            this.totalTime(a, b)) : this._time
        }
        ,
        k.duration = function(b) {
            return arguments.length ? a.prototype.duration.call(this, b) : this._duration
        }
        ,
        k.totalDuration = function(a) {
            return arguments.length ? -1 === this._repeat ? this : this.duration((a - this._repeat * this._repeatDelay) / (this._repeat + 1)) : (this._dirty && (this._totalDuration = -1 === this._repeat ? 999999999999 : this._duration * (this._repeat + 1) + this._repeatDelay * this._repeat,
            this._dirty = !1),
            this._totalDuration)
        }
        ,
        k.repeat = function(a) {
            return arguments.length ? (this._repeat = a,
            this._uncache(!0)) : this._repeat
        }
        ,
        k.repeatDelay = function(a) {
            return arguments.length ? (this._repeatDelay = a,
            this._uncache(!0)) : this._repeatDelay
        }
        ,
        k.yoyo = function(a) {
            return arguments.length ? (this._yoyo = a,
            this) : this._yoyo
        }
        ,
        f
    }, !0),
    _gsScope._gsDefine("TimelineLite", ["core.Animation", "core.SimpleTimeline", "TweenLite"], function(a, b, c) {
        var d = function(a) {
            b.call(this, a),
            this._labels = {},
            this.autoRemoveChildren = this.vars.autoRemoveChildren === !0,
            this.smoothChildTiming = this.vars.smoothChildTiming === !0,
            this._sortChildren = !0,
            this._onUpdate = this.vars.onUpdate;
            var c, d, e = this.vars;
            for (d in e)
                c = e[d],
                i(c) && -1 !== c.join("").indexOf("{self}") && (e[d] = this._swapSelfInParams(c));
            i(e.tweens) && this.add(e.tweens, 0, e.align, e.stagger)
        }
          , e = 1e-10
          , f = c._internals
          , g = d._internals = {}
          , h = f.isSelector
          , i = f.isArray
          , j = f.lazyTweens
          , k = f.lazyRender
          , l = _gsScope._gsDefine.globals
          , m = function(a) {
            var b, c = {};
            for (b in a)
                c[b] = a[b];
            return c
        }
          , n = function(a, b, c) {
            var d, e, f = a.cycle;
            for (d in f)
                e = f[d],
                a[d] = "function" == typeof e ? e.call(b[c], c) : e[c % e.length];
            delete a.cycle
        }
          , o = g.pauseCallback = function() {}
          , p = function(a) {
            var b, c = [], d = a.length;
            for (b = 0; b !== d; c.push(a[b++]))
                ;
            return c
        }
          , q = d.prototype = new b;
        return d.version = "1.18.2",
        q.constructor = d,
        q.kill()._gc = q._forcingPlayhead = q._hasPause = !1,
        q.to = function(a, b, d, e) {
            var f = d.repeat && l.TweenMax || c;
            return b ? this.add(new f(a,b,d), e) : this.set(a, d, e)
        }
        ,
        q.from = function(a, b, d, e) {
            return this.add((d.repeat && l.TweenMax || c).from(a, b, d), e)
        }
        ,
        q.fromTo = function(a, b, d, e, f) {
            var g = e.repeat && l.TweenMax || c;
            return b ? this.add(g.fromTo(a, b, d, e), f) : this.set(a, e, f)
        }
        ,
        q.staggerTo = function(a, b, e, f, g, i, j, k) {
            var l, o, q = new d({
                onComplete: i,
                onCompleteParams: j,
                callbackScope: k,
                smoothChildTiming: this.smoothChildTiming
            }), r = e.cycle;
            for ("string" == typeof a && (a = c.selector(a) || a),
            a = a || [],
            h(a) && (a = p(a)),
            f = f || 0,
            0 > f && (a = p(a),
            a.reverse(),
            f *= -1),
            o = 0; o < a.length; o++)
                l = m(e),
                l.startAt && (l.startAt = m(l.startAt),
                l.startAt.cycle && n(l.startAt, a, o)),
                r && n(l, a, o),
                q.to(a[o], b, l, o * f);
            return this.add(q, g)
        }
        ,
        q.staggerFrom = function(a, b, c, d, e, f, g, h) {
            return c.immediateRender = 0 != c.immediateRender,
            c.runBackwards = !0,
            this.staggerTo(a, b, c, d, e, f, g, h)
        }
        ,
        q.staggerFromTo = function(a, b, c, d, e, f, g, h, i) {
            return d.startAt = c,
            d.immediateRender = 0 != d.immediateRender && 0 != c.immediateRender,
            this.staggerTo(a, b, d, e, f, g, h, i)
        }
        ,
        q.call = function(a, b, d, e) {
            return this.add(c.delayedCall(0, a, b, d), e)
        }
        ,
        q.set = function(a, b, d) {
            return d = this._parseTimeOrLabel(d, 0, !0),
            null == b.immediateRender && (b.immediateRender = d === this._time && !this._paused),
            this.add(new c(a,0,b), d)
        }
        ,
        d.exportRoot = function(a, b) {
            a = a || {},
            null == a.smoothChildTiming && (a.smoothChildTiming = !0);
            var e, f, g = new d(a), h = g._timeline;
            for (null == b && (b = !0),
            h._remove(g, !0),
            g._startTime = 0,
            g._rawPrevTime = g._time = g._totalTime = h._time,
            e = h._first; e; )
                f = e._next,
                b && e instanceof c && e.target === e.vars.onComplete || g.add(e, e._startTime - e._delay),
                e = f;
            return h.add(g, 0),
            g
        }
        ,
        q.add = function(e, f, g, h) {
            var j, k, l, m, n, o;
            if ("number" != typeof f && (f = this._parseTimeOrLabel(f, 0, !0, e)),
            !(e instanceof a)) {
                if (e instanceof Array || e && e.push && i(e)) {
                    for (g = g || "normal",
                    h = h || 0,
                    j = f,
                    k = e.length,
                    l = 0; k > l; l++)
                        i(m = e[l]) && (m = new d({
                            tweens: m
                        })),
                        this.add(m, j),
                        "string" != typeof m && "function" != typeof m && ("sequence" === g ? j = m._startTime + m.totalDuration() / m._timeScale : "start" === g && (m._startTime -= m.delay())),
                        j += h;
                    return this._uncache(!0)
                }
                if ("string" == typeof e)
                    return this.addLabel(e, f);
                if ("function" != typeof e)
                    throw "Cannot add " + e + " into the timeline; it is not a tween, timeline, function, or string.";
                e = c.delayedCall(0, e)
            }
            if (b.prototype.add.call(this, e, f),
            (this._gc || this._time === this._duration) && !this._paused && this._duration < this.duration())
                for (n = this,
                o = n.rawTime() > e._startTime; n._timeline; )
                    o && n._timeline.smoothChildTiming ? n.totalTime(n._totalTime, !0) : n._gc && n._enabled(!0, !1),
                    n = n._timeline;
            return this
        }
        ,
        q.remove = function(b) {
            if (b instanceof a) {
                this._remove(b, !1);
                var c = b._timeline = b.vars.useFrames ? a._rootFramesTimeline : a._rootTimeline;
                return b._startTime = (b._paused ? b._pauseTime : c._time) - (b._reversed ? b.totalDuration() - b._totalTime : b._totalTime) / b._timeScale,
                this
            }
            if (b instanceof Array || b && b.push && i(b)) {
                for (var d = b.length; --d > -1; )
                    this.remove(b[d]);
                return this
            }
            return "string" == typeof b ? this.removeLabel(b) : this.kill(null, b)
        }
        ,
        q._remove = function(a, c) {
            b.prototype._remove.call(this, a, c);
            var d = this._last;
            return d ? this._time > d._startTime + d._totalDuration / d._timeScale && (this._time = this.duration(),
            this._totalTime = this._totalDuration) : this._time = this._totalTime = this._duration = this._totalDuration = 0,
            this
        }
        ,
        q.append = function(a, b) {
            return this.add(a, this._parseTimeOrLabel(null, b, !0, a))
        }
        ,
        q.insert = q.insertMultiple = function(a, b, c, d) {
            return this.add(a, b || 0, c, d)
        }
        ,
        q.appendMultiple = function(a, b, c, d) {
            return this.add(a, this._parseTimeOrLabel(null, b, !0, a), c, d)
        }
        ,
        q.addLabel = function(a, b) {
            return this._labels[a] = this._parseTimeOrLabel(b),
            this
        }
        ,
        q.addPause = function(a, b, d, e) {
            var f = c.delayedCall(0, o, d, e || this);
            return f.vars.onComplete = f.vars.onReverseComplete = b,
            f.data = "isPause",
            this._hasPause = !0,
            this.add(f, a)
        }
        ,
        q.removeLabel = function(a) {
            return delete this._labels[a],
            this
        }
        ,
        q.getLabelTime = function(a) {
            return null != this._labels[a] ? this._labels[a] : -1
        }
        ,
        q._parseTimeOrLabel = function(b, c, d, e) {
            var f;
            if (e instanceof a && e.timeline === this)
                this.remove(e);
            else if (e && (e instanceof Array || e.push && i(e)))
                for (f = e.length; --f > -1; )
                    e[f]instanceof a && e[f].timeline === this && this.remove(e[f]);
            if ("string" == typeof c)
                return this._parseTimeOrLabel(c, d && "number" == typeof b && null == this._labels[c] ? b - this.duration() : 0, d);
            if (c = c || 0,
            "string" != typeof b || !isNaN(b) && null == this._labels[b])
                null == b && (b = this.duration());
            else {
                if (f = b.indexOf("="),
                -1 === f)
                    return null == this._labels[b] ? d ? this._labels[b] = this.duration() + c : c : this._labels[b] + c;
                c = parseInt(b.charAt(f - 1) + "1", 10) * Number(b.substr(f + 1)),
                b = f > 1 ? this._parseTimeOrLabel(b.substr(0, f - 1), 0, d) : this.duration()
            }
            return Number(b) + c
        }
        ,
        q.seek = function(a, b) {
            return this.totalTime("number" == typeof a ? a : this._parseTimeOrLabel(a), b !== !1)
        }
        ,
        q.stop = function() {
            return this.paused(!0)
        }
        ,
        q.gotoAndPlay = function(a, b) {
            return this.play(a, b)
        }
        ,
        q.gotoAndStop = function(a, b) {
            return this.pause(a, b)
        }
        ,
        q.render = function(a, b, c) {
            this._gc && this._enabled(!0, !1);
            var d, f, g, h, i, l, m, n = this._dirty ? this.totalDuration() : this._totalDuration, o = this._time, p = this._startTime, q = this._timeScale, r = this._paused;
            if (a >= n - 1e-7)
                this._totalTime = this._time = n,
                this._reversed || this._hasPausedChild() || (f = !0,
                h = "onComplete",
                i = !!this._timeline.autoRemoveChildren,
                0 === this._duration && (0 >= a && a >= -1e-7 || this._rawPrevTime < 0 || this._rawPrevTime === e) && this._rawPrevTime !== a && this._first && (i = !0,
                this._rawPrevTime > e && (h = "onReverseComplete"))),
                this._rawPrevTime = this._duration || !b || a || this._rawPrevTime === a ? a : e,
                a = n + 1e-4;
            else if (1e-7 > a)
                if (this._totalTime = this._time = 0,
                (0 !== o || 0 === this._duration && this._rawPrevTime !== e && (this._rawPrevTime > 0 || 0 > a && this._rawPrevTime >= 0)) && (h = "onReverseComplete",
                f = this._reversed),
                0 > a)
                    this._active = !1,
                    this._timeline.autoRemoveChildren && this._reversed ? (i = f = !0,
                    h = "onReverseComplete") : this._rawPrevTime >= 0 && this._first && (i = !0),
                    this._rawPrevTime = a;
                else {
                    if (this._rawPrevTime = this._duration || !b || a || this._rawPrevTime === a ? a : e,
                    0 === a && f)
                        for (d = this._first; d && 0 === d._startTime; )
                            d._duration || (f = !1),
                            d = d._next;
                    a = 0,
                    this._initted || (i = !0)
                }
            else {
                if (this._hasPause && !this._forcingPlayhead && !b) {
                    if (a >= o)
                        for (d = this._first; d && d._startTime <= a && !l; )
                            d._duration || "isPause" !== d.data || d.ratio || 0 === d._startTime && 0 === this._rawPrevTime || (l = d),
                            d = d._next;
                    else
                        for (d = this._last; d && d._startTime >= a && !l; )
                            d._duration || "isPause" === d.data && d._rawPrevTime > 0 && (l = d),
                            d = d._prev;
                    l && (this._time = a = l._startTime,
                    this._totalTime = a + this._cycle * (this._totalDuration + this._repeatDelay))
                }
                this._totalTime = this._time = this._rawPrevTime = a
            }
            if (this._time !== o && this._first || c || i || l) {
                if (this._initted || (this._initted = !0),
                this._active || !this._paused && this._time !== o && a > 0 && (this._active = !0),
                0 === o && this.vars.onStart && 0 !== this._time && (b || this._callback("onStart")),
                m = this._time,
                m >= o)
                    for (d = this._first; d && (g = d._next,
                    m === this._time && (!this._paused || r)); )
                        (d._active || d._startTime <= m && !d._paused && !d._gc) && (l === d && this.pause(),
                        d._reversed ? d.render((d._dirty ? d.totalDuration() : d._totalDuration) - (a - d._startTime) * d._timeScale, b, c) : d.render((a - d._startTime) * d._timeScale, b, c)),
                        d = g;
                else
                    for (d = this._last; d && (g = d._prev,
                    m === this._time && (!this._paused || r)); ) {
                        if (d._active || d._startTime <= o && !d._paused && !d._gc) {
                            if (l === d) {
                                for (l = d._prev; l && l.endTime() > this._time; )
                                    l.render(l._reversed ? l.totalDuration() - (a - l._startTime) * l._timeScale : (a - l._startTime) * l._timeScale, b, c),
                                    l = l._prev;
                                l = null,
                                this.pause()
                            }
                            d._reversed ? d.render((d._dirty ? d.totalDuration() : d._totalDuration) - (a - d._startTime) * d._timeScale, b, c) : d.render((a - d._startTime) * d._timeScale, b, c)
                        }
                        d = g
                    }
                this._onUpdate && (b || (j.length && k(),
                this._callback("onUpdate"))),
                h && (this._gc || (p === this._startTime || q !== this._timeScale) && (0 === this._time || n >= this.totalDuration()) && (f && (j.length && k(),
                this._timeline.autoRemoveChildren && this._enabled(!1, !1),
                this._active = !1),
                !b && this.vars[h] && this._callback(h)))
            }
        }
        ,
        q._hasPausedChild = function() {
            for (var a = this._first; a; ) {
                if (a._paused || a instanceof d && a._hasPausedChild())
                    return !0;
                a = a._next
            }
            return !1
        }
        ,
        q.getChildren = function(a, b, d, e) {
            e = e || -9999999999;
            for (var f = [], g = this._first, h = 0; g; )
                g._startTime < e || (g instanceof c ? b !== !1 && (f[h++] = g) : (d !== !1 && (f[h++] = g),
                a !== !1 && (f = f.concat(g.getChildren(!0, b, d)),
                h = f.length))),
                g = g._next;
            return f
        }
        ,
        q.getTweensOf = function(a, b) {
            var d, e, f = this._gc, g = [], h = 0;
            for (f && this._enabled(!0, !0),
            d = c.getTweensOf(a),
            e = d.length; --e > -1; )
                (d[e].timeline === this || b && this._contains(d[e])) && (g[h++] = d[e]);
            return f && this._enabled(!1, !0),
            g
        }
        ,
        q.recent = function() {
            return this._recent
        }
        ,
        q._contains = function(a) {
            for (var b = a.timeline; b; ) {
                if (b === this)
                    return !0;
                b = b.timeline
            }
            return !1
        }
        ,
        q.shiftChildren = function(a, b, c) {
            c = c || 0;
            for (var d, e = this._first, f = this._labels; e; )
                e._startTime >= c && (e._startTime += a),
                e = e._next;
            if (b)
                for (d in f)
                    f[d] >= c && (f[d] += a);
            return this._uncache(!0)
        }
        ,
        q._kill = function(a, b) {
            if (!a && !b)
                return this._enabled(!1, !1);
            for (var c = b ? this.getTweensOf(b) : this.getChildren(!0, !0, !1), d = c.length, e = !1; --d > -1; )
                c[d]._kill(a, b) && (e = !0);
            return e
        }
        ,
        q.clear = function(a) {
            var b = this.getChildren(!1, !0, !0)
              , c = b.length;
            for (this._time = this._totalTime = 0; --c > -1; )
                b[c]._enabled(!1, !1);
            return a !== !1 && (this._labels = {}),
            this._uncache(!0)
        }
        ,
        q.invalidate = function() {
            for (var b = this._first; b; )
                b.invalidate(),
                b = b._next;
            return a.prototype.invalidate.call(this)
        }
        ,
        q._enabled = function(a, c) {
            if (a === this._gc)
                for (var d = this._first; d; )
                    d._enabled(a, !0),
                    d = d._next;
            return b.prototype._enabled.call(this, a, c)
        }
        ,
        q.totalTime = function(b, c, d) {
            this._forcingPlayhead = !0;
            var e = a.prototype.totalTime.apply(this, arguments);
            return this._forcingPlayhead = !1,
            e
        }
        ,
        q.duration = function(a) {
            return arguments.length ? (0 !== this.duration() && 0 !== a && this.timeScale(this._duration / a),
            this) : (this._dirty && this.totalDuration(),
            this._duration)
        }
        ,
        q.totalDuration = function(a) {
            if (!arguments.length) {
                if (this._dirty) {
                    for (var b, c, d = 0, e = this._last, f = 999999999999; e; )
                        b = e._prev,
                        e._dirty && e.totalDuration(),
                        e._startTime > f && this._sortChildren && !e._paused ? this.add(e, e._startTime - e._delay) : f = e._startTime,
                        e._startTime < 0 && !e._paused && (d -= e._startTime,
                        this._timeline.smoothChildTiming && (this._startTime += e._startTime / this._timeScale),
                        this.shiftChildren(-e._startTime, !1, -9999999999),
                        f = 0),
                        c = e._startTime + e._totalDuration / e._timeScale,
                        c > d && (d = c),
                        e = b;
                    this._duration = this._totalDuration = d,
                    this._dirty = !1
                }
                return this._totalDuration
            }
            return a && this.totalDuration() ? this.timeScale(this._totalDuration / a) : this
        }
        ,
        q.paused = function(b) {
            if (!b)
                for (var c = this._first, d = this._time; c; )
                    c._startTime === d && "isPause" === c.data && (c._rawPrevTime = 0),
                    c = c._next;
            return a.prototype.paused.apply(this, arguments)
        }
        ,
        q.usesFrames = function() {
            for (var b = this._timeline; b._timeline; )
                b = b._timeline;
            return b === a._rootFramesTimeline
        }
        ,
        q.rawTime = function() {
            return this._paused ? this._totalTime : (this._timeline.rawTime() - this._startTime) * this._timeScale
        }
        ,
        d
    }, !0),
    _gsScope._gsDefine("TimelineMax", ["TimelineLite", "TweenLite", "easing.Ease"], function(a, b, c) {
        var d = function(b) {
            a.call(this, b),
            this._repeat = this.vars.repeat || 0,
            this._repeatDelay = this.vars.repeatDelay || 0,
            this._cycle = 0,
            this._yoyo = this.vars.yoyo === !0,
            this._dirty = !0
        }
          , e = 1e-10
          , f = b._internals
          , g = f.lazyTweens
          , h = f.lazyRender
          , i = new c(null,null,1,0)
          , j = d.prototype = new a;
        return j.constructor = d,
        j.kill()._gc = !1,
        d.version = "1.18.2",
        j.invalidate = function() {
            return this._yoyo = this.vars.yoyo === !0,
            this._repeat = this.vars.repeat || 0,
            this._repeatDelay = this.vars.repeatDelay || 0,
            this._uncache(!0),
            a.prototype.invalidate.call(this)
        }
        ,
        j.addCallback = function(a, c, d, e) {
            return this.add(b.delayedCall(0, a, d, e), c)
        }
        ,
        j.removeCallback = function(a, b) {
            if (a)
                if (null == b)
                    this._kill(null, a);
                else
                    for (var c = this.getTweensOf(a, !1), d = c.length, e = this._parseTimeOrLabel(b); --d > -1; )
                        c[d]._startTime === e && c[d]._enabled(!1, !1);
            return this
        }
        ,
        j.removePause = function(b) {
            return this.removeCallback(a._internals.pauseCallback, b)
        }
        ,
        j.tweenTo = function(a, c) {
            c = c || {};
            var d, e, f, g = {
                ease: i,
                useFrames: this.usesFrames(),
                immediateRender: !1
            };
            for (e in c)
                g[e] = c[e];
            return g.time = this._parseTimeOrLabel(a),
            d = Math.abs(Number(g.time) - this._time) / this._timeScale || .001,
            f = new b(this,d,g),
            g.onStart = function() {
                f.target.paused(!0),
                f.vars.time !== f.target.time() && d === f.duration() && f.duration(Math.abs(f.vars.time - f.target.time()) / f.target._timeScale),
                c.onStart && f._callback("onStart")
            }
            ,
            f
        }
        ,
        j.tweenFromTo = function(a, b, c) {
            c = c || {},
            a = this._parseTimeOrLabel(a),
            c.startAt = {
                onComplete: this.seek,
                onCompleteParams: [a],
                callbackScope: this
            },
            c.immediateRender = c.immediateRender !== !1;
            var d = this.tweenTo(b, c);
            return d.duration(Math.abs(d.vars.time - a) / this._timeScale || .001)
        }
        ,
        j.render = function(a, b, c) {
            this._gc && this._enabled(!0, !1);
            var d, f, i, j, k, l, m, n, o = this._dirty ? this.totalDuration() : this._totalDuration, p = this._duration, q = this._time, r = this._totalTime, s = this._startTime, t = this._timeScale, u = this._rawPrevTime, v = this._paused, w = this._cycle;
            if (a >= o - 1e-7)
                this._locked || (this._totalTime = o,
                this._cycle = this._repeat),
                this._reversed || this._hasPausedChild() || (f = !0,
                j = "onComplete",
                k = !!this._timeline.autoRemoveChildren,
                0 === this._duration && (0 >= a && a >= -1e-7 || 0 > u || u === e) && u !== a && this._first && (k = !0,
                u > e && (j = "onReverseComplete"))),
                this._rawPrevTime = this._duration || !b || a || this._rawPrevTime === a ? a : e,
                this._yoyo && 0 !== (1 & this._cycle) ? this._time = a = 0 : (this._time = p,
                a = p + 1e-4);
            else if (1e-7 > a)
                if (this._locked || (this._totalTime = this._cycle = 0),
                this._time = 0,
                (0 !== q || 0 === p && u !== e && (u > 0 || 0 > a && u >= 0) && !this._locked) && (j = "onReverseComplete",
                f = this._reversed),
                0 > a)
                    this._active = !1,
                    this._timeline.autoRemoveChildren && this._reversed ? (k = f = !0,
                    j = "onReverseComplete") : u >= 0 && this._first && (k = !0),
                    this._rawPrevTime = a;
                else {
                    if (this._rawPrevTime = p || !b || a || this._rawPrevTime === a ? a : e,
                    0 === a && f)
                        for (d = this._first; d && 0 === d._startTime; )
                            d._duration || (f = !1),
                            d = d._next;
                    a = 0,
                    this._initted || (k = !0)
                }
            else if (0 === p && 0 > u && (k = !0),
            this._time = this._rawPrevTime = a,
            this._locked || (this._totalTime = a,
            0 !== this._repeat && (l = p + this._repeatDelay,
            this._cycle = this._totalTime / l >> 0,
            0 !== this._cycle && this._cycle === this._totalTime / l && this._cycle--,
            this._time = this._totalTime - this._cycle * l,
            this._yoyo && 0 !== (1 & this._cycle) && (this._time = p - this._time),
            this._time > p ? (this._time = p,
            a = p + 1e-4) : this._time < 0 ? this._time = a = 0 : a = this._time)),
            this._hasPause && !this._forcingPlayhead && !b) {
                if (a = this._time,
                a >= q)
                    for (d = this._first; d && d._startTime <= a && !m; )
                        d._duration || "isPause" !== d.data || d.ratio || 0 === d._startTime && 0 === this._rawPrevTime || (m = d),
                        d = d._next;
                else
                    for (d = this._last; d && d._startTime >= a && !m; )
                        d._duration || "isPause" === d.data && d._rawPrevTime > 0 && (m = d),
                        d = d._prev;
                m && (this._time = a = m._startTime,
                this._totalTime = a + this._cycle * (this._totalDuration + this._repeatDelay))
            }
            if (this._cycle !== w && !this._locked) {
                var x = this._yoyo && 0 !== (1 & w)
                  , y = x === (this._yoyo && 0 !== (1 & this._cycle))
                  , z = this._totalTime
                  , A = this._cycle
                  , B = this._rawPrevTime
                  , C = this._time;
                if (this._totalTime = w * p,
                this._cycle < w ? x = !x : this._totalTime += p,
                this._time = q,
                this._rawPrevTime = 0 === p ? u - 1e-4 : u,
                this._cycle = w,
                this._locked = !0,
                q = x ? 0 : p,
                this.render(q, b, 0 === p),
                b || this._gc || this.vars.onRepeat && this._callback("onRepeat"),
                q !== this._time)
                    return;
                if (y && (q = x ? p + 1e-4 : -1e-4,
                this.render(q, !0, !1)),
                this._locked = !1,
                this._paused && !v)
                    return;
                this._time = C,
                this._totalTime = z,
                this._cycle = A,
                this._rawPrevTime = B
            }
            if (!(this._time !== q && this._first || c || k || m))
                return void (r !== this._totalTime && this._onUpdate && (b || this._callback("onUpdate")));
            if (this._initted || (this._initted = !0),
            this._active || !this._paused && this._totalTime !== r && a > 0 && (this._active = !0),
            0 === r && this.vars.onStart && 0 !== this._totalTime && (b || this._callback("onStart")),
            n = this._time,
            n >= q)
                for (d = this._first; d && (i = d._next,
                n === this._time && (!this._paused || v)); )
                    (d._active || d._startTime <= this._time && !d._paused && !d._gc) && (m === d && this.pause(),
                    d._reversed ? d.render((d._dirty ? d.totalDuration() : d._totalDuration) - (a - d._startTime) * d._timeScale, b, c) : d.render((a - d._startTime) * d._timeScale, b, c)),
                    d = i;
            else
                for (d = this._last; d && (i = d._prev,
                n === this._time && (!this._paused || v)); ) {
                    if (d._active || d._startTime <= q && !d._paused && !d._gc) {
                        if (m === d) {
                            for (m = d._prev; m && m.endTime() > this._time; )
                                m.render(m._reversed ? m.totalDuration() - (a - m._startTime) * m._timeScale : (a - m._startTime) * m._timeScale, b, c),
                                m = m._prev;
                            m = null,
                            this.pause()
                        }
                        d._reversed ? d.render((d._dirty ? d.totalDuration() : d._totalDuration) - (a - d._startTime) * d._timeScale, b, c) : d.render((a - d._startTime) * d._timeScale, b, c)
                    }
                    d = i
                }
            this._onUpdate && (b || (g.length && h(),
            this._callback("onUpdate"))),
            j && (this._locked || this._gc || (s === this._startTime || t !== this._timeScale) && (0 === this._time || o >= this.totalDuration()) && (f && (g.length && h(),
            this._timeline.autoRemoveChildren && this._enabled(!1, !1),
            this._active = !1),
            !b && this.vars[j] && this._callback(j)))
        }
        ,
        j.getActive = function(a, b, c) {
            null == a && (a = !0),
            null == b && (b = !0),
            null == c && (c = !1);
            var d, e, f = [], g = this.getChildren(a, b, c), h = 0, i = g.length;
            for (d = 0; i > d; d++)
                e = g[d],
                e.isActive() && (f[h++] = e);
            return f
        }
        ,
        j.getLabelAfter = function(a) {
            a || 0 !== a && (a = this._time);
            var b, c = this.getLabelsArray(), d = c.length;
            for (b = 0; d > b; b++)
                if (c[b].time > a)
                    return c[b].name;
            return null
        }
        ,
        j.getLabelBefore = function(a) {
            null == a && (a = this._time);
            for (var b = this.getLabelsArray(), c = b.length; --c > -1; )
                if (b[c].time < a)
                    return b[c].name;
            return null
        }
        ,
        j.getLabelsArray = function() {
            var a, b = [], c = 0;
            for (a in this._labels)
                b[c++] = {
                    time: this._labels[a],
                    name: a
                };
            return b.sort(function(a, b) {
                return a.time - b.time
            }),
            b
        }
        ,
        j.progress = function(a, b) {
            return arguments.length ? this.totalTime(this.duration() * (this._yoyo && 0 !== (1 & this._cycle) ? 1 - a : a) + this._cycle * (this._duration + this._repeatDelay), b) : this._time / this.duration()
        }
        ,
        j.totalProgress = function(a, b) {
            return arguments.length ? this.totalTime(this.totalDuration() * a, b) : this._totalTime / this.totalDuration()
        }
        ,
        j.totalDuration = function(b) {
            return arguments.length ? -1 !== this._repeat && b ? this.timeScale(this.totalDuration() / b) : this : (this._dirty && (a.prototype.totalDuration.call(this),
            this._totalDuration = -1 === this._repeat ? 999999999999 : this._duration * (this._repeat + 1) + this._repeatDelay * this._repeat),
            this._totalDuration)
        }
        ,
        j.time = function(a, b) {
            return arguments.length ? (this._dirty && this.totalDuration(),
            a > this._duration && (a = this._duration),
            this._yoyo && 0 !== (1 & this._cycle) ? a = this._duration - a + this._cycle * (this._duration + this._repeatDelay) : 0 !== this._repeat && (a += this._cycle * (this._duration + this._repeatDelay)),
            this.totalTime(a, b)) : this._time
        }
        ,
        j.repeat = function(a) {
            return arguments.length ? (this._repeat = a,
            this._uncache(!0)) : this._repeat
        }
        ,
        j.repeatDelay = function(a) {
            return arguments.length ? (this._repeatDelay = a,
            this._uncache(!0)) : this._repeatDelay
        }
        ,
        j.yoyo = function(a) {
            return arguments.length ? (this._yoyo = a,
            this) : this._yoyo
        }
        ,
        j.currentLabel = function(a) {
            return arguments.length ? this.seek(a, !0) : this.getLabelBefore(this._time + 1e-8)
        }
        ,
        d
    }, !0),
    function() {
        var a = 180 / Math.PI
          , b = []
          , c = []
          , d = []
          , e = {}
          , f = _gsScope._gsDefine.globals
          , g = function(a, b, c, d) {
            this.a = a,
            this.b = b,
            this.c = c,
            this.d = d,
            this.da = d - a,
            this.ca = c - a,
            this.ba = b - a
        }
          , h = ",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,"
          , i = function(a, b, c, d) {
            var e = {
                a: a
            }
              , f = {}
              , g = {}
              , h = {
                c: d
            }
              , i = (a + b) / 2
              , j = (b + c) / 2
              , k = (c + d) / 2
              , l = (i + j) / 2
              , m = (j + k) / 2
              , n = (m - l) / 8;
            return e.b = i + (a - i) / 4,
            f.b = l + n,
            e.c = f.a = (e.b + f.b) / 2,
            f.c = g.a = (l + m) / 2,
            g.b = m - n,
            h.b = k + (d - k) / 4,
            g.c = h.a = (g.b + h.b) / 2,
            [e, f, g, h]
        }
          , j = function(a, e, f, g, h) {
            var j, k, l, m, n, o, p, q, r, s, t, u, v, w = a.length - 1, x = 0, y = a[0].a;
            for (j = 0; w > j; j++)
                n = a[x],
                k = n.a,
                l = n.d,
                m = a[x + 1].d,
                h ? (t = b[j],
                u = c[j],
                v = (u + t) * e * .25 / (g ? .5 : d[j] || .5),
                o = l - (l - k) * (g ? .5 * e : 0 !== t ? v / t : 0),
                p = l + (m - l) * (g ? .5 * e : 0 !== u ? v / u : 0),
                q = l - (o + ((p - o) * (3 * t / (t + u) + .5) / 4 || 0))) : (o = l - (l - k) * e * .5,
                p = l + (m - l) * e * .5,
                q = l - (o + p) / 2),
                o += q,
                p += q,
                n.c = r = o,
                0 !== j ? n.b = y : n.b = y = n.a + .6 * (n.c - n.a),
                n.da = l - k,
                n.ca = r - k,
                n.ba = y - k,
                f ? (s = i(k, y, r, l),
                a.splice(x, 1, s[0], s[1], s[2], s[3]),
                x += 4) : x++,
                y = p;
            n = a[x],
            n.b = y,
            n.c = y + .4 * (n.d - y),
            n.da = n.d - n.a,
            n.ca = n.c - n.a,
            n.ba = y - n.a,
            f && (s = i(n.a, y, n.c, n.d),
            a.splice(x, 1, s[0], s[1], s[2], s[3]))
        }
          , k = function(a, d, e, f) {
            var h, i, j, k, l, m, n = [];
            if (f)
                for (a = [f].concat(a),
                i = a.length; --i > -1; )
                    "string" == typeof (m = a[i][d]) && "=" === m.charAt(1) && (a[i][d] = f[d] + Number(m.charAt(0) + m.substr(2)));
            if (h = a.length - 2,
            0 > h)
                return n[0] = new g(a[0][d],0,0,a[-1 > h ? 0 : 1][d]),
                n;
            for (i = 0; h > i; i++)
                j = a[i][d],
                k = a[i + 1][d],
                n[i] = new g(j,0,0,k),
                e && (l = a[i + 2][d],
                b[i] = (b[i] || 0) + (k - j) * (k - j),
                c[i] = (c[i] || 0) + (l - k) * (l - k));
            return n[i] = new g(a[i][d],0,0,a[i + 1][d]),
            n
        }
          , l = function(a, f, g, i, l, m) {
            var n, o, p, q, r, s, t, u, v = {}, w = [], x = m || a[0];
            l = "string" == typeof l ? "," + l + "," : h,
            null == f && (f = 1);
            for (o in a[0])
                w.push(o);
            if (a.length > 1) {
                for (u = a[a.length - 1],
                t = !0,
                n = w.length; --n > -1; )
                    if (o = w[n],
                    Math.abs(x[o] - u[o]) > .05) {
                        t = !1;
                        break
                    }
                t && (a = a.concat(),
                m && a.unshift(m),
                a.push(a[1]),
                m = a[a.length - 3])
            }
            for (b.length = c.length = d.length = 0,
            n = w.length; --n > -1; )
                o = w[n],
                e[o] = -1 !== l.indexOf("," + o + ","),
                v[o] = k(a, o, e[o], m);
            for (n = b.length; --n > -1; )
                b[n] = Math.sqrt(b[n]),
                c[n] = Math.sqrt(c[n]);
            if (!i) {
                for (n = w.length; --n > -1; )
                    if (e[o])
                        for (p = v[w[n]],
                        s = p.length - 1,
                        q = 0; s > q; q++)
                            r = p[q + 1].da / c[q] + p[q].da / b[q],
                            d[q] = (d[q] || 0) + r * r;
                for (n = d.length; --n > -1; )
                    d[n] = Math.sqrt(d[n])
            }
            for (n = w.length,
            q = g ? 4 : 1; --n > -1; )
                o = w[n],
                p = v[o],
                j(p, f, g, i, e[o]),
                t && (p.splice(0, q),
                p.splice(p.length - q, q));
            return v
        }
          , m = function(a, b, c) {
            b = b || "soft";
            var d, e, f, h, i, j, k, l, m, n, o, p = {}, q = "cubic" === b ? 3 : 2, r = "soft" === b, s = [];
            if (r && c && (a = [c].concat(a)),
            null == a || a.length < q + 1)
                throw "invalid Bezier data";
            for (m in a[0])
                s.push(m);
            for (j = s.length; --j > -1; ) {
                for (m = s[j],
                p[m] = i = [],
                n = 0,
                l = a.length,
                k = 0; l > k; k++)
                    d = null == c ? a[k][m] : "string" == typeof (o = a[k][m]) && "=" === o.charAt(1) ? c[m] + Number(o.charAt(0) + o.substr(2)) : Number(o),
                    r && k > 1 && l - 1 > k && (i[n++] = (d + i[n - 2]) / 2),
                    i[n++] = d;
                for (l = n - q + 1,
                n = 0,
                k = 0; l > k; k += q)
                    d = i[k],
                    e = i[k + 1],
                    f = i[k + 2],
                    h = 2 === q ? 0 : i[k + 3],
                    i[n++] = o = 3 === q ? new g(d,e,f,h) : new g(d,(2 * e + d) / 3,(2 * e + f) / 3,f);
                i.length = n
            }
            return p
        }
          , n = function(a, b, c) {
            for (var d, e, f, g, h, i, j, k, l, m, n, o = 1 / c, p = a.length; --p > -1; )
                for (m = a[p],
                f = m.a,
                g = m.d - f,
                h = m.c - f,
                i = m.b - f,
                d = e = 0,
                k = 1; c >= k; k++)
                    j = o * k,
                    l = 1 - j,
                    d = e - (e = (j * j * g + 3 * l * (j * h + l * i)) * j),
                    n = p * c + k - 1,
                    b[n] = (b[n] || 0) + d * d
        }
          , o = function(a, b) {
            b = b >> 0 || 6;
            var c, d, e, f, g = [], h = [], i = 0, j = 0, k = b - 1, l = [], m = [];
            for (c in a)
                n(a[c], g, b);
            for (e = g.length,
            d = 0; e > d; d++)
                i += Math.sqrt(g[d]),
                f = d % b,
                m[f] = i,
                f === k && (j += i,
                f = d / b >> 0,
                l[f] = m,
                h[f] = j,
                i = 0,
                m = []);
            return {
                length: j,
                lengths: h,
                segments: l
            }
        }
          , p = _gsScope._gsDefine.plugin({
            propName: "bezier",
            priority: -1,
            version: "1.3.4",
            API: 2,
            global: !0,
            init: function(a, b, c) {
                this._target = a,
                b instanceof Array && (b = {
                    values: b
                }),
                this._func = {},
                this._round = {},
                this._props = [],
                this._timeRes = null == b.timeResolution ? 6 : parseInt(b.timeResolution, 10);
                var d, e, f, g, h, i = b.values || [], j = {}, k = i[0], n = b.autoRotate || c.vars.orientToBezier;
                this._autoRotate = n ? n instanceof Array ? n : [["x", "y", "rotation", n === !0 ? 0 : Number(n) || 0]] : null;
                for (d in k)
                    this._props.push(d);
                for (f = this._props.length; --f > -1; )
                    d = this._props[f],
                    this._overwriteProps.push(d),
                    e = this._func[d] = "function" == typeof a[d],
                    j[d] = e ? a[d.indexOf("set") || "function" != typeof a["get" + d.substr(3)] ? d : "get" + d.substr(3)]() : parseFloat(a[d]),
                    h || j[d] !== i[0][d] && (h = j);
                if (this._beziers = "cubic" !== b.type && "quadratic" !== b.type && "soft" !== b.type ? l(i, isNaN(b.curviness) ? 1 : b.curviness, !1, "thruBasic" === b.type, b.correlate, h) : m(i, b.type, j),
                this._segCount = this._beziers[d].length,
                this._timeRes) {
                    var p = o(this._beziers, this._timeRes);
                    this._length = p.length,
                    this._lengths = p.lengths,
                    this._segments = p.segments,
                    this._l1 = this._li = this._s1 = this._si = 0,
                    this._l2 = this._lengths[0],
                    this._curSeg = this._segments[0],
                    this._s2 = this._curSeg[0],
                    this._prec = 1 / this._curSeg.length
                }
                if (n = this._autoRotate)
                    for (this._initialRotations = [],
                    n[0]instanceof Array || (this._autoRotate = n = [n]),
                    f = n.length; --f > -1; ) {
                        for (g = 0; 3 > g; g++)
                            d = n[f][g],
                            this._func[d] = "function" == typeof a[d] ? a[d.indexOf("set") || "function" != typeof a["get" + d.substr(3)] ? d : "get" + d.substr(3)] : !1;
                        d = n[f][2],
                        this._initialRotations[f] = this._func[d] ? this._func[d].call(this._target) : this._target[d]
                    }
                return this._startRatio = c.vars.runBackwards ? 1 : 0,
                !0
            },
            set: function(b) {
                var c, d, e, f, g, h, i, j, k, l, m = this._segCount, n = this._func, o = this._target, p = b !== this._startRatio;
                if (this._timeRes) {
                    if (k = this._lengths,
                    l = this._curSeg,
                    b *= this._length,
                    e = this._li,
                    b > this._l2 && m - 1 > e) {
                        for (j = m - 1; j > e && (this._l2 = k[++e]) <= b; )
                            ;
                        this._l1 = k[e - 1],
                        this._li = e,
                        this._curSeg = l = this._segments[e],
                        this._s2 = l[this._s1 = this._si = 0]
                    } else if (b < this._l1 && e > 0) {
                        for (; e > 0 && (this._l1 = k[--e]) >= b; )
                            ;
                        0 === e && b < this._l1 ? this._l1 = 0 : e++,
                        this._l2 = k[e],
                        this._li = e,
                        this._curSeg = l = this._segments[e],
                        this._s1 = l[(this._si = l.length - 1) - 1] || 0,
                        this._s2 = l[this._si]
                    }
                    if (c = e,
                    b -= this._l1,
                    e = this._si,
                    b > this._s2 && e < l.length - 1) {
                        for (j = l.length - 1; j > e && (this._s2 = l[++e]) <= b; )
                            ;
                        this._s1 = l[e - 1],
                        this._si = e
                    } else if (b < this._s1 && e > 0) {
                        for (; e > 0 && (this._s1 = l[--e]) >= b; )
                            ;
                        0 === e && b < this._s1 ? this._s1 = 0 : e++,
                        this._s2 = l[e],
                        this._si = e
                    }
                    h = (e + (b - this._s1) / (this._s2 - this._s1)) * this._prec
                } else
                    c = 0 > b ? 0 : b >= 1 ? m - 1 : m * b >> 0,
                    h = (b - c * (1 / m)) * m;
                for (d = 1 - h,
                e = this._props.length; --e > -1; )
                    f = this._props[e],
                    g = this._beziers[f][c],
                    i = (h * h * g.da + 3 * d * (h * g.ca + d * g.ba)) * h + g.a,
                    this._round[f] && (i = Math.round(i)),
                    n[f] ? o[f](i) : o[f] = i;
                if (this._autoRotate) {
                    var q, r, s, t, u, v, w, x = this._autoRotate;
                    for (e = x.length; --e > -1; )
                        f = x[e][2],
                        v = x[e][3] || 0,
                        w = x[e][4] === !0 ? 1 : a,
                        g = this._beziers[x[e][0]],
                        q = this._beziers[x[e][1]],
                        g && q && (g = g[c],
                        q = q[c],
                        r = g.a + (g.b - g.a) * h,
                        t = g.b + (g.c - g.b) * h,
                        r += (t - r) * h,
                        t += (g.c + (g.d - g.c) * h - t) * h,
                        s = q.a + (q.b - q.a) * h,
                        u = q.b + (q.c - q.b) * h,
                        s += (u - s) * h,
                        u += (q.c + (q.d - q.c) * h - u) * h,
                        i = p ? Math.atan2(u - s, t - r) * w + v : this._initialRotations[e],
                        n[f] ? o[f](i) : o[f] = i)
                }
            }
        })
          , q = p.prototype;
        p.bezierThrough = l,
        p.cubicToQuadratic = i,
        p._autoCSS = !0,
        p.quadraticToCubic = function(a, b, c) {
            return new g(a,(2 * b + a) / 3,(2 * b + c) / 3,c)
        }
        ,
        p._cssRegister = function() {
            var a = f.CSSPlugin;
            if (a) {
                var b = a._internals
                  , c = b._parseToProxy
                  , d = b._setPluginRatio
                  , e = b.CSSPropTween;
                b._registerComplexSpecialProp("bezier", {
                    parser: function(a, b, f, g, h, i) {
                        b instanceof Array && (b = {
                            values: b
                        }),
                        i = new p;
                        var j, k, l, m = b.values, n = m.length - 1, o = [], q = {};
                        if (0 > n)
                            return h;
                        for (j = 0; n >= j; j++)
                            l = c(a, m[j], g, h, i, n !== j),
                            o[j] = l.end;
                        for (k in b)
                            q[k] = b[k];
                        return q.values = o,
                        h = new e(a,"bezier",0,0,l.pt,2),
                        h.data = l,
                        h.plugin = i,
                        h.setRatio = d,
                        0 === q.autoRotate && (q.autoRotate = !0),
                        !q.autoRotate || q.autoRotate instanceof Array || (j = q.autoRotate === !0 ? 0 : Number(q.autoRotate),
                        q.autoRotate = null != l.end.left ? [["left", "top", "rotation", j, !1]] : null != l.end.x ? [["x", "y", "rotation", j, !1]] : !1),
                        q.autoRotate && (g._transform || g._enableTransforms(!1),
                        l.autoRotate = g._target._gsTransform),
                        i._onInitTween(l.proxy, q, g._tween),
                        h
                    }
                })
            }
        }
        ,
        q._roundProps = function(a, b) {
            for (var c = this._overwriteProps, d = c.length; --d > -1; )
                (a[c[d]] || a.bezier || a.bezierThrough) && (this._round[c[d]] = b)
        }
        ,
        q._kill = function(a) {
            var b, c, d = this._props;
            for (b in this._beziers)
                if (b in a)
                    for (delete this._beziers[b],
                    delete this._func[b],
                    c = d.length; --c > -1; )
                        d[c] === b && d.splice(c, 1);
            return this._super._kill.call(this, a)
        }
    }(),
    _gsScope._gsDefine("plugins.CSSPlugin", ["plugins.TweenPlugin", "TweenLite"], function(a, b) {
        var c, d, e, f, g = function() {
            a.call(this, "css"),
            this._overwriteProps.length = 0,
            this.setRatio = g.prototype.setRatio
        }, h = _gsScope._gsDefine.globals, i = {}, j = g.prototype = new a("css");
        j.constructor = g,
        g.version = "1.18.2",
        g.API = 2,
        g.defaultTransformPerspective = 0,
        g.defaultSkewType = "compensated",
        g.defaultSmoothOrigin = !0,
        j = "px",
        g.suffixMap = {
            top: j,
            right: j,
            bottom: j,
            left: j,
            width: j,
            height: j,
            fontSize: j,
            padding: j,
            margin: j,
            perspective: j,
            lineHeight: ""
        };
        var k, l, m, n, o, p, q = /(?:\d|\-\d|\.\d|\-\.\d)+/g, r = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g, s = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi, t = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g, u = /(?:\d|\-|\+|=|#|\.)*/g, v = /opacity *= *([^)]*)/i, w = /opacity:([^;]*)/i, x = /alpha\(opacity *=.+?\)/i, y = /^(rgb|hsl)/, z = /([A-Z])/g, A = /-([a-z])/gi, B = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi, C = function(a, b) {
            return b.toUpperCase()
        }, D = /(?:Left|Right|Width)/i, E = /(M11|M12|M21|M22)=[\d\-\.e]+/gi, F = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i, G = /,(?=[^\)]*(?:\(|$))/gi, H = Math.PI / 180, I = 180 / Math.PI, J = {}, K = document, L = function(a) {
            return K.createElementNS ? K.createElementNS("http://www.w3.org/1999/xhtml", a) : K.createElement(a)
        }, M = L("div"), N = L("img"), O = g._internals = {
            _specialProps: i
        }, P = navigator.userAgent, Q = function() {
            var a = P.indexOf("Android")
              , b = L("a");
            return m = -1 !== P.indexOf("Safari") && -1 === P.indexOf("Chrome") && (-1 === a || Number(P.substr(a + 8, 1)) > 3),
            o = m && Number(P.substr(P.indexOf("Version/") + 8, 1)) < 6,
            n = -1 !== P.indexOf("Firefox"),
            (/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(P) || /Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(P)) && (p = parseFloat(RegExp.$1)),
            b ? (b.style.cssText = "top:1px;opacity:.55;",
            /^0.55/.test(b.style.opacity)) : !1
        }(), R = function(a) {
            return v.test("string" == typeof a ? a : (a.currentStyle ? a.currentStyle.filter : a.style.filter) || "") ? parseFloat(RegExp.$1) / 100 : 1
        }, S = function(a) {
            window.console && console.log(a)
        }, T = "", U = "", V = function(a, b) {
            b = b || M;
            var c, d, e = b.style;
            if (void 0 !== e[a])
                return a;
            for (a = a.charAt(0).toUpperCase() + a.substr(1),
            c = ["O", "Moz", "ms", "Ms", "Webkit"],
            d = 5; --d > -1 && void 0 === e[c[d] + a]; )
                ;
            return d >= 0 ? (U = 3 === d ? "ms" : c[d],
            T = "-" + U.toLowerCase() + "-",
            U + a) : null
        }, W = K.defaultView ? K.defaultView.getComputedStyle : function() {}
        , X = g.getStyle = function(a, b, c, d, e) {
            var f;
            return Q || "opacity" !== b ? (!d && a.style[b] ? f = a.style[b] : (c = c || W(a)) ? f = c[b] || c.getPropertyValue(b) || c.getPropertyValue(b.replace(z, "-$1").toLowerCase()) : a.currentStyle && (f = a.currentStyle[b]),
            null == e || f && "none" !== f && "auto" !== f && "auto auto" !== f ? f : e) : R(a)
        }
        , Y = O.convertToPixels = function(a, c, d, e, f) {
            if ("px" === e || !e)
                return d;
            if ("auto" === e || !d)
                return 0;
            var h, i, j, k = D.test(c), l = a, m = M.style, n = 0 > d;
            if (n && (d = -d),
            "%" === e && -1 !== c.indexOf("border"))
                h = d / 100 * (k ? a.clientWidth : a.clientHeight);
            else {
                if (m.cssText = "border:0 solid red;position:" + X(a, "position") + ";line-height:0;",
                "%" !== e && l.appendChild && "v" !== e.charAt(0) && "rem" !== e)
                    m[k ? "borderLeftWidth" : "borderTopWidth"] = d + e;
                else {
                    if (l = a.parentNode || K.body,
                    i = l._gsCache,
                    j = b.ticker.frame,
                    i && k && i.time === j)
                        return i.width * d / 100;
                    m[k ? "width" : "height"] = d + e
                }
                l.appendChild(M),
                h = parseFloat(M[k ? "offsetWidth" : "offsetHeight"]),
                l.removeChild(M),
                k && "%" === e && g.cacheWidths !== !1 && (i = l._gsCache = l._gsCache || {},
                i.time = j,
                i.width = h / d * 100),
                0 !== h || f || (h = Y(a, c, d, e, !0))
            }
            return n ? -h : h
        }
        , Z = O.calculateOffset = function(a, b, c) {
            if ("absolute" !== X(a, "position", c))
                return 0;
            var d = "left" === b ? "Left" : "Top"
              , e = X(a, "margin" + d, c);
            return a["offset" + d] - (Y(a, b, parseFloat(e), e.replace(u, "")) || 0)
        }
        , $ = function(a, b) {
            var c, d, e, f = {};
            if (b = b || W(a, null))
                if (c = b.length)
                    for (; --c > -1; )
                        e = b[c],
                        (-1 === e.indexOf("-transform") || za === e) && (f[e.replace(A, C)] = b.getPropertyValue(e));
                else
                    for (c in b)
                        (-1 === c.indexOf("Transform") || ya === c) && (f[c] = b[c]);
            else if (b = a.currentStyle || a.style)
                for (c in b)
                    "string" == typeof c && void 0 === f[c] && (f[c.replace(A, C)] = b[c]);
            return Q || (f.opacity = R(a)),
            d = La(a, b, !1),
            f.rotation = d.rotation,
            f.skewX = d.skewX,
            f.scaleX = d.scaleX,
            f.scaleY = d.scaleY,
            f.x = d.x,
            f.y = d.y,
            Ba && (f.z = d.z,
            f.rotationX = d.rotationX,
            f.rotationY = d.rotationY,
            f.scaleZ = d.scaleZ),
            f.filters && delete f.filters,
            f
        }, _ = function(a, b, c, d, e) {
            var f, g, h, i = {}, j = a.style;
            for (g in c)
                "cssText" !== g && "length" !== g && isNaN(g) && (b[g] !== (f = c[g]) || e && e[g]) && -1 === g.indexOf("Origin") && ("number" == typeof f || "string" == typeof f) && (i[g] = "auto" !== f || "left" !== g && "top" !== g ? "" !== f && "auto" !== f && "none" !== f || "string" != typeof b[g] || "" === b[g].replace(t, "") ? f : 0 : Z(a, g),
                void 0 !== j[g] && (h = new oa(j,g,j[g],h)));
            if (d)
                for (g in d)
                    "className" !== g && (i[g] = d[g]);
            return {
                difs: i,
                firstMPT: h
            }
        }, aa = {
            width: ["Left", "Right"],
            height: ["Top", "Bottom"]
        }, ba = ["marginLeft", "marginRight", "marginTop", "marginBottom"], ca = function(a, b, c) {
            var d = parseFloat("width" === b ? a.offsetWidth : a.offsetHeight)
              , e = aa[b]
              , f = e.length;
            for (c = c || W(a, null); --f > -1; )
                d -= parseFloat(X(a, "padding" + e[f], c, !0)) || 0,
                d -= parseFloat(X(a, "border" + e[f] + "Width", c, !0)) || 0;
            return d
        }, da = function(a, b) {
            if ("contain" === a || "auto" === a || "auto auto" === a)
                return a + " ";
            (null == a || "" === a) && (a = "0 0");
            var c = a.split(" ")
              , d = -1 !== a.indexOf("left") ? "0%" : -1 !== a.indexOf("right") ? "100%" : c[0]
              , e = -1 !== a.indexOf("top") ? "0%" : -1 !== a.indexOf("bottom") ? "100%" : c[1];
            return null == e ? e = "center" === d ? "50%" : "0" : "center" === e && (e = "50%"),
            ("center" === d || isNaN(parseFloat(d)) && -1 === (d + "").indexOf("=")) && (d = "50%"),
            a = d + " " + e + (c.length > 2 ? " " + c[2] : ""),
            b && (b.oxp = -1 !== d.indexOf("%"),
            b.oyp = -1 !== e.indexOf("%"),
            b.oxr = "=" === d.charAt(1),
            b.oyr = "=" === e.charAt(1),
            b.ox = parseFloat(d.replace(t, "")),
            b.oy = parseFloat(e.replace(t, "")),
            b.v = a),
            b || a
        }, ea = function(a, b) {
            return "string" == typeof a && "=" === a.charAt(1) ? parseInt(a.charAt(0) + "1", 10) * parseFloat(a.substr(2)) : parseFloat(a) - parseFloat(b)
        }, fa = function(a, b) {
            return null == a ? b : "string" == typeof a && "=" === a.charAt(1) ? parseInt(a.charAt(0) + "1", 10) * parseFloat(a.substr(2)) + b : parseFloat(a)
        }, ga = function(a, b, c, d) {
            var e, f, g, h, i, j = 1e-6;
            return null == a ? h = b : "number" == typeof a ? h = a : (e = 360,
            f = a.split("_"),
            i = "=" === a.charAt(1),
            g = (i ? parseInt(a.charAt(0) + "1", 10) * parseFloat(f[0].substr(2)) : parseFloat(f[0])) * (-1 === a.indexOf("rad") ? 1 : I) - (i ? 0 : b),
            f.length && (d && (d[c] = b + g),
            -1 !== a.indexOf("short") && (g %= e,
            g !== g % (e / 2) && (g = 0 > g ? g + e : g - e)),
            -1 !== a.indexOf("_cw") && 0 > g ? g = (g + 9999999999 * e) % e - (g / e | 0) * e : -1 !== a.indexOf("ccw") && g > 0 && (g = (g - 9999999999 * e) % e - (g / e | 0) * e)),
            h = b + g),
            j > h && h > -j && (h = 0),
            h
        }, ha = {
            aqua: [0, 255, 255],
            lime: [0, 255, 0],
            silver: [192, 192, 192],
            black: [0, 0, 0],
            maroon: [128, 0, 0],
            teal: [0, 128, 128],
            blue: [0, 0, 255],
            navy: [0, 0, 128],
            white: [255, 255, 255],
            fuchsia: [255, 0, 255],
            olive: [128, 128, 0],
            yellow: [255, 255, 0],
            orange: [255, 165, 0],
            gray: [128, 128, 128],
            purple: [128, 0, 128],
            green: [0, 128, 0],
            red: [255, 0, 0],
            pink: [255, 192, 203],
            cyan: [0, 255, 255],
            transparent: [255, 255, 255, 0]
        }, ia = function(a, b, c) {
            return a = 0 > a ? a + 1 : a > 1 ? a - 1 : a,
            255 * (1 > 6 * a ? b + (c - b) * a * 6 : .5 > a ? c : 2 > 3 * a ? b + (c - b) * (2 / 3 - a) * 6 : b) + .5 | 0
        }, ja = g.parseColor = function(a, b) {
            var c, d, e, f, g, h, i, j, k, l, m;
            if (a)
                if ("number" == typeof a)
                    c = [a >> 16, a >> 8 & 255, 255 & a];
                else {
                    if ("," === a.charAt(a.length - 1) && (a = a.substr(0, a.length - 1)),
                    ha[a])
                        c = ha[a];
                    else if ("#" === a.charAt(0))
                        4 === a.length && (d = a.charAt(1),
                        e = a.charAt(2),
                        f = a.charAt(3),
                        a = "#" + d + d + e + e + f + f),
                        a = parseInt(a.substr(1), 16),
                        c = [a >> 16, a >> 8 & 255, 255 & a];
                    else if ("hsl" === a.substr(0, 3))
                        if (c = m = a.match(q),
                        b) {
                            if (-1 !== a.indexOf("="))
                                return a.match(r)
                        } else
                            g = Number(c[0]) % 360 / 360,
                            h = Number(c[1]) / 100,
                            i = Number(c[2]) / 100,
                            e = .5 >= i ? i * (h + 1) : i + h - i * h,
                            d = 2 * i - e,
                            c.length > 3 && (c[3] = Number(a[3])),
                            c[0] = ia(g + 1 / 3, d, e),
                            c[1] = ia(g, d, e),
                            c[2] = ia(g - 1 / 3, d, e);
                    else
                        c = a.match(q) || ha.transparent;
                    c[0] = Number(c[0]),
                    c[1] = Number(c[1]),
                    c[2] = Number(c[2]),
                    c.length > 3 && (c[3] = Number(c[3]))
                }
            else
                c = ha.black;
            return b && !m && (d = c[0] / 255,
            e = c[1] / 255,
            f = c[2] / 255,
            j = Math.max(d, e, f),
            k = Math.min(d, e, f),
            i = (j + k) / 2,
            j === k ? g = h = 0 : (l = j - k,
            h = i > .5 ? l / (2 - j - k) : l / (j + k),
            g = j === d ? (e - f) / l + (f > e ? 6 : 0) : j === e ? (f - d) / l + 2 : (d - e) / l + 4,
            g *= 60),
            c[0] = g + .5 | 0,
            c[1] = 100 * h + .5 | 0,
            c[2] = 100 * i + .5 | 0),
            c
        }
        , ka = function(a, b) {
            var c, d, e, f = a.match(la) || [], g = 0, h = f.length ? "" : a;
            for (c = 0; c < f.length; c++)
                d = f[c],
                e = a.substr(g, a.indexOf(d, g) - g),
                g += e.length + d.length,
                d = ja(d, b),
                3 === d.length && d.push(1),
                h += e + (b ? "hsla(" + d[0] + "," + d[1] + "%," + d[2] + "%," + d[3] : "rgba(" + d.join(",")) + ")";
            return h
        }, la = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b";
        for (j in ha)
            la += "|" + j + "\\b";
        la = new RegExp(la + ")","gi"),
        g.colorStringFilter = function(a) {
            var b, c = a[0] + a[1];
            la.lastIndex = 0,
            la.test(c) && (b = -1 !== c.indexOf("hsl(") || -1 !== c.indexOf("hsla("),
            a[0] = ka(a[0], b),
            a[1] = ka(a[1], b))
        }
        ,
        b.defaultStringFilter || (b.defaultStringFilter = g.colorStringFilter);
        var ma = function(a, b, c, d) {
            if (null == a)
                return function(a) {
                    return a
                }
                ;
            var e, f = b ? (a.match(la) || [""])[0] : "", g = a.split(f).join("").match(s) || [], h = a.substr(0, a.indexOf(g[0])), i = ")" === a.charAt(a.length - 1) ? ")" : "", j = -1 !== a.indexOf(" ") ? " " : ",", k = g.length, l = k > 0 ? g[0].replace(q, "") : "";
            return k ? e = b ? function(a) {
                var b, m, n, o;
                if ("number" == typeof a)
                    a += l;
                else if (d && G.test(a)) {
                    for (o = a.replace(G, "|").split("|"),
                    n = 0; n < o.length; n++)
                        o[n] = e(o[n]);
                    return o.join(",")
                }
                if (b = (a.match(la) || [f])[0],
                m = a.split(b).join("").match(s) || [],
                n = m.length,
                k > n--)
                    for (; ++n < k; )
                        m[n] = c ? m[(n - 1) / 2 | 0] : g[n];
                return h + m.join(j) + j + b + i + (-1 !== a.indexOf("inset") ? " inset" : "")
            }
            : function(a) {
                var b, f, m;
                if ("number" == typeof a)
                    a += l;
                else if (d && G.test(a)) {
                    for (f = a.replace(G, "|").split("|"),
                    m = 0; m < f.length; m++)
                        f[m] = e(f[m]);
                    return f.join(",")
                }
                if (b = a.match(s) || [],
                m = b.length,
                k > m--)
                    for (; ++m < k; )
                        b[m] = c ? b[(m - 1) / 2 | 0] : g[m];
                return h + b.join(j) + i
            }
            : function(a) {
                return a
            }
        }
          , na = function(a) {
            return a = a.split(","),
            function(b, c, d, e, f, g, h) {
                var i, j = (c + "").split(" ");
                for (h = {},
                i = 0; 4 > i; i++)
                    h[a[i]] = j[i] = j[i] || j[(i - 1) / 2 >> 0];
                return e.parse(b, h, f, g)
            }
        }
          , oa = (O._setPluginRatio = function(a) {
            this.plugin.setRatio(a);
            for (var b, c, d, e, f, g = this.data, h = g.proxy, i = g.firstMPT, j = 1e-6; i; )
                b = h[i.v],
                i.r ? b = Math.round(b) : j > b && b > -j && (b = 0),
                i.t[i.p] = b,
                i = i._next;
            if (g.autoRotate && (g.autoRotate.rotation = h.rotation),
            1 === a || 0 === a)
                for (i = g.firstMPT,
                f = 1 === a ? "e" : "b"; i; ) {
                    if (c = i.t,
                    c.type) {
                        if (1 === c.type) {
                            for (e = c.xs0 + c.s + c.xs1,
                            d = 1; d < c.l; d++)
                                e += c["xn" + d] + c["xs" + (d + 1)];
                            c[f] = e
                        }
                    } else
                        c[f] = c.s + c.xs0;
                    i = i._next
                }
        }
        ,
        function(a, b, c, d, e) {
            this.t = a,
            this.p = b,
            this.v = c,
            this.r = e,
            d && (d._prev = this,
            this._next = d)
        }
        )
          , pa = (O._parseToProxy = function(a, b, c, d, e, f) {
            var g, h, i, j, k, l = d, m = {}, n = {}, o = c._transform, p = J;
            for (c._transform = null,
            J = b,
            d = k = c.parse(a, b, d, e),
            J = p,
            f && (c._transform = o,
            l && (l._prev = null,
            l._prev && (l._prev._next = null))); d && d !== l; ) {
                if (d.type <= 1 && (h = d.p,
                n[h] = d.s + d.c,
                m[h] = d.s,
                f || (j = new oa(d,"s",h,j,d.r),
                d.c = 0),
                1 === d.type))
                    for (g = d.l; --g > 0; )
                        i = "xn" + g,
                        h = d.p + "_" + i,
                        n[h] = d.data[i],
                        m[h] = d[i],
                        f || (j = new oa(d,i,h,j,d.rxp[i]));
                d = d._next
            }
            return {
                proxy: m,
                end: n,
                firstMPT: j,
                pt: k
            }
        }
        ,
        O.CSSPropTween = function(a, b, d, e, g, h, i, j, k, l, m) {
            this.t = a,
            this.p = b,
            this.s = d,
            this.c = e,
            this.n = i || b,
            a instanceof pa || f.push(this.n),
            this.r = j,
            this.type = h || 0,
            k && (this.pr = k,
            c = !0),
            this.b = void 0 === l ? d : l,
            this.e = void 0 === m ? d + e : m,
            g && (this._next = g,
            g._prev = this)
        }
        )
          , qa = function(a, b, c, d, e, f) {
            var g = new pa(a,b,c,d - c,e,-1,f);
            return g.b = c,
            g.e = g.xs0 = d,
            g
        }
          , ra = g.parseComplex = function(a, b, c, d, e, f, g, h, i, j) {
            c = c || f || "",
            g = new pa(a,b,0,0,g,j ? 2 : 1,null,!1,h,c,d),
            d += "";
            var l, m, n, o, p, s, t, u, v, w, x, y, z, A = c.split(", ").join(",").split(" "), B = d.split(", ").join(",").split(" "), C = A.length, D = k !== !1;
            for ((-1 !== d.indexOf(",") || -1 !== c.indexOf(",")) && (A = A.join(" ").replace(G, ", ").split(" "),
            B = B.join(" ").replace(G, ", ").split(" "),
            C = A.length),
            C !== B.length && (A = (f || "").split(" "),
            C = A.length),
            g.plugin = i,
            g.setRatio = j,
            la.lastIndex = 0,
            l = 0; C > l; l++)
                if (o = A[l],
                p = B[l],
                u = parseFloat(o),
                u || 0 === u)
                    g.appendXtra("", u, ea(p, u), p.replace(r, ""), D && -1 !== p.indexOf("px"), !0);
                else if (e && la.test(o))
                    y = "," === p.charAt(p.length - 1) ? ")," : ")",
                    z = -1 !== p.indexOf("hsl") && Q,
                    o = ja(o, z),
                    p = ja(p, z),
                    v = o.length + p.length > 6,
                    v && !Q && 0 === p[3] ? (g["xs" + g.l] += g.l ? " transparent" : "transparent",
                    g.e = g.e.split(B[l]).join("transparent")) : (Q || (v = !1),
                    z ? g.appendXtra(v ? "hsla(" : "hsl(", o[0], ea(p[0], o[0]), ",", !1, !0).appendXtra("", o[1], ea(p[1], o[1]), "%,", !1).appendXtra("", o[2], ea(p[2], o[2]), v ? "%," : "%" + y, !1) : g.appendXtra(v ? "rgba(" : "rgb(", o[0], p[0] - o[0], ",", !0, !0).appendXtra("", o[1], p[1] - o[1], ",", !0).appendXtra("", o[2], p[2] - o[2], v ? "," : y, !0),
                    v && (o = o.length < 4 ? 1 : o[3],
                    g.appendXtra("", o, (p.length < 4 ? 1 : p[3]) - o, y, !1))),
                    la.lastIndex = 0;
                else if (s = o.match(q)) {
                    if (t = p.match(r),
                    !t || t.length !== s.length)
                        return g;
                    for (n = 0,
                    m = 0; m < s.length; m++)
                        x = s[m],
                        w = o.indexOf(x, n),
                        g.appendXtra(o.substr(n, w - n), Number(x), ea(t[m], x), "", D && "px" === o.substr(w + x.length, 2), 0 === m),
                        n = w + x.length;
                    g["xs" + g.l] += o.substr(n)
                } else
                    g["xs" + g.l] += g.l ? " " + p : p;
            if (-1 !== d.indexOf("=") && g.data) {
                for (y = g.xs0 + g.data.s,
                l = 1; l < g.l; l++)
                    y += g["xs" + l] + g.data["xn" + l];
                g.e = y + g["xs" + l]
            }
            return g.l || (g.type = -1,
            g.xs0 = g.e),
            g.xfirst || g
        }
          , sa = 9;
        for (j = pa.prototype,
        j.l = j.pr = 0; --sa > 0; )
            j["xn" + sa] = 0,
            j["xs" + sa] = "";
        j.xs0 = "",
        j._next = j._prev = j.xfirst = j.data = j.plugin = j.setRatio = j.rxp = null,
        j.appendXtra = function(a, b, c, d, e, f) {
            var g = this
              , h = g.l;
            return g["xs" + h] += f && h ? " " + a : a || "",
            c || 0 === h || g.plugin ? (g.l++,
            g.type = g.setRatio ? 2 : 1,
            g["xs" + g.l] = d || "",
            h > 0 ? (g.data["xn" + h] = b + c,
            g.rxp["xn" + h] = e,
            g["xn" + h] = b,
            g.plugin || (g.xfirst = new pa(g,"xn" + h,b,c,g.xfirst || g,0,g.n,e,g.pr),
            g.xfirst.xs0 = 0),
            g) : (g.data = {
                s: b + c
            },
            g.rxp = {},
            g.s = b,
            g.c = c,
            g.r = e,
            g)) : (g["xs" + h] += b + (d || ""),
            g)
        }
        ;
        var ta = function(a, b) {
            b = b || {},
            this.p = b.prefix ? V(a) || a : a,
            i[a] = i[this.p] = this,
            this.format = b.formatter || ma(b.defaultValue, b.color, b.collapsible, b.multi),
            b.parser && (this.parse = b.parser),
            this.clrs = b.color,
            this.multi = b.multi,
            this.keyword = b.keyword,
            this.dflt = b.defaultValue,
            this.pr = b.priority || 0
        }
          , ua = O._registerComplexSpecialProp = function(a, b, c) {
            "object" != typeof b && (b = {
                parser: c
            });
            var d, e, f = a.split(","), g = b.defaultValue;
            for (c = c || [g],
            d = 0; d < f.length; d++)
                b.prefix = 0 === d && b.prefix,
                b.defaultValue = c[d] || g,
                e = new ta(f[d],b)
        }
          , va = function(a) {
            if (!i[a]) {
                var b = a.charAt(0).toUpperCase() + a.substr(1) + "Plugin";
                ua(a, {
                    parser: function(a, c, d, e, f, g, j) {
                        var k = h.com.greensock.plugins[b];
                        return k ? (k._cssRegister(),
                        i[d].parse(a, c, d, e, f, g, j)) : (S("Error: " + b + " js file not loaded."),
                        f)
                    }
                })
            }
        };
        j = ta.prototype,
        j.parseComplex = function(a, b, c, d, e, f) {
            var g, h, i, j, k, l, m = this.keyword;
            if (this.multi && (G.test(c) || G.test(b) ? (h = b.replace(G, "|").split("|"),
            i = c.replace(G, "|").split("|")) : m && (h = [b],
            i = [c])),
            i) {
                for (j = i.length > h.length ? i.length : h.length,
                g = 0; j > g; g++)
                    b = h[g] = h[g] || this.dflt,
                    c = i[g] = i[g] || this.dflt,
                    m && (k = b.indexOf(m),
                    l = c.indexOf(m),
                    k !== l && (-1 === l ? h[g] = h[g].split(m).join("") : -1 === k && (h[g] += " " + m)));
                b = h.join(", "),
                c = i.join(", ")
            }
            return ra(a, this.p, b, c, this.clrs, this.dflt, d, this.pr, e, f)
        }
        ,
        j.parse = function(a, b, c, d, f, g, h) {
            return this.parseComplex(a.style, this.format(X(a, this.p, e, !1, this.dflt)), this.format(b), f, g)
        }
        ,
        g.registerSpecialProp = function(a, b, c) {
            ua(a, {
                parser: function(a, d, e, f, g, h, i) {
                    var j = new pa(a,e,0,0,g,2,e,!1,c);
                    return j.plugin = h,
                    j.setRatio = b(a, d, f._tween, e),
                    j
                },
                priority: c
            })
        }
        ,
        g.useSVGTransformAttr = m || n;
        var wa, xa = "scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent".split(","), ya = V("transform"), za = T + "transform", Aa = V("transformOrigin"), Ba = null !== V("perspective"), Ca = O.Transform = function() {
            this.perspective = parseFloat(g.defaultTransformPerspective) || 0,
            this.force3D = g.defaultForce3D !== !1 && Ba ? g.defaultForce3D || "auto" : !1
        }
        , Da = window.SVGElement, Ea = function(a, b, c) {
            var d, e = K.createElementNS("http://www.w3.org/2000/svg", a), f = /([a-z])([A-Z])/g;
            for (d in c)
                e.setAttributeNS(null, d.replace(f, "$1-$2").toLowerCase(), c[d]);
            return b.appendChild(e),
            e
        }, Fa = K.documentElement, Ga = function() {
            var a, b, c, d = p || /Android/i.test(P) && !window.chrome;
            return K.createElementNS && !d && (a = Ea("svg", Fa),
            b = Ea("rect", a, {
                width: 100,
                height: 50,
                x: 100
            }),
            c = b.getBoundingClientRect().width,
            b.style[Aa] = "50% 50%",
            b.style[ya] = "scaleX(0.5)",
            d = c === b.getBoundingClientRect().width && !(n && Ba),
            Fa.removeChild(a)),
            d
        }(), Ha = function(a, b, c, d, e) {
            var f, h, i, j, k, l, m, n, o, p, q, r, s, t, u = a._gsTransform, v = Ka(a, !0);
            u && (s = u.xOrigin,
            t = u.yOrigin),
            (!d || (f = d.split(" ")).length < 2) && (m = a.getBBox(),
            b = da(b).split(" "),
            f = [(-1 !== b[0].indexOf("%") ? parseFloat(b[0]) / 100 * m.width : parseFloat(b[0])) + m.x, (-1 !== b[1].indexOf("%") ? parseFloat(b[1]) / 100 * m.height : parseFloat(b[1])) + m.y]),
            c.xOrigin = j = parseFloat(f[0]),
            c.yOrigin = k = parseFloat(f[1]),
            d && v !== Ja && (l = v[0],
            m = v[1],
            n = v[2],
            o = v[3],
            p = v[4],
            q = v[5],
            r = l * o - m * n,
            h = j * (o / r) + k * (-n / r) + (n * q - o * p) / r,
            i = j * (-m / r) + k * (l / r) - (l * q - m * p) / r,
            j = c.xOrigin = f[0] = h,
            k = c.yOrigin = f[1] = i),
            u && (e || e !== !1 && g.defaultSmoothOrigin !== !1 ? (h = j - s,
            i = k - t,
            u.xOffset += h * v[0] + i * v[2] - h,
            u.yOffset += h * v[1] + i * v[3] - i) : u.xOffset = u.yOffset = 0),
            a.setAttribute("data-svg-origin", f.join(" "))
        }, Ia = function(a) {
            return !!(Da && "function" == typeof a.getBBox && a.getCTM && (!a.parentNode || a.parentNode.getBBox && a.parentNode.getCTM))
        }, Ja = [1, 0, 0, 1, 0, 0], Ka = function(a, b) {
            var c, d, e, f, g, h = a._gsTransform || new Ca, i = 1e5;
            if (ya ? d = X(a, za, null, !0) : a.currentStyle && (d = a.currentStyle.filter.match(E),
            d = d && 4 === d.length ? [d[0].substr(4), Number(d[2].substr(4)), Number(d[1].substr(4)), d[3].substr(4), h.x || 0, h.y || 0].join(",") : ""),
            c = !d || "none" === d || "matrix(1, 0, 0, 1, 0, 0)" === d,
            (h.svg || a.getBBox && Ia(a)) && (c && -1 !== (a.style[ya] + "").indexOf("matrix") && (d = a.style[ya],
            c = 0),
            e = a.getAttribute("transform"),
            c && e && (-1 !== e.indexOf("matrix") ? (d = e,
            c = 0) : -1 !== e.indexOf("translate") && (d = "matrix(1,0,0,1," + e.match(/(?:\-|\b)[\d\-\.e]+\b/gi).join(",") + ")",
            c = 0))),
            c)
                return Ja;
            for (e = (d || "").match(/(?:\-|\b)[\d\-\.e]+\b/gi) || [],
            sa = e.length; --sa > -1; )
                f = Number(e[sa]),
                e[sa] = (g = f - (f |= 0)) ? (g * i + (0 > g ? -.5 : .5) | 0) / i + f : f;
            return b && e.length > 6 ? [e[0], e[1], e[4], e[5], e[12], e[13]] : e
        }, La = O.getTransform = function(a, c, d, f) {
            if (a._gsTransform && d && !f)
                return a._gsTransform;
            var h, i, j, k, l, m, n = d ? a._gsTransform || new Ca : new Ca, o = n.scaleX < 0, p = 2e-5, q = 1e5, r = Ba ? parseFloat(X(a, Aa, c, !1, "0 0 0").split(" ")[2]) || n.zOrigin || 0 : 0, s = parseFloat(g.defaultTransformPerspective) || 0;
            if (n.svg = !(!a.getBBox || !Ia(a)),
            n.svg && (Ha(a, X(a, Aa, e, !1, "50% 50%") + "", n, a.getAttribute("data-svg-origin")),
            wa = g.useSVGTransformAttr || Ga),
            h = Ka(a),
            h !== Ja) {
                if (16 === h.length) {
                    var t, u, v, w, x, y = h[0], z = h[1], A = h[2], B = h[3], C = h[4], D = h[5], E = h[6], F = h[7], G = h[8], H = h[9], J = h[10], K = h[12], L = h[13], M = h[14], N = h[11], O = Math.atan2(E, J);
                    n.zOrigin && (M = -n.zOrigin,
                    K = G * M - h[12],
                    L = H * M - h[13],
                    M = J * M + n.zOrigin - h[14]),
                    n.rotationX = O * I,
                    O && (w = Math.cos(-O),
                    x = Math.sin(-O),
                    t = C * w + G * x,
                    u = D * w + H * x,
                    v = E * w + J * x,
                    G = C * -x + G * w,
                    H = D * -x + H * w,
                    J = E * -x + J * w,
                    N = F * -x + N * w,
                    C = t,
                    D = u,
                    E = v),
                    O = Math.atan2(-A, J),
                    n.rotationY = O * I,
                    O && (w = Math.cos(-O),
                    x = Math.sin(-O),
                    t = y * w - G * x,
                    u = z * w - H * x,
                    v = A * w - J * x,
                    H = z * x + H * w,
                    J = A * x + J * w,
                    N = B * x + N * w,
                    y = t,
                    z = u,
                    A = v),
                    O = Math.atan2(z, y),
                    n.rotation = O * I,
                    O && (w = Math.cos(-O),
                    x = Math.sin(-O),
                    y = y * w + C * x,
                    u = z * w + D * x,
                    D = z * -x + D * w,
                    E = A * -x + E * w,
                    z = u),
                    n.rotationX && Math.abs(n.rotationX) + Math.abs(n.rotation) > 359.9 && (n.rotationX = n.rotation = 0,
                    n.rotationY = 180 - n.rotationY),
                    n.scaleX = (Math.sqrt(y * y + z * z) * q + .5 | 0) / q,
                    n.scaleY = (Math.sqrt(D * D + H * H) * q + .5 | 0) / q,
                    n.scaleZ = (Math.sqrt(E * E + J * J) * q + .5 | 0) / q,
                    n.skewX = 0,
                    n.perspective = N ? 1 / (0 > N ? -N : N) : 0,
                    n.x = K,
                    n.y = L,
                    n.z = M,
                    n.svg && (n.x -= n.xOrigin - (n.xOrigin * y - n.yOrigin * C),
                    n.y -= n.yOrigin - (n.yOrigin * z - n.xOrigin * D))
                } else if ((!Ba || f || !h.length || n.x !== h[4] || n.y !== h[5] || !n.rotationX && !n.rotationY) && (void 0 === n.x || "none" !== X(a, "display", c))) {
                    var P = h.length >= 6
                      , Q = P ? h[0] : 1
                      , R = h[1] || 0
                      , S = h[2] || 0
                      , T = P ? h[3] : 1;
                    n.x = h[4] || 0,
                    n.y = h[5] || 0,
                    j = Math.sqrt(Q * Q + R * R),
                    k = Math.sqrt(T * T + S * S),
                    l = Q || R ? Math.atan2(R, Q) * I : n.rotation || 0,
                    m = S || T ? Math.atan2(S, T) * I + l : n.skewX || 0,
                    Math.abs(m) > 90 && Math.abs(m) < 270 && (o ? (j *= -1,
                    m += 0 >= l ? 180 : -180,
                    l += 0 >= l ? 180 : -180) : (k *= -1,
                    m += 0 >= m ? 180 : -180)),
                    n.scaleX = j,
                    n.scaleY = k,
                    n.rotation = l,
                    n.skewX = m,
                    Ba && (n.rotationX = n.rotationY = n.z = 0,
                    n.perspective = s,
                    n.scaleZ = 1),
                    n.svg && (n.x -= n.xOrigin - (n.xOrigin * Q + n.yOrigin * S),
                    n.y -= n.yOrigin - (n.xOrigin * R + n.yOrigin * T))
                }
                n.zOrigin = r;
                for (i in n)
                    n[i] < p && n[i] > -p && (n[i] = 0)
            }
            return d && (a._gsTransform = n,
            n.svg && (wa && a.style[ya] ? b.delayedCall(.001, function() {
                Pa(a.style, ya)
            }) : !wa && a.getAttribute("transform") && b.delayedCall(.001, function() {
                a.removeAttribute("transform")
            }))),
            n
        }
        , Ma = function(a) {
            var b, c, d = this.data, e = -d.rotation * H, f = e + d.skewX * H, g = 1e5, h = (Math.cos(e) * d.scaleX * g | 0) / g, i = (Math.sin(e) * d.scaleX * g | 0) / g, j = (Math.sin(f) * -d.scaleY * g | 0) / g, k = (Math.cos(f) * d.scaleY * g | 0) / g, l = this.t.style, m = this.t.currentStyle;
            if (m) {
                c = i,
                i = -j,
                j = -c,
                b = m.filter,
                l.filter = "";
                var n, o, q = this.t.offsetWidth, r = this.t.offsetHeight, s = "absolute" !== m.position, t = "progid:DXImageTransform.Microsoft.Matrix(M11=" + h + ", M12=" + i + ", M21=" + j + ", M22=" + k, w = d.x + q * d.xPercent / 100, x = d.y + r * d.yPercent / 100;
                if (null != d.ox && (n = (d.oxp ? q * d.ox * .01 : d.ox) - q / 2,
                o = (d.oyp ? r * d.oy * .01 : d.oy) - r / 2,
                w += n - (n * h + o * i),
                x += o - (n * j + o * k)),
                s ? (n = q / 2,
                o = r / 2,
                t += ", Dx=" + (n - (n * h + o * i) + w) + ", Dy=" + (o - (n * j + o * k) + x) + ")") : t += ", sizingMethod='auto expand')",
                -1 !== b.indexOf("DXImageTransform.Microsoft.Matrix(") ? l.filter = b.replace(F, t) : l.filter = t + " " + b,
                (0 === a || 1 === a) && 1 === h && 0 === i && 0 === j && 1 === k && (s && -1 === t.indexOf("Dx=0, Dy=0") || v.test(b) && 100 !== parseFloat(RegExp.$1) || -1 === b.indexOf(b.indexOf("Alpha")) && l.removeAttribute("filter")),
                !s) {
                    var y, z, A, B = 8 > p ? 1 : -1;
                    for (n = d.ieOffsetX || 0,
                    o = d.ieOffsetY || 0,
                    d.ieOffsetX = Math.round((q - ((0 > h ? -h : h) * q + (0 > i ? -i : i) * r)) / 2 + w),
                    d.ieOffsetY = Math.round((r - ((0 > k ? -k : k) * r + (0 > j ? -j : j) * q)) / 2 + x),
                    sa = 0; 4 > sa; sa++)
                        z = ba[sa],
                        y = m[z],
                        c = -1 !== y.indexOf("px") ? parseFloat(y) : Y(this.t, z, parseFloat(y), y.replace(u, "")) || 0,
                        A = c !== d[z] ? 2 > sa ? -d.ieOffsetX : -d.ieOffsetY : 2 > sa ? n - d.ieOffsetX : o - d.ieOffsetY,
                        l[z] = (d[z] = Math.round(c - A * (0 === sa || 2 === sa ? 1 : B))) + "px"
                }
            }
        }, Na = O.set3DTransformRatio = O.setTransformRatio = function(a) {
            var b, c, d, e, f, g, h, i, j, k, l, m, o, p, q, r, s, t, u, v, w, x, y, z = this.data, A = this.t.style, B = z.rotation, C = z.rotationX, D = z.rotationY, E = z.scaleX, F = z.scaleY, G = z.scaleZ, I = z.x, J = z.y, K = z.z, L = z.svg, M = z.perspective, N = z.force3D;
            if (((1 === a || 0 === a) && "auto" === N && (this.tween._totalTime === this.tween._totalDuration || !this.tween._totalTime) || !N) && !K && !M && !D && !C && 1 === G || wa && L || !Ba)
                return void (B || z.skewX || L ? (B *= H,
                x = z.skewX * H,
                y = 1e5,
                b = Math.cos(B) * E,
                e = Math.sin(B) * E,
                c = Math.sin(B - x) * -F,
                f = Math.cos(B - x) * F,
                x && "simple" === z.skewType && (s = Math.tan(x),
                s = Math.sqrt(1 + s * s),
                c *= s,
                f *= s,
                z.skewY && (b *= s,
                e *= s)),
                L && (I += z.xOrigin - (z.xOrigin * b + z.yOrigin * c) + z.xOffset,
                J += z.yOrigin - (z.xOrigin * e + z.yOrigin * f) + z.yOffset,
                wa && (z.xPercent || z.yPercent) && (p = this.t.getBBox(),
                I += .01 * z.xPercent * p.width,
                J += .01 * z.yPercent * p.height),
                p = 1e-6,
                p > I && I > -p && (I = 0),
                p > J && J > -p && (J = 0)),
                u = (b * y | 0) / y + "," + (e * y | 0) / y + "," + (c * y | 0) / y + "," + (f * y | 0) / y + "," + I + "," + J + ")",
                L && wa ? this.t.setAttribute("transform", "matrix(" + u) : A[ya] = (z.xPercent || z.yPercent ? "translate(" + z.xPercent + "%," + z.yPercent + "%) matrix(" : "matrix(") + u) : A[ya] = (z.xPercent || z.yPercent ? "translate(" + z.xPercent + "%," + z.yPercent + "%) matrix(" : "matrix(") + E + ",0,0," + F + "," + I + "," + J + ")");
            if (n && (p = 1e-4,
            p > E && E > -p && (E = G = 2e-5),
            p > F && F > -p && (F = G = 2e-5),
            !M || z.z || z.rotationX || z.rotationY || (M = 0)),
            B || z.skewX)
                B *= H,
                q = b = Math.cos(B),
                r = e = Math.sin(B),
                z.skewX && (B -= z.skewX * H,
                q = Math.cos(B),
                r = Math.sin(B),
                "simple" === z.skewType && (s = Math.tan(z.skewX * H),
                s = Math.sqrt(1 + s * s),
                q *= s,
                r *= s,
                z.skewY && (b *= s,
                e *= s))),
                c = -r,
                f = q;
            else {
                if (!(D || C || 1 !== G || M || L))
                    return void (A[ya] = (z.xPercent || z.yPercent ? "translate(" + z.xPercent + "%," + z.yPercent + "%) translate3d(" : "translate3d(") + I + "px," + J + "px," + K + "px)" + (1 !== E || 1 !== F ? " scale(" + E + "," + F + ")" : ""));
                b = f = 1,
                c = e = 0
            }
            j = 1,
            d = g = h = i = k = l = 0,
            m = M ? -1 / M : 0,
            o = z.zOrigin,
            p = 1e-6,
            v = ",",
            w = "0",
            B = D * H,
            B && (q = Math.cos(B),
            r = Math.sin(B),
            h = -r,
            k = m * -r,
            d = b * r,
            g = e * r,
            j = q,
            m *= q,
            b *= q,
            e *= q),
            B = C * H,
            B && (q = Math.cos(B),
            r = Math.sin(B),
            s = c * q + d * r,
            t = f * q + g * r,
            i = j * r,
            l = m * r,
            d = c * -r + d * q,
            g = f * -r + g * q,
            j *= q,
            m *= q,
            c = s,
            f = t),
            1 !== G && (d *= G,
            g *= G,
            j *= G,
            m *= G),
            1 !== F && (c *= F,
            f *= F,
            i *= F,
            l *= F),
            1 !== E && (b *= E,
            e *= E,
            h *= E,
            k *= E),
            (o || L) && (o && (I += d * -o,
            J += g * -o,
            K += j * -o + o),
            L && (I += z.xOrigin - (z.xOrigin * b + z.yOrigin * c) + z.xOffset,
            J += z.yOrigin - (z.xOrigin * e + z.yOrigin * f) + z.yOffset),
            p > I && I > -p && (I = w),
            p > J && J > -p && (J = w),
            p > K && K > -p && (K = 0)),
            u = z.xPercent || z.yPercent ? "translate(" + z.xPercent + "%," + z.yPercent + "%) matrix3d(" : "matrix3d(",
            u += (p > b && b > -p ? w : b) + v + (p > e && e > -p ? w : e) + v + (p > h && h > -p ? w : h),
            u += v + (p > k && k > -p ? w : k) + v + (p > c && c > -p ? w : c) + v + (p > f && f > -p ? w : f),
            C || D || 1 !== G ? (u += v + (p > i && i > -p ? w : i) + v + (p > l && l > -p ? w : l) + v + (p > d && d > -p ? w : d),
            u += v + (p > g && g > -p ? w : g) + v + (p > j && j > -p ? w : j) + v + (p > m && m > -p ? w : m) + v) : u += ",0,0,0,0,1,0,",
            u += I + v + J + v + K + v + (M ? 1 + -K / M : 1) + ")",
            A[ya] = u
        }
        ;
        j = Ca.prototype,
        j.x = j.y = j.z = j.skewX = j.skewY = j.rotation = j.rotationX = j.rotationY = j.zOrigin = j.xPercent = j.yPercent = j.xOffset = j.yOffset = 0,
        j.scaleX = j.scaleY = j.scaleZ = 1,
        ua("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin", {
            parser: function(a, b, c, d, f, h, i) {
                if (d._lastParsedTransform === i)
                    return f;
                d._lastParsedTransform = i;
                var j, k, l, m, n, o, p, q, r, s, t = a._gsTransform, u = a.style, v = 1e-6, w = xa.length, x = i, y = {}, z = "transformOrigin";
                if (i.display ? (m = X(a, "display"),
                u.display = "block",
                j = La(a, e, !0, i.parseTransform),
                u.display = m) : j = La(a, e, !0, i.parseTransform),
                d._transform = j,
                "string" == typeof x.transform && ya)
                    m = M.style,
                    m[ya] = x.transform,
                    m.display = "block",
                    m.position = "absolute",
                    K.body.appendChild(M),
                    k = La(M, null, !1),
                    K.body.removeChild(M),
                    k.perspective || (k.perspective = j.perspective),
                    null != x.xPercent && (k.xPercent = fa(x.xPercent, j.xPercent)),
                    null != x.yPercent && (k.yPercent = fa(x.yPercent, j.yPercent));
                else if ("object" == typeof x) {
                    if (k = {
                        scaleX: fa(null != x.scaleX ? x.scaleX : x.scale, j.scaleX),
                        scaleY: fa(null != x.scaleY ? x.scaleY : x.scale, j.scaleY),
                        scaleZ: fa(x.scaleZ, j.scaleZ),
                        x: fa(x.x, j.x),
                        y: fa(x.y, j.y),
                        z: fa(x.z, j.z),
                        xPercent: fa(x.xPercent, j.xPercent),
                        yPercent: fa(x.yPercent, j.yPercent),
                        perspective: fa(x.transformPerspective, j.perspective)
                    },
                    q = x.directionalRotation,
                    null != q)
                        if ("object" == typeof q)
                            for (m in q)
                                x[m] = q[m];
                        else
                            x.rotation = q;
                    "string" == typeof x.x && -1 !== x.x.indexOf("%") && (k.x = 0,
                    k.xPercent = fa(x.x, j.xPercent)),
                    "string" == typeof x.y && -1 !== x.y.indexOf("%") && (k.y = 0,
                    k.yPercent = fa(x.y, j.yPercent)),
                    k.rotation = ga("rotation"in x ? x.rotation : "shortRotation"in x ? x.shortRotation + "_short" : "rotationZ"in x ? x.rotationZ : j.rotation, j.rotation, "rotation", y),
                    Ba && (k.rotationX = ga("rotationX"in x ? x.rotationX : "shortRotationX"in x ? x.shortRotationX + "_short" : j.rotationX || 0, j.rotationX, "rotationX", y),
                    k.rotationY = ga("rotationY"in x ? x.rotationY : "shortRotationY"in x ? x.shortRotationY + "_short" : j.rotationY || 0, j.rotationY, "rotationY", y)),
                    k.skewX = null == x.skewX ? j.skewX : ga(x.skewX, j.skewX),
                    k.skewY = null == x.skewY ? j.skewY : ga(x.skewY, j.skewY),
                    (l = k.skewY - j.skewY) && (k.skewX += l,
                    k.rotation += l)
                }
                for (Ba && null != x.force3D && (j.force3D = x.force3D,
                p = !0),
                j.skewType = x.skewType || j.skewType || g.defaultSkewType,
                o = j.force3D || j.z || j.rotationX || j.rotationY || k.z || k.rotationX || k.rotationY || k.perspective,
                o || null == x.scale || (k.scaleZ = 1); --w > -1; )
                    c = xa[w],
                    n = k[c] - j[c],
                    (n > v || -v > n || null != x[c] || null != J[c]) && (p = !0,
                    f = new pa(j,c,j[c],n,f),
                    c in y && (f.e = y[c]),
                    f.xs0 = 0,
                    f.plugin = h,
                    d._overwriteProps.push(f.n));
                return n = x.transformOrigin,
                j.svg && (n || x.svgOrigin) && (r = j.xOffset,
                s = j.yOffset,
                Ha(a, da(n), k, x.svgOrigin, x.smoothOrigin),
                f = qa(j, "xOrigin", (t ? j : k).xOrigin, k.xOrigin, f, z),
                f = qa(j, "yOrigin", (t ? j : k).yOrigin, k.yOrigin, f, z),
                (r !== j.xOffset || s !== j.yOffset) && (f = qa(j, "xOffset", t ? r : j.xOffset, j.xOffset, f, z),
                f = qa(j, "yOffset", t ? s : j.yOffset, j.yOffset, f, z)),
                n = wa ? null : "0px 0px"),
                (n || Ba && o && j.zOrigin) && (ya ? (p = !0,
                c = Aa,
                n = (n || X(a, c, e, !1, "50% 50%")) + "",
                f = new pa(u,c,0,0,f,-1,z),
                f.b = u[c],
                f.plugin = h,
                Ba ? (m = j.zOrigin,
                n = n.split(" "),
                j.zOrigin = (n.length > 2 && (0 === m || "0px" !== n[2]) ? parseFloat(n[2]) : m) || 0,
                f.xs0 = f.e = n[0] + " " + (n[1] || "50%") + " 0px",
                f = new pa(j,"zOrigin",0,0,f,-1,f.n),
                f.b = m,
                f.xs0 = f.e = j.zOrigin) : f.xs0 = f.e = n) : da(n + "", j)),
                p && (d._transformType = j.svg && wa || !o && 3 !== this._transformType ? 2 : 3),
                f
            },
            prefix: !0
        }),
        ua("boxShadow", {
            defaultValue: "0px 0px 0px 0px #999",
            prefix: !0,
            color: !0,
            multi: !0,
            keyword: "inset"
        }),
        ua("borderRadius", {
            defaultValue: "0px",
            parser: function(a, b, c, f, g, h) {
                b = this.format(b);
                var i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, x, y = ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"], z = a.style;
                for (q = parseFloat(a.offsetWidth),
                r = parseFloat(a.offsetHeight),
                i = b.split(" "),
                j = 0; j < y.length; j++)
                    this.p.indexOf("border") && (y[j] = V(y[j])),
                    m = l = X(a, y[j], e, !1, "0px"),
                    -1 !== m.indexOf(" ") && (l = m.split(" "),
                    m = l[0],
                    l = l[1]),
                    n = k = i[j],
                    o = parseFloat(m),
                    t = m.substr((o + "").length),
                    u = "=" === n.charAt(1),
                    u ? (p = parseInt(n.charAt(0) + "1", 10),
                    n = n.substr(2),
                    p *= parseFloat(n),
                    s = n.substr((p + "").length - (0 > p ? 1 : 0)) || "") : (p = parseFloat(n),
                    s = n.substr((p + "").length)),
                    "" === s && (s = d[c] || t),
                    s !== t && (v = Y(a, "borderLeft", o, t),
                    w = Y(a, "borderTop", o, t),
                    "%" === s ? (m = v / q * 100 + "%",
                    l = w / r * 100 + "%") : "em" === s ? (x = Y(a, "borderLeft", 1, "em"),
                    m = v / x + "em",
                    l = w / x + "em") : (m = v + "px",
                    l = w + "px"),
                    u && (n = parseFloat(m) + p + s,
                    k = parseFloat(l) + p + s)),
                    g = ra(z, y[j], m + " " + l, n + " " + k, !1, "0px", g);
                return g
            },
            prefix: !0,
            formatter: ma("0px 0px 0px 0px", !1, !0)
        }),
        ua("backgroundPosition", {
            defaultValue: "0 0",
            parser: function(a, b, c, d, f, g) {
                var h, i, j, k, l, m, n = "background-position", o = e || W(a, null), q = this.format((o ? p ? o.getPropertyValue(n + "-x") + " " + o.getPropertyValue(n + "-y") : o.getPropertyValue(n) : a.currentStyle.backgroundPositionX + " " + a.currentStyle.backgroundPositionY) || "0 0"), r = this.format(b);
                if (-1 !== q.indexOf("%") != (-1 !== r.indexOf("%")) && (m = X(a, "backgroundImage").replace(B, ""),
                m && "none" !== m)) {
                    for (h = q.split(" "),
                    i = r.split(" "),
                    N.setAttribute("src", m),
                    j = 2; --j > -1; )
                        q = h[j],
                        k = -1 !== q.indexOf("%"),
                        k !== (-1 !== i[j].indexOf("%")) && (l = 0 === j ? a.offsetWidth - N.width : a.offsetHeight - N.height,
                        h[j] = k ? parseFloat(q) / 100 * l + "px" : parseFloat(q) / l * 100 + "%");
                    q = h.join(" ")
                }
                return this.parseComplex(a.style, q, r, f, g)
            },
            formatter: da
        }),
        ua("backgroundSize", {
            defaultValue: "0 0",
            formatter: da
        }),
        ua("perspective", {
            defaultValue: "0px",
            prefix: !0
        }),
        ua("perspectiveOrigin", {
            defaultValue: "50% 50%",
            prefix: !0
        }),
        ua("transformStyle", {
            prefix: !0
        }),
        ua("backfaceVisibility", {
            prefix: !0
        }),
        ua("userSelect", {
            prefix: !0
        }),
        ua("margin", {
            parser: na("marginTop,marginRight,marginBottom,marginLeft")
        }),
        ua("padding", {
            parser: na("paddingTop,paddingRight,paddingBottom,paddingLeft")
        }),
        ua("clip", {
            defaultValue: "rect(0px,0px,0px,0px)",
            parser: function(a, b, c, d, f, g) {
                var h, i, j;
                return 9 > p ? (i = a.currentStyle,
                j = 8 > p ? " " : ",",
                h = "rect(" + i.clipTop + j + i.clipRight + j + i.clipBottom + j + i.clipLeft + ")",
                b = this.format(b).split(",").join(j)) : (h = this.format(X(a, this.p, e, !1, this.dflt)),
                b = this.format(b)),
                this.parseComplex(a.style, h, b, f, g)
            }
        }),
        ua("textShadow", {
            defaultValue: "0px 0px 0px #999",
            color: !0,
            multi: !0
        }),
        ua("autoRound,strictUnits", {
            parser: function(a, b, c, d, e) {
                return e
            }
        }),
        ua("border", {
            defaultValue: "0px solid #000",
            parser: function(a, b, c, d, f, g) {
                return this.parseComplex(a.style, this.format(X(a, "borderTopWidth", e, !1, "0px") + " " + X(a, "borderTopStyle", e, !1, "solid") + " " + X(a, "borderTopColor", e, !1, "#000")), this.format(b), f, g)
            },
            color: !0,
            formatter: function(a) {
                var b = a.split(" ");
                return b[0] + " " + (b[1] || "solid") + " " + (a.match(la) || ["#000"])[0]
            }
        }),
        ua("borderWidth", {
            parser: na("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")
        }),
        ua("float,cssFloat,styleFloat", {
            parser: function(a, b, c, d, e, f) {
                var g = a.style
                  , h = "cssFloat"in g ? "cssFloat" : "styleFloat";
                return new pa(g,h,0,0,e,-1,c,!1,0,g[h],b)
            }
        });
        var Oa = function(a) {
            var b, c = this.t, d = c.filter || X(this.data, "filter") || "", e = this.s + this.c * a | 0;
            100 === e && (-1 === d.indexOf("atrix(") && -1 === d.indexOf("radient(") && -1 === d.indexOf("oader(") ? (c.removeAttribute("filter"),
            b = !X(this.data, "filter")) : (c.filter = d.replace(x, ""),
            b = !0)),
            b || (this.xn1 && (c.filter = d = d || "alpha(opacity=" + e + ")"),
            -1 === d.indexOf("pacity") ? 0 === e && this.xn1 || (c.filter = d + " alpha(opacity=" + e + ")") : c.filter = d.replace(v, "opacity=" + e))
        };
        ua("opacity,alpha,autoAlpha", {
            defaultValue: "1",
            parser: function(a, b, c, d, f, g) {
                var h = parseFloat(X(a, "opacity", e, !1, "1"))
                  , i = a.style
                  , j = "autoAlpha" === c;
                return "string" == typeof b && "=" === b.charAt(1) && (b = ("-" === b.charAt(0) ? -1 : 1) * parseFloat(b.substr(2)) + h),
                j && 1 === h && "hidden" === X(a, "visibility", e) && 0 !== b && (h = 0),
                Q ? f = new pa(i,"opacity",h,b - h,f) : (f = new pa(i,"opacity",100 * h,100 * (b - h),f),
                f.xn1 = j ? 1 : 0,
                i.zoom = 1,
                f.type = 2,
                f.b = "alpha(opacity=" + f.s + ")",
                f.e = "alpha(opacity=" + (f.s + f.c) + ")",
                f.data = a,
                f.plugin = g,
                f.setRatio = Oa),
                j && (f = new pa(i,"visibility",0,0,f,-1,null,!1,0,0 !== h ? "inherit" : "hidden",0 === b ? "hidden" : "inherit"),
                f.xs0 = "inherit",
                d._overwriteProps.push(f.n),
                d._overwriteProps.push(c)),
                f
            }
        });
        var Pa = function(a, b) {
            b && (a.removeProperty ? (("ms" === b.substr(0, 2) || "webkit" === b.substr(0, 6)) && (b = "-" + b),
            a.removeProperty(b.replace(z, "-$1").toLowerCase())) : a.removeAttribute(b))
        }
          , Qa = function(a) {
            if (this.t._gsClassPT = this,
            1 === a || 0 === a) {
                this.t.setAttribute("class", 0 === a ? this.b : this.e);
                for (var b = this.data, c = this.t.style; b; )
                    b.v ? c[b.p] = b.v : Pa(c, b.p),
                    b = b._next;
                1 === a && this.t._gsClassPT === this && (this.t._gsClassPT = null)
            } else
                this.t.getAttribute("class") !== this.e && this.t.setAttribute("class", this.e)
        };
        ua("className", {
            parser: function(a, b, d, f, g, h, i) {
                var j, k, l, m, n, o = a.getAttribute("class") || "", p = a.style.cssText;
                if (g = f._classNamePT = new pa(a,d,0,0,g,2),
                g.setRatio = Qa,
                g.pr = -11,
                c = !0,
                g.b = o,
                k = $(a, e),
                l = a._gsClassPT) {
                    for (m = {},
                    n = l.data; n; )
                        m[n.p] = 1,
                        n = n._next;
                    l.setRatio(1)
                }
                return a._gsClassPT = g,
                g.e = "=" !== b.charAt(1) ? b : o.replace(new RegExp("\\s*\\b" + b.substr(2) + "\\b"), "") + ("+" === b.charAt(0) ? " " + b.substr(2) : ""),
                a.setAttribute("class", g.e),
                j = _(a, k, $(a), i, m),
                a.setAttribute("class", o),
                g.data = j.firstMPT,
                a.style.cssText = p,
                g = g.xfirst = f.parse(a, j.difs, g, h)
            }
        });
        var Ra = function(a) {
            if ((1 === a || 0 === a) && this.data._totalTime === this.data._totalDuration && "isFromStart" !== this.data.data) {
                var b, c, d, e, f, g = this.t.style, h = i.transform.parse;
                if ("all" === this.e)
                    g.cssText = "",
                    e = !0;
                else
                    for (b = this.e.split(" ").join("").split(","),
                    d = b.length; --d > -1; )
                        c = b[d],
                        i[c] && (i[c].parse === h ? e = !0 : c = "transformOrigin" === c ? Aa : i[c].p),
                        Pa(g, c);
                e && (Pa(g, ya),
                f = this.t._gsTransform,
                f && (f.svg && (this.t.removeAttribute("data-svg-origin"),
                this.t.removeAttribute("transform")),
                delete this.t._gsTransform))
            }
        };
        for (ua("clearProps", {
            parser: function(a, b, d, e, f) {
                return f = new pa(a,d,0,0,f,2),
                f.setRatio = Ra,
                f.e = b,
                f.pr = -10,
                f.data = e._tween,
                c = !0,
                f
            }
        }),
        j = "bezier,throwProps,physicsProps,physics2D".split(","),
        sa = j.length; sa--; )
            va(j[sa]);
        j = g.prototype,
        j._firstPT = j._lastParsedTransform = j._transform = null,
        j._onInitTween = function(a, b, h) {
            if (!a.nodeType)
                return !1;
            this._target = a,
            this._tween = h,
            this._vars = b,
            k = b.autoRound,
            c = !1,
            d = b.suffixMap || g.suffixMap,
            e = W(a, ""),
            f = this._overwriteProps;
            var j, n, p, q, r, s, t, u, v, x = a.style;
            if (l && "" === x.zIndex && (j = X(a, "zIndex", e),
            ("auto" === j || "" === j) && this._addLazySet(x, "zIndex", 0)),
            "string" == typeof b && (q = x.cssText,
            j = $(a, e),
            x.cssText = q + ";" + b,
            j = _(a, j, $(a)).difs,
            !Q && w.test(b) && (j.opacity = parseFloat(RegExp.$1)),
            b = j,
            x.cssText = q),
            b.className ? this._firstPT = n = i.className.parse(a, b.className, "className", this, null, null, b) : this._firstPT = n = this.parse(a, b, null),
            this._transformType) {
                for (v = 3 === this._transformType,
                ya ? m && (l = !0,
                "" === x.zIndex && (t = X(a, "zIndex", e),
                ("auto" === t || "" === t) && this._addLazySet(x, "zIndex", 0)),
                o && this._addLazySet(x, "WebkitBackfaceVisibility", this._vars.WebkitBackfaceVisibility || (v ? "visible" : "hidden"))) : x.zoom = 1,
                p = n; p && p._next; )
                    p = p._next;
                u = new pa(a,"transform",0,0,null,2),
                this._linkCSSP(u, null, p),
                u.setRatio = ya ? Na : Ma,
                u.data = this._transform || La(a, e, !0),
                u.tween = h,
                u.pr = -1,
                f.pop()
            }
            if (c) {
                for (; n; ) {
                    for (s = n._next,
                    p = q; p && p.pr > n.pr; )
                        p = p._next;
                    (n._prev = p ? p._prev : r) ? n._prev._next = n : q = n,
                    (n._next = p) ? p._prev = n : r = n,
                    n = s
                }
                this._firstPT = q
            }
            return !0
        }
        ,
        j.parse = function(a, b, c, f) {
            var g, h, j, l, m, n, o, p, q, r, s = a.style;
            for (g in b)
                n = b[g],
                h = i[g],
                h ? c = h.parse(a, n, g, this, c, f, b) : (m = X(a, g, e) + "",
                q = "string" == typeof n,
                "color" === g || "fill" === g || "stroke" === g || -1 !== g.indexOf("Color") || q && y.test(n) ? (q || (n = ja(n),
                n = (n.length > 3 ? "rgba(" : "rgb(") + n.join(",") + ")"),
                c = ra(s, g, m, n, !0, "transparent", c, 0, f)) : !q || -1 === n.indexOf(" ") && -1 === n.indexOf(",") ? (j = parseFloat(m),
                o = j || 0 === j ? m.substr((j + "").length) : "",
                ("" === m || "auto" === m) && ("width" === g || "height" === g ? (j = ca(a, g, e),
                o = "px") : "left" === g || "top" === g ? (j = Z(a, g, e),
                o = "px") : (j = "opacity" !== g ? 0 : 1,
                o = "")),
                r = q && "=" === n.charAt(1),
                r ? (l = parseInt(n.charAt(0) + "1", 10),
                n = n.substr(2),
                l *= parseFloat(n),
                p = n.replace(u, "")) : (l = parseFloat(n),
                p = q ? n.replace(u, "") : ""),
                "" === p && (p = g in d ? d[g] : o),
                n = l || 0 === l ? (r ? l + j : l) + p : b[g],
                o !== p && "" !== p && (l || 0 === l) && j && (j = Y(a, g, j, o),
                "%" === p ? (j /= Y(a, g, 100, "%") / 100,
                b.strictUnits !== !0 && (m = j + "%")) : "em" === p || "rem" === p || "vw" === p || "vh" === p ? j /= Y(a, g, 1, p) : "px" !== p && (l = Y(a, g, l, p),
                p = "px"),
                r && (l || 0 === l) && (n = l + j + p)),
                r && (l += j),
                !j && 0 !== j || !l && 0 !== l ? void 0 !== s[g] && (n || n + "" != "NaN" && null != n) ? (c = new pa(s,g,l || j || 0,0,c,-1,g,!1,0,m,n),
                c.xs0 = "none" !== n || "display" !== g && -1 === g.indexOf("Style") ? n : m) : S("invalid " + g + " tween value: " + b[g]) : (c = new pa(s,g,j,l - j,c,0,g,k !== !1 && ("px" === p || "zIndex" === g),0,m,n),
                c.xs0 = p)) : c = ra(s, g, m, n, !0, null, c, 0, f)),
                f && c && !c.plugin && (c.plugin = f);
            return c
        }
        ,
        j.setRatio = function(a) {
            var b, c, d, e = this._firstPT, f = 1e-6;
            if (1 !== a || this._tween._time !== this._tween._duration && 0 !== this._tween._time)
                if (a || this._tween._time !== this._tween._duration && 0 !== this._tween._time || this._tween._rawPrevTime === -1e-6)
                    for (; e; ) {
                        if (b = e.c * a + e.s,
                        e.r ? b = Math.round(b) : f > b && b > -f && (b = 0),
                        e.type)
                            if (1 === e.type)
                                if (d = e.l,
                                2 === d)
                                    e.t[e.p] = e.xs0 + b + e.xs1 + e.xn1 + e.xs2;
                                else if (3 === d)
                                    e.t[e.p] = e.xs0 + b + e.xs1 + e.xn1 + e.xs2 + e.xn2 + e.xs3;
                                else if (4 === d)
                                    e.t[e.p] = e.xs0 + b + e.xs1 + e.xn1 + e.xs2 + e.xn2 + e.xs3 + e.xn3 + e.xs4;
                                else if (5 === d)
                                    e.t[e.p] = e.xs0 + b + e.xs1 + e.xn1 + e.xs2 + e.xn2 + e.xs3 + e.xn3 + e.xs4 + e.xn4 + e.xs5;
                                else {
                                    for (c = e.xs0 + b + e.xs1,
                                    d = 1; d < e.l; d++)
                                        c += e["xn" + d] + e["xs" + (d + 1)];
                                    e.t[e.p] = c
                                }
                            else
                                -1 === e.type ? e.t[e.p] = e.xs0 : e.setRatio && e.setRatio(a);
                        else
                            e.t[e.p] = b + e.xs0;
                        e = e._next
                    }
                else
                    for (; e; )
                        2 !== e.type ? e.t[e.p] = e.b : e.setRatio(a),
                        e = e._next;
            else
                for (; e; ) {
                    if (2 !== e.type)
                        if (e.r && -1 !== e.type)
                            if (b = Math.round(e.s + e.c),
                            e.type) {
                                if (1 === e.type) {
                                    for (d = e.l,
                                    c = e.xs0 + b + e.xs1,
                                    d = 1; d < e.l; d++)
                                        c += e["xn" + d] + e["xs" + (d + 1)];
                                    e.t[e.p] = c
                                }
                            } else
                                e.t[e.p] = b + e.xs0;
                        else
                            e.t[e.p] = e.e;
                    else
                        e.setRatio(a);
                    e = e._next
                }
        }
        ,
        j._enableTransforms = function(a) {
            this._transform = this._transform || La(this._target, e, !0),
            this._transformType = this._transform.svg && wa || !a && 3 !== this._transformType ? 2 : 3
        }
        ;
        var Sa = function(a) {
            this.t[this.p] = this.e,
            this.data._linkCSSP(this, this._next, null, !0)
        };
        j._addLazySet = function(a, b, c) {
            var d = this._firstPT = new pa(a,b,0,0,this._firstPT,2);
            d.e = c,
            d.setRatio = Sa,
            d.data = this
        }
        ,
        j._linkCSSP = function(a, b, c, d) {
            return a && (b && (b._prev = a),
            a._next && (a._next._prev = a._prev),
            a._prev ? a._prev._next = a._next : this._firstPT === a && (this._firstPT = a._next,
            d = !0),
            c ? c._next = a : d || null !== this._firstPT || (this._firstPT = a),
            a._next = b,
            a._prev = c),
            a
        }
        ,
        j._kill = function(b) {
            var c, d, e, f = b;
            if (b.autoAlpha || b.alpha) {
                f = {};
                for (d in b)
                    f[d] = b[d];
                f.opacity = 1,
                f.autoAlpha && (f.visibility = 1)
            }
            return b.className && (c = this._classNamePT) && (e = c.xfirst,
            e && e._prev ? this._linkCSSP(e._prev, c._next, e._prev._prev) : e === this._firstPT && (this._firstPT = c._next),
            c._next && this._linkCSSP(c._next, c._next._next, e._prev),
            this._classNamePT = null),
            a.prototype._kill.call(this, f)
        }
        ;
        var Ta = function(a, b, c) {
            var d, e, f, g;
            if (a.slice)
                for (e = a.length; --e > -1; )
                    Ta(a[e], b, c);
            else
                for (d = a.childNodes,
                e = d.length; --e > -1; )
                    f = d[e],
                    g = f.type,
                    f.style && (b.push($(f)),
                    c && c.push(f)),
                    1 !== g && 9 !== g && 11 !== g || !f.childNodes.length || Ta(f, b, c)
        };
        return g.cascadeTo = function(a, c, d) {
            var e, f, g, h, i = b.to(a, c, d), j = [i], k = [], l = [], m = [], n = b._internals.reservedProps;
            for (a = i._targets || i.target,
            Ta(a, k, m),
            i.render(c, !0, !0),
            Ta(a, l),
            i.render(0, !0, !0),
            i._enabled(!0),
            e = m.length; --e > -1; )
                if (f = _(m[e], k[e], l[e]),
                f.firstMPT) {
                    f = f.difs;
                    for (g in d)
                        n[g] && (f[g] = d[g]);
                    h = {};
                    for (g in f)
                        h[g] = k[e][g];
                    j.push(b.fromTo(m[e], c, h, f))
                }
            return j
        }
        ,
        a.activate([g]),
        g
    }, !0),
    function() {
        var a = _gsScope._gsDefine.plugin({
            propName: "roundProps",
            version: "1.5",
            priority: -1,
            API: 2,
            init: function(a, b, c) {
                return this._tween = c,
                !0
            }
        })
          , b = function(a) {
            for (; a; )
                a.f || a.blob || (a.r = 1),
                a = a._next
        }
          , c = a.prototype;
        c._onInitAllProps = function() {
            for (var a, c, d, e = this._tween, f = e.vars.roundProps.join ? e.vars.roundProps : e.vars.roundProps.split(","), g = f.length, h = {}, i = e._propLookup.roundProps; --g > -1; )
                h[f[g]] = 1;
            for (g = f.length; --g > -1; )
                for (a = f[g],
                c = e._firstPT; c; )
                    d = c._next,
                    c.pg ? c.t._roundProps(h, !0) : c.n === a && (2 === c.f && c.t ? b(c.t._firstPT) : (this._add(c.t, a, c.s, c.c),
                    d && (d._prev = c._prev),
                    c._prev ? c._prev._next = d : e._firstPT === c && (e._firstPT = d),
                    c._next = c._prev = null,
                    e._propLookup[a] = i)),
                    c = d;
            return !1
        }
        ,
        c._add = function(a, b, c, d) {
            this._addTween(a, b, c, c + d, b, !0),
            this._overwriteProps.push(b)
        }
    }(),
    function() {
        _gsScope._gsDefine.plugin({
            propName: "attr",
            API: 2,
            version: "0.5.0",
            init: function(a, b, c) {
                var d;
                if ("function" != typeof a.setAttribute)
                    return !1;
                for (d in b)
                    this._addTween(a, "setAttribute", a.getAttribute(d) + "", b[d] + "", d, !1, d),
                    this._overwriteProps.push(d);
                return !0
            }
        })
    }(),
    _gsScope._gsDefine.plugin({
        propName: "directionalRotation",
        version: "0.2.1",
        API: 2,
        init: function(a, b, c) {
            "object" != typeof b && (b = {
                rotation: b
            }),
            this.finals = {};
            var d, e, f, g, h, i, j = b.useRadians === !0 ? 2 * Math.PI : 360, k = 1e-6;
            for (d in b)
                "useRadians" !== d && (i = (b[d] + "").split("_"),
                e = i[0],
                f = parseFloat("function" != typeof a[d] ? a[d] : a[d.indexOf("set") || "function" != typeof a["get" + d.substr(3)] ? d : "get" + d.substr(3)]()),
                g = this.finals[d] = "string" == typeof e && "=" === e.charAt(1) ? f + parseInt(e.charAt(0) + "1", 10) * Number(e.substr(2)) : Number(e) || 0,
                h = g - f,
                i.length && (e = i.join("_"),
                -1 !== e.indexOf("short") && (h %= j,
                h !== h % (j / 2) && (h = 0 > h ? h + j : h - j)),
                -1 !== e.indexOf("_cw") && 0 > h ? h = (h + 9999999999 * j) % j - (h / j | 0) * j : -1 !== e.indexOf("ccw") && h > 0 && (h = (h - 9999999999 * j) % j - (h / j | 0) * j)),
                (h > k || -k > h) && (this._addTween(a, d, f, f + h, d),
                this._overwriteProps.push(d)));
            return !0
        },
        set: function(a) {
            var b;
            if (1 !== a)
                this._super.setRatio.call(this, a);
            else
                for (b = this._firstPT; b; )
                    b.f ? b.t[b.p](this.finals[b.p]) : b.t[b.p] = this.finals[b.p],
                    b = b._next
        }
    })._autoCSS = !0,
    _gsScope._gsDefine("easing.Back", ["easing.Ease"], function(a) {
        var b, c, d, e = _gsScope.GreenSockGlobals || _gsScope, f = e.com.greensock, g = 2 * Math.PI, h = Math.PI / 2, i = f._class, j = function(b, c) {
            var d = i("easing." + b, function() {}, !0)
              , e = d.prototype = new a;
            return e.constructor = d,
            e.getRatio = c,
            d
        }, k = a.register || function() {}
        , l = function(a, b, c, d, e) {
            var f = i("easing." + a, {
                easeOut: new b,
                easeIn: new c,
                easeInOut: new d
            }, !0);
            return k(f, a),
            f
        }, m = function(a, b, c) {
            this.t = a,
            this.v = b,
            c && (this.next = c,
            c.prev = this,
            this.c = c.v - b,
            this.gap = c.t - a)
        }, n = function(b, c) {
            var d = i("easing." + b, function(a) {
                this._p1 = a || 0 === a ? a : 1.70158,
                this._p2 = 1.525 * this._p1
            }, !0)
              , e = d.prototype = new a;
            return e.constructor = d,
            e.getRatio = c,
            e.config = function(a) {
                return new d(a)
            }
            ,
            d
        }, o = l("Back", n("BackOut", function(a) {
            return (a -= 1) * a * ((this._p1 + 1) * a + this._p1) + 1
        }), n("BackIn", function(a) {
            return a * a * ((this._p1 + 1) * a - this._p1)
        }), n("BackInOut", function(a) {
            return (a *= 2) < 1 ? .5 * a * a * ((this._p2 + 1) * a - this._p2) : .5 * ((a -= 2) * a * ((this._p2 + 1) * a + this._p2) + 2)
        })), p = i("easing.SlowMo", function(a, b, c) {
            b = b || 0 === b ? b : .7,
            null == a ? a = .7 : a > 1 && (a = 1),
            this._p = 1 !== a ? b : 0,
            this._p1 = (1 - a) / 2,
            this._p2 = a,
            this._p3 = this._p1 + this._p2,
            this._calcEnd = c === !0
        }, !0), q = p.prototype = new a;
        return q.constructor = p,
        q.getRatio = function(a) {
            var b = a + (.5 - a) * this._p;
            return a < this._p1 ? this._calcEnd ? 1 - (a = 1 - a / this._p1) * a : b - (a = 1 - a / this._p1) * a * a * a * b : a > this._p3 ? this._calcEnd ? 1 - (a = (a - this._p3) / this._p1) * a : b + (a - b) * (a = (a - this._p3) / this._p1) * a * a * a : this._calcEnd ? 1 : b
        }
        ,
        p.ease = new p(.7,.7),
        q.config = p.config = function(a, b, c) {
            return new p(a,b,c)
        }
        ,
        b = i("easing.SteppedEase", function(a) {
            a = a || 1,
            this._p1 = 1 / a,
            this._p2 = a + 1
        }, !0),
        q = b.prototype = new a,
        q.constructor = b,
        q.getRatio = function(a) {
            return 0 > a ? a = 0 : a >= 1 && (a = .999999999),
            (this._p2 * a >> 0) * this._p1
        }
        ,
        q.config = b.config = function(a) {
            return new b(a)
        }
        ,
        c = i("easing.RoughEase", function(b) {
            b = b || {};
            for (var c, d, e, f, g, h, i = b.taper || "none", j = [], k = 0, l = 0 | (b.points || 20), n = l, o = b.randomize !== !1, p = b.clamp === !0, q = b.template instanceof a ? b.template : null, r = "number" == typeof b.strength ? .4 * b.strength : .4; --n > -1; )
                c = o ? Math.random() : 1 / l * n,
                d = q ? q.getRatio(c) : c,
                "none" === i ? e = r : "out" === i ? (f = 1 - c,
                e = f * f * r) : "in" === i ? e = c * c * r : .5 > c ? (f = 2 * c,
                e = f * f * .5 * r) : (f = 2 * (1 - c),
                e = f * f * .5 * r),
                o ? d += Math.random() * e - .5 * e : n % 2 ? d += .5 * e : d -= .5 * e,
                p && (d > 1 ? d = 1 : 0 > d && (d = 0)),
                j[k++] = {
                    x: c,
                    y: d
                };
            for (j.sort(function(a, b) {
                return a.x - b.x
            }),
            h = new m(1,1,null),
            n = l; --n > -1; )
                g = j[n],
                h = new m(g.x,g.y,h);
            this._prev = new m(0,0,0 !== h.t ? h : h.next)
        }, !0),
        q = c.prototype = new a,
        q.constructor = c,
        q.getRatio = function(a) {
            var b = this._prev;
            if (a > b.t) {
                for (; b.next && a >= b.t; )
                    b = b.next;
                b = b.prev
            } else
                for (; b.prev && a <= b.t; )
                    b = b.prev;
            return this._prev = b,
            b.v + (a - b.t) / b.gap * b.c
        }
        ,
        q.config = function(a) {
            return new c(a)
        }
        ,
        c.ease = new c,
        l("Bounce", j("BounceOut", function(a) {
            return 1 / 2.75 > a ? 7.5625 * a * a : 2 / 2.75 > a ? 7.5625 * (a -= 1.5 / 2.75) * a + .75 : 2.5 / 2.75 > a ? 7.5625 * (a -= 2.25 / 2.75) * a + .9375 : 7.5625 * (a -= 2.625 / 2.75) * a + .984375
        }), j("BounceIn", function(a) {
            return (a = 1 - a) < 1 / 2.75 ? 1 - 7.5625 * a * a : 2 / 2.75 > a ? 1 - (7.5625 * (a -= 1.5 / 2.75) * a + .75) : 2.5 / 2.75 > a ? 1 - (7.5625 * (a -= 2.25 / 2.75) * a + .9375) : 1 - (7.5625 * (a -= 2.625 / 2.75) * a + .984375)
        }), j("BounceInOut", function(a) {
            var b = .5 > a;
            return a = b ? 1 - 2 * a : 2 * a - 1,
            a = 1 / 2.75 > a ? 7.5625 * a * a : 2 / 2.75 > a ? 7.5625 * (a -= 1.5 / 2.75) * a + .75 : 2.5 / 2.75 > a ? 7.5625 * (a -= 2.25 / 2.75) * a + .9375 : 7.5625 * (a -= 2.625 / 2.75) * a + .984375,
            b ? .5 * (1 - a) : .5 * a + .5
        })),
        l("Circ", j("CircOut", function(a) {
            return Math.sqrt(1 - (a -= 1) * a)
        }), j("CircIn", function(a) {
            return -(Math.sqrt(1 - a * a) - 1)
        }), j("CircInOut", function(a) {
            return (a *= 2) < 1 ? -.5 * (Math.sqrt(1 - a * a) - 1) : .5 * (Math.sqrt(1 - (a -= 2) * a) + 1)
        })),
        d = function(b, c, d) {
            var e = i("easing." + b, function(a, b) {
                this._p1 = a >= 1 ? a : 1,
                this._p2 = (b || d) / (1 > a ? a : 1),
                this._p3 = this._p2 / g * (Math.asin(1 / this._p1) || 0),
                this._p2 = g / this._p2
            }, !0)
              , f = e.prototype = new a;
            return f.constructor = e,
            f.getRatio = c,
            f.config = function(a, b) {
                return new e(a,b)
            }
            ,
            e
        }
        ,
        l("Elastic", d("ElasticOut", function(a) {
            return this._p1 * Math.pow(2, -10 * a) * Math.sin((a - this._p3) * this._p2) + 1
        }, .3), d("ElasticIn", function(a) {
            return -(this._p1 * Math.pow(2, 10 * (a -= 1)) * Math.sin((a - this._p3) * this._p2))
        }, .3), d("ElasticInOut", function(a) {
            return (a *= 2) < 1 ? -.5 * (this._p1 * Math.pow(2, 10 * (a -= 1)) * Math.sin((a - this._p3) * this._p2)) : this._p1 * Math.pow(2, -10 * (a -= 1)) * Math.sin((a - this._p3) * this._p2) * .5 + 1
        }, .45)),
        l("Expo", j("ExpoOut", function(a) {
            return 1 - Math.pow(2, -10 * a)
        }), j("ExpoIn", function(a) {
            return Math.pow(2, 10 * (a - 1)) - .001
        }), j("ExpoInOut", function(a) {
            return (a *= 2) < 1 ? .5 * Math.pow(2, 10 * (a - 1)) : .5 * (2 - Math.pow(2, -10 * (a - 1)))
        })),
        l("Sine", j("SineOut", function(a) {
            return Math.sin(a * h)
        }), j("SineIn", function(a) {
            return -Math.cos(a * h) + 1
        }), j("SineInOut", function(a) {
            return -.5 * (Math.cos(Math.PI * a) - 1)
        })),
        i("easing.EaseLookup", {
            find: function(b) {
                return a.map[b]
            }
        }, !0),
        k(e.SlowMo, "SlowMo", "ease,"),
        k(c, "RoughEase", "ease,"),
        k(b, "SteppedEase", "ease,"),
        o
    }, !0)
}),
_gsScope._gsDefine && _gsScope._gsQueue.pop()(),
function(a, b) {
    "use strict";
    var c = a.GreenSockGlobals = a.GreenSockGlobals || a;
    if (!c.TweenLite) {
        var d, e, f, g, h, i = function(a) {
            var b, d = a.split("."), e = c;
            for (b = 0; b < d.length; b++)
                e[d[b]] = e = e[d[b]] || {};
            return e
        }, j = i("com.greensock"), k = 1e-10, l = function(a) {
            var b, c = [], d = a.length;
            for (b = 0; b !== d; c.push(a[b++]))
                ;
            return c
        }, m = function() {}, n = function() {
            var a = Object.prototype.toString
              , b = a.call([]);
            return function(c) {
                return null != c && (c instanceof Array || "object" == typeof c && !!c.push && a.call(c) === b)
            }
        }(), o = {}, p = function(d, e, f, g) {
            this.sc = o[d] ? o[d].sc : [],
            o[d] = this,
            this.gsClass = null,
            this.func = f;
            var h = [];
            this.check = function(j) {
                for (var k, l, m, n, q, r = e.length, s = r; --r > -1; )
                    (k = o[e[r]] || new p(e[r],[])).gsClass ? (h[r] = k.gsClass,
                    s--) : j && k.sc.push(this);
                if (0 === s && f)
                    for (l = ("com.greensock." + d).split("."),
                    m = l.pop(),
                    n = i(l.join("."))[m] = this.gsClass = f.apply(f, h),
                    g && (c[m] = n,
                    q = "undefined" != typeof module && module.exports,
                    !q && "function" == typeof define && define.amd ? define((a.GreenSockAMDPath ? a.GreenSockAMDPath + "/" : "") + d.split(".").pop(), [], function() {
                        return n
                    }) : d === b && q && (module.exports = n)),
                    r = 0; r < this.sc.length; r++)
                        this.sc[r].check()
            }
            ,
            this.check(!0)
        }, q = a._gsDefine = function(a, b, c, d) {
            return new p(a,b,c,d)
        }
        , r = j._class = function(a, b, c) {
            return b = b || function() {}
            ,
            q(a, [], function() {
                return b
            }, c),
            b
        }
        ;
        q.globals = c;
        var s = [0, 0, 1, 1]
          , t = []
          , u = r("easing.Ease", function(a, b, c, d) {
            this._func = a,
            this._type = c || 0,
            this._power = d || 0,
            this._params = b ? s.concat(b) : s
        }, !0)
          , v = u.map = {}
          , w = u.register = function(a, b, c, d) {
            for (var e, f, g, h, i = b.split(","), k = i.length, l = (c || "easeIn,easeOut,easeInOut").split(","); --k > -1; )
                for (f = i[k],
                e = d ? r("easing." + f, null, !0) : j.easing[f] || {},
                g = l.length; --g > -1; )
                    h = l[g],
                    v[f + "." + h] = v[h + f] = e[h] = a.getRatio ? a : a[h] || new a
        }
        ;
        for (f = u.prototype,
        f._calcEnd = !1,
        f.getRatio = function(a) {
            if (this._func)
                return this._params[0] = a,
                this._func.apply(null, this._params);
            var b = this._type
              , c = this._power
              , d = 1 === b ? 1 - a : 2 === b ? a : .5 > a ? 2 * a : 2 * (1 - a);
            return 1 === c ? d *= d : 2 === c ? d *= d * d : 3 === c ? d *= d * d * d : 4 === c && (d *= d * d * d * d),
            1 === b ? 1 - d : 2 === b ? d : .5 > a ? d / 2 : 1 - d / 2
        }
        ,
        d = ["Linear", "Quad", "Cubic", "Quart", "Quint,Strong"],
        e = d.length; --e > -1; )
            f = d[e] + ",Power" + e,
            w(new u(null,null,1,e), f, "easeOut", !0),
            w(new u(null,null,2,e), f, "easeIn" + (0 === e ? ",easeNone" : "")),
            w(new u(null,null,3,e), f, "easeInOut");
        v.linear = j.easing.Linear.easeIn,
        v.swing = j.easing.Quad.easeInOut;
        var x = r("events.EventDispatcher", function(a) {
            this._listeners = {},
            this._eventTarget = a || this
        });
        f = x.prototype,
        f.addEventListener = function(a, b, c, d, e) {
            e = e || 0;
            var f, i, j = this._listeners[a], k = 0;
            for (null == j && (this._listeners[a] = j = []),
            i = j.length; --i > -1; )
                f = j[i],
                f.c === b && f.s === c ? j.splice(i, 1) : 0 === k && f.pr < e && (k = i + 1);
            j.splice(k, 0, {
                c: b,
                s: c,
                up: d,
                pr: e
            }),
            this !== g || h || g.wake()
        }
        ,
        f.removeEventListener = function(a, b) {
            var c, d = this._listeners[a];
            if (d)
                for (c = d.length; --c > -1; )
                    if (d[c].c === b)
                        return void d.splice(c, 1)
        }
        ,
        f.dispatchEvent = function(a) {
            var b, c, d, e = this._listeners[a];
            if (e)
                for (b = e.length,
                c = this._eventTarget; --b > -1; )
                    d = e[b],
                    d && (d.up ? d.c.call(d.s || c, {
                        type: a,
                        target: c
                    }) : d.c.call(d.s || c))
        }
        ;
        var y = a.requestAnimationFrame
          , z = a.cancelAnimationFrame
          , A = Date.now || function() {
            return (new Date).getTime()
        }
          , B = A();
        for (d = ["ms", "moz", "webkit", "o"],
        e = d.length; --e > -1 && !y; )
            y = a[d[e] + "RequestAnimationFrame"],
            z = a[d[e] + "CancelAnimationFrame"] || a[d[e] + "CancelRequestAnimationFrame"];
        r("Ticker", function(a, b) {
            var c, d, e, f, i, j = this, l = A(), n = b !== !1 && y ? "auto" : !1, o = 500, p = 33, q = "tick", r = function(a) {
                var b, g, h = A() - B;
                h > o && (l += h - p),
                B += h,
                j.time = (B - l) / 1e3,
                b = j.time - i,
                (!c || b > 0 || a === !0) && (j.frame++,
                i += b + (b >= f ? .004 : f - b),
                g = !0),
                a !== !0 && (e = d(r)),
                g && j.dispatchEvent(q)
            };
            x.call(j),
            j.time = j.frame = 0,
            j.tick = function() {
                r(!0)
            }
            ,
            j.lagSmoothing = function(a, b) {
                o = a || 1 / k,
                p = Math.min(b, o, 0)
            }
            ,
            j.sleep = function() {
                null != e && (n && z ? z(e) : clearTimeout(e),
                d = m,
                e = null,
                j === g && (h = !1))
            }
            ,
            j.wake = function(a) {
                null !== e ? j.sleep() : a ? l += -B + (B = A()) : j.frame > 10 && (B = A() - o + 5),
                d = 0 === c ? m : n && y ? y : function(a) {
                    return setTimeout(a, 1e3 * (i - j.time) + 1 | 0)
                }
                ,
                j === g && (h = !0),
                r(2)
            }
            ,
            j.fps = function(a) {
                return arguments.length ? (c = a,
                f = 1 / (c || 60),
                i = this.time + f,
                void j.wake()) : c
            }
            ,
            j.useRAF = function(a) {
                return arguments.length ? (j.sleep(),
                n = a,
                void j.fps(c)) : n
            }
            ,
            j.fps(a),
            setTimeout(function() {
                "auto" === n && j.frame < 5 && "hidden" !== document.visibilityState && j.useRAF(!1)
            }, 1500)
        }),
        f = j.Ticker.prototype = new j.events.EventDispatcher,
        f.constructor = j.Ticker;
        var C = r("core.Animation", function(a, b) {
            if (this.vars = b = b || {},
            this._duration = this._totalDuration = a || 0,
            this._delay = Number(b.delay) || 0,
            this._timeScale = 1,
            this._active = b.immediateRender === !0,
            this.data = b.data,
            this._reversed = b.reversed === !0,
            V) {
                h || g.wake();
                var c = this.vars.useFrames ? U : V;
                c.add(this, c._time),
                this.vars.paused && this.paused(!0)
            }
        });
        g = C.ticker = new j.Ticker,
        f = C.prototype,
        f._dirty = f._gc = f._initted = f._paused = !1,
        f._totalTime = f._time = 0,
        f._rawPrevTime = -1,
        f._next = f._last = f._onUpdate = f._timeline = f.timeline = null,
        f._paused = !1;
        var D = function() {
            h && A() - B > 2e3 && g.wake(),
            setTimeout(D, 2e3)
        };
        D(),
        f.play = function(a, b) {
            return null != a && this.seek(a, b),
            this.reversed(!1).paused(!1)
        }
        ,
        f.pause = function(a, b) {
            return null != a && this.seek(a, b),
            this.paused(!0)
        }
        ,
        f.resume = function(a, b) {
            return null != a && this.seek(a, b),
            this.paused(!1)
        }
        ,
        f.seek = function(a, b) {
            return this.totalTime(Number(a), b !== !1)
        }
        ,
        f.restart = function(a, b) {
            return this.reversed(!1).paused(!1).totalTime(a ? -this._delay : 0, b !== !1, !0)
        }
        ,
        f.reverse = function(a, b) {
            return null != a && this.seek(a || this.totalDuration(), b),
            this.reversed(!0).paused(!1)
        }
        ,
        f.render = function(a, b, c) {}
        ,
        f.invalidate = function() {
            return this._time = this._totalTime = 0,
            this._initted = this._gc = !1,
            this._rawPrevTime = -1,
            (this._gc || !this.timeline) && this._enabled(!0),
            this
        }
        ,
        f.isActive = function() {
            var a, b = this._timeline, c = this._startTime;
            return !b || !this._gc && !this._paused && b.isActive() && (a = b.rawTime()) >= c && a < c + this.totalDuration() / this._timeScale
        }
        ,
        f._enabled = function(a, b) {
            return h || g.wake(),
            this._gc = !a,
            this._active = this.isActive(),
            b !== !0 && (a && !this.timeline ? this._timeline.add(this, this._startTime - this._delay) : !a && this.timeline && this._timeline._remove(this, !0)),
            !1
        }
        ,
        f._kill = function(a, b) {
            return this._enabled(!1, !1)
        }
        ,
        f.kill = function(a, b) {
            return this._kill(a, b),
            this
        }
        ,
        f._uncache = function(a) {
            for (var b = a ? this : this.timeline; b; )
                b._dirty = !0,
                b = b.timeline;
            return this
        }
        ,
        f._swapSelfInParams = function(a) {
            for (var b = a.length, c = a.concat(); --b > -1; )
                "{self}" === a[b] && (c[b] = this);
            return c
        }
        ,
        f._callback = function(a) {
            var b = this.vars;
            b[a].apply(b[a + "Scope"] || b.callbackScope || this, b[a + "Params"] || t)
        }
        ,
        f.eventCallback = function(a, b, c, d) {
            if ("on" === (a || "").substr(0, 2)) {
                var e = this.vars;
                if (1 === arguments.length)
                    return e[a];
                null == b ? delete e[a] : (e[a] = b,
                e[a + "Params"] = n(c) && -1 !== c.join("").indexOf("{self}") ? this._swapSelfInParams(c) : c,
                e[a + "Scope"] = d),
                "onUpdate" === a && (this._onUpdate = b)
            }
            return this
        }
        ,
        f.delay = function(a) {
            return arguments.length ? (this._timeline.smoothChildTiming && this.startTime(this._startTime + a - this._delay),
            this._delay = a,
            this) : this._delay
        }
        ,
        f.duration = function(a) {
            return arguments.length ? (this._duration = this._totalDuration = a,
            this._uncache(!0),
            this._timeline.smoothChildTiming && this._time > 0 && this._time < this._duration && 0 !== a && this.totalTime(this._totalTime * (a / this._duration), !0),
            this) : (this._dirty = !1,
            this._duration)
        }
        ,
        f.totalDuration = function(a) {
            return this._dirty = !1,
            arguments.length ? this.duration(a) : this._totalDuration
        }
        ,
        f.time = function(a, b) {
            return arguments.length ? (this._dirty && this.totalDuration(),
            this.totalTime(a > this._duration ? this._duration : a, b)) : this._time
        }
        ,
        f.totalTime = function(a, b, c) {
            if (h || g.wake(),
            !arguments.length)
                return this._totalTime;
            if (this._timeline) {
                if (0 > a && !c && (a += this.totalDuration()),
                this._timeline.smoothChildTiming) {
                    this._dirty && this.totalDuration();
                    var d = this._totalDuration
                      , e = this._timeline;
                    if (a > d && !c && (a = d),
                    this._startTime = (this._paused ? this._pauseTime : e._time) - (this._reversed ? d - a : a) / this._timeScale,
                    e._dirty || this._uncache(!1),
                    e._timeline)
                        for (; e._timeline; )
                            e._timeline._time !== (e._startTime + e._totalTime) / e._timeScale && e.totalTime(e._totalTime, !0),
                            e = e._timeline
                }
                this._gc && this._enabled(!0, !1),
                (this._totalTime !== a || 0 === this._duration) && (I.length && X(),
                this.render(a, b, !1),
                I.length && X())
            }
            return this
        }
        ,
        f.progress = f.totalProgress = function(a, b) {
            var c = this.duration();
            return arguments.length ? this.totalTime(c * a, b) : c ? this._time / c : this.ratio
        }
        ,
        f.startTime = function(a) {
            return arguments.length ? (a !== this._startTime && (this._startTime = a,
            this.timeline && this.timeline._sortChildren && this.timeline.add(this, a - this._delay)),
            this) : this._startTime
        }
        ,
        f.endTime = function(a) {
            return this._startTime + (0 != a ? this.totalDuration() : this.duration()) / this._timeScale
        }
        ,
        f.timeScale = function(a) {
            if (!arguments.length)
                return this._timeScale;
            if (a = a || k,
            this._timeline && this._timeline.smoothChildTiming) {
                var b = this._pauseTime
                  , c = b || 0 === b ? b : this._timeline.totalTime();
                this._startTime = c - (c - this._startTime) * this._timeScale / a
            }
            return this._timeScale = a,
            this._uncache(!1)
        }
        ,
        f.reversed = function(a) {
            return arguments.length ? (a != this._reversed && (this._reversed = a,
            this.totalTime(this._timeline && !this._timeline.smoothChildTiming ? this.totalDuration() - this._totalTime : this._totalTime, !0)),
            this) : this._reversed
        }
        ,
        f.paused = function(a) {
            if (!arguments.length)
                return this._paused;
            var b, c, d = this._timeline;
            return a != this._paused && d && (h || a || g.wake(),
            b = d.rawTime(),
            c = b - this._pauseTime,
            !a && d.smoothChildTiming && (this._startTime += c,
            this._uncache(!1)),
            this._pauseTime = a ? b : null,
            this._paused = a,
            this._active = this.isActive(),
            !a && 0 !== c && this._initted && this.duration() && (b = d.smoothChildTiming ? this._totalTime : (b - this._startTime) / this._timeScale,
            this.render(b, b === this._totalTime, !0))),
            this._gc && !a && this._enabled(!0, !1),
            this
        }
        ;
        var E = r("core.SimpleTimeline", function(a) {
            C.call(this, 0, a),
            this.autoRemoveChildren = this.smoothChildTiming = !0
        });
        f = E.prototype = new C,
        f.constructor = E,
        f.kill()._gc = !1,
        f._first = f._last = f._recent = null,
        f._sortChildren = !1,
        f.add = f.insert = function(a, b, c, d) {
            var e, f;
            if (a._startTime = Number(b || 0) + a._delay,
            a._paused && this !== a._timeline && (a._pauseTime = a._startTime + (this.rawTime() - a._startTime) / a._timeScale),
            a.timeline && a.timeline._remove(a, !0),
            a.timeline = a._timeline = this,
            a._gc && a._enabled(!0, !0),
            e = this._last,
            this._sortChildren)
                for (f = a._startTime; e && e._startTime > f; )
                    e = e._prev;
            return e ? (a._next = e._next,
            e._next = a) : (a._next = this._first,
            this._first = a),
            a._next ? a._next._prev = a : this._last = a,
            a._prev = e,
            this._recent = a,
            this._timeline && this._uncache(!0),
            this
        }
        ,
        f._remove = function(a, b) {
            return a.timeline === this && (b || a._enabled(!1, !0),
            a._prev ? a._prev._next = a._next : this._first === a && (this._first = a._next),
            a._next ? a._next._prev = a._prev : this._last === a && (this._last = a._prev),
            a._next = a._prev = a.timeline = null,
            a === this._recent && (this._recent = this._last),
            this._timeline && this._uncache(!0)),
            this
        }
        ,
        f.render = function(a, b, c) {
            var d, e = this._first;
            for (this._totalTime = this._time = this._rawPrevTime = a; e; )
                d = e._next,
                (e._active || a >= e._startTime && !e._paused) && (e._reversed ? e.render((e._dirty ? e.totalDuration() : e._totalDuration) - (a - e._startTime) * e._timeScale, b, c) : e.render((a - e._startTime) * e._timeScale, b, c)),
                e = d
        }
        ,
        f.rawTime = function() {
            return h || g.wake(),
            this._totalTime
        }
        ;
        var F = r("TweenLite", function(b, c, d) {
            if (C.call(this, c, d),
            this.render = F.prototype.render,
            null == b)
                throw "Cannot tween a null target.";
            this.target = b = "string" != typeof b ? b : F.selector(b) || b;
            var e, f, g, h = b.jquery || b.length && b !== a && b[0] && (b[0] === a || b[0].nodeType && b[0].style && !b.nodeType), i = this.vars.overwrite;
            if (this._overwrite = i = null == i ? T[F.defaultOverwrite] : "number" == typeof i ? i >> 0 : T[i],
            (h || b instanceof Array || b.push && n(b)) && "number" != typeof b[0])
                for (this._targets = g = l(b),
                this._propLookup = [],
                this._siblings = [],
                e = 0; e < g.length; e++)
                    f = g[e],
                    f ? "string" != typeof f ? f.length && f !== a && f[0] && (f[0] === a || f[0].nodeType && f[0].style && !f.nodeType) ? (g.splice(e--, 1),
                    this._targets = g = g.concat(l(f))) : (this._siblings[e] = Y(f, this, !1),
                    1 === i && this._siblings[e].length > 1 && $(f, this, null, 1, this._siblings[e])) : (f = g[e--] = F.selector(f),
                    "string" == typeof f && g.splice(e + 1, 1)) : g.splice(e--, 1);
            else
                this._propLookup = {},
                this._siblings = Y(b, this, !1),
                1 === i && this._siblings.length > 1 && $(b, this, null, 1, this._siblings);
            (this.vars.immediateRender || 0 === c && 0 === this._delay && this.vars.immediateRender !== !1) && (this._time = -k,
            this.render(-this._delay))
        }, !0)
          , G = function(b) {
            return b && b.length && b !== a && b[0] && (b[0] === a || b[0].nodeType && b[0].style && !b.nodeType)
        }
          , H = function(a, b) {
            var c, d = {};
            for (c in a)
                S[c] || c in b && "transform" !== c && "x" !== c && "y" !== c && "width" !== c && "height" !== c && "className" !== c && "border" !== c || !(!P[c] || P[c] && P[c]._autoCSS) || (d[c] = a[c],
                delete a[c]);
            a.css = d
        };
        f = F.prototype = new C,
        f.constructor = F,
        f.kill()._gc = !1,
        f.ratio = 0,
        f._firstPT = f._targets = f._overwrittenProps = f._startAt = null,
        f._notifyPluginsOfEnabled = f._lazy = !1,
        F.version = "1.18.2",
        F.defaultEase = f._ease = new u(null,null,1,1),
        F.defaultOverwrite = "auto",
        F.ticker = g,
        F.autoSleep = 120,
        F.lagSmoothing = function(a, b) {
            g.lagSmoothing(a, b)
        }
        ,
        F.selector = a.$ || a.jQuery || function(b) {
            var c = a.$ || a.jQuery;
            return c ? (F.selector = c,
            c(b)) : "undefined" == typeof document ? b : document.querySelectorAll ? document.querySelectorAll(b) : document.getElementById("#" === b.charAt(0) ? b.substr(1) : b)
        }
        ;
        var I = []
          , J = {}
          , K = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi
          , L = function(a) {
            for (var b, c = this._firstPT, d = 1e-6; c; )
                b = c.blob ? a ? this.join("") : this.start : c.c * a + c.s,
                c.r ? b = Math.round(b) : d > b && b > -d && (b = 0),
                c.f ? c.fp ? c.t[c.p](c.fp, b) : c.t[c.p](b) : c.t[c.p] = b,
                c = c._next
        }
          , M = function(a, b, c, d) {
            var e, f, g, h, i, j, k, l = [a, b], m = 0, n = "", o = 0;
            for (l.start = a,
            c && (c(l),
            a = l[0],
            b = l[1]),
            l.length = 0,
            e = a.match(K) || [],
            f = b.match(K) || [],
            d && (d._next = null,
            d.blob = 1,
            l._firstPT = d),
            i = f.length,
            h = 0; i > h; h++)
                k = f[h],
                j = b.substr(m, b.indexOf(k, m) - m),
                n += j || !h ? j : ",",
                m += j.length,
                o ? o = (o + 1) % 5 : "rgba(" === j.substr(-5) && (o = 1),
                k === e[h] || e.length <= h ? n += k : (n && (l.push(n),
                n = ""),
                g = parseFloat(e[h]),
                l.push(g),
                l._firstPT = {
                    _next: l._firstPT,
                    t: l,
                    p: l.length - 1,
                    s: g,
                    c: ("=" === k.charAt(1) ? parseInt(k.charAt(0) + "1", 10) * parseFloat(k.substr(2)) : parseFloat(k) - g) || 0,
                    f: 0,
                    r: o && 4 > o
                }),
                m += k.length;
            return n += b.substr(m),
            n && l.push(n),
            l.setRatio = L,
            l
        }
          , N = function(a, b, c, d, e, f, g, h) {
            var i, j, k = "get" === c ? a[b] : c, l = typeof a[b], m = "string" == typeof d && "=" === d.charAt(1), n = {
                t: a,
                p: b,
                s: k,
                f: "function" === l,
                pg: 0,
                n: e || b,
                r: f,
                pr: 0,
                c: m ? parseInt(d.charAt(0) + "1", 10) * parseFloat(d.substr(2)) : parseFloat(d) - k || 0
            };
            return "number" !== l && ("function" === l && "get" === c && (j = b.indexOf("set") || "function" != typeof a["get" + b.substr(3)] ? b : "get" + b.substr(3),
            n.s = k = g ? a[j](g) : a[j]()),
            "string" == typeof k && (g || isNaN(k)) ? (n.fp = g,
            i = M(k, d, h || F.defaultStringFilter, n),
            n = {
                t: i,
                p: "setRatio",
                s: 0,
                c: 1,
                f: 2,
                pg: 0,
                n: e || b,
                pr: 0
            }) : m || (n.s = parseFloat(k),
            n.c = parseFloat(d) - n.s || 0)),
            n.c ? ((n._next = this._firstPT) && (n._next._prev = n),
            this._firstPT = n,
            n) : void 0
        }
          , O = F._internals = {
            isArray: n,
            isSelector: G,
            lazyTweens: I,
            blobDif: M
        }
          , P = F._plugins = {}
          , Q = O.tweenLookup = {}
          , R = 0
          , S = O.reservedProps = {
            ease: 1,
            delay: 1,
            overwrite: 1,
            onComplete: 1,
            onCompleteParams: 1,
            onCompleteScope: 1,
            useFrames: 1,
            runBackwards: 1,
            startAt: 1,
            onUpdate: 1,
            onUpdateParams: 1,
            onUpdateScope: 1,
            onStart: 1,
            onStartParams: 1,
            onStartScope: 1,
            onReverseComplete: 1,
            onReverseCompleteParams: 1,
            onReverseCompleteScope: 1,
            onRepeat: 1,
            onRepeatParams: 1,
            onRepeatScope: 1,
            easeParams: 1,
            yoyo: 1,
            immediateRender: 1,
            repeat: 1,
            repeatDelay: 1,
            data: 1,
            paused: 1,
            reversed: 1,
            autoCSS: 1,
            lazy: 1,
            onOverwrite: 1,
            callbackScope: 1,
            stringFilter: 1
        }
          , T = {
            none: 0,
            all: 1,
            auto: 2,
            concurrent: 3,
            allOnStart: 4,
            preexisting: 5,
            "true": 1,
            "false": 0
        }
          , U = C._rootFramesTimeline = new E
          , V = C._rootTimeline = new E
          , W = 30
          , X = O.lazyRender = function() {
            var a, b = I.length;
            for (J = {}; --b > -1; )
                a = I[b],
                a && a._lazy !== !1 && (a.render(a._lazy[0], a._lazy[1], !0),
                a._lazy = !1);
            I.length = 0
        }
        ;
        V._startTime = g.time,
        U._startTime = g.frame,
        V._active = U._active = !0,
        setTimeout(X, 1),
        C._updateRoot = F.render = function() {
            var a, b, c;
            if (I.length && X(),
            V.render((g.time - V._startTime) * V._timeScale, !1, !1),
            U.render((g.frame - U._startTime) * U._timeScale, !1, !1),
            I.length && X(),
            g.frame >= W) {
                W = g.frame + (parseInt(F.autoSleep, 10) || 120);
                for (c in Q) {
                    for (b = Q[c].tweens,
                    a = b.length; --a > -1; )
                        b[a]._gc && b.splice(a, 1);
                    0 === b.length && delete Q[c]
                }
                if (c = V._first,
                (!c || c._paused) && F.autoSleep && !U._first && 1 === g._listeners.tick.length) {
                    for (; c && c._paused; )
                        c = c._next;
                    c || g.sleep()
                }
            }
        }
        ,
        g.addEventListener("tick", C._updateRoot);
        var Y = function(a, b, c) {
            var d, e, f = a._gsTweenID;
            if (Q[f || (a._gsTweenID = f = "t" + R++)] || (Q[f] = {
                target: a,
                tweens: []
            }),
            b && (d = Q[f].tweens,
            d[e = d.length] = b,
            c))
                for (; --e > -1; )
                    d[e] === b && d.splice(e, 1);
            return Q[f].tweens
        }
          , Z = function(a, b, c, d) {
            var e, f, g = a.vars.onOverwrite;
            return g && (e = g(a, b, c, d)),
            g = F.onOverwrite,
            g && (f = g(a, b, c, d)),
            e !== !1 && f !== !1
        }
          , $ = function(a, b, c, d, e) {
            var f, g, h, i;
            if (1 === d || d >= 4) {
                for (i = e.length,
                f = 0; i > f; f++)
                    if ((h = e[f]) !== b)
                        h._gc || h._kill(null, a, b) && (g = !0);
                    else if (5 === d)
                        break;
                return g
            }
            var j, l = b._startTime + k, m = [], n = 0, o = 0 === b._duration;
            for (f = e.length; --f > -1; )
                (h = e[f]) === b || h._gc || h._paused || (h._timeline !== b._timeline ? (j = j || _(b, 0, o),
                0 === _(h, j, o) && (m[n++] = h)) : h._startTime <= l && h._startTime + h.totalDuration() / h._timeScale > l && ((o || !h._initted) && l - h._startTime <= 2e-10 || (m[n++] = h)));
            for (f = n; --f > -1; )
                if (h = m[f],
                2 === d && h._kill(c, a, b) && (g = !0),
                2 !== d || !h._firstPT && h._initted) {
                    if (2 !== d && !Z(h, b))
                        continue;
                    h._enabled(!1, !1) && (g = !0)
                }
            return g
        }
          , _ = function(a, b, c) {
            for (var d = a._timeline, e = d._timeScale, f = a._startTime; d._timeline; ) {
                if (f += d._startTime,
                e *= d._timeScale,
                d._paused)
                    return -100;
                d = d._timeline
            }
            return f /= e,
            f > b ? f - b : c && f === b || !a._initted && 2 * k > f - b ? k : (f += a.totalDuration() / a._timeScale / e) > b + k ? 0 : f - b - k
        };
        f._init = function() {
            var a, b, c, d, e, f = this.vars, g = this._overwrittenProps, h = this._duration, i = !!f.immediateRender, j = f.ease;
            if (f.startAt) {
                this._startAt && (this._startAt.render(-1, !0),
                this._startAt.kill()),
                e = {};
                for (d in f.startAt)
                    e[d] = f.startAt[d];
                if (e.overwrite = !1,
                e.immediateRender = !0,
                e.lazy = i && f.lazy !== !1,
                e.startAt = e.delay = null,
                this._startAt = F.to(this.target, 0, e),
                i)
                    if (this._time > 0)
                        this._startAt = null;
                    else if (0 !== h)
                        return
            } else if (f.runBackwards && 0 !== h)
                if (this._startAt)
                    this._startAt.render(-1, !0),
                    this._startAt.kill(),
                    this._startAt = null;
                else {
                    0 !== this._time && (i = !1),
                    c = {};
                    for (d in f)
                        S[d] && "autoCSS" !== d || (c[d] = f[d]);
                    if (c.overwrite = 0,
                    c.data = "isFromStart",
                    c.lazy = i && f.lazy !== !1,
                    c.immediateRender = i,
                    this._startAt = F.to(this.target, 0, c),
                    i) {
                        if (0 === this._time)
                            return
                    } else
                        this._startAt._init(),
                        this._startAt._enabled(!1),
                        this.vars.immediateRender && (this._startAt = null)
                }
            if (this._ease = j = j ? j instanceof u ? j : "function" == typeof j ? new u(j,f.easeParams) : v[j] || F.defaultEase : F.defaultEase,
            f.easeParams instanceof Array && j.config && (this._ease = j.config.apply(j, f.easeParams)),
            this._easeType = this._ease._type,
            this._easePower = this._ease._power,
            this._firstPT = null,
            this._targets)
                for (a = this._targets.length; --a > -1; )
                    this._initProps(this._targets[a], this._propLookup[a] = {}, this._siblings[a], g ? g[a] : null) && (b = !0);
            else
                b = this._initProps(this.target, this._propLookup, this._siblings, g);
            if (b && F._onPluginEvent("_onInitAllProps", this),
            g && (this._firstPT || "function" != typeof this.target && this._enabled(!1, !1)),
            f.runBackwards)
                for (c = this._firstPT; c; )
                    c.s += c.c,
                    c.c = -c.c,
                    c = c._next;
            this._onUpdate = f.onUpdate,
            this._initted = !0
        }
        ,
        f._initProps = function(b, c, d, e) {
            var f, g, h, i, j, k;
            if (null == b)
                return !1;
            J[b._gsTweenID] && X(),
            this.vars.css || b.style && b !== a && b.nodeType && P.css && this.vars.autoCSS !== !1 && H(this.vars, b);
            for (f in this.vars)
                if (k = this.vars[f],
                S[f])
                    k && (k instanceof Array || k.push && n(k)) && -1 !== k.join("").indexOf("{self}") && (this.vars[f] = k = this._swapSelfInParams(k, this));
                else if (P[f] && (i = new P[f])._onInitTween(b, this.vars[f], this)) {
                    for (this._firstPT = j = {
                        _next: this._firstPT,
                        t: i,
                        p: "setRatio",
                        s: 0,
                        c: 1,
                        f: 1,
                        n: f,
                        pg: 1,
                        pr: i._priority
                    },
                    g = i._overwriteProps.length; --g > -1; )
                        c[i._overwriteProps[g]] = this._firstPT;
                    (i._priority || i._onInitAllProps) && (h = !0),
                    (i._onDisable || i._onEnable) && (this._notifyPluginsOfEnabled = !0),
                    j._next && (j._next._prev = j)
                } else
                    c[f] = N.call(this, b, f, "get", k, f, 0, null, this.vars.stringFilter);
            return e && this._kill(e, b) ? this._initProps(b, c, d, e) : this._overwrite > 1 && this._firstPT && d.length > 1 && $(b, this, c, this._overwrite, d) ? (this._kill(c, b),
            this._initProps(b, c, d, e)) : (this._firstPT && (this.vars.lazy !== !1 && this._duration || this.vars.lazy && !this._duration) && (J[b._gsTweenID] = !0),
            h)
        }
        ,
        f.render = function(a, b, c) {
            var d, e, f, g, h = this._time, i = this._duration, j = this._rawPrevTime;
            if (a >= i - 1e-7)
                this._totalTime = this._time = i,
                this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1,
                this._reversed || (d = !0,
                e = "onComplete",
                c = c || this._timeline.autoRemoveChildren),
                0 === i && (this._initted || !this.vars.lazy || c) && (this._startTime === this._timeline._duration && (a = 0),
                (0 > j || 0 >= a && a >= -1e-7 || j === k && "isPause" !== this.data) && j !== a && (c = !0,
                j > k && (e = "onReverseComplete")),
                this._rawPrevTime = g = !b || a || j === a ? a : k);
            else if (1e-7 > a)
                this._totalTime = this._time = 0,
                this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0,
                (0 !== h || 0 === i && j > 0) && (e = "onReverseComplete",
                d = this._reversed),
                0 > a && (this._active = !1,
                0 === i && (this._initted || !this.vars.lazy || c) && (j >= 0 && (j !== k || "isPause" !== this.data) && (c = !0),
                this._rawPrevTime = g = !b || a || j === a ? a : k)),
                this._initted || (c = !0);
            else if (this._totalTime = this._time = a,
            this._easeType) {
                var l = a / i
                  , m = this._easeType
                  , n = this._easePower;
                (1 === m || 3 === m && l >= .5) && (l = 1 - l),
                3 === m && (l *= 2),
                1 === n ? l *= l : 2 === n ? l *= l * l : 3 === n ? l *= l * l * l : 4 === n && (l *= l * l * l * l),
                1 === m ? this.ratio = 1 - l : 2 === m ? this.ratio = l : .5 > a / i ? this.ratio = l / 2 : this.ratio = 1 - l / 2
            } else
                this.ratio = this._ease.getRatio(a / i);
            if (this._time !== h || c) {
                if (!this._initted) {
                    if (this._init(),
                    !this._initted || this._gc)
                        return;
                    if (!c && this._firstPT && (this.vars.lazy !== !1 && this._duration || this.vars.lazy && !this._duration))
                        return this._time = this._totalTime = h,
                        this._rawPrevTime = j,
                        I.push(this),
                        void (this._lazy = [a, b]);
                    this._time && !d ? this.ratio = this._ease.getRatio(this._time / i) : d && this._ease._calcEnd && (this.ratio = this._ease.getRatio(0 === this._time ? 0 : 1))
                }
                for (this._lazy !== !1 && (this._lazy = !1),
                this._active || !this._paused && this._time !== h && a >= 0 && (this._active = !0),
                0 === h && (this._startAt && (a >= 0 ? this._startAt.render(a, b, c) : e || (e = "_dummyGS")),
                this.vars.onStart && (0 !== this._time || 0 === i) && (b || this._callback("onStart"))),
                f = this._firstPT; f; )
                    f.f ? f.t[f.p](f.c * this.ratio + f.s) : f.t[f.p] = f.c * this.ratio + f.s,
                    f = f._next;
                this._onUpdate && (0 > a && this._startAt && a !== -1e-4 && this._startAt.render(a, b, c),
                b || (this._time !== h || d) && this._callback("onUpdate")),
                e && (!this._gc || c) && (0 > a && this._startAt && !this._onUpdate && a !== -1e-4 && this._startAt.render(a, b, c),
                d && (this._timeline.autoRemoveChildren && this._enabled(!1, !1),
                this._active = !1),
                !b && this.vars[e] && this._callback(e),
                0 === i && this._rawPrevTime === k && g !== k && (this._rawPrevTime = 0))
            }
        }
        ,
        f._kill = function(a, b, c) {
            if ("all" === a && (a = null),
            null == a && (null == b || b === this.target))
                return this._lazy = !1,
                this._enabled(!1, !1);
            b = "string" != typeof b ? b || this._targets || this.target : F.selector(b) || b;
            var d, e, f, g, h, i, j, k, l, m = c && this._time && c._startTime === this._startTime && this._timeline === c._timeline;
            if ((n(b) || G(b)) && "number" != typeof b[0])
                for (d = b.length; --d > -1; )
                    this._kill(a, b[d], c) && (i = !0);
            else {
                if (this._targets) {
                    for (d = this._targets.length; --d > -1; )
                        if (b === this._targets[d]) {
                            h = this._propLookup[d] || {},
                            this._overwrittenProps = this._overwrittenProps || [],
                            e = this._overwrittenProps[d] = a ? this._overwrittenProps[d] || {} : "all";
                            break
                        }
                } else {
                    if (b !== this.target)
                        return !1;
                    h = this._propLookup,
                    e = this._overwrittenProps = a ? this._overwrittenProps || {} : "all"
                }
                if (h) {
                    if (j = a || h,
                    k = a !== e && "all" !== e && a !== h && ("object" != typeof a || !a._tempKill),
                    c && (F.onOverwrite || this.vars.onOverwrite)) {
                        for (f in j)
                            h[f] && (l || (l = []),
                            l.push(f));
                        if ((l || !a) && !Z(this, c, b, l))
                            return !1
                    }
                    for (f in j)
                        (g = h[f]) && (m && (g.f ? g.t[g.p](g.s) : g.t[g.p] = g.s,
                        i = !0),
                        g.pg && g.t._kill(j) && (i = !0),
                        g.pg && 0 !== g.t._overwriteProps.length || (g._prev ? g._prev._next = g._next : g === this._firstPT && (this._firstPT = g._next),
                        g._next && (g._next._prev = g._prev),
                        g._next = g._prev = null),
                        delete h[f]),
                        k && (e[f] = 1);
                    !this._firstPT && this._initted && this._enabled(!1, !1)
                }
            }
            return i
        }
        ,
        f.invalidate = function() {
            return this._notifyPluginsOfEnabled && F._onPluginEvent("_onDisable", this),
            this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null,
            this._notifyPluginsOfEnabled = this._active = this._lazy = !1,
            this._propLookup = this._targets ? {} : [],
            C.prototype.invalidate.call(this),
            this.vars.immediateRender && (this._time = -k,
            this.render(-this._delay)),
            this
        }
        ,
        f._enabled = function(a, b) {
            if (h || g.wake(),
            a && this._gc) {
                var c, d = this._targets;
                if (d)
                    for (c = d.length; --c > -1; )
                        this._siblings[c] = Y(d[c], this, !0);
                else
                    this._siblings = Y(this.target, this, !0)
            }
            return C.prototype._enabled.call(this, a, b),
            this._notifyPluginsOfEnabled && this._firstPT ? F._onPluginEvent(a ? "_onEnable" : "_onDisable", this) : !1
        }
        ,
        F.to = function(a, b, c) {
            return new F(a,b,c)
        }
        ,
        F.from = function(a, b, c) {
            return c.runBackwards = !0,
            c.immediateRender = 0 != c.immediateRender,
            new F(a,b,c)
        }
        ,
        F.fromTo = function(a, b, c, d) {
            return d.startAt = c,
            d.immediateRender = 0 != d.immediateRender && 0 != c.immediateRender,
            new F(a,b,d)
        }
        ,
        F.delayedCall = function(a, b, c, d, e) {
            return new F(b,0,{
                delay: a,
                onComplete: b,
                onCompleteParams: c,
                callbackScope: d,
                onReverseComplete: b,
                onReverseCompleteParams: c,
                immediateRender: !1,
                lazy: !1,
                useFrames: e,
                overwrite: 0
            })
        }
        ,
        F.set = function(a, b) {
            return new F(a,0,b)
        }
        ,
        F.getTweensOf = function(a, b) {
            if (null == a)
                return [];
            a = "string" != typeof a ? a : F.selector(a) || a;
            var c, d, e, f;
            if ((n(a) || G(a)) && "number" != typeof a[0]) {
                for (c = a.length,
                d = []; --c > -1; )
                    d = d.concat(F.getTweensOf(a[c], b));
                for (c = d.length; --c > -1; )
                    for (f = d[c],
                    e = c; --e > -1; )
                        f === d[e] && d.splice(c, 1)
            } else
                for (d = Y(a).concat(),
                c = d.length; --c > -1; )
                    (d[c]._gc || b && !d[c].isActive()) && d.splice(c, 1);
            return d
        }
        ,
        F.killTweensOf = F.killDelayedCallsTo = function(a, b, c) {
            "object" == typeof b && (c = b,
            b = !1);
            for (var d = F.getTweensOf(a, b), e = d.length; --e > -1; )
                d[e]._kill(c, a)
        }
        ;
        var aa = r("plugins.TweenPlugin", function(a, b) {
            this._overwriteProps = (a || "").split(","),
            this._propName = this._overwriteProps[0],
            this._priority = b || 0,
            this._super = aa.prototype
        }, !0);
        if (f = aa.prototype,
        aa.version = "1.18.0",
        aa.API = 2,
        f._firstPT = null,
        f._addTween = N,
        f.setRatio = L,
        f._kill = function(a) {
            var b, c = this._overwriteProps, d = this._firstPT;
            if (null != a[this._propName])
                this._overwriteProps = [];
            else
                for (b = c.length; --b > -1; )
                    null != a[c[b]] && c.splice(b, 1);
            for (; d; )
                null != a[d.n] && (d._next && (d._next._prev = d._prev),
                d._prev ? (d._prev._next = d._next,
                d._prev = null) : this._firstPT === d && (this._firstPT = d._next)),
                d = d._next;
            return !1
        }
        ,
        f._roundProps = function(a, b) {
            for (var c = this._firstPT; c; )
                (a[this._propName] || null != c.n && a[c.n.split(this._propName + "_").join("")]) && (c.r = b),
                c = c._next
        }
        ,
        F._onPluginEvent = function(a, b) {
            var c, d, e, f, g, h = b._firstPT;
            if ("_onInitAllProps" === a) {
                for (; h; ) {
                    for (g = h._next,
                    d = e; d && d.pr > h.pr; )
                        d = d._next;
                    (h._prev = d ? d._prev : f) ? h._prev._next = h : e = h,
                    (h._next = d) ? d._prev = h : f = h,
                    h = g
                }
                h = b._firstPT = e
            }
            for (; h; )
                h.pg && "function" == typeof h.t[a] && h.t[a]() && (c = !0),
                h = h._next;
            return c
        }
        ,
        aa.activate = function(a) {
            for (var b = a.length; --b > -1; )
                a[b].API === aa.API && (P[(new a[b])._propName] = a[b]);
            return !0
        }
        ,
        q.plugin = function(a) {
            if (!(a && a.propName && a.init && a.API))
                throw "illegal plugin definition.";
            var b, c = a.propName, d = a.priority || 0, e = a.overwriteProps, f = {
                init: "_onInitTween",
                set: "setRatio",
                kill: "_kill",
                round: "_roundProps",
                initAll: "_onInitAllProps"
            }, g = r("plugins." + c.charAt(0).toUpperCase() + c.substr(1) + "Plugin", function() {
                aa.call(this, c, d),
                this._overwriteProps = e || []
            }, a.global === !0), h = g.prototype = new aa(c);
            h.constructor = g,
            g.API = a.API;
            for (b in f)
                "function" == typeof a[b] && (h[f[b]] = a[b]);
            return g.version = a.version,
            aa.activate([g]),
            g
        }
        ,
        d = a._gsQueue) {
            for (e = 0; e < d.length; e++)
                d[e]();
            for (f in o)
                o[f].func || a.console.log("GSAP encountered missing dependency: com.greensock." + f)
        }
        h = !1
    }
}("undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window, "TweenMax");
var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function() {
    "use strict";
    var a = document.documentElement
      , b = window
      , c = function(c, d) {
        var e = "x" === d ? "Width" : "Height"
          , f = "scroll" + e
          , g = "client" + e
          , h = document.body;
        return c === b || c === a || c === h ? Math.max(a[f], h[f]) - (b["inner" + e] || a[g] || h[g]) : c[f] - c["offset" + e]
    }
      , d = _gsScope._gsDefine.plugin({
        propName: "scrollTo",
        API: 2,
        version: "1.7.6",
        init: function(a, d, e) {
            return this._wdw = a === b,
            this._target = a,
            this._tween = e,
            "object" != typeof d && (d = {
                y: d
            }),
            this.vars = d,
            this._autoKill = d.autoKill !== !1,
            this.x = this.xPrev = this.getX(),
            this.y = this.yPrev = this.getY(),
            null != d.x ? (this._addTween(this, "x", this.x, "max" === d.x ? c(a, "x") : d.x, "scrollTo_x", !0),
            this._overwriteProps.push("scrollTo_x")) : this.skipX = !0,
            null != d.y ? (this._addTween(this, "y", this.y, "max" === d.y ? c(a, "y") : d.y, "scrollTo_y", !0),
            this._overwriteProps.push("scrollTo_y")) : this.skipY = !0,
            !0
        },
        set: function(a) {
            this._super.setRatio.call(this, a);
            var d = this._wdw || !this.skipX ? this.getX() : this.xPrev
              , e = this._wdw || !this.skipY ? this.getY() : this.yPrev
              , f = e - this.yPrev
              , g = d - this.xPrev;
            this.x < 0 && (this.x = 0),
            this.y < 0 && (this.y = 0),
            this._autoKill && (!this.skipX && (g > 7 || -7 > g) && d < c(this._target, "x") && (this.skipX = !0),
            !this.skipY && (f > 7 || -7 > f) && e < c(this._target, "y") && (this.skipY = !0),
            this.skipX && this.skipY && (this._tween.kill(),
            this.vars.onAutoKill && this.vars.onAutoKill.apply(this.vars.onAutoKillScope || this._tween, this.vars.onAutoKillParams || []))),
            this._wdw ? b.scrollTo(this.skipX ? d : this.x, this.skipY ? e : this.y) : (this.skipY || (this._target.scrollTop = this.y),
            this.skipX || (this._target.scrollLeft = this.x)),
            this.xPrev = this.x,
            this.yPrev = this.y
        }
    })
      , e = d.prototype;
    d.max = c,
    e.getX = function() {
        return this._wdw ? null != b.pageXOffset ? b.pageXOffset : null != a.scrollLeft ? a.scrollLeft : document.body.scrollLeft : this._target.scrollLeft
    }
    ,
    e.getY = function() {
        return this._wdw ? null != b.pageYOffset ? b.pageYOffset : null != a.scrollTop ? a.scrollTop : document.body.scrollTop : this._target.scrollTop
    }
    ,
    e._kill = function(a) {
        return a.scrollTo_x && (this.skipX = !0),
        a.scrollTo_y && (this.skipY = !0),
        this._super._kill.call(this, a)
    }
}),
_gsScope._gsDefine && _gsScope._gsQueue.pop()();

/*! GreenSock Custom ease */
var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function() {
    "use strict";
    _gsScope._gsDefine("easing.CustomEase", ["easing.Ease"], function(a) {
        var b = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi
          , c = /[achlmqstvz]|(-?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi
          , d = /[\+\-]?\d*\.?\d+e[\+\-]?\d+/gi
          , e = /[cLlsS]/g
          , f = "CustomEase only accepts Cubic Bezier data."
          , g = function(a, b, c, d, e, f, h, i, j, k, l) {
            var m, n = (a + c) / 2, o = (b + d) / 2, p = (c + e) / 2, q = (d + f) / 2, r = (e + h) / 2, s = (f + i) / 2, t = (n + p) / 2, u = (o + q) / 2, v = (p + r) / 2, w = (q + s) / 2, x = (t + v) / 2, y = (u + w) / 2, z = h - a, A = i - b, B = Math.abs((c - h) * A - (d - i) * z), C = Math.abs((e - h) * A - (f - i) * z);
            return k || (k = [{
                x: a,
                y: b
            }, {
                x: h,
                y: i
            }],
            l = 1),
            k.splice(l || k.length - 1, 0, {
                x: x,
                y: y
            }),
            (B + C) * (B + C) > j * (z * z + A * A) && (m = k.length,
            g(a, b, n, o, t, u, x, y, j, k, l),
            g(x, y, v, w, r, s, h, i, j, k, l + 1 + (k.length - m))),
            k
        }
          , h = function(a) {
            var b, e, g, h, i, j, k, l, m, n, o, p = (a + "").replace(d, function(a) {
                var b = +a;
                return 1e-4 > b && b > -1e-4 ? 0 : b
            }).match(c) || [], q = [], r = 0, s = 0, t = p.length, u = 2;
            for (b = 0; t > b; b++)
                if (m = h,
                isNaN(p[b]) ? (h = p[b].toUpperCase(),
                i = h !== p[b]) : b--,
                e = +p[b + 1],
                g = +p[b + 2],
                i && (e += r,
                g += s),
                b || (k = e,
                l = g),
                "M" === h)
                    j && j.length < 8 && (q.length -= 1,
                    u = 0),
                    r = k = e,
                    s = l = g,
                    j = [e, g],
                    u = 2,
                    q.push(j),
                    b += 2,
                    h = "L";
                else if ("C" === h)
                    j || (j = [0, 0]),
                    j[u++] = e,
                    j[u++] = g,
                    i || (r = s = 0),
                    j[u++] = r + 1 * p[b + 3],
                    j[u++] = s + 1 * p[b + 4],
                    j[u++] = r += 1 * p[b + 5],
                    j[u++] = s += 1 * p[b + 6],
                    b += 6;
                else if ("S" === h)
                    "C" === m || "S" === m ? (n = r - j[u - 4],
                    o = s - j[u - 3],
                    j[u++] = r + n,
                    j[u++] = s + o) : (j[u++] = r,
                    j[u++] = s),
                    j[u++] = e,
                    j[u++] = g,
                    i || (r = s = 0),
                    j[u++] = r += 1 * p[b + 3],
                    j[u++] = s += 1 * p[b + 4],
                    b += 4;
                else {
                    if ("L" !== h && "Z" !== h)
                        throw f;
                    "Z" === h && (e = k,
                    g = l,
                    j.closed = !0),
                    ("L" === h || Math.abs(r - e) > .5 || Math.abs(s - g) > .5) && (j[u++] = r + (e - r) / 3,
                    j[u++] = s + (g - s) / 3,
                    j[u++] = r + 2 * (e - r) / 3,
                    j[u++] = s + 2 * (g - s) / 3,
                    j[u++] = e,
                    j[u++] = g,
                    "L" === h && (b += 2)),
                    r = e,
                    s = g
                }
            return q[0]
        }
          , i = function(a) {
            var b, c = a.length, d = 999999999999;
            for (b = 1; c > b; b += 6)
                +a[b] < d && (d = +a[b]);
            return d
        }
          , j = function(a, b, c) {
            c || 0 === c || (c = Math.max(+a[a.length - 1], +a[1]));
            var d, e = -1 * +a[0], f = -c, g = a.length, h = 1 / (+a[g - 2] + e), j = -b || (Math.abs(+a[g - 1] - +a[1]) < .01 * (+a[g - 2] - +a[0]) ? i(a) + f : +a[g - 1] + f);
            for (j = j ? 1 / j : -h,
            d = 0; g > d; d += 2)
                a[d] = (+a[d] + e) * h,
                a[d + 1] = (+a[d + 1] + f) * j
        }
          , k = function(a) {
            var b = this.lookup[a * this.l | 0] || this.lookup[this.l - 1];
            return b.nx < a && (b = b.n),
            b.y + (a - b.x) / b.cx * b.cy
        }
          , l = function(b, c, d) {
            this._calcEnd = !0,
            this.id = b,
            b && (a.map[b] = this),
            this.getRatio = k,
            this.setData(c, d)
        }
          , m = l.prototype = new a;
        return m.constructor = l,
        m.setData = function(a, c) {
            a = a || "0,0,1,1";
            var d, i, k, l, m, n, o, p, q, r, s = a.match(b), t = 1, u = [];
            if (c = c || {},
            r = c.precision || 1,
            this.data = a,
            this.lookup = [],
            this.points = u,
            this.fast = 1 >= r,
            (e.test(a) || -1 !== a.indexOf("M") && -1 === a.indexOf("C")) && (s = h(a)),
            d = s.length,
            4 === d)
                s.unshift(0, 0),
                s.push(1, 1),
                d = 8;
            else if ((d - 2) % 6)
                throw f;
            for ((0 !== +s[0] || 1 !== +s[d - 2]) && j(s, c.height, c.originY),
            this.rawBezier = s,
            l = 2; d > l; l += 6)
                i = {
                    x: +s[l - 2],
                    y: +s[l - 1]
                },
                k = {
                    x: +s[l + 4],
                    y: +s[l + 5]
                },
                u.push(i, k),
                g(i.x, i.y, +s[l], +s[l + 1], +s[l + 2], +s[l + 3], k.x, k.y, 1 / (2e5 * r), u, u.length - 1);
            for (d = u.length,
            l = 0; d > l; l++)
                o = u[l],
                p = u[l - 1] || o,
                o.x > p.x || p.y !== o.y && p.x === o.x || o === p ? (p.cx = o.x - p.x,
                p.cy = o.y - p.y,
                p.n = o,
                p.nx = o.x,
                this.fast && l > 1 && Math.abs(p.cy / p.cx - u[l - 2].cy / u[l - 2].cx) > 2 && (this.fast = !1),
                p.cx < t && (p.cx ? t = p.cx : (p.cx = .001,
                l === d - 1 && (p.x -= .001,
                t = Math.min(t, .001),
                this.fast = !1)))) : (u.splice(l--, 1),
                d--);
            if (d = 1 / t + 1 | 0,
            this.l = d,
            m = 1 / d,
            n = 0,
            o = u[0],
            this.fast) {
                for (l = 0; d > l; l++)
                    q = l * m,
                    o.nx < q && (o = u[++n]),
                    i = o.y + (q - o.x) / o.cx * o.cy,
                    this.lookup[l] = {
                        x: q,
                        cx: m,
                        y: i,
                        cy: 0,
                        nx: 9
                    },
                    l && (this.lookup[l - 1].cy = i - this.lookup[l - 1].y);
                this.lookup[d - 1].cy = u[u.length - 1].y - i
            } else {
                for (l = 0; d > l; l++)
                    o.nx < l * m && (o = u[++n]),
                    this.lookup[l] = o;
                n < u.length - 1 && (this.lookup[l - 1] = u[u.length - 2])
            }
            return this._calcEnd = 1 !== u[u.length - 1].y || 0 !== u[0].y,
            this
        }
        ,
        m.getRatio = k,
        m.getSVGData = function(a) {
            return l.getSVGData(this, a)
        }
        ,
        l.create = function(a, b, c) {
            return new l(a,b,c)
        }
        ,
        l.version = "0.2.2",
        l.bezierToPoints = g,
        l.get = function(b) {
            return a.map[b]
        }
        ,
        l.getSVGData = function(b, c) {
            c = c || {};
            var d, e, f, g, h, i, j, k, l, m, n = 1e3, o = c.width || 100, p = c.height || 100, q = c.x || 0, r = (c.y || 0) + p, s = c.path;
            if (c.invert && (p = -p,
            r = 0),
            b = b.getRatio ? b : a.map[b] || console.log("No ease found: ", b),
            b.rawBezier) {
                for (d = [],
                j = b.rawBezier.length,
                f = 0; j > f; f += 2)
                    d.push(((q + b.rawBezier[f] * o) * n | 0) / n + "," + ((r + b.rawBezier[f + 1] * -p) * n | 0) / n);
                d[0] = "M" + d[0],
                d[1] = "C" + d[1]
            } else
                for (d = ["M" + q + "," + r],
                j = Math.max(5, 200 * (c.precision || 1)),
                g = 1 / j,
                j += 2,
                k = 5 / j,
                l = ((q + g * o) * n | 0) / n,
                m = ((r + b.getRatio(g) * -p) * n | 0) / n,
                e = (m - r) / (l - q),
                f = 2; j > f; f++)
                    h = ((q + f * g * o) * n | 0) / n,
                    i = ((r + b.getRatio(f * g) * -p) * n | 0) / n,
                    (Math.abs((i - m) / (h - l) - e) > k || f === j - 1) && (d.push(l + "," + m),
                    e = (i - m) / (h - l)),
                    l = h,
                    m = i;
            return s && ("string" == typeof s ? document.querySelector(s) : s).setAttribute("d", d.join(" ")),
            d.join(" ")
        }
        ,
        l
    }, !0)
}),
_gsScope._gsDefine && _gsScope._gsQueue.pop()(),
function(a) {
    "use strict";
    var b = function() {
        return (_gsScope.GreenSockGlobals || _gsScope)[a]
    };
    "undefined" != typeof module && module.exports ? (require("../TweenLite.min.js"),
    module.exports = b()) : "function" == typeof define && define.amd && define(["TweenLite"], b)
}("CustomEase");

var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
(function(t) {
    "use strict";
    var e = t.GreenSockGlobals || t
      , i = function(t) {
        var i, s = t.split("."), r = e;
        for (i = 0; s.length > i; i++)
            r[s[i]] = r = r[s[i]] || {};
        return r
    }
      , s = i("com.greensock.utils")
      , r = function(t) {
        var e = t.nodeType
          , i = "";
        if (1 === e || 9 === e || 11 === e) {
            if ("string" == typeof t.textContent)
                return t.textContent;
            for (t = t.firstChild; t; t = t.nextSibling)
                i += r(t)
        } else if (3 === e || 4 === e)
            return t.nodeValue;
        return i
    }
      , n = document
      , a = n.defaultView ? n.defaultView.getComputedStyle : function() {}
      , o = /([A-Z])/g
      , l = function(t, e, i, s) {
        var r;
        return (i = i || a(t, null)) ? (t = i.getPropertyValue(e.replace(o, "-$1").toLowerCase()),
        r = t || i.length ? t : i[e]) : t.currentStyle && (i = t.currentStyle,
        r = i[e]),
        s ? r : parseInt(r, 10) || 0
    }
      , h = function(t) {
        return t.length && t[0] && (t[0].nodeType && t[0].style && !t.nodeType || t[0].length && t[0][0]) ? !0 : !1
    }
      , _ = function(t) {
        var e, i, s, r = [], n = t.length;
        for (e = 0; n > e; e++)
            if (i = t[e],
            h(i))
                for (s = i.length,
                s = 0; i.length > s; s++)
                    r.push(i[s]);
            else
                r.push(i);
        return r
    }
      , u = ")eefec303079ad17405c"
      , c = /(?:<br>|<br\/>|<br \/>)/gi
      , f = n.all && !n.addEventListener
      , p = "<div style='position:relative;display:inline-block;" + (f ? "*display:inline;*zoom:1;'" : "'")
      , m = function(t) {
        t = t || "";
        var e = -1 !== t.indexOf("++")
          , i = 1;
        return e && (t = t.split("++").join("")),
        function() {
            return p + (t ? " class='" + t + (e ? i++ : "") + "'>" : ">")
        }
    }
      , d = s.SplitText = e.SplitText = function(t, e) {
        if ("string" == typeof t && (t = d.selector(t)),
        !t)
            throw "cannot split a null element.";
        this.elements = h(t) ? _(t) : [t],
        this.chars = [],
        this.words = [],
        this.lines = [],
        this._originals = [],
        this.vars = e || {},
        this.split(e)
    }
      , g = function(t, e, i) {
        var s = t.nodeType;
        if (1 === s || 9 === s || 11 === s)
            for (t = t.firstChild; t; t = t.nextSibling)
                g(t, e, i);
        else
            (3 === s || 4 === s) && (t.nodeValue = t.nodeValue.split(e).join(i))
    }
      , v = function(t, e) {
        for (var i = e.length; --i > -1; )
            t.push(e[i])
    }
      , y = function(t, e, i, s, o) {
        c.test(t.innerHTML) && (t.innerHTML = t.innerHTML.replace(c, u));
        var h, _, f, p, d, y, T, w, b, x, P, S, k, C, R = r(t), O = e.type || e.split || "chars,words,lines", A = -1 !== O.indexOf("lines") ? [] : null, D = -1 !== O.indexOf("words"), M = -1 !== O.indexOf("chars"), L = "absolute" === e.position || e.absolute === !0, F = L ? "&#173; " : " ", z = -999, I = a(t), E = l(t, "paddingLeft", I), N = l(t, "borderBottomWidth", I) + l(t, "borderTopWidth", I), X = l(t, "borderLeftWidth", I) + l(t, "borderRightWidth", I), B = l(t, "paddingTop", I) + l(t, "paddingBottom", I), j = l(t, "paddingLeft", I) + l(t, "paddingRight", I), U = l(t, "textAlign", I, !0), Y = t.clientHeight, q = t.clientWidth, V = "</div>", G = m(e.wordsClass), Q = m(e.charsClass), W = -1 !== (e.linesClass || "").indexOf("++"), Z = e.linesClass, H = -1 !== R.indexOf("<"), $ = !0, K = [], J = [], te = [];
        for (W && (Z = Z.split("++").join("")),
        H && (R = R.split("<").join("{{LT}}")),
        h = R.length,
        p = G(),
        d = 0; h > d; d++)
            if (T = R.charAt(d),
            ")" === T && R.substr(d, 20) === u)
                p += ($ ? V : "") + "<BR/>",
                $ = !1,
                d !== h - 20 && R.substr(d + 20, 20) !== u && (p += " " + G(),
                $ = !0),
                d += 19;
            else if (" " === T && " " !== R.charAt(d - 1) && d !== h - 1 && R.substr(d - 20, 20) !== u) {
                for (p += $ ? V : "",
                $ = !1; " " === R.charAt(d + 1); )
                    p += F,
                    d++;
                (")" !== R.charAt(d + 1) || R.substr(d + 1, 20) !== u) && (p += F + G(),
                $ = !0)
            } else
                "{" === T && "{{LT}}" === R.substr(d, 6) ? (p += M ? Q() + "{{LT}}" + "</div>" : "{{LT}}",
                d += 5) : p += M && " " !== T ? Q() + T + "</div>" : T;
        for (t.innerHTML = p + ($ ? V : ""),
        H && g(t, "{{LT}}", "<"),
        y = t.getElementsByTagName("*"),
        h = y.length,
        w = [],
        d = 0; h > d; d++)
            w[d] = y[d];
        if (A || L)
            for (d = 0; h > d; d++)
                b = w[d],
                f = b.parentNode === t,
                (f || L || M && !D) && (x = b.offsetTop,
                A && f && x !== z && "BR" !== b.nodeName && (_ = [],
                A.push(_),
                z = x),
                L && (b._x = b.offsetLeft,
                b._y = x,
                b._w = b.offsetWidth,
                b._h = b.offsetHeight),
                A && (D !== f && M || (_.push(b),
                b._x -= E),
                f && d && (w[d - 1]._wordEnd = !0),
                "BR" === b.nodeName && b.nextSibling && "BR" === b.nextSibling.nodeName && A.push([])));
        for (d = 0; h > d; d++)
            b = w[d],
            f = b.parentNode === t,
            "BR" !== b.nodeName ? (L && (S = b.style,
            D || f || (b._x += b.parentNode._x,
            b._y += b.parentNode._y),
            S.left = b._x + "px",
            S.top = b._y + "px",
            S.position = "absolute",
            S.display = "block",
            S.width = b._w + 1 + "px",
            S.height = b._h + "px"),
            D ? f && "" !== b.innerHTML ? J.push(b) : M && K.push(b) : f ? (t.removeChild(b),
            w.splice(d--, 1),
            h--) : !f && M && (x = !A && !L && b.nextSibling,
            t.appendChild(b),
            x || t.appendChild(n.createTextNode(" ")),
            K.push(b))) : A || L ? (t.removeChild(b),
            w.splice(d--, 1),
            h--) : D || t.appendChild(b);
        if (A) {
            for (L && (P = n.createElement("div"),
            t.appendChild(P),
            k = P.offsetWidth + "px",
            x = P.offsetParent === t ? 0 : t.offsetLeft,
            t.removeChild(P)),
            S = t.style.cssText,
            t.style.cssText = "display:none;"; t.firstChild; )
                t.removeChild(t.firstChild);
            for (C = !L || !D && !M,
            d = 0; A.length > d; d++) {
                for (_ = A[d],
                P = n.createElement("div"),
                P.style.cssText = "display:block;text-align:" + U + ";position:" + (L ? "absolute;" : "relative;"),
                Z && (P.className = Z + (W ? d + 1 : "")),
                te.push(P),
                h = _.length,
                y = 0; h > y; y++)
                    "BR" !== _[y].nodeName && (b = _[y],
                    P.appendChild(b),
                    C && (b._wordEnd || D) && P.appendChild(n.createTextNode(" ")),
                    L && (0 === y && (P.style.top = b._y + "px",
                    P.style.left = E + x + "px"),
                    b.style.top = "0px",
                    x && (b.style.left = b._x - x + "px")));
                0 === h && (P.innerHTML = "&nbsp;"),
                D || M || (P.innerHTML = r(P).split(String.fromCharCode(160)).join(" ")),
                L && (P.style.width = k,
                P.style.height = b._h + "px"),
                t.appendChild(P)
            }
            t.style.cssText = S
        }
        L && (Y > t.clientHeight && (t.style.height = Y - B + "px",
        Y > t.clientHeight && (t.style.height = Y + N + "px")),
        q > t.clientWidth && (t.style.width = q - j + "px",
        q > t.clientWidth && (t.style.width = q + X + "px"))),
        v(i, K),
        v(s, J),
        v(o, te)
    }
      , T = d.prototype;
    T.split = function(t) {
        this.isSplit && this.revert(),
        this.vars = t || this.vars,
        this._originals.length = this.chars.length = this.words.length = this.lines.length = 0;
        for (var e = this.elements.length; --e > -1; )
            this._originals[e] = this.elements[e].innerHTML,
            y(this.elements[e], this.vars, this.chars, this.words, this.lines);
        return this.chars.reverse(),
        this.words.reverse(),
        this.lines.reverse(),
        this.isSplit = !0,
        this
    }
    ,
    T.revert = function() {
        if (!this._originals)
            throw "revert() call wasn't scoped properly.";
        for (var t = this._originals.length; --t > -1; )
            this.elements[t].innerHTML = this._originals[t];
        return this.chars = [],
        this.words = [],
        this.lines = [],
        this.isSplit = !1,
        this
    }
    ,
    d.selector = t.$ || t.jQuery || function(e) {
        var i = t.$ || t.jQuery;
        return i ? (d.selector = i,
        i(e)) : "undefined" == typeof document ? e : document.querySelectorAll ? document.querySelectorAll(e) : document.getElementById("#" === e.charAt(0) ? e.substr(1) : e)
    }
    ,
    d.version = "0.3.4"
}
)(_gsScope),
function(t) {
    "use strict";
    var e = function() {
        return (_gsScope.GreenSockGlobals || _gsScope)[t]
    };
    "function" == typeof define && define.amd ? define(["TweenLite"], e) : "undefined" != typeof module && module.exports && (module.exports = e())
}("SplitText");

var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function() {
    "use strict";
    function a(a, b, c, d, e, f) {
        return c = (parseFloat(c) - parseFloat(a)) * e,
        d = (parseFloat(d) - parseFloat(b)) * f,
        Math.sqrt(c * c + d * d)
    }
    function b(a) {
        return "string" != typeof a && a.nodeType || (a = _gsScope.TweenLite.selector(a),
        a.length && (a = a[0])),
        a
    }
    function c(a, b, c) {
        var d, e, f = a.indexOf(" ");
        return -1 === f ? (d = void 0 !== c ? c + "" : a,
        e = a) : (d = a.substr(0, f),
        e = a.substr(f + 1)),
        d = -1 !== d.indexOf("%") ? parseFloat(d) / 100 * b : parseFloat(d),
        e = -1 !== e.indexOf("%") ? parseFloat(e) / 100 * b : parseFloat(e),
        d > e ? [e, d] : [d, e]
    }
    function d(c) {
        if (!c)
            return 0;
        c = b(c);
        var d, e, f, g, h, j, k, l = c.tagName.toLowerCase(), m = 1, n = 1;
        "non-scaling-stroke" === c.getAttribute("vector-effect") && (n = c.getScreenCTM(),
        m = n.a,
        n = n.d);
        try {
            e = c.getBBox()
        } catch (o) {}
        if (e && (e.width || e.height) || "rect" !== l && "circle" !== l && "ellipse" !== l || (e = {
            width: parseFloat(c.getAttribute("rect" === l ? "width" : "circle" === l ? "r" : "rx")),
            height: parseFloat(c.getAttribute("rect" === l ? "height" : "circle" === l ? "r" : "ry"))
        },
        "rect" !== l && (e.width *= 2,
        e.height *= 2)),
        "path" === l)
            g = c.style.strokeDasharray,
            c.style.strokeDasharray = "none",
            d = c.getTotalLength() || 0,
            m !== n && console.log("Warning: <path> length cannot be measured accurately when vector-effect is non-scaling-stroke and the element isn't proportionally scaled."),
            d *= (m + n) / 2,
            c.style.strokeDasharray = g;
        else if ("rect" === l)
            d = 2 * e.width * m + 2 * e.height * n;
        else if ("line" === l)
            d = a(c.getAttribute("x1"), c.getAttribute("y1"), c.getAttribute("x2"), c.getAttribute("y2"), m, n);
        else if ("polyline" === l || "polygon" === l)
            for (f = c.getAttribute("points").match(i) || [],
            "polygon" === l && f.push(f[0], f[1]),
            d = 0,
            h = 2; h < f.length; h += 2)
                d += a(f[h - 2], f[h - 1], f[h], f[h + 1], m, n) || 0;
        else
            ("circle" === l || "ellipse" === l) && (j = e.width / 2 * m,
            k = e.height / 2 * n,
            d = Math.PI * (3 * (j + k) - Math.sqrt((3 * j + k) * (j + 3 * k))));
        return d || 0
    }
    function e(a, c) {
        if (!a)
            return [0, 0];
        a = b(a),
        c = c || d(a) + 1;
        var e = h(a)
          , f = e.strokeDasharray || ""
          , g = parseFloat(e.strokeDashoffset)
          , i = f.indexOf(",");
        return 0 > i && (i = f.indexOf(" ")),
        f = 0 > i ? c : parseFloat(f.substr(0, i)) || 1e-5,
        f > c && (f = c),
        [Math.max(0, -g), Math.max(0, f - g)]
    }
    var f, g = _gsScope.document, h = g.defaultView ? g.defaultView.getComputedStyle : function() {}
    , i = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi, j = -1 !== ((_gsScope.navigator || {}).userAgent || "").indexOf("Edge");
    f = _gsScope._gsDefine.plugin({
        propName: "drawSVG",
        API: 2,
        version: "0.1.3",
        global: !0,
        overwriteProps: ["drawSVG"],
        init: function(a, b, f, g) {
            if (!a.getBBox)
                return !1;
            var i, k, l, m, n = d(a) + 1;
            return this._style = a.style,
            "function" == typeof b && (b = b(g, a)),
            b === !0 || "true" === b ? b = "0 100%" : b ? -1 === (b + "").indexOf(" ") && (b = "0 " + b) : b = "0 0",
            i = e(a, n),
            k = c(b, n, i[0]),
            this._length = n + 10,
            0 === i[0] && 0 === k[0] ? (l = Math.max(1e-5, k[1] - n),
            this._dash = n + l,
            this._offset = n - i[1] + l,
            this._addTween(this, "_offset", this._offset, n - k[1] + l, "drawSVG")) : (this._dash = i[1] - i[0] || 1e-6,
            this._offset = -i[0],
            this._addTween(this, "_dash", this._dash, k[1] - k[0] || 1e-5, "drawSVG"),
            this._addTween(this, "_offset", this._offset, -k[0], "drawSVG")),
            j && (m = h(a),
            k = m.strokeLinecap,
            "butt" !== k && k !== m.strokeLinejoin && (k = parseFloat(m.strokeMiterlimit),
            this._addTween(a.style, "strokeMiterlimit", k, k + 1e-4, "strokeMiterlimit"))),
            !0
        },
        set: function(a) {
            this._firstPT && (this._super.setRatio.call(this, a),
            this._style.strokeDashoffset = this._offset,
            1 === a || 0 === a ? this._style.strokeDasharray = this._offset < .001 && this._length - this._dash <= 10 ? "none" : this._offset === this._dash ? "0px, 999999px" : this._dash + "px," + this._length + "px" : this._style.strokeDasharray = this._dash + "px," + this._length + "px")
        }
    }),
    f.getLength = d,
    f.getPosition = e
}),
_gsScope._gsDefine && _gsScope._gsQueue.pop()(),
function(a) {
    "use strict";
    var b = function() {
        return (_gsScope.GreenSockGlobals || _gsScope)[a]
    };
    "function" == typeof define && define.amd ? define(["TweenLite"], b) : "undefined" != typeof module && module.exports && (require("../TweenLite.js"),
    module.exports = b())
}("DrawSVGPlugin");

var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function() {
    "use strict";
    _gsScope._gsDefine("utils.Draggable", ["events.EventDispatcher", "TweenLite", "plugins.CSSPlugin"], function(a, b, c) {
        var d, e, f, g, h, i, j, k, l, m = {
            css: {}
        }, n = {
            css: {}
        }, o = {
            css: {}
        }, p = {
            css: {}
        }, q = _gsScope._gsDefine.globals, r = {}, s = {
            style: {}
        }, t = _gsScope.document || {
            createElement: function() {
                return s
            }
        }, u = t.documentElement || {}, v = function(a) {
            return t.createElementNS ? t.createElementNS("http://www.w3.org/1999/xhtml", a) : t.createElement(a)
        }, w = v("div"), x = [], y = function() {
            return !1
        }, z = 180 / Math.PI, A = 999999999999999, B = Date.now || function() {
            return (new Date).getTime()
        }
        , C = !(t.addEventListener || !t.all), D = t.createElement("div"), E = [], F = {}, G = 0, H = /^(?:a|input|textarea|button|select)$/i, I = 0, J = _gsScope.navigator && -1 !== _gsScope.navigator.userAgent.toLowerCase().indexOf("android"), K = 0, L = {}, M = {}, N = function(a) {
            if ("string" == typeof a && (a = b.selector(a)),
            !a || a.nodeType)
                return [a];
            var c, d = [], e = a.length;
            for (c = 0; c !== e; d.push(a[c++]))
                ;
            return d
        }, O = function(a, b) {
            var c, d = {};
            if (b)
                for (c in a)
                    d[c] = a[c] * b;
            else
                for (c in a)
                    d[c] = a[c];
            return d
        }, P = function() {
            for (var a = E.length; --a > -1; )
                E[a]()
        }, Q = function(a) {
            E.push(a),
            1 === E.length && b.ticker.addEventListener("tick", P, this, !1, 1)
        }, R = function(a) {
            for (var c = E.length; --c > -1; )
                E[c] === a && E.splice(c, 1);
            b.to(S, 0, {
                overwrite: "all",
                delay: 15,
                onComplete: S
            })
        }, S = function() {
            E.length || b.ticker.removeEventListener("tick", P)
        }, T = function(a, b) {
            var c;
            for (c in b)
                void 0 === a[c] && (a[c] = b[c]);
            return a
        }, U = function() {
            return null != window.pageYOffset ? window.pageYOffset : null != t.scrollTop ? t.scrollTop : u.scrollTop || t.body.scrollTop || 0
        }, V = function() {
            return null != window.pageXOffset ? window.pageXOffset : null != t.scrollLeft ? t.scrollLeft : u.scrollLeft || t.body.scrollLeft || 0
        }, W = function(a, b) {
            Ja(a, "scroll", b),
            Y(a.parentNode) || W(a.parentNode, b)
        }, X = function(a, b) {
            Ka(a, "scroll", b),
            Y(a.parentNode) || X(a.parentNode, b)
        }, Y = function(a) {
            return !(a && a !== u && a !== t && a !== t.body && a !== window && a.nodeType && a.parentNode)
        }, Z = function(a, b) {
            var c = "x" === b ? "Width" : "Height"
              , d = "scroll" + c
              , e = "client" + c
              , f = t.body;
            return Math.max(0, Y(a) ? Math.max(u[d], f[d]) - (window["inner" + c] || u[e] || f[e]) : a[d] - a[e])
        }, $ = function(a) {
            var b = Y(a)
              , c = Z(a, "x")
              , d = Z(a, "y");
            b ? a = M : $(a.parentNode),
            a._gsMaxScrollX = c,
            a._gsMaxScrollY = d,
            a._gsScrollX = a.scrollLeft || 0,
            a._gsScrollY = a.scrollTop || 0
        }, _ = function(a, b) {
            return a = a || window.event,
            r.pageX = a.clientX + t.body.scrollLeft + u.scrollLeft,
            r.pageY = a.clientY + t.body.scrollTop + u.scrollTop,
            b && (a.returnValue = !1),
            r
        }, aa = function(a) {
            return a ? ("string" == typeof a && (a = b.selector(a)),
            a.length && a !== window && a[0] && a[0].style && !a.nodeType && (a = a[0]),
            a === window || a.nodeType && a.style ? a : null) : a
        }, ba = function(a, b) {
            var c, e, f, g = a.style;
            if (void 0 === g[b]) {
                for (f = ["O", "Moz", "ms", "Ms", "Webkit"],
                e = 5,
                c = b.charAt(0).toUpperCase() + b.substr(1); --e > -1 && void 0 === g[f[e] + c]; )
                    ;
                if (0 > e)
                    return "";
                d = 3 === e ? "ms" : f[e],
                b = d + c
            }
            return b
        }, ca = function(a, b, c) {
            var d = a.style;
            d && (void 0 === d[b] && (b = ba(a, b)),
            null == c ? d.removeProperty ? d.removeProperty(b.replace(/([A-Z])/g, "-$1").toLowerCase()) : d.removeAttribute(b) : void 0 !== d[b] && (d[b] = c))
        }, da = t.defaultView ? t.defaultView.getComputedStyle : y, ea = /(?:Left|Right|Width)/i, fa = /(?:\d|\-|\+|=|#|\.)*/g, ga = function(a, b, c, d, e) {
            if ("px" === d || !d)
                return c;
            if ("auto" === d || !c)
                return 0;
            var f, g = ea.test(b), h = a, i = w.style, j = 0 > c;
            return j && (c = -c),
            "%" === d && -1 !== b.indexOf("border") ? f = c / 100 * (g ? a.clientWidth : a.clientHeight) : (i.cssText = "border:0 solid red;position:" + ia(a, "position", !0) + ";line-height:0;",
            "%" !== d && h.appendChild ? i[g ? "borderLeftWidth" : "borderTopWidth"] = c + d : (h = a.parentNode || t.body,
            i[g ? "width" : "height"] = c + d),
            h.appendChild(w),
            f = parseFloat(w[g ? "offsetWidth" : "offsetHeight"]),
            h.removeChild(w),
            0 !== f || e || (f = ga(a, b, c, d, !0))),
            j ? -f : f
        }, ha = function(a, b) {
            if ("absolute" !== ia(a, "position", !0))
                return 0;
            var c = "left" === b ? "Left" : "Top"
              , d = ia(a, "margin" + c, !0);
            return a["offset" + c] - (ga(a, b, parseFloat(d), (d + "").replace(fa, "")) || 0)
        }, ia = function(a, b, c) {
            var d, e = (a._gsTransform || {})[b];
            return e || 0 === e ? e : (a.style[b] ? e = a.style[b] : (d = da(a)) ? (e = d.getPropertyValue(b.replace(/([A-Z])/g, "-$1").toLowerCase()),
            e = e || d.length ? e : d[b]) : a.currentStyle && (e = a.currentStyle[b]),
            "auto" !== e || "top" !== b && "left" !== b || (e = ha(a, b)),
            c ? e : parseFloat(e) || 0)
        }, ja = function(a, b, c) {
            var d = a.vars
              , e = d[c]
              , f = a._listeners[b];
            "function" == typeof e && e.apply(d[c + "Scope"] || d.callbackScope || a, d[c + "Params"] || [a.pointerEvent]),
            f && a.dispatchEvent(b)
        }, ka = function(a, b) {
            var c, d, e, f = aa(a);
            return f ? Ea(f, b) : void 0 !== a.left ? (e = ya(b),
            {
                left: a.left - e.x,
                top: a.top - e.y,
                width: a.width,
                height: a.height
            }) : (d = a.min || a.minX || a.minRotation || 0,
            c = a.min || a.minY || 0,
            {
                left: d,
                top: c,
                width: (a.max || a.maxX || a.maxRotation || 0) - d,
                height: (a.max || a.maxY || 0) - c
            })
        }, la = function() {
            if (!t.createElementNS)
                return g = 0,
                void (h = !1);
            var a, b, c, d, e = v("div"), f = t.createElementNS("http://www.w3.org/2000/svg", "svg"), l = v("div"), m = e.style, n = t.body || u, o = "flex" === ia(n, "display", !0);
            t.body && oa && (m.position = "absolute",
            n.appendChild(l),
            l.appendChild(e),
            d = e.offsetParent,
            l.style[oa] = "rotate(1deg)",
            k = e.offsetParent === d,
            l.style.position = "absolute",
            m.height = "10px",
            d = e.offsetTop,
            l.style.border = "5px solid red",
            j = d !== e.offsetTop,
            n.removeChild(l)),
            m = f.style,
            f.setAttributeNS(null, "width", "400px"),
            f.setAttributeNS(null, "height", "400px"),
            f.setAttributeNS(null, "viewBox", "0 0 400 400"),
            m.display = "block",
            m.boxSizing = "border-box",
            m.border = "0px solid red",
            m.transform = "none",
            e.style.cssText = "width:100px;height:100px;overflow:scroll;-ms-overflow-style:none;",
            n.appendChild(e),
            e.appendChild(f),
            c = f.createSVGPoint().matrixTransform(f.getScreenCTM()),
            b = c.y,
            e.scrollTop = 100,
            c.x = c.y = 0,
            c = c.matrixTransform(f.getScreenCTM()),
            i = b - c.y < 100.1 ? 0 : b - c.y - 150,
            e.removeChild(f),
            n.removeChild(e),
            n.appendChild(f),
            o && (n.style.display = "block"),
            a = f.getScreenCTM(),
            b = a.e,
            m.border = "50px solid red",
            a = f.getScreenCTM(),
            0 === b && 0 === a.e && 0 === a.f && 1 === a.a ? (g = 1,
            h = !0) : (g = b !== a.e ? 1 : 0,
            h = 1 !== a.a),
            o && (n.style.display = "flex"),
            n.removeChild(f)
        }, ma = "" !== ba(w, "perspective"), na = ba(w, "transformOrigin").replace(/^ms/g, "Ms").replace(/([A-Z])/g, "-$1").toLowerCase(), oa = ba(w, "transform"), pa = oa.replace(/^ms/g, "Ms").replace(/([A-Z])/g, "-$1").toLowerCase(), qa = {}, ra = {}, sa = _gsScope.SVGElement, ta = function(a) {
            return !!(sa && "function" == typeof a.getBBox && a.getCTM && (!a.parentNode || a.parentNode.getBBox && a.parentNode.getCTM))
        }, ua = (/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(navigator.userAgent) || /Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(navigator.userAgent)) && parseFloat(RegExp.$1) < 11, va = [], wa = [], xa = function(a) {
            if (!a.getBoundingClientRect || !a.parentNode || !oa)
                return {
                    offsetTop: 0,
                    offsetLeft: 0,
                    scaleX: 1,
                    scaleY: 1,
                    offsetParent: u
                };
            if (Ta.cacheSVGData !== !1 && a._dCache && a._dCache.lastUpdate === b.ticker.frame)
                return a._dCache;
            var c, d, e, f, j, k, l, m, n, o, p, q, r = a, s = za(a);
            if (s.lastUpdate = b.ticker.frame,
            a.getBBox && !s.isSVGRoot) {
                for (r = a.parentNode,
                c = a.getBBox(); r && "svg" !== (r.nodeName + "").toLowerCase(); )
                    r = r.parentNode;
                return f = xa(r),
                s.offsetTop = c.y * f.scaleY,
                s.offsetLeft = c.x * f.scaleX,
                s.scaleX = f.scaleX,
                s.scaleY = f.scaleY,
                s.offsetParent = r || u,
                s
            }
            for (e = s.offsetParent,
            e === t.body && (e = u),
            wa.length = va.length = 0; r && (j = ia(r, oa, !0),
            "matrix(1, 0, 0, 1, 0, 0)" !== j && "none" !== j && "translate3d(0px, 0px, 0px)" !== j && (wa.push(r),
            va.push(r.style[oa]),
            r.style[oa] = "none"),
            r !== e); )
                r = r.parentNode;
            for (d = e.getBoundingClientRect(),
            j = a.getScreenCTM(),
            m = a.createSVGPoint(),
            l = m.matrixTransform(j),
            m.x = m.y = 10,
            m = m.matrixTransform(j),
            s.scaleX = (m.x - l.x) / 10,
            s.scaleY = (m.y - l.y) / 10,
            void 0 === g && la(),
            s.borderBox && !h && a.getAttribute("width") && (f = da(a) || {},
            n = parseFloat(f.borderLeftWidth) + parseFloat(f.borderRightWidth) || 0,
            o = parseFloat(f.borderTopWidth) + parseFloat(f.borderBottomWidth) || 0,
            p = parseFloat(f.width) || 0,
            q = parseFloat(f.height) || 0,
            s.scaleX *= (p - n) / p,
            s.scaleY *= (q - o) / q),
            i ? (c = a.getBoundingClientRect(),
            s.offsetLeft = c.left - d.left,
            s.offsetTop = c.top - d.top) : (s.offsetLeft = l.x - d.left,
            s.offsetTop = l.y - d.top),
            s.offsetParent = e,
            k = wa.length; --k > -1; )
                wa[k].style[oa] = va[k];
            return s
        }, ya = function(a, c) {
            if (c = c || {},
            !a || a === u || !a.parentNode || a === window)
                return {
                    x: 0,
                    y: 0
                };
            var d = da(a)
              , e = na && d ? d.getPropertyValue(na) : "50% 50%"
              , f = e.split(" ")
              , g = -1 !== e.indexOf("left") ? "0%" : -1 !== e.indexOf("right") ? "100%" : f[0]
              , h = -1 !== e.indexOf("top") ? "0%" : -1 !== e.indexOf("bottom") ? "100%" : f[1];
            return ("center" === h || null == h) && (h = "50%"),
            ("center" === g || isNaN(parseFloat(g))) && (g = "50%"),
            a.getBBox && ta(a) ? (a._gsTransform || (b.set(a, {
                x: "+=0",
                overwrite: !1
            }),
            void 0 === a._gsTransform.xOrigin && console.log("Draggable requires at least GSAP 1.17.0")),
            e = a.getBBox(),
            c.x = a._gsTransform.xOrigin - e.x,
            c.y = a._gsTransform.yOrigin - e.y) : (a.getBBox && -1 !== (g + h).indexOf("%") && (a = a.getBBox(),
            a = {
                offsetWidth: a.width,
                offsetHeight: a.height
            }),
            c.x = -1 !== g.indexOf("%") ? a.offsetWidth * parseFloat(g) / 100 : parseFloat(g),
            c.y = -1 !== h.indexOf("%") ? a.offsetHeight * parseFloat(h) / 100 : parseFloat(h)),
            c
        }, za = function(a) {
            if (Ta.cacheSVGData !== !1 && a._dCache && a._dCache.lastUpdate === b.ticker.frame)
                return a._dCache;
            var c, d = a._dCache = a._dCache || {}, e = da(a), f = a.getBBox && ta(a), g = "svg" === (a.nodeName + "").toLowerCase();
            if (d.isSVG = f,
            d.isSVGRoot = g,
            d.borderBox = "border-box" === e.boxSizing,
            d.computedStyle = e,
            g)
                c = a.parentNode || u,
                c.insertBefore(w, a),
                d.offsetParent = w.offsetParent || u,
                c.removeChild(w);
            else if (f) {
                for (c = a.parentNode; c && "svg" !== (c.nodeName + "").toLowerCase(); )
                    c = c.parentNode;
                d.offsetParent = c
            } else
                d.offsetParent = a.offsetParent;
            return d
        }, Aa = function(a, b, c, d, e) {
            if (a === window || !a || !a.style || !a.parentNode)
                return [1, 0, 0, 1, 0, 0];
            var f, h, i, l, m, n, o, p, q, r, s, v, w, x, y = a._dCache || za(a), z = a.parentNode, A = z._dCache || za(z), B = y.computedStyle, C = y.isSVG ? A.offsetParent : z.offsetParent;
            return f = y.isSVG && -1 !== (a.style[oa] + "").indexOf("matrix") ? a.style[oa] : B ? B.getPropertyValue(pa) : a.currentStyle ? a.currentStyle[oa] : "1,0,0,1,0,0",
            a.getBBox && -1 !== (a.getAttribute("transform") + "").indexOf("matrix") && (f = a.getAttribute("transform")),
            f = (f + "").match(/(?:\-|\.|\b)(\d|\.|e\-)+/g) || [1, 0, 0, 1, 0, 0],
            f.length > 6 && (f = [f[0], f[1], f[4], f[5], f[12], f[13]]),
            d ? f[4] = f[5] = 0 : y.isSVG && (m = a._gsTransform) && (m.xOrigin || m.yOrigin) && (f[0] = parseFloat(f[0]),
            f[1] = parseFloat(f[1]),
            f[2] = parseFloat(f[2]),
            f[3] = parseFloat(f[3]),
            f[4] = parseFloat(f[4]) - (m.xOrigin - (m.xOrigin * f[0] + m.yOrigin * f[2])),
            f[5] = parseFloat(f[5]) - (m.yOrigin - (m.xOrigin * f[1] + m.yOrigin * f[3]))),
            b && (void 0 === g && la(),
            i = y.isSVG || y.isSVGRoot ? xa(a) : a,
            y.isSVG ? (l = a.getBBox(),
            r = A.isSVGRoot ? {
                x: 0,
                y: 0
            } : z.getBBox(),
            i = {
                offsetLeft: l.x - r.x,
                offsetTop: l.y - r.y,
                offsetParent: y.offsetParent
            }) : y.isSVGRoot ? (s = parseInt(B.borderTopWidth, 10) || 0,
            v = parseInt(B.borderLeftWidth, 10) || 0,
            w = (f[0] - g) * v + f[2] * s,
            x = f[1] * v + (f[3] - g) * s,
            n = b.x,
            o = b.y,
            p = n - (n * f[0] + o * f[2]),
            q = o - (n * f[1] + o * f[3]),
            f[4] = parseFloat(f[4]) + p,
            f[5] = parseFloat(f[5]) + q,
            b.x -= p,
            b.y -= q,
            n = i.scaleX,
            o = i.scaleY,
            e || (b.x *= n,
            b.y *= o),
            f[0] *= n,
            f[1] *= o,
            f[2] *= n,
            f[3] *= o,
            ua || (b.x += w,
            b.y += x),
            C === t.body && i.offsetParent === u && (C = u)) : !j && a.offsetParent && (b.x += parseInt(ia(a.offsetParent, "borderLeftWidth"), 10) || 0,
            b.y += parseInt(ia(a.offsetParent, "borderTopWidth"), 10) || 0),
            h = z === u || z === t.body,
            f[4] = Number(f[4]) + b.x + (i.offsetLeft || 0) - c.x - (h ? 0 : z.scrollLeft || 0),
            f[5] = Number(f[5]) + b.y + (i.offsetTop || 0) - c.y - (h ? 0 : z.scrollTop || 0),
            z && "fixed" === ia(a, "position", B) && (f[4] += V(),
            f[5] += U()),
            !z || z === u || C !== i.offsetParent || A.isSVG || k && "100100" !== Aa(z).join("") || (i = A.isSVGRoot ? xa(z) : z,
            f[4] -= i.offsetLeft || 0,
            f[5] -= i.offsetTop || 0,
            j || !A.offsetParent || y.isSVG || y.isSVGRoot || (f[4] -= parseInt(ia(A.offsetParent, "borderLeftWidth"), 10) || 0,
            f[5] -= parseInt(ia(A.offsetParent, "borderTopWidth"), 10) || 0))),
            f
        }, Ba = function(a, b) {
            if (!a || a === window || !a.parentNode)
                return [1, 0, 0, 1, 0, 0];
            for (var c, d, e, f, g, h, i, j, k = ya(a, qa), l = ya(a.parentNode, ra), m = Aa(a, k, l, !1, !0); (a = a.parentNode) && a.parentNode && a !== u; )
                k = l,
                l = ya(a.parentNode, k === qa ? ra : qa),
                i = Aa(a, k, l),
                c = m[0],
                d = m[1],
                e = m[2],
                f = m[3],
                g = m[4],
                h = m[5],
                m[0] = c * i[0] + d * i[2],
                m[1] = c * i[1] + d * i[3],
                m[2] = e * i[0] + f * i[2],
                m[3] = e * i[1] + f * i[3],
                m[4] = g * i[0] + h * i[2] + i[4],
                m[5] = g * i[1] + h * i[3] + i[5];
            return b && (c = m[0],
            d = m[1],
            e = m[2],
            f = m[3],
            g = m[4],
            h = m[5],
            j = c * f - d * e,
            m[0] = f / j,
            m[1] = -d / j,
            m[2] = -e / j,
            m[3] = c / j,
            m[4] = (e * h - f * g) / j,
            m[5] = -(c * h - d * g) / j),
            m
        }, Ca = function(a, b, c, d, e) {
            a = aa(a);
            var f = Ba(a, !1, e)
              , g = b.x
              , h = b.y;
            return c && (ya(a, b),
            g -= b.x,
            h -= b.y),
            d = d === !0 ? b : d || {},
            d.x = g * f[0] + h * f[2] + f[4],
            d.y = g * f[1] + h * f[3] + f[5],
            d
        }, Da = function(a, b, c) {
            var d = a.x * b[0] + a.y * b[2] + b[4]
              , e = a.x * b[1] + a.y * b[3] + b[5];
            return a.x = d * c[0] + e * c[2] + c[4],
            a.y = d * c[1] + e * c[3] + c[5],
            a
        }, Ea = function(a, b, c) {
            if (!(a = aa(a)))
                return null;
            b = aa(b);
            var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, v, w, x, y, z, A, B = a.getBBox && ta(a);
            if (a === window)
                g = U(),
                e = V(),
                f = e + (u.clientWidth || a.innerWidth || t.body.clientWidth || 0),
                h = g + ((a.innerHeight || 0) - 20 < u.clientHeight ? u.clientHeight : a.innerHeight || t.body.clientHeight || 0);
            else {
                if (void 0 === b || b === window)
                    return a.getBoundingClientRect();
                d = ya(a),
                e = -d.x,
                g = -d.y,
                B ? (o = a.getBBox(),
                p = o.width,
                q = o.height) : "svg" !== (a.nodeName + "").toLowerCase() && a.offsetWidth ? (p = a.offsetWidth,
                q = a.offsetHeight) : (z = da(a),
                p = parseFloat(z.width),
                q = parseFloat(z.height)),
                f = e + p,
                h = g + q,
                "svg" !== a.nodeName.toLowerCase() || C || (r = xa(a),
                A = r.computedStyle || {},
                w = (a.getAttribute("viewBox") || "0 0").split(" "),
                x = parseFloat(w[0]),
                y = parseFloat(w[1]),
                s = parseFloat(A.borderLeftWidth) || 0,
                v = parseFloat(A.borderTopWidth) || 0,
                f -= p - (p - s) / r.scaleX - x,
                h -= q - (q - v) / r.scaleY - y,
                e -= s / r.scaleX - x,
                g -= v / r.scaleY - y,
                z && (f += (parseFloat(A.borderRightWidth) + s) / r.scaleX,
                h += (v + parseFloat(A.borderBottomWidth)) / r.scaleY))
            }
            return a === b ? {
                left: e,
                top: g,
                width: f - e,
                height: h - g
            } : (i = Ba(a),
            j = Ba(b, !0),
            k = Da({
                x: e,
                y: g
            }, i, j),
            l = Da({
                x: f,
                y: g
            }, i, j),
            m = Da({
                x: f,
                y: h
            }, i, j),
            n = Da({
                x: e,
                y: h
            }, i, j),
            e = Math.min(k.x, l.x, m.x, n.x),
            g = Math.min(k.y, l.y, m.y, n.y),
            L.x = L.y = 0,
            c && ya(b, L),
            {
                left: e + L.x,
                top: g + L.y,
                width: Math.max(k.x, l.x, m.x, n.x) - e,
                height: Math.max(k.y, l.y, m.y, n.y) - g
            })
        }, Fa = function(a) {
            return a && a.length && a[0] && (a[0].nodeType && a[0].style && !a.nodeType || a[0].length && a[0][0]) ? !0 : !1
        }, Ga = function(a) {
            var b, c, d, e = [], f = a.length;
            for (b = 0; f > b; b++)
                if (c = a[b],
                Fa(c))
                    for (d = c.length,
                    d = 0; d < c.length; d++)
                        e.push(c[d]);
                else
                    c && 0 !== c.length && e.push(c);
            return e
        }, Ha = "ontouchstart"in u && "orientation"in window, Ia = function(a) {
            for (var b = a.split(","), c = (void 0 !== w.onpointerdown ? "pointerdown,pointermove,pointerup,pointercancel" : void 0 !== w.onmspointerdown ? "MSPointerDown,MSPointerMove,MSPointerUp,MSPointerCancel" : a).split(","), d = {}, e = 8; --e > -1; )
                d[b[e]] = c[e],
                d[c[e]] = b[e];
            return d
        }("touchstart,touchmove,touchend,touchcancel"), Ja = function(a, b, c, d) {
            a.addEventListener ? a.addEventListener(Ia[b] || b, c, d) : a.attachEvent && a.attachEvent("on" + b, c)
        }, Ka = function(a, b, c) {
            a.removeEventListener ? a.removeEventListener(Ia[b] || b, c) : a.detachEvent && a.detachEvent("on" + b, c)
        }, La = function(a, b) {
            for (var c = a.length; --c > -1; )
                if (a[c].identifier === b)
                    return !0;
            return !1
        }, Ma = function(a) {
            e = a.touches && I < a.touches.length,
            Ka(a.target, "touchend", Ma)
        }, Na = function(a) {
            e = a.touches && I < a.touches.length,
            Ja(a.target, "touchend", Ma)
        }, Oa = function(a, b, c, d, e, f) {
            var g, h, i, j = {};
            if (b)
                if (1 !== e && b instanceof Array) {
                    if (j.end = g = [],
                    i = b.length,
                    "object" == typeof b[0])
                        for (h = 0; i > h; h++)
                            g[h] = O(b[h], e);
                    else
                        for (h = 0; i > h; h++)
                            g[h] = b[h] * e;
                    c += 1.1,
                    d -= 1.1
                } else
                    "function" == typeof b ? j.end = function(c) {
                        var d, f, g = b.call(a, c);
                        if (1 !== e && "object" == typeof g) {
                            d = {};
                            for (f in g)
                                d[f] = g[f] * e;
                            g = d
                        }
                        return g
                    }
                    : j.end = b;
            return (c || 0 === c) && (j.max = c),
            (d || 0 === d) && (j.min = d),
            f && (j.velocity = 0),
            j
        }, Pa = function(a) {
            var b;
            return a && a.getAttribute && "BODY" !== a.nodeName ? "true" === (b = a.getAttribute("data-clickable")) || "false" !== b && (a.onclick || H.test(a.nodeName + "") || "true" === a.getAttribute("contentEditable")) ? !0 : Pa(a.parentNode) : !1
        }, Qa = function(a, b) {
            for (var c, d = a.length; --d > -1; )
                c = a[d],
                c.ondragstart = c.onselectstart = b ? null : y,
                ca(c, "userSelect", b ? "text" : "none")
        }, Ra = function() {
            var a, b = t.createElement("div"), c = t.createElement("div"), d = c.style, e = t.body || w;
            return d.display = "inline-block",
            d.position = "relative",
            b.style.cssText = c.innerHTML = "width:90px; height:40px; padding:10px; overflow:auto; visibility: hidden",
            b.appendChild(c),
            e.appendChild(b),
            l = c.offsetHeight + 18 > b.scrollHeight,
            d.width = "100%",
            oa || (d.paddingRight = "500px",
            a = b.scrollLeft = b.scrollWidth - b.clientWidth,
            d.left = "-90px",
            a = a !== b.scrollLeft),
            e.removeChild(b),
            a
        }(), Sa = function(a, c) {
            a = aa(a),
            c = c || {};
            var d, e, f, g, h, i, j = t.createElement("div"), k = j.style, m = a.firstChild, n = 0, o = 0, p = a.scrollTop, q = a.scrollLeft, r = a.scrollWidth, s = a.scrollHeight, u = 0, v = 0, w = 0;
            ma && c.force3D !== !1 ? (h = "translate3d(",
            i = "px,0px)") : oa && (h = "translate(",
            i = "px)"),
            this.scrollTop = function(a, b) {
                return arguments.length ? void this.top(-a, b) : -this.top()
            }
            ,
            this.scrollLeft = function(a, b) {
                return arguments.length ? void this.left(-a, b) : -this.left()
            }
            ,
            this.left = function(d, e) {
                if (!arguments.length)
                    return -(a.scrollLeft + o);
                var f = a.scrollLeft - q
                  , g = o;
                return (f > 2 || -2 > f) && !e ? (q = a.scrollLeft,
                b.killTweensOf(this, !0, {
                    left: 1,
                    scrollLeft: 1
                }),
                this.left(-q),
                void (c.onKill && c.onKill())) : (d = -d,
                0 > d ? (o = d - .5 | 0,
                d = 0) : d > v ? (o = d - v | 0,
                d = v) : o = 0,
                (o || g) && (h ? this._suspendTransforms || (k[oa] = h + -o + "px," + -n + i) : k.left = -o + "px",
                Ra && o + u >= 0 && (k.paddingRight = o + u + "px")),
                a.scrollLeft = 0 | d,
                void (q = a.scrollLeft))
            }
            ,
            this.top = function(d, e) {
                if (!arguments.length)
                    return -(a.scrollTop + n);
                var f = a.scrollTop - p
                  , g = n;
                return (f > 2 || -2 > f) && !e ? (p = a.scrollTop,
                b.killTweensOf(this, !0, {
                    top: 1,
                    scrollTop: 1
                }),
                this.top(-p),
                void (c.onKill && c.onKill())) : (d = -d,
                0 > d ? (n = d - .5 | 0,
                d = 0) : d > w ? (n = d - w | 0,
                d = w) : n = 0,
                (n || g) && (h ? this._suspendTransforms || (k[oa] = h + -o + "px," + -n + i) : k.top = -n + "px"),
                a.scrollTop = 0 | d,
                void (p = a.scrollTop))
            }
            ,
            this.maxScrollTop = function() {
                return w
            }
            ,
            this.maxScrollLeft = function() {
                return v
            }
            ,
            this.disable = function() {
                for (m = j.firstChild; m; )
                    g = m.nextSibling,
                    a.appendChild(m),
                    m = g;
                a === j.parentNode && a.removeChild(j)
            }
            ,
            this.enable = function() {
                if (m = a.firstChild,
                m !== j) {
                    for (; m; )
                        g = m.nextSibling,
                        j.appendChild(m),
                        m = g;
                    a.appendChild(j),
                    this.calibrate()
                }
            }
            ,
            this.calibrate = function(b) {
                var c, g, h = a.clientWidth === d;
                p = a.scrollTop,
                q = a.scrollLeft,
                (!h || a.clientHeight !== e || j.offsetHeight !== f || r !== a.scrollWidth || s !== a.scrollHeight || b) && ((n || o) && (c = this.left(),
                g = this.top(),
                this.left(-a.scrollLeft),
                this.top(-a.scrollTop)),
                (!h || b) && (k.display = "block",
                k.width = "auto",
                k.paddingRight = "0px",
                u = Math.max(0, a.scrollWidth - a.clientWidth),
                u && (u += ia(a, "paddingLeft") + (l ? ia(a, "paddingRight") : 0))),
                k.display = "inline-block",
                k.position = "relative",
                k.overflow = "visible",
                k.verticalAlign = "top",
                k.width = "100%",
                k.paddingRight = u + "px",
                l && (k.paddingBottom = ia(a, "paddingBottom", !0)),
                C && (k.zoom = "1"),
                d = a.clientWidth,
                e = a.clientHeight,
                r = a.scrollWidth,
                s = a.scrollHeight,
                v = a.scrollWidth - d,
                w = a.scrollHeight - e,
                f = j.offsetHeight,
                k.display = "block",
                (c || g) && (this.left(c),
                this.top(g)))
            }
            ,
            this.content = j,
            this.element = a,
            this._suspendTransforms = !1,
            this.enable()
        }, Ta = function(d, g) {
            a.call(this, d),
            d = aa(d),
            f || (f = q.com.greensock.plugins.ThrowPropsPlugin),
            this.vars = g = O(g || {}),
            this.target = d,
            this.x = this.y = this.rotation = 0,
            this.dragResistance = parseFloat(g.dragResistance) || 0,
            this.edgeResistance = isNaN(g.edgeResistance) ? 1 : parseFloat(g.edgeResistance) || 0,
            this.lockAxis = g.lockAxis,
            this.autoScroll = g.autoScroll || 0,
            this.lockedAxis = null,
            this.allowEventDefault = !!g.allowEventDefault;
            var h, i, j, k, l, r, s, v, w, y, E, H, P, S, U, V, Z, ba, da, ea, fa, ga, ha, la, ma, na, oa, pa, qa, ra, sa, ua, va, wa, xa = (g.type || (C ? "top,left" : "x,y")).toLowerCase(), ya = -1 !== xa.indexOf("x") || -1 !== xa.indexOf("y"), za = -1 !== xa.indexOf("rotation"), Aa = za ? "rotation" : ya ? "x" : "left", Da = ya ? "y" : "top", Ea = -1 !== xa.indexOf("x") || -1 !== xa.indexOf("left") || "scroll" === xa, Fa = -1 !== xa.indexOf("y") || -1 !== xa.indexOf("top") || "scroll" === xa, Ga = g.minimumMovement || 2, Ma = this, Ra = N(g.trigger || g.handle || d), Ua = {}, Va = 0, Wa = !1, Ya = g.clickableTest || Pa, Za = 0, $a = function(a) {
                return Ma.isPressed && a.which < 2 ? void Ma.endDrag() : (a.preventDefault(),
                a.stopPropagation(),
                !1)
            }, _a = function(a) {
                if (Ma.autoScroll && Ma.isDragging && (Wa || ba)) {
                    var b, c, e, f, g, h, j, k, l = d, m = 15 * Ma.autoScroll;
                    for (Wa = !1,
                    M.scrollTop = null != window.pageYOffset ? window.pageYOffset : null != u.scrollTop ? u.scrollTop : t.body.scrollTop,
                    M.scrollLeft = null != window.pageXOffset ? window.pageXOffset : null != u.scrollLeft ? u.scrollLeft : t.body.scrollLeft,
                    f = Ma.pointerX - M.scrollLeft,
                    g = Ma.pointerY - M.scrollTop; l && !c; )
                        c = Y(l.parentNode),
                        b = c ? M : l.parentNode,
                        e = c ? {
                            bottom: Math.max(u.clientHeight, window.innerHeight || 0),
                            right: Math.max(u.clientWidth, window.innerWidth || 0),
                            left: 0,
                            top: 0
                        } : b.getBoundingClientRect(),
                        h = j = 0,
                        Fa && (k = b._gsMaxScrollY - b.scrollTop,
                        0 > k ? j = k : g > e.bottom - 40 && k ? (Wa = !0,
                        j = Math.min(k, m * (1 - Math.max(0, e.bottom - g) / 40) | 0)) : g < e.top + 40 && b.scrollTop && (Wa = !0,
                        j = -Math.min(b.scrollTop, m * (1 - Math.max(0, g - e.top) / 40) | 0)),
                        j && (b.scrollTop += j)),
                        Ea && (k = b._gsMaxScrollX - b.scrollLeft,
                        0 > k ? h = k : f > e.right - 40 && k ? (Wa = !0,
                        h = Math.min(k, m * (1 - Math.max(0, e.right - f) / 40) | 0)) : f < e.left + 40 && b.scrollLeft && (Wa = !0,
                        h = -Math.min(b.scrollLeft, m * (1 - Math.max(0, f - e.left) / 40) | 0)),
                        h && (b.scrollLeft += h)),
                        c && (h || j) && (window.scrollTo(b.scrollLeft, b.scrollTop),
                        nb(Ma.pointerX + h, Ma.pointerY + j)),
                        l = b
                }
                if (ba) {
                    var n = Ma.x
                      , o = Ma.y
                      , p = 1e-6;
                    p > n && n > -p && (n = 0),
                    p > o && o > -p && (o = 0),
                    za ? (Ma.deltaX = n - qa.data.rotation,
                    qa.data.rotation = Ma.rotation = n,
                    qa.setRatio(1)) : i ? (Fa && (Ma.deltaY = o - i.top(),
                    i.top(o)),
                    Ea && (Ma.deltaX = n - i.left(),
                    i.left(n))) : ya ? (Fa && (Ma.deltaY = o - qa.data.y,
                    qa.data.y = o),
                    Ea && (Ma.deltaX = n - qa.data.x,
                    qa.data.x = n),
                    qa.setRatio(1)) : (Fa && (Ma.deltaY = o - parseFloat(d.style.top || 0),
                    d.style.top = o + "px"),
                    Ea && (Ma.deltaY = n - parseFloat(d.style.left || 0),
                    d.style.left = n + "px")),
                    !v || a || ua || (ua = !0,
                    ja(Ma, "drag", "onDrag"),
                    ua = !1)
                }
                ba = !1
            }, ab = function(a, c) {
                var e, f = Ma.x, g = Ma.y;
                d._gsTransform || !ya && !za || b.set(d, {
                    x: "+=0",
                    overwrite: !1
                }),
                ya ? (Ma.y = d._gsTransform.y,
                Ma.x = d._gsTransform.x) : za ? Ma.x = Ma.rotation = d._gsTransform.rotation : i ? (Ma.y = i.top(),
                Ma.x = i.left()) : (Ma.y = parseInt(d.style.top, 10) || 0,
                Ma.x = parseInt(d.style.left, 10) || 0),
                (ea || fa || ga) && !c && (Ma.isDragging || Ma.isThrowing) && (ga && (L.x = Ma.x,
                L.y = Ma.y,
                e = ga(L),
                e.x !== Ma.x && (Ma.x = e.x,
                ba = !0),
                e.y !== Ma.y && (Ma.y = e.y,
                ba = !0)),
                ea && (e = ea(Ma.x),
                e !== Ma.x && (Ma.x = e,
                za && (Ma.rotation = e),
                ba = !0)),
                fa && (e = fa(Ma.y),
                e !== Ma.y && (Ma.y = e),
                ba = !0)),
                ba && _a(!0),
                a || (Ma.deltaX = Ma.x - f,
                Ma.deltaY = Ma.y - g,
                ja(Ma, "throwupdate", "onThrowUpdate"))
            }, bb = function() {
                var a, b, c, e;
                s = !1,
                i ? (i.calibrate(),
                Ma.minX = y = -i.maxScrollLeft(),
                Ma.minY = H = -i.maxScrollTop(),
                Ma.maxX = w = Ma.maxY = E = 0,
                s = !0) : g.bounds && (a = ka(g.bounds, d.parentNode),
                za ? (Ma.minX = y = a.left,
                Ma.maxX = w = a.left + a.width,
                Ma.minY = H = Ma.maxY = E = 0) : void 0 !== g.bounds.maxX || void 0 !== g.bounds.maxY ? (a = g.bounds,
                Ma.minX = y = a.minX,
                Ma.minY = H = a.minY,
                Ma.maxX = w = a.maxX,
                Ma.maxY = E = a.maxY) : (b = ka(d, d.parentNode),
                Ma.minX = y = ia(d, Aa) + a.left - b.left,
                Ma.minY = H = ia(d, Da) + a.top - b.top,
                Ma.maxX = w = y + (a.width - b.width),
                Ma.maxY = E = H + (a.height - b.height)),
                y > w && (Ma.minX = w,
                Ma.maxX = w = y,
                y = Ma.minX),
                H > E && (Ma.minY = E,
                Ma.maxY = E = H,
                H = Ma.minY),
                za && (Ma.minRotation = y,
                Ma.maxRotation = w),
                s = !0),
                g.liveSnap && (c = g.liveSnap === !0 ? g.snap || {} : g.liveSnap,
                e = c instanceof Array || "function" == typeof c,
                za ? (ea = jb(e ? c : c.rotation, y, w, 1),
                fa = null) : c.points ? ga = kb(e ? c : c.points, y, w, H, E, c.radius, i ? -1 : 1) : (Ea && (ea = jb(e ? c : c.x || c.left || c.scrollLeft, y, w, i ? -1 : 1)),
                Fa && (fa = jb(e ? c : c.y || c.top || c.scrollTop, H, E, i ? -1 : 1))))
            }, cb = function() {
                Ma.isThrowing = !1,
                ja(Ma, "throwcomplete", "onThrowComplete")
            }, db = function() {
                Ma.isThrowing = !1
            }, eb = function(a, b) {
                var c, e, h, j;
                a && f ? (a === !0 && (c = g.snap || g.liveSnap || {},
                e = c instanceof Array || "function" == typeof c,
                a = {
                    resistance: (g.throwResistance || g.resistance || 1e3) / (za ? 10 : 1)
                },
                za ? a.rotation = Oa(Ma, e ? c : c.rotation, w, y, 1, b) : (Ea && (a[Aa] = Oa(Ma, e ? c : c.points || c.x || c.left || c.scrollLeft, w, y, i ? -1 : 1, b || "x" === Ma.lockedAxis)),
                Fa && (a[Da] = Oa(Ma, e ? c : c.points || c.y || c.top || c.scrollTop, E, H, i ? -1 : 1, b || "y" === Ma.lockedAxis)),
                (c.points || c instanceof Array && "object" == typeof c[0]) && (a.linkedProps = Aa + "," + Da,
                a.radius = c.radius))),
                Ma.isThrowing = !0,
                j = isNaN(g.overshootTolerance) ? 1 === g.edgeResistance ? 0 : 1 - Ma.edgeResistance + .2 : g.overshootTolerance,
                Ma.tween = h = f.to(i || d, {
                    throwProps: a,
                    ease: g.ease || q.Power3.easeOut,
                    onComplete: cb,
                    onOverwrite: db,
                    onUpdate: g.fastMode ? ja : ab,
                    onUpdateParams: g.fastMode ? [Ma, "onthrowupdate", "onThrowUpdate"] : c && c.radius ? [!1, !0] : x
                }, isNaN(g.maxDuration) ? 2 : g.maxDuration, isNaN(g.minDuration) ? 0 === j || "object" == typeof a && a.resistance > 1e3 ? 0 : .5 : g.minDuration, j),
                g.fastMode || (i && (i._suspendTransforms = !0),
                h.render(h.duration(), !0, !0),
                ab(!0, !0),
                Ma.endX = Ma.x,
                Ma.endY = Ma.y,
                za && (Ma.endRotation = Ma.x),
                h.play(0),
                ab(!0, !0),
                i && (i._suspendTransforms = !1))) : s && Ma.applyBounds()
            }, fb = function(a) {
                var b, c, e, f, g, h, i, l, m, n = ma || [1, 0, 0, 1, 0, 0];
                ma = Ba(d.parentNode, !0),
                a && Ma.isPressed && n.join(",") !== ma.join(",") && (b = n[0],
                c = n[1],
                e = n[2],
                f = n[3],
                g = n[4],
                h = n[5],
                i = b * f - c * e,
                l = j * (f / i) + k * (-e / i) + (e * h - f * g) / i,
                m = j * (-c / i) + k * (b / i) + -(b * h - c * g) / i,
                k = l * ma[1] + m * ma[3] + ma[5],
                j = l * ma[0] + m * ma[2] + ma[4]),
                ma[1] || ma[2] || 1 != ma[0] || 1 != ma[3] || 0 != ma[4] || 0 != ma[5] || (ma = null)
            }, gb = function() {
                var a = 1 - Ma.edgeResistance;
                fb(!1),
                ma && (j = Ma.pointerX * ma[0] + Ma.pointerY * ma[2] + ma[4],
                k = Ma.pointerX * ma[1] + Ma.pointerY * ma[3] + ma[5]),
                ba && (nb(Ma.pointerX, Ma.pointerY),
                _a(!0)),
                i ? (bb(),
                r = i.top(),
                l = i.left()) : (hb() ? (ab(!0, !0),
                bb()) : Ma.applyBounds(),
                za ? (Z = Ma.rotationOrigin = Ca(d, {
                    x: 0,
                    y: 0
                }),
                ab(!0, !0),
                l = Ma.x,
                r = Ma.y = Math.atan2(Z.y - Ma.pointerY, Ma.pointerX - Z.x) * z) : (oa = d.parentNode ? d.parentNode.scrollTop || 0 : 0,
                pa = d.parentNode ? d.parentNode.scrollLeft || 0 : 0,
                r = ia(d, Da),
                l = ia(d, Aa))),
                s && a && (l > w ? l = w + (l - w) / a : y > l && (l = y - (y - l) / a),
                za || (r > E ? r = E + (r - E) / a : H > r && (r = H - (H - r) / a))),
                Ma.startX = l,
                Ma.startY = r
            }, hb = function() {
                return Ma.tween && Ma.tween.isActive()
            }, ib = function() {
                !D.parentNode || hb() || Ma.isDragging || D.parentNode.removeChild(D)
            }, jb = function(a, b, c, d) {
                return "function" == typeof a ? function(e) {
                    var f = Ma.isPressed ? 1 - Ma.edgeResistance : 1;
                    return a.call(Ma, e > c ? c + (e - c) * f : b > e ? b + (e - b) * f : e) * d
                }
                : a instanceof Array ? function(d) {
                    for (var e, f, g = a.length, h = 0, i = A; --g > -1; )
                        e = a[g],
                        f = e - d,
                        0 > f && (f = -f),
                        i > f && e >= b && c >= e && (h = g,
                        i = f);
                    return a[h]
                }
                : isNaN(a) ? function(a) {
                    return a
                }
                : function() {
                    return a * d
                }
            }, kb = function(a, b, c, d, e, f, g) {
                return f = f && A > f ? f * f : A,
                "function" == typeof a ? function(h) {
                    var i, j, k, l = Ma.isPressed ? 1 - Ma.edgeResistance : 1, m = h.x, n = h.y;
                    return h.x = m = m > c ? c + (m - c) * l : b > m ? b + (m - b) * l : m,
                    h.y = n = n > e ? e + (n - e) * l : d > n ? d + (n - d) * l : n,
                    i = a.call(Ma, h),
                    i !== h && (h.x = i.x,
                    h.y = i.y),
                    1 !== g && (h.x *= g,
                    h.y *= g),
                    A > f && (j = h.x - m,
                    k = h.y - n,
                    j * j + k * k > f && (h.x = m,
                    h.y = n)),
                    h
                }
                : a instanceof Array ? function(b) {
                    for (var c, d, e, g, h = a.length, i = 0, j = A; --h > -1; )
                        e = a[h],
                        c = e.x - b.x,
                        d = e.y - b.y,
                        g = c * c + d * d,
                        j > g && (i = h,
                        j = g);
                    return f >= j ? a[i] : b
                }
                : function(a) {
                    return a
                }
            }, lb = function(a) {
                var c;
                if (!(!h || Ma.isPressed || !a || ("mousedown" === a.type || "pointerdown" === a.type) && B() - Za < 30 && Ia[Ma.pointerEvent.type])) {
                    if (na = hb(),
                    Ma.pointerEvent = a,
                    Ia[a.type] ? (la = -1 !== a.type.indexOf("touch") ? a.currentTarget || a.target : t,
                    Ja(la, "touchend", ob),
                    Ja(la, "touchmove", mb),
                    Ja(la, "touchcancel", ob),
                    Ja(t, "touchstart", Na)) : (la = null,
                    Ja(t, "mousemove", mb)),
                    sa = null,
                    Ja(t, "mouseup", ob),
                    a && a.target && Ja(a.target, "mouseup", ob),
                    ha = Ya.call(Ma, a.target) && !g.dragClickables)
                        return Ja(a.target, "change", ob),
                        ja(Ma, "press", "onPress"),
                        void Qa(Ra, !0);
                    if (ra = la && Ea !== Fa && Ma.vars.allowNativeTouchScrolling !== !1 ? Ea ? "y" : "x" : !1,
                    C ? a = _(a, !0) : ra || Ma.allowEventDefault || (a.preventDefault(),
                    a.preventManipulation && a.preventManipulation()),
                    a.changedTouches ? (a = U = a.changedTouches[0],
                    V = a.identifier) : a.pointerId ? V = a.pointerId : U = V = null,
                    I++,
                    Q(_a),
                    k = Ma.pointerY = a.pageY,
                    j = Ma.pointerX = a.pageX,
                    (ra || Ma.autoScroll) && $(d.parentNode),
                    d.parentNode && (i || Ma.autoScroll && !za && d.parentNode._gsMaxScrollX && !D.parentNode) && !d.getBBox && (D.style.width = d.parentNode.scrollWidth + "px",
                    d.parentNode.appendChild(D)),
                    gb(),
                    Ma.tween && Ma.tween.kill(),
                    Ma.isThrowing = !1,
                    b.killTweensOf(i || d, !0, Ua),
                    i && b.killTweensOf(d, !0, {
                        scrollTo: 1
                    }),
                    Ma.tween = Ma.lockedAxis = null,
                    (g.zIndexBoost || !za && !i && g.zIndexBoost !== !1) && (d.style.zIndex = Ta.zIndex++),
                    Ma.isPressed = !0,
                    v = !(!g.onDrag && !Ma._listeners.drag),
                    !za)
                        for (c = Ra.length; --c > -1; )
                            ca(Ra[c], "cursor", g.cursor || "move");
                    ja(Ma, "press", "onPress")
                }
            }, mb = function(a) {
                var b, c, d, f, g, i, l = a;
                if (h && !e && Ma.isPressed && a) {
                    if (Ma.pointerEvent = a,
                    b = a.changedTouches) {
                        if (a = b[0],
                        a !== U && a.identifier !== V) {
                            for (f = b.length; --f > -1 && (a = b[f]).identifier !== V; )
                                ;
                            if (0 > f)
                                return
                        }
                    } else if (a.pointerId && V && a.pointerId !== V)
                        return;
                    if (C)
                        a = _(a, !0);
                    else {
                        if (la && ra && !sa && (c = a.pageX,
                        d = a.pageY,
                        ma && (f = c * ma[0] + d * ma[2] + ma[4],
                        d = c * ma[1] + d * ma[3] + ma[5],
                        c = f),
                        g = Math.abs(c - j),
                        i = Math.abs(d - k),
                        (g !== i && (g > Ga || i > Ga) || J && ra === sa) && (sa = g > i && Ea ? "x" : "y",
                        Ma.vars.lockAxisOnTouchScroll !== !1 && (Ma.lockedAxis = "x" === sa ? "y" : "x",
                        "function" == typeof Ma.vars.onLockAxis && Ma.vars.onLockAxis.call(Ma, l)),
                        J && ra === sa)))
                            return void ob(l);
                        Ma.allowEventDefault || ra && (!sa || ra === sa) || l.cancelable === !1 || (l.preventDefault(),
                        l.preventManipulation && l.preventManipulation())
                    }
                    Ma.autoScroll && (Wa = !0),
                    nb(a.pageX, a.pageY)
                }
            }, nb = function(a, b) {
                var c, d, e, f, g, h, i = 1 - Ma.dragResistance, m = 1 - Ma.edgeResistance;
                Ma.pointerX = a,
                Ma.pointerY = b,
                za ? (f = Math.atan2(Z.y - b, a - Z.x) * z,
                g = Ma.y - f,
                Ma.y = f,
                g > 180 ? r -= 360 : -180 > g && (r += 360),
                e = l + (r - f) * i) : (ma && (h = a * ma[0] + b * ma[2] + ma[4],
                b = a * ma[1] + b * ma[3] + ma[5],
                a = h),
                d = b - k,
                c = a - j,
                Ga > d && d > -Ga && (d = 0),
                Ga > c && c > -Ga && (c = 0),
                (Ma.lockAxis || Ma.lockedAxis) && (c || d) && (h = Ma.lockedAxis,
                h || (Ma.lockedAxis = h = Ea && Math.abs(c) > Math.abs(d) ? "y" : Fa ? "x" : null,
                h && "function" == typeof Ma.vars.onLockAxis && Ma.vars.onLockAxis.call(Ma, Ma.pointerEvent)),
                "y" === h ? d = 0 : "x" === h && (c = 0)),
                e = l + c * i,
                f = r + d * i),
                (ea || fa || ga) && (Ma.x !== e || Ma.y !== f && !za) ? (ga && (L.x = e,
                L.y = f,
                h = ga(L),
                e = h.x,
                f = h.y),
                ea && (e = ea(e)),
                fa && (f = fa(f))) : s && (e > w ? e = w + (e - w) * m : y > e && (e = y + (e - y) * m),
                za || (f > E ? f = E + (f - E) * m : H > f && (f = H + (f - H) * m))),
                za || ma || (e = Math.round(e),
                f = Math.round(f)),
                (Ma.x !== e || Ma.y !== f && !za) && (za ? (Ma.endRotation = Ma.x = Ma.endX = e,
                ba = !0) : (Fa && (Ma.y = Ma.endY = f,
                ba = !0),
                Ea && (Ma.x = Ma.endX = e,
                ba = !0)),
                !Ma.isDragging && Ma.isPressed && (Ma.isDragging = !0,
                ja(Ma, "dragstart", "onDragStart")))
            }, ob = function(a, c) {
                if (h && Ma.isPressed && (!a || null == V || c || !(a.pointerId && a.pointerId !== V || a.changedTouches && !La(a.changedTouches, V)))) {
                    Ma.isPressed = !1;
                    var e, f, i, j, k, l = a, m = Ma.isDragging, n = b.delayedCall(.001, ib);
                    if (la ? (Ka(la, "touchend", ob),
                    Ka(la, "touchmove", mb),
                    Ka(la, "touchcancel", ob),
                    Ka(t, "touchstart", Na)) : Ka(t, "mousemove", mb),
                    Ka(t, "mouseup", ob),
                    a && a.target && Ka(a.target, "mouseup", ob),
                    ba = !1,
                    ha)
                        return a && Ka(a.target, "change", ob),
                        Qa(Ra, !1),
                        ja(Ma, "release", "onRelease"),
                        ja(Ma, "click", "onClick"),
                        void (ha = !1);
                    if (R(_a),
                    !za)
                        for (f = Ra.length; --f > -1; )
                            ca(Ra[f], "cursor", g.cursor || "move");
                    if (m && (Va = K = B(),
                    Ma.isDragging = !1),
                    I--,
                    a) {
                        if (C && (a = _(a, !1)),
                        e = a.changedTouches,
                        e && (a = e[0],
                        a !== U && a.identifier !== V)) {
                            for (f = e.length; --f > -1 && (a = e[f]).identifier !== V; )
                                ;
                            if (0 > f)
                                return
                        }
                        Ma.pointerEvent = l,
                        Ma.pointerX = a.pageX,
                        Ma.pointerY = a.pageY
                    }
                    return l && !m ? (na && (g.snap || g.bounds) && eb(g.throwProps),
                    ja(Ma, "release", "onRelease"),
                    J && "touchmove" === l.type || (ja(Ma, "click", "onClick"),
                    j = l.target || l.srcElement || d,
                    Za = B(),
                    k = function() {
                        Za !== va && Ma.enabled() && !Ma.isPressed && (j.click ? j.click() : t.createEvent && (i = t.createEvent("MouseEvents"),
                        i.initMouseEvent("click", !0, !0, window, 1, Ma.pointerEvent.screenX, Ma.pointerEvent.screenY, Ma.pointerX, Ma.pointerY, !1, !1, !1, !1, 0, null),
                        j.dispatchEvent(i)))
                    }
                    ,
                    J || l.defaultPrevented || b.delayedCall(1e-5, k))) : (eb(g.throwProps),
                    C || Ma.allowEventDefault || !l || !g.dragClickables && Ya.call(Ma, l.target) || !m || ra && (!sa || ra !== sa) || l.cancelable === !1 || (l.preventDefault(),
                    l.preventManipulation && l.preventManipulation()),
                    ja(Ma, "release", "onRelease")),
                    hb() && n.duration(Ma.tween.duration()),
                    m && ja(Ma, "dragend", "onDragEnd"),
                    !0
                }
            }, pb = function(a) {
                if (a && Ma.isDragging && !i) {
                    var b = a.target || a.srcElement || d.parentNode
                      , c = b.scrollLeft - b._gsScrollX
                      , e = b.scrollTop - b._gsScrollY;
                    (c || e) && (ma ? (j -= c * ma[0] + e * ma[2],
                    k -= e * ma[3] + c * ma[1]) : (j -= c,
                    k -= e),
                    b._gsScrollX += c,
                    b._gsScrollY += e,
                    nb(Ma.pointerX, Ma.pointerY))
                }
            }, qb = function(a) {
                var b = B()
                  , c = 40 > b - Za
                  , d = 40 > b - Va
                  , e = c && va === Za
                  , f = !!a.preventDefault
                  , g = Ma.pointerEvent && Ma.pointerEvent.defaultPrevented
                  , h = c && wa === Za
                  , i = a.isTrusted || null == a.isTrusted && c && e;
                return f && (e || d && Ma.vars.suppressClickOnDrag !== !1) && a.stopImmediatePropagation(),
                !c || Ma.pointerEvent && Ma.pointerEvent.defaultPrevented || e && i === h ? void ((Ma.isPressed || d || c) && (f ? i && a.detail && c && !g || (a.preventDefault(),
                a.preventManipulation && a.preventManipulation()) : a.returnValue = !1)) : (i && e && (wa = Za),
                void (va = Za))
            };
            da = Ta.get(this.target),
            da && da.kill(),
            this.startDrag = function(a) {
                lb(a),
                Ma.isDragging || (Ma.isDragging = !0,
                ja(Ma, "dragstart", "onDragStart"))
            }
            ,
            this.drag = mb,
            this.endDrag = function(a) {
                ob(a, !0)
            }
            ,
            this.timeSinceDrag = function() {
                return Ma.isDragging ? 0 : (B() - Va) / 1e3
            }
            ,
            this.hitTest = function(a, b) {
                return Ta.hitTest(Ma.target, a, b)
            }
            ,
            this.getDirection = function(a, b) {
                var c, d, e, g, h, i, j = "velocity" === a && f ? a : "object" != typeof a || za ? "start" : "element";
                return "element" === j && (h = Xa(Ma.target),
                i = Xa(a)),
                c = "start" === j ? Ma.x - l : "velocity" === j ? f.getVelocity(this.target, Aa) : h.left + h.width / 2 - (i.left + i.width / 2),
                za ? 0 > c ? "counter-clockwise" : "clockwise" : (b = b || 2,
                d = "start" === j ? Ma.y - r : "velocity" === j ? f.getVelocity(this.target, Da) : h.top + h.height / 2 - (i.top + i.height / 2),
                e = Math.abs(c / d),
                g = 1 / b > e ? "" : 0 > c ? "left" : "right",
                b > e && ("" !== g && (g += "-"),
                g += 0 > d ? "up" : "down"),
                g)
            }
            ,
            this.applyBounds = function(a) {
                var b, c, e, f, h, i;
                if (a && g.bounds !== a)
                    return g.bounds = a,
                    Ma.update(!0);
                if (ab(!0),
                bb(),
                s) {
                    if (b = Ma.x,
                    c = Ma.y,
                    b > w ? b = w : y > b && (b = y),
                    c > E ? c = E : H > c && (c = H),
                    (Ma.x !== b || Ma.y !== c) && (e = !0,
                    Ma.x = Ma.endX = b,
                    za ? Ma.endRotation = b : Ma.y = Ma.endY = c,
                    ba = !0,
                    _a(!0),
                    Ma.autoScroll && !Ma.isDragging))
                        for ($(d.parentNode),
                        f = d,
                        M.scrollTop = null != window.pageYOffset ? window.pageYOffset : null != u.scrollTop ? u.scrollTop : t.body.scrollTop,
                        M.scrollLeft = null != window.pageXOffset ? window.pageXOffset : null != u.scrollLeft ? u.scrollLeft : t.body.scrollLeft; f && !i; )
                            i = Y(f.parentNode),
                            h = i ? M : f.parentNode,
                            Fa && h.scrollTop > h._gsMaxScrollY && (h.scrollTop = h._gsMaxScrollY),
                            Ea && h.scrollLeft > h._gsMaxScrollX && (h.scrollLeft = h._gsMaxScrollX),
                            f = h;
                    Ma.isThrowing && (e || Ma.endX > w || Ma.endX < y || Ma.endY > E || Ma.endY < H) && eb(g.throwProps, e)
                }
                return Ma
            }
            ,
            this.update = function(a, b, c) {
                var e = Ma.x
                  , f = Ma.y;
                return fb(!b),
                a ? Ma.applyBounds() : (ba && c && _a(!0),
                ab(!0)),
                b && (nb(Ma.pointerX, Ma.pointerY),
                ba && _a(!0)),
                Ma.isPressed && !b && (Ea && Math.abs(e - Ma.x) > .01 || Fa && Math.abs(f - Ma.y) > .01 && !za) && gb(),
                Ma.autoScroll && ($(d.parentNode),
                Wa = Ma.isDragging,
                _a(!0)),
                Ma.autoScroll && (X(d, pb),
                W(d, pb)),
                Ma
            }
            ,
            this.enable = function(a) {
                var e, j, k;
                if ("soft" !== a) {
                    for (j = Ra.length; --j > -1; )
                        k = Ra[j],
                        Ja(k, "mousedown", lb),
                        Ja(k, "touchstart", lb),
                        Ja(k, "click", qb, !0),
                        za || ca(k, "cursor", g.cursor || "move"),
                        ca(k, "touchCallout", "none"),
                        ca(k, "touchAction", Ea === Fa ? "none" : Ea ? "pan-y" : "pan-x"),
                        ta(k) && ca(k.ownerSVGElement || k, "touchAction", Ea === Fa ? "none" : Ea ? "pan-y" : "pan-x"),
                        this.vars.allowContextMenu || Ja(k, "contextmenu", $a);
                    Qa(Ra, !1)
                }
                return W(d, pb),
                h = !0,
                f && "soft" !== a && f.track(i || d, ya ? "x,y" : za ? "rotation" : "top,left"),
                i && i.enable(),
                d._gsDragID = e = "d" + G++,
                F[e] = this,
                i && (i.element._gsDragID = e),
                b.set(d, {
                    x: "+=0",
                    overwrite: !1
                }),
                qa = {
                    t: d,
                    data: C ? S : d._gsTransform,
                    tween: {},
                    setRatio: C ? function() {
                        b.set(d, P)
                    }
                    : c._internals.setTransformRatio || c._internals.set3DTransformRatio
                },
                gb(),
                Ma.update(!0),
                Ma
            }
            ,
            this.disable = function(a) {
                var b, c, e = Ma.isDragging;
                if (!za)
                    for (b = Ra.length; --b > -1; )
                        ca(Ra[b], "cursor", null);
                if ("soft" !== a) {
                    for (b = Ra.length; --b > -1; )
                        c = Ra[b],
                        ca(c, "touchCallout", null),
                        ca(c, "touchAction", null),
                        Ka(c, "mousedown", lb),
                        Ka(c, "touchstart", lb),
                        Ka(c, "click", qb),
                        Ka(c, "contextmenu", $a);
                    Qa(Ra, !0),
                    la && (Ka(la, "touchcancel", ob),
                    Ka(la, "touchend", ob),
                    Ka(la, "touchmove", mb)),
                    Ka(t, "mouseup", ob),
                    Ka(t, "mousemove", mb)
                }
                return X(d, pb),
                h = !1,
                f && "soft" !== a && f.untrack(i || d, ya ? "x,y" : za ? "rotation" : "top,left"),
                i && i.disable(),
                R(_a),
                Ma.isDragging = Ma.isPressed = ha = !1,
                e && ja(Ma, "dragend", "onDragEnd"),
                Ma
            }
            ,
            this.enabled = function(a, b) {
                return arguments.length ? a ? Ma.enable(b) : Ma.disable(b) : h
            }
            ,
            this.kill = function() {
                return Ma.isThrowing = !1,
                b.killTweensOf(i || d, !0, Ua),
                Ma.disable(),
                delete F[d._gsDragID],
                Ma
            }
            ,
            -1 !== xa.indexOf("scroll") && (i = this.scrollProxy = new Sa(d,T({
                onKill: function() {
                    Ma.isPressed && ob(null)
                }
            }, g)),
            d.style.overflowY = Fa && !Ha ? "auto" : "hidden",
            d.style.overflowX = Ea && !Ha ? "auto" : "hidden",
            d = i.content),
            g.force3D !== !1 && b.set(d, {
                force3D: !0
            }),
            za ? Ua.rotation = 1 : (Ea && (Ua[Aa] = 1),
            Fa && (Ua[Da] = 1)),
            za ? (P = p,
            S = P.css,
            P.overwrite = !1) : ya && (P = Ea && Fa ? m : Ea ? n : o,
            S = P.css,
            P.overwrite = !1),
            this.enable()
        }, Ua = Ta.prototype = new a;
        Ua.constructor = Ta,
        Ua.pointerX = Ua.pointerY = Ua.startX = Ua.startY = Ua.deltaX = Ua.deltaY = 0,
        Ua.isDragging = Ua.isPressed = !1,
        Ta.version = "0.15.1",
        Ta.zIndex = 1e3,
        Ja(t, "touchcancel", function() {}),
        Ja(t, "contextmenu", function(a) {
            var b;
            for (b in F)
                F[b].isPressed && F[b].endDrag()
        }),
        Ta.create = function(a, c) {
            "string" == typeof a && (a = b.selector(a));
            for (var d = a && 0 !== a.length ? Fa(a) ? Ga(a) : [a] : [], e = d.length; --e > -1; )
                d[e] = new Ta(d[e],c);
            return d
        }
        ,
        Ta.get = function(a) {
            return F[(aa(a) || {})._gsDragID]
        }
        ,
        Ta.timeSinceDrag = function() {
            return (B() - K) / 1e3
        }
        ;
        var Va = {}
          , Wa = function(a) {
            var b, c, d = 0, e = 0;
            for (a = aa(a),
            b = a.offsetWidth,
            c = a.offsetHeight; a; )
                d += a.offsetTop,
                e += a.offsetLeft,
                a = a.offsetParent;
            return {
                top: d,
                left: e,
                width: b,
                height: c
            }
        }
          , Xa = function(a, b) {
            if (a === window)
                return Va.left = Va.top = 0,
                Va.width = Va.right = u.clientWidth || a.innerWidth || t.body.clientWidth || 0,
                Va.height = Va.bottom = (a.innerHeight || 0) - 20 < u.clientHeight ? u.clientHeight : a.innerHeight || t.body.clientHeight || 0,
                Va;
            var c = a.pageX !== b ? {
                left: a.pageX - V(),
                top: a.pageY - U(),
                right: a.pageX - V() + 1,
                bottom: a.pageY - U() + 1
            } : a.nodeType || a.left === b || a.top === b ? C ? Wa(a) : aa(a).getBoundingClientRect() : a;
            return c.right === b && c.width !== b ? (c.right = c.left + c.width,
            c.bottom = c.top + c.height) : c.width === b && (c = {
                width: c.right - c.left,
                height: c.bottom - c.top,
                right: c.right,
                left: c.left,
                bottom: c.bottom,
                top: c.top
            }),
            c
        };
        return Ta.hitTest = function(a, b, c) {
            if (a === b)
                return !1;
            var d, e, f, g = Xa(a), h = Xa(b), i = h.left > g.right || h.right < g.left || h.top > g.bottom || h.bottom < g.top;
            return i || !c ? !i : (f = -1 !== (c + "").indexOf("%"),
            c = parseFloat(c) || 0,
            d = {
                left: Math.max(g.left, h.left),
                top: Math.max(g.top, h.top)
            },
            d.width = Math.min(g.right, h.right) - d.left,
            d.height = Math.min(g.bottom, h.bottom) - d.top,
            d.width < 0 || d.height < 0 ? !1 : f ? (c *= .01,
            e = d.width * d.height,
            e >= g.width * g.height * c || e >= h.width * h.height * c) : d.width > c && d.height > c)
        }
        ,
        D.style.cssText = "visibility:hidden;height:1px;top:-1px;pointer-events:none;position:relative;clear:both;",
        Ta
    }, !0)
}),
_gsScope._gsDefine && _gsScope._gsQueue.pop()(),
function(a) {
    "use strict";
    var b = function() {
        return (_gsScope.GreenSockGlobals || _gsScope)[a]
    };
    "undefined" != typeof module && module.exports ? (require("../TweenLite.min.js"),
    require("../plugins/CSSPlugin.min.js"),
    module.exports = b()) : "function" == typeof define && define.amd && define(["TweenLite", "CSSPlugin"], b)
}("Draggable");

var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function() {
    "use strict";
    _gsScope._gsDefine("plugins.ThrowPropsPlugin", ["plugins.TweenPlugin", "TweenLite", "easing.Ease", "utils.VelocityTracker"], function(a, b, c, d) {
        var e, f, g, h, i = function(b, c) {
            a.call(this, "throwProps"),
            this._overwriteProps.length = 0
        }, j = 999999999999999, k = 1e-10, l = _gsScope._gsDefine.globals, m = !1, n = {
            x: 1,
            y: 1,
            z: 2,
            scale: 1,
            scaleX: 1,
            scaleY: 1,
            rotation: 1,
            rotationZ: 1,
            rotationX: 2,
            rotationY: 2,
            skewX: 1,
            skewY: 1,
            xPercent: 1,
            yPercent: 1
        }, o = function(a, b, c, d) {
            for (var e, f, g = b.length, h = 0, i = j; --g > -1; )
                e = b[g],
                f = e - a,
                0 > f && (f = -f),
                i > f && e >= d && c >= e && (h = g,
                i = f);
            return b[h]
        }, p = function(a, b, c, d) {
            if ("auto" === a.end)
                return a;
            c = isNaN(c) ? j : c,
            d = isNaN(d) ? -j : d;
            var e = "function" == typeof a.end ? a.end(b) : a.end instanceof Array ? o(b, a.end, c, d) : Number(a.end);
            return e > c ? e = c : d > e && (e = d),
            {
                max: e,
                min: e,
                unitFactor: a.unitFactor
            }
        }, q = function(a, b, c) {
            for (var d in b)
                void 0 === a[d] && d !== c && (a[d] = b[d]);
            return a
        }, r = i.calculateChange = function(a, d, e, f) {
            null == f && (f = .05);
            var g = d instanceof c ? d : d ? new c(d) : b.defaultEase;
            return e * f * a / g.getRatio(f)
        }
        , s = i.calculateDuration = function(a, d, e, f, g) {
            g = g || .05;
            var h = f instanceof c ? f : f ? new c(f) : b.defaultEase;
            return Math.abs((d - a) * h.getRatio(g) / e / g)
        }
        , t = i.calculateTweenDuration = function(a, e, f, g, h, j) {
            if ("string" == typeof a && (a = b.selector(a)),
            !a)
                return 0;
            null == f && (f = 10),
            null == g && (g = .2),
            null == h && (h = 1),
            a.length && (a = a[0] || a);
            var l, n, o, t, u, v, w, x, y, z, A = 0, B = 9999999999, C = e.throwProps || e, D = e.ease instanceof c ? e.ease : e.ease ? new c(e.ease) : b.defaultEase, E = isNaN(C.checkpoint) ? .05 : Number(C.checkpoint), F = isNaN(C.resistance) ? i.defaultResistance : Number(C.resistance);
            for (l in C)
                "resistance" !== l && "checkpoint" !== l && "preventOvershoot" !== l && (n = C[l],
                "object" != typeof n && (y = y || d.getByTarget(a),
                y && y.isTrackingProp(l) ? n = "number" == typeof n ? {
                    velocity: n
                } : {
                    velocity: y.getVelocity(l)
                } : (t = Number(n) || 0,
                o = t * F > 0 ? t / F : t / -F)),
                "object" == typeof n && (void 0 !== n.velocity && "number" == typeof n.velocity ? t = Number(n.velocity) || 0 : (y = y || d.getByTarget(a),
                t = y && y.isTrackingProp(l) ? y.getVelocity(l) : 0),
                u = isNaN(n.resistance) ? F : Number(n.resistance),
                o = t * u > 0 ? t / u : t / -u,
                v = "function" == typeof a[l] ? a[l.indexOf("set") || "function" != typeof a["get" + l.substr(3)] ? l : "get" + l.substr(3)]() : a[l] || 0,
                w = v + r(t, D, o, E),
                void 0 !== n.end && (n = p(n, w, n.max, n.min),
                (j || m) && (C[l] = q(n, C[l], "end"))),
                void 0 !== n.max && w > Number(n.max) + k ? (z = n.unitFactor || i.defaultUnitFactors[l] || 1,
                x = v > n.max && n.min !== n.max || t * z > -15 && 45 > t * z ? g + .1 * (f - g) : s(v, n.max, t, D, E),
                B > x + h && (B = x + h)) : void 0 !== n.min && w < Number(n.min) - k && (z = n.unitFactor || i.defaultUnitFactors[l] || 1,
                x = v < n.min && n.min !== n.max || t * z > -45 && 15 > t * z ? g + .1 * (f - g) : s(v, n.min, t, D, E),
                B > x + h && (B = x + h)),
                x > A && (A = x)),
                o > A && (A = o));
            return A > B && (A = B),
            A > f ? f : g > A ? g : A
        }
        , u = i.prototype = new a("throwProps");
        return u.constructor = i,
        i.version = "0.10.0",
        i.API = 2,
        i._autoCSS = !0,
        i.defaultResistance = 100,
        i.defaultUnitFactors = {
            time: 1e3,
            totalTime: 1e3
        },
        i.track = function(a, b, c) {
            return d.track(a, b, c)
        }
        ,
        i.untrack = function(a, b) {
            d.untrack(a, b)
        }
        ,
        i.isTracking = function(a, b) {
            return d.isTracking(a, b)
        }
        ,
        i.getVelocity = function(a, b) {
            var c = d.getByTarget(a);
            return c ? c.getVelocity(b) : NaN
        }
        ,
        i._cssRegister = function() {
            var a = l.com.greensock.plugins.CSSPlugin;
            if (a) {
                var b = a._internals
                  , c = b._parseToProxy
                  , g = b._setPluginRatio
                  , h = b.CSSPropTween;
                b._registerComplexSpecialProp("throwProps", {
                    parser: function(a, b, j, k, l, m) {
                        m = new i;
                        var o, p, q, r, s, t = {}, u = {}, v = {}, w = {}, x = {}, y = {};
                        f = {};
                        for (q in b)
                            "resistance" !== q && "preventOvershoot" !== q && (p = b[q],
                            "object" == typeof p ? (void 0 !== p.velocity && "number" == typeof p.velocity ? t[q] = Number(p.velocity) || 0 : (s = s || d.getByTarget(a),
                            t[q] = s && s.isTrackingProp(q) ? s.getVelocity(q) : 0),
                            void 0 !== p.end && (w[q] = p.end),
                            void 0 !== p.min && (u[q] = p.min),
                            void 0 !== p.max && (v[q] = p.max),
                            p.preventOvershoot && (y[q] = !0),
                            void 0 !== p.resistance && (o = !0,
                            x[q] = p.resistance)) : "number" == typeof p ? t[q] = p : (s = s || d.getByTarget(a),
                            s && s.isTrackingProp(q) ? t[q] = s.getVelocity(q) : t[q] = p || 0),
                            n[q] && k._enableTransforms(2 === n[q]));
                        r = c(a, t, k, l, m),
                        e = r.proxy,
                        t = r.end;
                        for (q in e)
                            f[q] = {
                                velocity: t[q],
                                min: u[q],
                                max: v[q],
                                end: w[q],
                                resistance: x[q],
                                preventOvershoot: y[q]
                            };
                        return null != b.resistance && (f.resistance = b.resistance),
                        b.preventOvershoot && (f.preventOvershoot = !0),
                        l = new h(a,"throwProps",0,0,r.pt,2),
                        k._overwriteProps.pop(),
                        l.plugin = m,
                        l.setRatio = g,
                        l.data = r,
                        m._onInitTween(e, f, k._tween),
                        l
                    }
                })
            }
        }
        ,
        i.to = function(a, c, d, i, j) {
            c.throwProps || (c = {
                throwProps: c
            }),
            0 === j && (c.throwProps.preventOvershoot = !0),
            m = !0;
            var k = new b(a,i || 1,c);
            return k.render(0, !0, !0),
            k.vars.css ? (k.duration(t(e, {
                throwProps: f,
                ease: c.ease
            }, d, i, j)),
            k._delay && !k.vars.immediateRender ? k.invalidate() : g._onInitTween(e, h, k),
            m = !1,
            k) : (k.kill(),
            k = new b(a,t(a, c, d, i, j),c),
            m = !1,
            k)
        }
        ,
        u._onInitTween = function(a, b, c, e) {
            this.target = a,
            this._props = [],
            g = this,
            h = b;
            var f, i, j, k, l, n, o, s, t, u = c._ease, v = isNaN(b.checkpoint) ? .05 : Number(b.checkpoint), w = c._duration, x = b.preventOvershoot, y = 0;
            for (f in b)
                if ("resistance" !== f && "checkpoint" !== f && "preventOvershoot" !== f) {
                    if (i = b[f],
                    "function" == typeof i && (i = i(e, a)),
                    "number" == typeof i)
                        l = Number(i) || 0;
                    else if ("object" != typeof i || isNaN(i.velocity)) {
                        if (t = t || d.getByTarget(a),
                        !t || !t.isTrackingProp(f))
                            throw "ERROR: No velocity was defined in the throwProps tween of " + a + " property: " + f;
                        l = t.getVelocity(f)
                    } else
                        l = Number(i.velocity);
                    n = r(l, u, w, v),
                    s = 0,
                    k = "function" == typeof a[f],
                    j = k ? a[f.indexOf("set") || "function" != typeof a["get" + f.substr(3)] ? f : "get" + f.substr(3)]() : a[f],
                    "object" == typeof i && (o = j + n,
                    void 0 !== i.end && (i = p(i, o, i.max, i.min),
                    m && (b[f] = q(i, b[f], "end"))),
                    void 0 !== i.max && Number(i.max) < o ? x || i.preventOvershoot ? n = i.max - j : s = i.max - j - n : void 0 !== i.min && Number(i.min) > o && (x || i.preventOvershoot ? n = i.min - j : s = i.min - j - n)),
                    this._overwriteProps[y] = f,
                    this._props[y++] = {
                        p: f,
                        s: j,
                        c1: n,
                        c2: s,
                        f: k,
                        r: !1
                    }
                }
            return !0
        }
        ,
        u._kill = function(b) {
            for (var c = this._props.length; --c > -1; )
                null != b[this._props[c].p] && this._props.splice(c, 1);
            return a.prototype._kill.call(this, b)
        }
        ,
        u._mod = function(a) {
            for (var b, c = this._props, d = c.length; --d > -1; )
                b = a[c[d].p] || a.throwProps,
                "function" == typeof b && (c[d].m = b)
        }
        ,
        u.setRatio = function(a) {
            for (var b, c, d = this._props.length; --d > -1; )
                b = this._props[d],
                c = b.s + b.c1 * a + b.c2 * a * a,
                b.m ? c = b.m(c, this.target) : 1 === a && (c = (1e4 * c + (0 > c ? -.5 : .5) | 0) / 1e4),
                b.f ? this.target[b.p](c) : this.target[b.p] = c
        }
        ,
        a.activate([i]),
        i
    }, !0),
    _gsScope._gsDefine("utils.VelocityTracker", ["TweenLite"], function(a) {
        var b, c, d, e, f = /([A-Z])/g, g = {}, h = {
            x: 1,
            y: 1,
            z: 2,
            scale: 1,
            scaleX: 1,
            scaleY: 1,
            rotation: 1,
            rotationZ: 1,
            rotationX: 2,
            rotationY: 2,
            skewX: 1,
            skewY: 1,
            xPercent: 1,
            yPercent: 1
        }, i = document.defaultView ? document.defaultView.getComputedStyle : function() {}
        , j = function(a, b, c) {
            var d = (a._gsTransform || g)[b];
            return d || 0 === d ? d : (a.style[b] ? d = a.style[b] : (c = c || i(a, null)) ? d = c[b] || c.getPropertyValue(b) || c.getPropertyValue(b.replace(f, "-$1").toLowerCase()) : a.currentStyle && (d = a.currentStyle[b]),
            parseFloat(d) || 0)
        }, k = a.ticker, l = function(a, b, c) {
            this.p = a,
            this.f = b,
            this.v1 = this.v2 = 0,
            this.t1 = this.t2 = k.time,
            this.css = !1,
            this.type = "",
            this._prev = null,
            c && (this._next = c,
            c._prev = this)
        }, m = function() {
            var a, c, f = b, g = k.time;
            if (g - d >= .03)
                for (e = d,
                d = g; f; ) {
                    for (c = f._firstVP; c; )
                        a = c.css ? j(f.target, c.p) : c.f ? f.target[c.p]() : f.target[c.p],
                        (a !== c.v1 || g - c.t1 > .15) && (c.v2 = c.v1,
                        c.v1 = a,
                        c.t2 = c.t1,
                        c.t1 = g),
                        c = c._next;
                    f = f._next
                }
        }, n = function(a) {
            this._lookup = {},
            this.target = a,
            this.elem = a.style && a.nodeType ? !0 : !1,
            c || (k.addEventListener("tick", m, null, !1, -100),
            d = e = k.time,
            c = !0),
            b && (this._next = b,
            b._prev = this),
            b = this
        }, o = n.getByTarget = function(a) {
            for (var c = b; c; ) {
                if (c.target === a)
                    return c;
                c = c._next
            }
        }
        , p = n.prototype;
        return p.addProp = function(b, c) {
            if (!this._lookup[b]) {
                var d = this.target
                  , e = "function" == typeof d[b]
                  , f = e ? this._altProp(b) : b
                  , g = this._firstVP;
                this._firstVP = this._lookup[b] = this._lookup[f] = g = new l(f !== b && 0 === b.indexOf("set") ? f : b,e,g),
                g.css = this.elem && (void 0 !== this.target.style[g.p] || h[g.p]),
                g.css && h[g.p] && !d._gsTransform && a.set(d, {
                    x: "+=0",
                    overwrite: !1
                }),
                g.type = c || g.css && 0 === b.indexOf("rotation") ? "deg" : "",
                g.v1 = g.v2 = g.css ? j(d, g.p) : e ? d[g.p]() : d[g.p]
            }
        }
        ,
        p.removeProp = function(a) {
            var b = this._lookup[a];
            b && (b._prev ? b._prev._next = b._next : b === this._firstVP && (this._firstVP = b._next),
            b._next && (b._next._prev = b._prev),
            this._lookup[a] = 0,
            b.f && (this._lookup[this._altProp(a)] = 0))
        }
        ,
        p.isTrackingProp = function(a) {
            return this._lookup[a]instanceof l
        }
        ,
        p.getVelocity = function(a) {
            var b, c, d, e = this._lookup[a], f = this.target;
            if (!e)
                throw "The velocity of " + a + " is not being tracked.";
            return b = e.css ? j(f, e.p) : e.f ? f[e.p]() : f[e.p],
            c = b - e.v2,
            ("rad" === e.type || "deg" === e.type) && (d = "rad" === e.type ? 2 * Math.PI : 360,
            c %= d,
            c !== c % (d / 2) && (c = 0 > c ? c + d : c - d)),
            c / (k.time - e.t2)
        }
        ,
        p._altProp = function(a) {
            var b = a.substr(0, 3)
              , c = ("get" === b ? "set" : "set" === b ? "get" : b) + a.substr(3);
            return "function" == typeof this.target[c] ? c : a
        }
        ,
        n.getByTarget = function(c) {
            var d = b;
            for ("string" == typeof c && (c = a.selector(c)),
            c.length && c !== window && c[0] && c[0].style && !c.nodeType && (c = c[0]); d; ) {
                if (d.target === c)
                    return d;
                d = d._next
            }
        }
        ,
        n.track = function(a, b, c) {
            var d = o(a)
              , e = b.split(",")
              , f = e.length;
            for (c = (c || "").split(","),
            d || (d = new n(a)); --f > -1; )
                d.addProp(e[f], c[f] || c[0]);
            return d
        }
        ,
        n.untrack = function(a, c) {
            var d = o(a)
              , e = (c || "").split(",")
              , f = e.length;
            if (d) {
                for (; --f > -1; )
                    d.removeProp(e[f]);
                d._firstVP && c || (d._prev ? d._prev._next = d._next : d === b && (b = d._next),
                d._next && (d._next._prev = d._prev))
            }
        }
        ,
        n.isTracking = function(a, b) {
            var c = o(a);
            return c ? !b && c._firstVP ? !0 : c.isTrackingProp(b) : !1
        }
        ,
        n
    }, !0)
}),
_gsScope._gsDefine && _gsScope._gsQueue.pop()(),
function(a) {
    "use strict";
    var b = function() {
        return (_gsScope.GreenSockGlobals || _gsScope)[a]
    };
    "function" == typeof define && define.amd ? define(["TweenLite"], b) : "undefined" != typeof module && module.exports && (require("../TweenLite.js"),
    module.exports = b())
}("ThrowPropsPlugin");

/*! ScrollMagic v2.0.5  */
!function(e, t) {
    "function" == typeof define && define.amd ? define(t) : "object" == typeof exports ? module.exports = t() : e.ScrollMagic = t()
}(this, function() {
    "use strict";
    var e = function() {};
    e.version = "2.0.5",
    window.addEventListener("mousewheel", function() {});
    var t = "data-scrollmagic-pin-spacer";
    e.Controller = function(r) {
        var o, s, a = "ScrollMagic.Controller", l = "FORWARD", c = "REVERSE", u = "PAUSED", f = n.defaults, d = this, h = i.extend({}, f, r), g = [], p = !1, v = 0, m = u, w = !0, y = 0, S = !0, b = function() {
            for (var e in h)
                f.hasOwnProperty(e) || delete h[e];
            if (h.container = i.get.elements(h.container)[0],
            !h.container)
                throw a + " init failed.";
            w = h.container === window || h.container === document.body || !document.body.contains(h.container),
            w && (h.container = window),
            y = z(),
            h.container.addEventListener("resize", T),
            h.container.addEventListener("scroll", T),
            h.refreshInterval = parseInt(h.refreshInterval) || f.refreshInterval,
            E()
        }, E = function() {
            h.refreshInterval > 0 && (s = window.setTimeout(A, h.refreshInterval))
        }, x = function() {
            return h.vertical ? i.get.scrollTop(h.container) : i.get.scrollLeft(h.container)
        }, z = function() {
            return h.vertical ? i.get.height(h.container) : i.get.width(h.container)
        }, C = this._setScrollPos = function(e) {
            h.vertical ? w ? window.scrollTo(i.get.scrollLeft(), e) : h.container.scrollTop = e : w ? window.scrollTo(e, i.get.scrollTop()) : h.container.scrollLeft = e
        }
        , F = function() {
            if (S && p) {
                var e = i.type.Array(p) ? p : g.slice(0);
                p = !1;
                var t = v;
                v = d.scrollPos();
                var n = v - t;
                0 !== n && (m = n > 0 ? l : c),
                m === c && e.reverse(),
                e.forEach(function(e) {
                    e.update(!0)
                })
            }
        }, L = function() {
            o = i.rAF(F)
        }, T = function(e) {
            "resize" == e.type && (y = z(),
            m = u),
            p !== !0 && (p = !0,
            L())
        }, A = function() {
            if (!w && y != z()) {
                var e;
                try {
                    e = new Event("resize",{
                        bubbles: !1,
                        cancelable: !1
                    })
                } catch (t) {
                    e = document.createEvent("Event"),
                    e.initEvent("resize", !1, !1)
                }
                h.container.dispatchEvent(e)
            }
            g.forEach(function(e) {
                e.refresh()
            }),
            E()
        };
        this._options = h;
        var O = function(e) {
            if (e.length <= 1)
                return e;
            var t = e.slice(0);
            return t.sort(function(e, t) {
                return e.scrollOffset() > t.scrollOffset() ? 1 : -1
            }),
            t
        };
        return this.addScene = function(t) {
            if (i.type.Array(t))
                t.forEach(function(e) {
                    d.addScene(e)
                });
            else if (t instanceof e.Scene)
                if (t.controller() !== d)
                    t.addTo(d);
                else if (g.indexOf(t) < 0) {
                    g.push(t),
                    g = O(g),
                    t.on("shift.controller_sort", function() {
                        g = O(g)
                    });
                    for (var n in h.globalSceneOptions)
                        t[n] && t[n].call(t, h.globalSceneOptions[n])
                }
            return d
        }
        ,
        this.removeScene = function(e) {
            if (i.type.Array(e))
                e.forEach(function(e) {
                    d.removeScene(e)
                });
            else {
                var t = g.indexOf(e);
                t > -1 && (e.off("shift.controller_sort"),
                g.splice(t, 1),
                e.remove())
            }
            return d
        }
        ,
        this.updateScene = function(t, n) {
            return i.type.Array(t) ? t.forEach(function(e) {
                d.updateScene(e, n)
            }) : n ? t.update(!0) : p !== !0 && t instanceof e.Scene && (p = p || [],
            -1 == p.indexOf(t) && p.push(t),
            p = O(p),
            L()),
            d
        }
        ,
        this.update = function(e) {
            return T({
                type: "resize"
            }),
            e && F(),
            d
        }
        ,
        this.scrollTo = function(n, r) {
            if (i.type.Number(n))
                C.call(h.container, n, r);
            else if (n instanceof e.Scene)
                n.controller() === d && d.scrollTo(n.scrollOffset(), r);
            else if (i.type.Function(n))
                C = n;
            else {
                var o = i.get.elements(n)[0];
                if (o) {
                    for (; o.parentNode.hasAttribute(t); )
                        o = o.parentNode;
                    var s = h.vertical ? "top" : "left"
                      , a = i.get.offset(h.container)
                      , l = i.get.offset(o);
                    w || (a[s] -= d.scrollPos()),
                    d.scrollTo(l[s] - a[s], r)
                }
            }
            return d
        }
        ,
        this.scrollPos = function(e) {
            return arguments.length ? (i.type.Function(e) && (x = e),
            d) : x.call(d)
        }
        ,
        this.info = function(e) {
            var t = {
                size: y,
                vertical: h.vertical,
                scrollPos: v,
                scrollDirection: m,
                container: h.container,
                isDocument: w
            };
            return arguments.length ? void 0 !== t[e] ? t[e] : void 0 : t
        }
        ,
        this.loglevel = function() {
            return d
        }
        ,
        this.enabled = function(e) {
            return arguments.length ? (S != e && (S = !!e,
            d.updateScene(g, !0)),
            d) : S
        }
        ,
        this.destroy = function(e) {
            window.clearTimeout(s);
            for (var t = g.length; t--; )
                g[t].destroy(e);
            return h.container.removeEventListener("resize", T),
            h.container.removeEventListener("scroll", T),
            i.cAF(o),
            null
        }
        ,
        b(),
        d
    }
    ;
    var n = {
        defaults: {
            container: window,
            vertical: !0,
            globalSceneOptions: {},
            loglevel: 2,
            refreshInterval: 100
        }
    };
    e.Controller.addOption = function(e, t) {
        n.defaults[e] = t
    }
    ,
    e.Controller.extend = function(t) {
        var n = this;
        e.Controller = function() {
            return n.apply(this, arguments),
            this.$super = i.extend({}, this),
            t.apply(this, arguments) || this
        }
        ,
        i.extend(e.Controller, n),
        e.Controller.prototype = n.prototype,
        e.Controller.prototype.constructor = e.Controller
    }
    ,
    e.Scene = function(n) {
        var o, s, a = "BEFORE", l = "DURING", c = "AFTER", u = r.defaults, f = this, d = i.extend({}, u, n), h = a, g = 0, p = {
            start: 0,
            end: 0
        }, v = 0, m = !0, w = function() {
            for (var e in d)
                u.hasOwnProperty(e) || delete d[e];
            for (var t in u)
                L(t);
            C()
        }, y = {};
        this.on = function(e, t) {
            return i.type.Function(t) && (e = e.trim().split(" "),
            e.forEach(function(e) {
                var n = e.split(".")
                  , r = n[0]
                  , i = n[1];
                "*" != r && (y[r] || (y[r] = []),
                y[r].push({
                    namespace: i || "",
                    callback: t
                }))
            })),
            f
        }
        ,
        this.off = function(e, t) {
            return e ? (e = e.trim().split(" "),
            e.forEach(function(e) {
                var n = e.split(".")
                  , r = n[0]
                  , i = n[1] || ""
                  , o = "*" === r ? Object.keys(y) : [r];
                o.forEach(function(e) {
                    for (var n = y[e] || [], r = n.length; r--; ) {
                        var o = n[r];
                        !o || i !== o.namespace && "*" !== i || t && t != o.callback || n.splice(r, 1)
                    }
                    n.length || delete y[e]
                })
            }),
            f) : f
        }
        ,
        this.trigger = function(t, n) {
            if (t) {
                var r = t.trim().split(".")
                  , i = r[0]
                  , o = r[1]
                  , s = y[i];
                s && s.forEach(function(t) {
                    o && o !== t.namespace || t.callback.call(f, new e.Event(i,t.namespace,f,n))
                })
            }
            return f
        }
        ,
        f.on("change.internal", function(e) {
            "loglevel" !== e.what && "tweenChanges" !== e.what && ("triggerElement" === e.what ? E() : "reverse" === e.what && f.update())
        }).on("shift.internal", function() {
            S(),
            f.update()
        }),
        this.addTo = function(t) {
            return t instanceof e.Controller && s != t && (s && s.removeScene(f),
            s = t,
            C(),
            b(!0),
            E(!0),
            S(),
            s.info("container").addEventListener("resize", x),
            t.addScene(f),
            f.trigger("add", {
                controller: s
            }),
            f.update()),
            f
        }
        ,
        this.enabled = function(e) {
            return arguments.length ? (m != e && (m = !!e,
            f.update(!0)),
            f) : m
        }
        ,
        this.remove = function() {
            if (s) {
                s.info("container").removeEventListener("resize", x);
                var e = s;
                s = void 0,
                e.removeScene(f),
                f.trigger("remove")
            }
            return f
        }
        ,
        this.destroy = function(e) {
            return f.trigger("destroy", {
                reset: e
            }),
            f.remove(),
            f.off("*.*"),
            null
        }
        ,
        this.update = function(e) {
            if (s)
                if (e)
                    if (s.enabled() && m) {
                        var t, n = s.info("scrollPos");
                        t = d.duration > 0 ? (n - p.start) / (p.end - p.start) : n >= p.start ? 1 : 0,
                        f.trigger("update", {
                            startPos: p.start,
                            endPos: p.end,
                            scrollPos: n
                        }),
                        f.progress(t)
                    } else
                        T && h === l && O(!0);
                else
                    s.updateScene(f, !1);
            return f
        }
        ,
        this.refresh = function() {
            return b(),
            E(),
            f
        }
        ,
        this.progress = function(e) {
            if (arguments.length) {
                var t = !1
                  , n = h
                  , r = s ? s.info("scrollDirection") : "PAUSED"
                  , i = d.reverse || e >= g;
                if (0 === d.duration ? (t = g != e,
                g = 1 > e && i ? 0 : 1,
                h = 0 === g ? a : l) : 0 > e && h !== a && i ? (g = 0,
                h = a,
                t = !0) : e >= 0 && 1 > e && i ? (g = e,
                h = l,
                t = !0) : e >= 1 && h !== c ? (g = 1,
                h = c,
                t = !0) : h !== l || i || O(),
                t) {
                    var o = {
                        progress: g,
                        state: h,
                        scrollDirection: r
                    }
                      , u = h != n
                      , p = function(e) {
                        f.trigger(e, o)
                    };
                    u && n !== l && (p("enter"),
                    p(n === a ? "start" : "end")),
                    p("progress"),
                    u && h !== l && (p(h === a ? "start" : "end"),
                    p("leave"))
                }
                return f
            }
            return g
        }
        ;
        var S = function() {
            p = {
                start: v + d.offset
            },
            s && d.triggerElement && (p.start -= s.info("size") * d.triggerHook),
            p.end = p.start + d.duration
        }
          , b = function(e) {
            if (o) {
                var t = "duration";
                F(t, o.call(f)) && !e && (f.trigger("change", {
                    what: t,
                    newval: d[t]
                }),
                f.trigger("shift", {
                    reason: t
                }))
            }
        }
          , E = function(e) {
            var n = 0
              , r = d.triggerElement;
            if (s && r) {
                for (var o = s.info(), a = i.get.offset(o.container), l = o.vertical ? "top" : "left"; r.parentNode.hasAttribute(t); )
                    r = r.parentNode;
                var c = i.get.offset(r);
                o.isDocument || (a[l] -= s.scrollPos()),
                n = c[l] - a[l]
            }
            var u = n != v;
            v = n,
            u && !e && f.trigger("shift", {
                reason: "triggerElementPosition"
            })
        }
          , x = function() {
            d.triggerHook > 0 && f.trigger("shift", {
                reason: "containerResize"
            })
        }
          , z = i.extend(r.validate, {
            duration: function(e) {
                if (i.type.String(e) && e.match(/^(\.|\d)*\d+%$/)) {
                    var t = parseFloat(e) / 100;
                    e = function() {
                        return s ? s.info("size") * t : 0
                    }
                }
                if (i.type.Function(e)) {
                    o = e;
                    try {
                        e = parseFloat(o())
                    } catch (n) {
                        e = -1
                    }
                }
                if (e = parseFloat(e),
                !i.type.Number(e) || 0 > e)
                    throw o ? (o = void 0,
                    0) : 0;
                return e
            }
        })
          , C = function(e) {
            e = arguments.length ? [e] : Object.keys(z),
            e.forEach(function(e) {
                var t;
                if (z[e])
                    try {
                        t = z[e](d[e])
                    } catch (n) {
                        t = u[e]
                    } finally {
                        d[e] = t
                    }
            })
        }
          , F = function(e, t) {
            var n = !1
              , r = d[e];
            return d[e] != t && (d[e] = t,
            C(e),
            n = r != d[e]),
            n
        }
          , L = function(e) {
            f[e] || (f[e] = function(t) {
                return arguments.length ? ("duration" === e && (o = void 0),
                F(e, t) && (f.trigger("change", {
                    what: e,
                    newval: d[e]
                }),
                r.shifts.indexOf(e) > -1 && f.trigger("shift", {
                    reason: e
                })),
                f) : d[e]
            }
            )
        };
        this.controller = function() {
            return s
        }
        ,
        this.state = function() {
            return h
        }
        ,
        this.scrollOffset = function() {
            return p.start
        }
        ,
        this.triggerPosition = function() {
            var e = d.offset;
            return s && (e += d.triggerElement ? v : s.info("size") * f.triggerHook()),
            e
        }
        ;
        var T, A;
        f.on("shift.internal", function(e) {
            var t = "duration" === e.reason;
            (h === c && t || h === l && 0 === d.duration) && O(),
            t && _()
        }).on("progress.internal", function() {
            O()
        }).on("add.internal", function() {
            _()
        }).on("destroy.internal", function(e) {
            f.removePin(e.reset)
        });
        var O = function(e) {
            if (T && s) {
                var t = s.info()
                  , n = A.spacer.firstChild;
                if (e || h !== l) {
                    var r = {
                        position: A.inFlow ? "relative" : "absolute",
                        top: 0,
                        left: 0
                    }
                      , o = i.css(n, "position") != r.position;
                    A.pushFollowers ? d.duration > 0 && (h === c && 0 === parseFloat(i.css(A.spacer, "padding-top")) ? o = !0 : h === a && 0 === parseFloat(i.css(A.spacer, "padding-bottom")) && (o = !0)) : r[t.vertical ? "top" : "left"] = d.duration * g,
                    i.css(n, r),
                    o && _()
                } else {
                    "fixed" != i.css(n, "position") && (i.css(n, {
                        position: "fixed"
                    }),
                    _());
                    var u = i.get.offset(A.spacer, !0)
                      , f = d.reverse || 0 === d.duration ? t.scrollPos - p.start : Math.round(g * d.duration * 10) / 10;
                    u[t.vertical ? "top" : "left"] += f,
                    i.css(A.spacer.firstChild, {
                        top: u.top,
                        left: u.left
                    })
                }
            }
        }
          , _ = function() {
            if (T && s && A.inFlow) {
                var e = h === l
                  , t = s.info("vertical")
                  , n = A.spacer.firstChild
                  , r = i.isMarginCollapseType(i.css(A.spacer, "display"))
                  , o = {};
                A.relSize.width || A.relSize.autoFullWidth ? e ? i.css(T, {
                    width: i.get.width(A.spacer)
                }) : i.css(T, {
                    width: "100%"
                }) : (o["min-width"] = i.get.width(t ? T : n, !0, !0),
                o.width = e ? o["min-width"] : "auto"),
                A.relSize.height ? e ? i.css(T, {
                    height: i.get.height(A.spacer) - (A.pushFollowers ? d.duration : 0)
                }) : i.css(T, {
                    height: "100%"
                }) : (o["min-height"] = i.get.height(t ? n : T, !0, !r),
                o.height = e ? o["min-height"] : "auto"),
                A.pushFollowers && (o["padding" + (t ? "Top" : "Left")] = d.duration * g,
                o["padding" + (t ? "Bottom" : "Right")] = d.duration * (1 - g)),
                i.css(A.spacer, o)
            }
        }
          , N = function() {
            s && T && h === l && !s.info("isDocument") && O()
        }
          , P = function() {
            s && T && h === l && ((A.relSize.width || A.relSize.autoFullWidth) && i.get.width(window) != i.get.width(A.spacer.parentNode) || A.relSize.height && i.get.height(window) != i.get.height(A.spacer.parentNode)) && _()
        }
          , D = function(e) {
            s && T && h === l && !s.info("isDocument") && (e.preventDefault(),
            s._setScrollPos(s.info("scrollPos") - ((e.wheelDelta || e[s.info("vertical") ? "wheelDeltaY" : "wheelDeltaX"]) / 3 || 30 * -e.detail)))
        };
        this.setPin = function(e, n) {
            var r = {
                pushFollowers: !0,
                spacerClass: "scrollmagic-pin-spacer"
            };
            if (n = i.extend({}, r, n),
            e = i.get.elements(e)[0],
            !e)
                return f;
            if ("fixed" === i.css(e, "position"))
                return f;
            if (T) {
                if (T === e)
                    return f;
                f.removePin()
            }
            T = e;
            var o = T.parentNode.style.display
              , s = ["top", "left", "bottom", "right", "margin", "marginLeft", "marginRight", "marginTop", "marginBottom"];
            T.parentNode.style.display = "none";
            var a = "absolute" != i.css(T, "position")
              , l = i.css(T, s.concat(["display"]))
              , c = i.css(T, ["width", "height"]);
            T.parentNode.style.display = o,
            !a && n.pushFollowers && (n.pushFollowers = !1);
            var u = T.parentNode.insertBefore(document.createElement("div"), T)
              , d = i.extend(l, {
                position: a ? "relative" : "absolute",
                boxSizing: "content-box",
                mozBoxSizing: "content-box",
                webkitBoxSizing: "content-box"
            });
            if (a || i.extend(d, i.css(T, ["width", "height"])),
            i.css(u, d),
            u.setAttribute(t, ""),
            i.addClass(u, n.spacerClass),
            A = {
                spacer: u,
                relSize: {
                    width: "%" === c.width.slice(-1),
                    height: "%" === c.height.slice(-1),
                    autoFullWidth: "auto" === c.width && a && i.isMarginCollapseType(l.display)
                },
                pushFollowers: n.pushFollowers,
                inFlow: a
            },
            !T.___origStyle) {
                T.___origStyle = {};
                var h = T.style
                  , g = s.concat(["width", "height", "position", "boxSizing", "mozBoxSizing", "webkitBoxSizing"]);
                g.forEach(function(e) {
                    T.___origStyle[e] = h[e] || ""
                })
            }
            return A.relSize.width && i.css(u, {
                width: c.width
            }),
            A.relSize.height && i.css(u, {
                height: c.height
            }),
            u.appendChild(T),
            i.css(T, {
                position: a ? "relative" : "absolute",
                margin: "auto",
                top: "auto",
                left: "auto",
                bottom: "auto",
                right: "auto"
            }),
            (A.relSize.width || A.relSize.autoFullWidth) && i.css(T, {
                boxSizing: "border-box",
                mozBoxSizing: "border-box",
                webkitBoxSizing: "border-box"
            }),
            window.addEventListener("scroll", N),
            window.addEventListener("resize", N),
            window.addEventListener("resize", P),
            T.addEventListener("mousewheel", D),
            T.addEventListener("DOMMouseScroll", D),
            O(),
            f
        }
        ,
        this.removePin = function(e) {
            if (T) {
                if (h === l && O(!0),
                e || !s) {
                    var n = A.spacer.firstChild;
                    if (n.hasAttribute(t)) {
                        var r = A.spacer.style
                          , o = ["margin", "marginLeft", "marginRight", "marginTop", "marginBottom"];
                        margins = {},
                        o.forEach(function(e) {
                            margins[e] = r[e] || ""
                        }),
                        i.css(n, margins)
                    }
                    A.spacer.parentNode.insertBefore(n, A.spacer),
                    A.spacer.parentNode.removeChild(A.spacer),
                    T.parentNode.hasAttribute(t) || (i.css(T, T.___origStyle),
                    delete T.___origStyle)
                }
                window.removeEventListener("scroll", N),
                window.removeEventListener("resize", N),
                window.removeEventListener("resize", P),
                T.removeEventListener("mousewheel", D),
                T.removeEventListener("DOMMouseScroll", D),
                T = void 0
            }
            return f
        }
        ;
        var R, k = [];
        return f.on("destroy.internal", function(e) {
            f.removeClassToggle(e.reset)
        }),
        this.setClassToggle = function(e, t) {
            var n = i.get.elements(e);
            return 0 !== n.length && i.type.String(t) ? (k.length > 0 && f.removeClassToggle(),
            R = t,
            k = n,
            f.on("enter.internal_class leave.internal_class", function(e) {
                var t = "enter" === e.type ? i.addClass : i.removeClass;
                k.forEach(function(e) {
                    t(e, R)
                })
            }),
            f) : f
        }
        ,
        this.removeClassToggle = function(e) {
            return e && k.forEach(function(e) {
                i.removeClass(e, R)
            }),
            f.off("start.internal_class end.internal_class"),
            R = void 0,
            k = [],
            f
        }
        ,
        w(),
        f
    }
    ;
    var r = {
        defaults: {
            duration: 0,
            offset: 0,
            triggerElement: void 0,
            triggerHook: .5,
            reverse: !0,
            loglevel: 2
        },
        validate: {
            offset: function(e) {
                if (e = parseFloat(e),
                !i.type.Number(e))
                    throw 0;
                return e
            },
            triggerElement: function(e) {
                if (e = e || void 0) {
                    var t = i.get.elements(e)[0];
                    if (!t)
                        throw 0;
                    e = t
                }
                return e
            },
            triggerHook: function(e) {
                var t = {
                    onCenter: .5,
                    onEnter: 1,
                    onLeave: 0
                };
                if (i.type.Number(e))
                    e = Math.max(0, Math.min(parseFloat(e), 1));
                else {
                    if (!(e in t))
                        throw 0;
                    e = t[e]
                }
                return e
            },
            reverse: function(e) {
                return !!e
            }
        },
        shifts: ["duration", "offset", "triggerHook"]
    };
    e.Scene.addOption = function(e, t, n, i) {
        e in r.defaults || (r.defaults[e] = t,
        r.validate[e] = n,
        i && r.shifts.push(e))
    }
    ,
    e.Scene.extend = function(t) {
        var n = this;
        e.Scene = function() {
            return n.apply(this, arguments),
            this.$super = i.extend({}, this),
            t.apply(this, arguments) || this
        }
        ,
        i.extend(e.Scene, n),
        e.Scene.prototype = n.prototype,
        e.Scene.prototype.constructor = e.Scene
    }
    ,
    e.Event = function(e, t, n, r) {
        r = r || {};
        for (var i in r)
            this[i] = r[i];
        return this.type = e,
        this.target = this.currentTarget = n,
        this.namespace = t || "",
        this.timeStamp = this.timestamp = Date.now(),
        this
    }
    ;
    var i = e._util = function(e) {
        var t, n = {}, r = function(e) {
            return parseFloat(e) || 0
        }, i = function(t) {
            return t.currentStyle ? t.currentStyle : e.getComputedStyle(t)
        }, o = function(t, n, o, s) {
            if (n = n === document ? e : n,
            n === e)
                s = !1;
            else if (!f.DomElement(n))
                return 0;
            t = t.charAt(0).toUpperCase() + t.substr(1).toLowerCase();
            var a = (o ? n["offset" + t] || n["outer" + t] : n["client" + t] || n["inner" + t]) || 0;
            if (o && s) {
                var l = i(n);
                a += "Height" === t ? r(l.marginTop) + r(l.marginBottom) : r(l.marginLeft) + r(l.marginRight)
            }
            return a
        }, s = function(e) {
            return e.replace(/^[^a-z]+([a-z])/g, "$1").replace(/-([a-z])/g, function(e) {
                return e[1].toUpperCase()
            })
        };
        n.extend = function(e) {
            for (e = e || {},
            t = 1; t < arguments.length; t++)
                if (arguments[t])
                    for (var n in arguments[t])
                        arguments[t].hasOwnProperty(n) && (e[n] = arguments[t][n]);
            return e
        }
        ,
        n.isMarginCollapseType = function(e) {
            return ["block", "flex", "list-item", "table", "-webkit-box"].indexOf(e) > -1
        }
        ;
        var a = 0
          , l = ["ms", "moz", "webkit", "o"]
          , c = e.requestAnimationFrame
          , u = e.cancelAnimationFrame;
        for (t = 0; !c && t < l.length; ++t)
            c = e[l[t] + "RequestAnimationFrame"],
            u = e[l[t] + "CancelAnimationFrame"] || e[l[t] + "CancelRequestAnimationFrame"];
        c || (c = function(t) {
            var n = (new Date).getTime()
              , r = Math.max(0, 16 - (n - a))
              , i = e.setTimeout(function() {
                t(n + r)
            }, r);
            return a = n + r,
            i
        }
        ),
        u || (u = function(t) {
            e.clearTimeout(t)
        }
        ),
        n.rAF = c.bind(e),
        n.cAF = u.bind(e);
        var f = n.type = function(e) {
            return Object.prototype.toString.call(e).replace(/^\[object (.+)\]$/, "$1").toLowerCase()
        }
        ;
        f.String = function(e) {
            return "string" === f(e)
        }
        ,
        f.Function = function(e) {
            return "function" === f(e)
        }
        ,
        f.Array = function(e) {
            return Array.isArray(e)
        }
        ,
        f.Number = function(e) {
            return !f.Array(e) && e - parseFloat(e) + 1 >= 0
        }
        ,
        f.DomElement = function(e) {
            return "object" == typeof HTMLElement ? e instanceof HTMLElement : e && "object" == typeof e && null !== e && 1 === e.nodeType && "string" == typeof e.nodeName
        }
        ;
        var d = n.get = {};
        return d.elements = function(t) {
            var n = [];
            if (f.String(t))
                try {
                    t = document.querySelectorAll(t)
                } catch (r) {
                    return n
                }
            if ("nodelist" === f(t) || f.Array(t))
                for (var i = 0, o = n.length = t.length; o > i; i++) {
                    var s = t[i];
                    n[i] = f.DomElement(s) ? s : d.elements(s)
                }
            else
                (f.DomElement(t) || t === document || t === e) && (n = [t]);
            return n
        }
        ,
        d.scrollTop = function(t) {
            return t && "number" == typeof t.scrollTop ? t.scrollTop : e.pageYOffset || 0
        }
        ,
        d.scrollLeft = function(t) {
            return t && "number" == typeof t.scrollLeft ? t.scrollLeft : e.pageXOffset || 0
        }
        ,
        d.width = function(e, t, n) {
            return o("width", e, t, n)
        }
        ,
        d.height = function(e, t, n) {
            return o("height", e, t, n)
        }
        ,
        d.offset = function(e, t) {
            var n = {
                top: 0,
                left: 0
            };
            if (e && e.getBoundingClientRect) {
                var r = e.getBoundingClientRect();
                n.top = r.top,
                n.left = r.left,
                t || (n.top += d.scrollTop(),
                n.left += d.scrollLeft())
            }
            return n
        }
        ,
        n.addClass = function(e, t) {
            t && (e.classList ? e.classList.add(t) : e.className += " " + t)
        }
        ,
        n.removeClass = function(e, t) {
            t && (e.classList ? e.classList.remove(t) : e.className = e.className.replace(RegExp("(^|\\b)" + t.split(" ").join("|") + "(\\b|$)", "gi"), " "))
        }
        ,
        n.css = function(e, t) {
            if (f.String(t))
                return i(e)[s(t)];
            if (f.Array(t)) {
                var n = {}
                  , r = i(e);
                return t.forEach(function(e) {
                    n[e] = r[s(e)]
                }),
                n
            }
            for (var o in t) {
                var a = t[o];
                a == parseFloat(a) && (a += "px"),
                e.style[s(o)] = a
            }
        }
        ,
        n
    }(window || {});
    return e
});
!function(e, n) {
    "function" == typeof define && define.amd ? define(["ScrollMagic", "TweenMax", "TimelineMax"], n) : "object" == typeof exports ? (require("gsap"),
    n(require("scrollmagic"), TweenMax, TimelineMax)) : n(e.ScrollMagic || e.jQuery && e.jQuery.ScrollMagic, e.TweenMax || e.TweenLite, e.TimelineMax || e.TimelineLite)
}(this, function(e, n, r) {
    "use strict";
    e.Scene.addOption("tweenChanges", !1, function(e) {
        return !!e
    }),
    e.Scene.extend(function() {
        var e, t = this;
        t.on("progress.plugin_gsap", function() {
            i()
        }),
        t.on("destroy.plugin_gsap", function(e) {
            t.removeTween(e.reset)
        });
        var i = function() {
            if (e) {
                var n = t.progress()
                  , r = t.state();
                e.repeat && -1 === e.repeat() ? "DURING" === r && e.paused() ? e.play() : "DURING" === r || e.paused() || e.pause() : n != e.progress() && (0 === t.duration() ? n > 0 ? e.play() : e.reverse() : t.tweenChanges() && e.tweenTo ? e.tweenTo(n * e.duration()) : e.progress(n).pause())
            }
        };
        t.setTween = function(o, a, s) {
            var u;
            arguments.length > 1 && (arguments.length < 3 && (s = a,
            a = 1),
            o = n.to(o, a, s));
            try {
                u = r ? new r({
                    smoothChildTiming: !0
                }).add(o) : o,
                u.pause()
            } catch (p) {
                return t
            }
            return e && t.removeTween(),
            e = u,
            o.repeat && -1 === o.repeat() && (e.repeat(-1),
            e.yoyo(o.yoyo())),
            i(),
            t
        }
        ,
        t.removeTween = function(n) {
            return e && (n && e.progress(0).pause(),
            e.kill(),
            e = void 0),
            t
        }
    })
});

/*! Virtual Scroll */
var VirtualScroll = function(a) {
    var c, f, g, l, b = {}, d = [], e = !1, h = 10, i = 100, j = 240, k = 1, m = "onwheel"in a, n = "onmousewheel"in a, o = "ontouchstart"in a, p = navigator.msMaxTouchPoints && navigator.msMaxTouchPoints > 1, q = !!window.navigator.msPointerEnabled, r = "onkeydown"in a, s = navigator.userAgent.indexOf("Firefox") > -1, t = navigator.userAgent.indexOf("Chrome") > -1, u = -1 != navigator.appVersion.indexOf("Win"), v = {
        y: 0,
        x: 0,
        deltaX: 0,
        deltaY: 0,
        originalEvent: null
    };
    b.on = function(a) {
        e || C(),
        d.push(a),
        c = d.length
    }
    ,
    b.options = function(a) {
        j = a.keyStep || 120,
        i = a.firefoxMult || 15,
        h = a.touchMult || 2,
        k = a.mouseMult || 1
    }
    ,
    b.off = function(a) {
        d.splice(a, 1),
        (c = d.length) <= 0 && D()
    }
    ;
    var w = function(a) {
        v.x += v.deltaX,
        v.y += v.deltaY,
        v.originalEvent = a;
        for (var b = 0; b < c; b++)
            d[b](v)
    }
      , x = function(a) {
        v.deltaX = a.wheelDeltaX || -1 * a.deltaX,
        v.deltaY = a.wheelDeltaY || -1 * a.deltaY,
        s && 1 == a.deltaMode && (v.deltaX *= i,
        v.deltaY *= i),
        u && t && (v.deltaX *= 3,
        v.deltaY *= 3),
        v.deltaX *= k,
        v.deltaY *= k,
        w(a)
    }
      , y = function(a) {
        v.deltaX = a.wheelDeltaX ? a.wheelDeltaX : 0,
        v.deltaY = a.wheelDeltaY ? a.wheelDeltaY : a.wheelDelta,
        w(a)
    }
      , z = function(a) {
        var b = a.targetTouches ? a.targetTouches[0] : a;
        f = b.pageX,
        g = b.pageY
    }
      , A = function(a) {
        var b = a.targetTouches ? a.targetTouches[0] : a;
        v.deltaX = (b.pageX - f) * h,
        v.deltaY = (b.pageY - g) * h,
        f = b.pageX,
        g = b.pageY,
        w(a)
    }
      , B = function(a) {
        switch (v.deltaX = v.deltaY = 0,
        a.keyCode) {
        case 37:
            v.deltaX = -j;
            break;
        case 39:
            v.deltaX = j;
            break;
        case 38:
            v.deltaY = j;
            break;
        case 40:
            v.deltaY = -j
        }
        w(a)
    }
      , C = function() {
        m && a.addEventListener("wheel", x),
        n && a.addEventListener("mousewheel", y),
        o && (a.addEventListener("touchstart", z),
        a.addEventListener("touchmove", A)),
        q && p && (l = a.body.style.msTouchAction,
        a.body.style.msTouchAction = "none",
        a.addEventListener("MSPointerDown", z, !0),
        a.addEventListener("MSPointerMove", A, !0)),
        r && a.addEventListener("keydown", B),
        e = !0
    }
      , D = function() {
        m && a.removeEventListener("wheel", x),
        n && a.removeEventListener("mousewheel", y),
        o && (a.removeEventListener("touchstart", z),
        a.removeEventListener("touchmove", A)),
        q && p && (a.body.style.msTouchAction = l,
        a.removeEventListener("MSPointerDown", z, !0),
        a.removeEventListener("MSPointerMove", A, !0)),
        r && a.removeEventListener("keydown", B),
        e = !1
    };
    return b
}(document);

/*! Barba.js */
!function(t, e) {
    "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("Barba", [], e) : "object" == typeof exports ? exports.Barba = e() : t.Barba = e()
}(this, function() {
    return function(t) {
        function e(r) {
            if (n[r])
                return n[r].exports;
            var i = n[r] = {
                exports: {},
                id: r,
                loaded: !1
            };
            return t[r].call(i.exports, i, i.exports, e),
            i.loaded = !0,
            i.exports
        }
        var n = {};
        return e.m = t,
        e.c = n,
        e.p = "http://localhost:8080/dist",
        e(0)
    }([function(t, e, n) {
        "function" != typeof Promise && (window.Promise = n(1));
        var r = {
            version: "1.0.0",
            BaseTransition: n(4),
            BaseView: n(6),
            BaseCache: n(8),
            Dispatcher: n(7),
            HistoryManager: n(9),
            Pjax: n(10),
            Prefetch: n(13),
            Utils: n(5)
        };
        t.exports = r
    }
    , function(t, e, n) {
        (function(e) {
            !function(n) {
                function r() {}
                function i(t, e) {
                    return function() {
                        t.apply(e, arguments)
                    }
                }
                function o(t) {
                    if ("object" != typeof this)
                        throw new TypeError("Promises must be constructed via new");
                    if ("function" != typeof t)
                        throw new TypeError("not a function");
                    this._state = 0,
                    this._handled = !1,
                    this._value = void 0,
                    this._deferreds = [],
                    h(t, this)
                }
                function s(t, e) {
                    for (; 3 === t._state; )
                        t = t._value;
                    return 0 === t._state ? void t._deferreds.push(e) : (t._handled = !0,
                    void l(function() {
                        var n = 1 === t._state ? e.onFulfilled : e.onRejected;
                        if (null === n)
                            return void (1 === t._state ? a : c)(e.promise, t._value);
                        var r;
                        try {
                            r = n(t._value)
                        } catch (t) {
                            return void c(e.promise, t)
                        }
                        a(e.promise, r)
                    }))
                }
                function a(t, e) {
                    try {
                        if (e === t)
                            throw new TypeError("A promise cannot be resolved with itself.");
                        if (e && ("object" == typeof e || "function" == typeof e)) {
                            var n = e.then;
                            if (e instanceof o)
                                return t._state = 3,
                                t._value = e,
                                void u(t);
                            if ("function" == typeof n)
                                return void h(i(n, e), t)
                        }
                        t._state = 1,
                        t._value = e,
                        u(t)
                    } catch (e) {
                        c(t, e)
                    }
                }
                function c(t, e) {
                    t._state = 2,
                    t._value = e,
                    u(t)
                }
                function u(t) {
                    2 === t._state && 0 === t._deferreds.length && l(function() {
                        t._handled || p(t._value)
                    });
                    for (var e = 0, n = t._deferreds.length; e < n; e++)
                        s(t, t._deferreds[e]);
                    t._deferreds = null
                }
                function f(t, e, n) {
                    this.onFulfilled = "function" == typeof t ? t : null,
                    this.onRejected = "function" == typeof e ? e : null,
                    this.promise = n
                }
                function h(t, e) {
                    var n = !1;
                    try {
                        t(function(t) {
                            n || (n = !0,
                            a(e, t))
                        }, function(t) {
                            n || (n = !0,
                            c(e, t))
                        })
                    } catch (t) {
                        if (n)
                            return;
                        n = !0,
                        c(e, t)
                    }
                }
                var d = setTimeout
                  , l = "function" == typeof e && e || function(t) {
                    d(t, 0)
                }
                  , p = function(t) {
                    "undefined" != typeof console && console && console.warn("Possible Unhandled Promise Rejection:", t)
                };
                o.prototype.catch = function(t) {
                    return this.then(null, t)
                }
                ,
                o.prototype.then = function(t, e) {
                    var n = new this.constructor(r);
                    return s(this, new f(t,e,n)),
                    n
                }
                ,
                o.all = function(t) {
                    var e = Array.prototype.slice.call(t);
                    return new o(function(t, n) {
                        function r(o, s) {
                            try {
                                if (s && ("object" == typeof s || "function" == typeof s)) {
                                    var a = s.then;
                                    if ("function" == typeof a)
                                        return void a.call(s, function(t) {
                                            r(o, t)
                                        }, n)
                                }
                                e[o] = s,
                                0 === --i && t(e)
                            } catch (t) {
                                n(t)
                            }
                        }
                        if (0 === e.length)
                            return t([]);
                        for (var i = e.length, o = 0; o < e.length; o++)
                            r(o, e[o])
                    }
                    )
                }
                ,
                o.resolve = function(t) {
                    return t && "object" == typeof t && t.constructor === o ? t : new o(function(e) {
                        e(t)
                    }
                    )
                }
                ,
                o.reject = function(t) {
                    return new o(function(e, n) {
                        n(t)
                    }
                    )
                }
                ,
                o.race = function(t) {
                    return new o(function(e, n) {
                        for (var r = 0, i = t.length; r < i; r++)
                            t[r].then(e, n)
                    }
                    )
                }
                ,
                o._setImmediateFn = function(t) {
                    l = t
                }
                ,
                o._setUnhandledRejectionFn = function(t) {
                    p = t
                }
                ,
                "undefined" != typeof t && t.exports ? t.exports = o : n.Promise || (n.Promise = o)
            }(this)
        }
        ).call(e, n(2).setImmediate)
    }
    , function(t, e, n) {
        (function(t, r) {
            function i(t, e) {
                this._id = t,
                this._clearFn = e
            }
            var o = n(3).nextTick
              , s = Function.prototype.apply
              , a = Array.prototype.slice
              , c = {}
              , u = 0;
            e.setTimeout = function() {
                return new i(s.call(setTimeout, window, arguments),clearTimeout)
            }
            ,
            e.setInterval = function() {
                return new i(s.call(setInterval, window, arguments),clearInterval)
            }
            ,
            e.clearTimeout = e.clearInterval = function(t) {
                t.close()
            }
            ,
            i.prototype.unref = i.prototype.ref = function() {}
            ,
            i.prototype.close = function() {
                this._clearFn.call(window, this._id)
            }
            ,
            e.enroll = function(t, e) {
                clearTimeout(t._idleTimeoutId),
                t._idleTimeout = e
            }
            ,
            e.unenroll = function(t) {
                clearTimeout(t._idleTimeoutId),
                t._idleTimeout = -1
            }
            ,
            e._unrefActive = e.active = function(t) {
                clearTimeout(t._idleTimeoutId);
                var e = t._idleTimeout;
                e >= 0 && (t._idleTimeoutId = setTimeout(function() {
                    t._onTimeout && t._onTimeout()
                }, e))
            }
            ,
            e.setImmediate = "function" == typeof t ? t : function(t) {
                var n = u++
                  , r = !(arguments.length < 2) && a.call(arguments, 1);
                return c[n] = !0,
                o(function() {
                    c[n] && (r ? t.apply(null, r) : t.call(null),
                    e.clearImmediate(n))
                }),
                n
            }
            ,
            e.clearImmediate = "function" == typeof r ? r : function(t) {
                delete c[t]
            }
        }
        ).call(e, n(2).setImmediate, n(2).clearImmediate)
    }
    , function(t, e) {
        function n() {
            h && u && (h = !1,
            u.length ? f = u.concat(f) : d = -1,
            f.length && r())
        }
        function r() {
            if (!h) {
                var t = s(n);
                h = !0;
                for (var e = f.length; e; ) {
                    for (u = f,
                    f = []; ++d < e; )
                        u && u[d].run();
                    d = -1,
                    e = f.length
                }
                u = null,
                h = !1,
                a(t)
            }
        }
        function i(t, e) {
            this.fun = t,
            this.array = e
        }
        function o() {}
        var s, a, c = t.exports = {};
        !function() {
            try {
                s = setTimeout
            } catch (t) {
                s = function() {
                    throw new Error("setTimeout is not defined")
                }
            }
            try {
                a = clearTimeout
            } catch (t) {
                a = function() {
                    throw new Error("clearTimeout is not defined")
                }
            }
        }();
        var u, f = [], h = !1, d = -1;
        c.nextTick = function(t) {
            var e = new Array(arguments.length - 1);
            if (arguments.length > 1)
                for (var n = 1; n < arguments.length; n++)
                    e[n - 1] = arguments[n];
            f.push(new i(t,e)),
            1 !== f.length || h || s(r, 0)
        }
        ,
        i.prototype.run = function() {
            this.fun.apply(null, this.array)
        }
        ,
        c.title = "browser",
        c.browser = !0,
        c.env = {},
        c.argv = [],
        c.version = "",
        c.versions = {},
        c.on = o,
        c.addListener = o,
        c.once = o,
        c.off = o,
        c.removeListener = o,
        c.removeAllListeners = o,
        c.emit = o,
        c.binding = function(t) {
            throw new Error("process.binding is not supported")
        }
        ,
        c.cwd = function() {
            return "/"
        }
        ,
        c.chdir = function(t) {
            throw new Error("process.chdir is not supported")
        }
        ,
        c.umask = function() {
            return 0
        }
    }
    , function(t, e, n) {
        var r = n(5)
          , i = {
            oldContainer: void 0,
            newContainer: void 0,
            newContainerLoading: void 0,
            extend: function(t) {
                return r.extend(this, t)
            },
            init: function(t, e) {
                var n = this;
                return this.oldContainer = t,
                this._newContainerPromise = e,
                this.deferred = r.deferred(),
                this.newContainerReady = r.deferred(),
                this.newContainerLoading = this.newContainerReady.promise,
                this.start(),
                this._newContainerPromise.then(function(t) {
                    n.newContainer = t,
                    n.newContainerReady.resolve()
                }),
                this.deferred.promise
            },
            done: function() {
                this.oldContainer.parentNode.removeChild(this.oldContainer),
                this.newContainer.style.visibility = "visible",
                this.deferred.resolve()
            },
            start: function() {}
        };
        t.exports = i
    }
    , function(t, e) {
        var n = {
            getCurrentUrl: function() {
                return window.location.protocol + "//" + window.location.host + window.location.pathname + window.location.search
            },
            cleanLink: function(t) {
                return t.replace(/#.*/, "")
            },
            xhrTimeout: 5e3,
            xhr: function(t) {
                var e = this.deferred()
                  , n = new XMLHttpRequest;
                return n.onreadystatechange = function() {
                    if (4 === n.readyState)
                        return 200 === n.status ? e.resolve(n.responseText) : e.reject(new Error("xhr: HTTP code is not 200"))
                }
                ,
                n.ontimeout = function() {
                    return e.reject(new Error("xhr: Timeout exceeded"))
                }
                ,
                n.open("GET", t),
                n.timeout = this.xhrTimeout,
                n.setRequestHeader("x-barba", "yes"),
                n.send(),
                e.promise
            },
            extend: function(t, e) {
                var n = Object.create(t);
                for (var r in e)
                    e.hasOwnProperty(r) && (n[r] = e[r]);
                return n
            },
            deferred: function() {
                return new function() {
                    this.resolve = null,
                    this.reject = null,
                    this.promise = new Promise(function(t, e) {
                        this.resolve = t,
                        this.reject = e
                    }
                    .bind(this))
                }
            },
            getPort: function(t) {
                var e = "undefined" != typeof t ? t : window.location.port
                  , n = window.location.protocol;
                return "" != e ? parseInt(e) : "http:" === n ? 80 : "https:" === n ? 443 : void 0
            }
        };
        t.exports = n
    }
    , function(t, e, n) {
        var r = n(7)
          , i = n(5)
          , o = {
            namespace: null,
            extend: function(t) {
                return i.extend(this, t)
            },
            init: function() {
                var t = this;
                r.on("initStateChange", function(e, n) {
                    n && n.namespace === t.namespace && t.onLeave()
                }),
                r.on("newPageReady", function(e, n, r) {
                    t.container = r,
                    e.namespace === t.namespace && t.onEnter()
                }),
                r.on("transitionCompleted", function(e, n) {
                    e.namespace === t.namespace && t.onEnterCompleted(),
                    n && n.namespace === t.namespace && t.onLeaveCompleted()
                })
            },
            onEnter: function() {},
            onEnterCompleted: function() {},
            onLeave: function() {},
            onLeaveCompleted: function() {}
        };
        t.exports = o
    }
    , function(t, e) {
        var n = {
            events: {},
            on: function(t, e) {
                this.events[t] = this.events[t] || [],
                this.events[t].push(e)
            },
            off: function(t, e) {
                t in this.events != !1 && this.events[t].splice(this.events[t].indexOf(e), 1)
            },
            trigger: function(t) {
                if (t in this.events != !1)
                    for (var e = 0; e < this.events[t].length; e++)
                        this.events[t][e].apply(this, Array.prototype.slice.call(arguments, 1))
            }
        };
        t.exports = n
    }
    , function(t, e, n) {
        var r = n(5)
          , i = {
            data: {},
            extend: function(t) {
                return r.extend(this, t)
            },
            set: function(t, e) {
                this.data[t] = e
            },
            get: function(t) {
                return this.data[t]
            },
            reset: function() {
                this.data = {}
            }
        };
        t.exports = i
    }
    , function(t, e) {
        var n = {
            history: [],
            add: function(t, e) {
                e || (e = void 0),
                this.history.push({
                    url: t,
                    namespace: e
                })
            },
            currentStatus: function() {
                return this.history[this.history.length - 1]
            },
            prevStatus: function() {
                var t = this.history;
                return t.length < 2 ? null : t[t.length - 2]
            }
        };
        t.exports = n
    }
    , function(t, e, n) {
        var r = n(5)
          , i = n(7)
          , o = n(11)
          , s = n(8)
          , a = n(9)
          , c = n(12)
          , u = {
            Dom: c,
            History: a,
            Cache: s,
            cacheEnabled: !0,
            transitionProgress: !1,
            ignoreClassLink: "no-barba",
            start: function() {
                this.init()
            },
            init: function() {
                var t = this.Dom.getContainer()
                  , e = this.Dom.getWrapper();
                e.setAttribute("aria-live", "polite"),
                this.History.add(this.getCurrentUrl(), this.Dom.getNamespace(t)),
                i.trigger("initStateChange", this.History.currentStatus()),
                i.trigger("newPageReady", this.History.currentStatus(), {}, t, this.Dom.currentHTML),
                i.trigger("transitionCompleted", this.History.currentStatus()),
                this.bindEvents()
            },
            bindEvents: function() {
                document.addEventListener("click", this.onLinkClick.bind(this)),
                window.addEventListener("popstate", this.onStateChange.bind(this))
            },
            getCurrentUrl: function() {
                return r.cleanLink(r.getCurrentUrl())
            },
            goTo: function(t) {
                window.history.pushState(null, null, t),
                this.onStateChange()
            },
            forceGoTo: function(t) {
                window.location = t
            },
            load: function(t) {
                var e, n = r.deferred(), i = this;
                return e = this.Cache.get(t),
                e || (e = r.xhr(t),
                this.Cache.set(t, e)),
                e.then(function(t) {
                    var e = i.Dom.parseResponse(t);
                    i.Dom.putContainer(e),
                    i.cacheEnabled || i.Cache.reset(),
                    n.resolve(e)
                }, function() {
                    i.forceGoTo(t),
                    n.reject()
                }),
                n.promise
            },
            getHref: function(t) {
                if (t)
                    return t.getAttribute && "string" == typeof t.getAttribute("xlink:href") ? t.getAttribute("xlink:href") : "string" == typeof t.href ? t.href : void 0
            },
            onLinkClick: function(t) {
            },
            preventCheck: function(t, e) {
                if (!window.history.pushState)
                    return !1;
                var n = this.getHref(e);
                return !(!e || !n) && (!(t.which > 1 || t.metaKey || t.ctrlKey || t.shiftKey || t.altKey) && ((!e.target || "_blank" !== e.target) && (window.location.protocol === e.protocol && window.location.hostname === e.hostname && (r.getPort() === r.getPort(e.port) && (!(n.indexOf("#") > -1) && ((!e.getAttribute || "string" != typeof e.getAttribute("download")) && (r.cleanLink(n) != r.cleanLink(location.href) && !e.classList.contains(this.ignoreClassLink))))))))
            },
            getTransition: function() {
                return o
            },
            onStateChange: function() {
                var t = this.getCurrentUrl();
                if (this.transitionProgress && this.forceGoTo(t),
                this.History.currentStatus().url === t)
                    return !1;
                this.History.add(t);
                var e = this.load(t)
                  , n = Object.create(this.getTransition());
                this.transitionProgress = !0,
                i.trigger("initStateChange", this.History.currentStatus(), this.History.prevStatus());
                var r = n.init(this.Dom.getContainer(), e);
                e.then(this.onNewContainerLoaded.bind(this)),
                r.then(this.onTransitionEnd.bind(this))
            },
            onNewContainerLoaded: function(t) {
                var e = this.History.currentStatus();
                e.namespace = this.Dom.getNamespace(t),
                i.trigger("newPageReady", this.History.currentStatus(), this.History.prevStatus(), t, this.Dom.currentHTML)
            },
            onTransitionEnd: function() {
                this.transitionProgress = !1,
                i.trigger("transitionCompleted", this.History.currentStatus(), this.History.prevStatus())
            }
        };
        t.exports = u
    }
    , function(t, e, n) {
        var r = n(4)
          , i = r.extend({
            start: function() {
                this.newContainerLoading.then(this.finish.bind(this))
            },
            finish: function() {
                document.body.scrollTop = 0,
                this.done()
            }
        });
        t.exports = i
    }
    , function(t, e) {
        var n = {
            dataNamespace: "pagename",
            wrapperId: "main_page",
            containerClass: "content",
            currentHTML: document.documentElement.innerHTML,
            parseResponse: function(t) {
                this.currentHTML = t;
                var e = document.createElement("div");
                e.innerHTML = t;
                var n = e.querySelector("title");
                return n && (document.title = n.textContent),
                this.getContainer(e)
            },
            getWrapper: function() {
                var t = document.getElementById(this.wrapperId);
                if (!t)
                    throw new Error("Barba.js: wrapper not found!");
                return t
            },
            getContainer: function(t) {
                if (t || (t = document.body),
                !t)
                    throw new Error("Barba.js: DOM not ready!");
                var e = this.parseContainer(t);
                if (e && e.jquery && (e = e[0]),
                !e)
                    throw new Error("Barba.js: no container found");
                return e
            },
            getNamespace: function(t) {
                return t && t.dataset ? t.dataset[this.dataNamespace] : t ? t.getAttribute("data-" + this.dataNamespace) : null
            },
            putContainer: function(t) {
                t.style.visibility = "hidden";
                var e = this.getWrapper();
                e.appendChild(t)
            },
            parseContainer: function(t) {
                return t.querySelector("." + this.containerClass)
            }
        };
        t.exports = n
    }
    , function(t, e, n) {
        var r = n(5)
          , i = n(10)
          , o = {
            ignoreClassLink: "no-barba-prefetch",
            init: function() {
                return !!window.history.pushState && (document.body.addEventListener("mouseover", this.onLinkEnter.bind(this)),
                void document.body.addEventListener("touchstart", this.onLinkEnter.bind(this)))
            },
            onLinkEnter: function(t) {
                for (var e = t.target; e && !i.getHref(e); )
                    e = e.parentNode;
                if (e && !e.classList.contains(this.ignoreClassLink)) {
                    var n = i.getHref(e);
                    if (i.preventCheck(t, e) && !i.Cache.get(n)) {
                        var o = r.xhr(n);
                        i.Cache.set(n, o)
                    }
                }
            }
        };
        t.exports = o
    }
    ])
});

/* Instafeed */
(function() {
    var e;
    e = function() {
        function e(e, t) {
            var n, r;
            this.options = {
                target: "instafeed",
                get: "popular",
                resolution: "thumbnail",
                sortBy: "none",
                links: !0,
                mock: !1,
                useHttp: !1
            };
            if (typeof e == "object")
                for (n in e)
                    r = e[n],
                    this.options[n] = r;
            this.context = t != null ? t : this,
            this.unique = this._genKey()
        }
        return e.prototype.hasNext = function() {
            return typeof this.context.nextUrl == "string" && this.context.nextUrl.length > 0
        }
        ,
        e.prototype.next = function() {
            return this.hasNext() ? this.run(this.context.nextUrl) : !1
        }
        ,
        e.prototype.run = function(t) {
            var n, r, i;
            if (typeof this.options.clientId != "string" && typeof this.options.accessToken != "string")
                throw new Error("Missing clientId or accessToken.");
            if (typeof this.options.accessToken != "string" && typeof this.options.clientId != "string")
                throw new Error("Missing clientId or accessToken.");
            return this.options.before != null && typeof this.options.before == "function" && this.options.before.call(this),
            typeof document != "undefined" && document !== null && (i = document.createElement("script"),
            i.id = "instafeed-fetcher",
            i.src = t || this._buildUrl(),
            n = document.getElementsByTagName("head"),
            n[0].appendChild(i),
            r = "instafeedCache" + this.unique,
            window[r] = new e(this.options,this),
            window[r].unique = this.unique),
            !0
        }
        ,
        e.prototype.parse = function(e) {
            var t, n, r, i, s, o, u, a, f, l, c, h, p, d, v, m, g, y, b, w, E, S, x, T, N, C, k, L, A, O, M, _, D;
            if (typeof e != "object") {
                if (this.options.error != null && typeof this.options.error == "function")
                    return this.options.error.call(this, "Invalid JSON data"),
                    !1;
                throw new Error("Invalid JSON response")
            }
            if (e.meta.code !== 200) {
                if (this.options.error != null && typeof this.options.error == "function")
                    return this.options.error.call(this, e.meta.error_message),
                    !1;
                throw new Error("Error from Instagram: " + e.meta.error_message)
            }
            if (e.data.length === 0) {
                if (this.options.error != null && typeof this.options.error == "function")
                    return this.options.error.call(this, "No images were returned from Instagram"),
                    !1;
                throw new Error("No images were returned from Instagram")
            }
            this.options.success != null && typeof this.options.success == "function" && this.options.success.call(this, e),
            this.context.nextUrl = "",
            e.pagination != null && (this.context.nextUrl = e.pagination.next_url);
            if (this.options.sortBy !== "none") {
                this.options.sortBy === "random" ? M = ["", "random"] : M = this.options.sortBy.split("-"),
                O = M[0] === "least" ? !0 : !1;
                switch (M[1]) {
                case "random":
                    e.data.sort(function() {
                        return .5 - Math.random()
                    });
                    break;
                case "recent":
                    e.data = this._sortBy(e.data, "created_time", O);
                    break;
                case "liked":
                    e.data = this._sortBy(e.data, "likes.count", O);
                    break;
                case "commented":
                    e.data = this._sortBy(e.data, "comments.count", O);
                    break;
                default:
                    throw new Error("Invalid option for sortBy: '" + this.options.sortBy + "'.")
                }
            }
            if (typeof document != "undefined" && document !== null && this.options.mock === !1) {
                m = e.data,
                A = parseInt(this.options.limit, 10),
                this.options.limit != null && m.length > A && (m = m.slice(0, A)),
                u = document.createDocumentFragment(),
                this.options.filter != null && typeof this.options.filter == "function" && (m = this._filter(m, this.options.filter));
                if (this.options.template != null && typeof this.options.template == "string") {
                    f = "",
                    d = "",
                    w = "",
                    D = document.createElement("div");
                    for (c = 0,
                    N = m.length; c < N; c++) {
                        h = m[c],
                        p = h.images[this.options.resolution],
                        this.options.resolution == "standard_resolution" ? (imageFull = p.url.replace("/s640x640/sh0.08/", "/"),
                        v = imageFull) : v = p.url;
                        if (typeof p != "object")
                            throw o = "No image found for resolution: " + this.options.resolution + ".",
                            new Error(o);
                        E = p.width,
                        y = p.height,
                        b = "square",
                        E > y && (b = "landscape"),
                        E < y && (b = "portrait"),
                        v = p.url,
                        l = window.location.protocol.indexOf("http") >= 0,
                        l && !this.options.useHttp && (v = v.replace(/https?:\/\//, "//")),
                        d = this._makeTemplate(this.options.template, {
                            model: h,
                            id: h.id,
                            link: h.link,
                            type: h.type,
                            image: v,
                            width: E,
                            height: y,
                            orientation: b,
                            caption: this._getObjectProperty(h, "caption.text"),
                            likes: h.likes.count,
                            comments: h.comments.count,
                            location: this._getObjectProperty(h, "location.name")
                        }),
                        f += d
                    }
                    D.innerHTML = f,
                    i = [],
                    r = 0,
                    n = D.childNodes.length;
                    while (r < n)
                        i.push(D.childNodes[r]),
                        r += 1;
                    for (x = 0,
                    C = i.length; x < C; x++)
                        L = i[x],
                        u.appendChild(L)
                } else
                    for (T = 0,
                    k = m.length; T < k; T++) {
                        h = m[T],
                        g = document.createElement("img"),
                        p = h.images[this.options.resolution];
                        if (typeof p != "object")
                            throw o = "No image found for resolution: " + this.options.resolution + ".",
                            new Error(o);
                        v = p.url,
                        l = window.location.protocol.indexOf("http") >= 0,
                        l && !this.options.useHttp && (v = v.replace(/https?:\/\//, "//")),
                        g.src = v,
                        this.options.links === !0 ? (t = document.createElement("a"),
                        t.href = h.link,
                        t.appendChild(g),
                        u.appendChild(t)) : u.appendChild(g)
                    }
                _ = this.options.target,
                typeof _ == "string" && (_ = document.getElementById(_));
                if (_ == null)
                    throw o = 'No element with id="' + this.options.target + '" on page.',
                    new Error(o);
                _.appendChild(u),
                a = document.getElementsByTagName("head")[0],
                a.removeChild(document.getElementById("instafeed-fetcher")),
                S = "instafeedCache" + this.unique,
                window[S] = void 0;
                try {
                    delete window[S]
                } catch (P) {
                    s = P
                }
            }
            return this.options.after != null && typeof this.options.after == "function" && this.options.after.call(this),
            !0
        }
        ,
        e.prototype._buildUrl = function() {
            var e, t, n;
            e = "https://api.instagram.com/v1";
            switch (this.options.get) {
            case "popular":
                t = "media/popular";
                break;
            case "tagged":
                if (!this.options.tagName)
                    throw new Error("No tag name specified. Use the 'tagName' option.");
                t = "tags/" + this.options.tagName + "/media/recent";
                break;
            case "location":
                if (!this.options.locationId)
                    throw new Error("No location specified. Use the 'locationId' option.");
                t = "locations/" + this.options.locationId + "/media/recent";
                break;
            case "user":
                if (!this.options.userId)
                    throw new Error("No user specified. Use the 'userId' option.");
                t = "users/" + this.options.userId + "/media/recent";
                break;
            default:
                throw new Error("Invalid option for get: '" + this.options.get + "'.")
            }
            return n = e + "/" + t,
            this.options.accessToken != null ? n += "?access_token=" + this.options.accessToken : n += "?client_id=" + this.options.clientId,
            this.options.limit != null && (n += "&count=" + this.options.limit),
            n += "&callback=instafeedCache" + this.unique + ".parse",
            n
        }
        ,
        e.prototype._genKey = function() {
            var e;
            return e = function() {
                return ((1 + Math.random()) * 65536 | 0).toString(16).substring(1)
            }
            ,
            "" + e() + e() + e() + e()
        }
        ,
        e.prototype._makeTemplate = function(e, t) {
            var n, r, i, s, o;
            r = /(?:\{{2})([\w\[\]\.]+)(?:\}{2})/,
            n = e;
            while (r.test(n))
                s = n.match(r)[1],
                o = (i = this._getObjectProperty(t, s)) != null ? i : "",
                n = n.replace(r, function() {
                    return "" + o
                });
            return n
        }
        ,
        e.prototype._getObjectProperty = function(e, t) {
            var n, r;
            t = t.replace(/\[(\w+)\]/g, ".$1"),
            r = t.split(".");
            while (r.length) {
                n = r.shift();
                if (!(e != null && n in e))
                    return null;
                e = e[n]
            }
            return e
        }
        ,
        e.prototype._sortBy = function(e, t, n) {
            var r;
            return r = function(e, r) {
                var i, s;
                return i = this._getObjectProperty(e, t),
                s = this._getObjectProperty(r, t),
                n ? i > s ? 1 : -1 : i < s ? 1 : -1
            }
            ,
            e.sort(r.bind(this)),
            e
        }
        ,
        e.prototype._filter = function(e, t) {
            var n, r, i, s, o;
            n = [],
            r = function(e) {
                if (t(e))
                    return n.push(e)
            }
            ;
            for (i = 0,
            o = e.length; i < o; i++)
                s = e[i],
                r(s);
            return n
        }
        ,
        e
    }(),
    function(e, t) {
        return typeof define == "function" && define.amd ? define([], t) : typeof module == "object" && module.exports ? module.exports = t() : e.Instafeed = t()
    }(this, function() {
        return e
    })
}
).call(this);
